// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/proxima-nova-regular-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/proxima-nova-regular-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/PN-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/fa-brands-400.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/fa-brands-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/fa-brands-400.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/fa-brands-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/fa-brands-400.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/fa-regular-400.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/fonts/fa-regular-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/fonts/fa-regular-400.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/fonts/fa-regular-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../assets/fonts/fa-regular-400.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../assets/fonts/fa-solid-900.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../../assets/fonts/fa-solid-900.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../../assets/fonts/fa-solid-900.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../../assets/fonts/fa-solid-900.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../../assets/fonts/fa-solid-900.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___, { hash: "#fontawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___, { hash: "#fontawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___, { hash: "#fontawesome" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*COMMON STYLES*/
/*! Generated by Font Squirrel (https://www.fontsquirrel.com) on January 7, 2019 */
@font-face {
  font-family: "ProximaNovaRegular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "ProximaNovaBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal;
}
*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  outline: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.5);
  margin: 0;
  padding: 0;
  -webkit-text-size-adjust: 100%;
  -moz-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -webkit-touch-callout: default;
  -webkit-overflow-scrolling: touch;
  font-size: 16px;
  color: #232f3a;
  font-family: "ProximaNovaRegular", sans-serif;
  white-space: normal;
  word-wrap: break-word;
}

body,
form,
input,
select,
textarea,
button,
label,
h1,
h2,
h3,
h4,
h5,
h6 {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: "ProximaNovaRegular", sans-serif;
}

html,
body {
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  font-size: 16px;
  line-height: 24px;
  color: #000;
  font-weight: normal;
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  background: #f7f8fa;
  font-family: "ProximaNovaRegular", sans-serif;
}

img {
  display: block;
  margin: 0 auto;
  max-width: 100%;
}

ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
ul li {
  list-style: none;
}

.ui.container {
  padding: 0 20px;
  width: 100%;
}
@media only screen and (min-width: 1200px) {
  .ui.container {
    width: 100%;
    max-width: 100%;
  }
}

.ui.grid {
  margin-top: 10px;
  margin-bottom: 0;
  margin-left: -0.5rem;
  margin-right: -0.5rem;
}
.ui.grid > .row {
  padding-top: 0;
  padding-bottom: 0;
  margin-bottom: 10px;
}

.ui.grid > .row:before {
  box-shadow: none !important;
}

.ui.grid > .row > .column {
  margin-top: 0.1rem;
  margin-bottom: 0.1rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.nopadding {
  padding: 0 !important;
}

.clear {
  clear: both;
  line-height: 0;
  font-size: 0;
  overflow: hidden;
}

.clearfix {
  *zoom: 1;
}

.clearfix:after,
.container:after {
  clear: both;
  content: ".";
  display: block;
  font-size: 0;
  height: 0;
  line-height: 0;
  visibility: hidden;
}

sup {
  vertical-align: top;
  padding: 0;
  margin: 0;
}

:focus,
a {
  outline: none;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
  border-radius: 5px;
}

::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.7);
}

i.icon:before {
  font-family: Icons;
}

i.icon.outline {
  font-family: outline-icons;
}
i.icon.outline::before {
  font-family: outline-icons;
}

i.icon.close:before {
  content: "✖";
  font-weight: 600;
}

i.icon.equal:before {
  font-size: 2em;
  content: "=";
  font-weight: 600;
  color: #dcdcdc;
}

i.squareIcon {
  background-color: #285482;
}
i.squareIcon::before {
  color: #fff !important;
  font-size: 0.9em;
}

h1 {
  font-family: "ProximaNovaRegular";
  font-size: 2.49em;
  line-height: 1.2em;
  color: #232f3a;
  font-weight: normal;
}

h2 {
  font-family: "ProximaNovaRegular";
  font-size: 2.07em;
  line-height: 1.2em;
  color: #232f3a;
  font-weight: normal;
}

h3 {
  font-family: "ProximaNovaRegular";
  font-size: 1.73em;
  line-height: 1.2em;
  color: #232f3a;
  font-weight: normal;
}

h4 {
  font-family: "ProximaNovaRegular";
  font-size: 1.44em;
  line-height: 1.2em;
  color: #232f3a;
  font-weight: normal;
}

h5 {
  font-family: "ProximaNovaRegular";
  font-size: 1.44em;
  line-height: 1.2em;
  color: #232f3a;
  font-weight: normal;
}

h6 {
  font-family: "ProximaNovaRegular";
  font-size: 11.9px;
  line-height: 1.2em;
  color: #232f3a;
  font-weight: normal;
}

p,
li,
span {
  font-family: "ProximaNovaRegular";
  font-size: 16px;
  line-height: 1.5em;
  font-weight: 400;
  font-style: normal;
  color: #232f3a;
  text-transform: none;
}

a {
  font-size: 16px;
  line-height: 1.5em;
  font-weight: 400;
  font-style: normal;
  color: #232f3a;
  text-decoration: none;
}

/*COMMON CLASSES*/
.noPrivilege {
  padding: 0px 0 50px 0;
  text-align: center;
}
.noPrivilege .dontSign {
  display: block;
  margin-bottom: 30px;
}
.noPrivilege .dontSign i {
  text-align: center;
  display: initial;
}
.noPrivilege .dontSign i::before {
  font-size: 3.7em;
  color: #c8c8c8;
}

.floatLeft {
  float: left !important;
}

.floatRight {
  float: right !important;
}

.floatNone {
  float: none !important;
}

.txtCenter {
  text-align: center !important;
}

.txtLeft {
  text-align: left;
}

.txtRight {
  text-align: right;
}

.textJustify {
  text-align: justify;
}

.textNowrap {
  white-space: nowrap;
}

.lowercase {
  text-transform: lowercase !important;
}

.uppercase {
  text-transform: uppercase !important;
}

.capitalize {
  text-transform: capitalize !important;
}

.transformNone {
  text-transform: none !important;
}

.relative {
  position: relative;
}

.heightAuto {
  height: auto !important;
  min-height: 100%;
}

.ellip {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.breakAll {
  word-break: break-all;
}

.noBreak {
  word-break: normal !important;
}

.noScroll {
  overflow: hidden !important;
}

.no_bg {
  background: none !important;
}

.noBorder {
  border: none !important;
}

.borderLeft {
  border-left: 1px solid #99928a;
}

.borderTop {
  border-top: 1px solid #99928a;
}

.borderRight {
  border-right: 1px solid #99928a;
}

.borderBottom {
  border-bottom: 1px solid #99928a;
}

.center-block {
  display: block;
  margin-right: auto;
  margin-left: auto;
}

.hide {
  display: none !important;
}

.show {
  display: block !important;
}

.invisible {
  visibility: hidden;
}

.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.paddingLR0 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.pt0 {
  padding-top: 0 !important;
}

.pt5 {
  padding-top: 5px !important;
}

.pt10 {
  padding-top: 10px !important;
}

.padTopBot50 {
  position: relative;
  padding-top: 140px !important;
  padding-bottom: 30px !important;
}

.pb10 {
  padding-bottom: 10px !important;
}

.pt20 {
  padding-top: 20px !important;
}

.pb20 {
  padding-bottom: 20px !important;
}

.pl10 {
  padding-left: 10px !important;
}

.margin0 {
  margin: 0 !important;
}

.mt0 {
  margin-top: 0 !important;
}

.mt5 {
  margin-top: 5px !important;
}

.mt10 {
  margin-top: 10px !important;
}

.mt20 {
  margin-top: 20px !important;
}

.mt30 {
  margin-top: 30px !important;
}

.mt-20 {
  margin-top: -20px !important;
}

.mb0 {
  margin-bottom: 0 !important;
}

.mb5 {
  margin-bottom: 5px !important;
}

.mb10 {
  margin-bottom: 10px !important;
}

.mb20 {
  margin-bottom: 20px !important;
}

.mb30 {
  margin-bottom: 30px !important;
}

.mr5 {
  margin-right: 5px !important;
}

.mr10 {
  margin-right: 10px !important;
}

.mr20 {
  margin-right: 20px !important;
}

.mr30 {
  margin-right: 30px !important;
}

.ml5 {
  margin-left: 5px !important;
}

.ml10 {
  margin-left: 10px !important;
}

.ml20 {
  margin-left: 20px !important;
}

.ml30 {
  margin-left: 30px !important;
}

.middleIcon {
  display: inline-block;
  width: 24px;
  height: 22px;
  margin: 0 10px;
  vertical-align: middle;
}

.leftIcon {
  display: inline-block;
  width: 24px;
  height: 22px;
  margin: 0 10px 0 0;
  vertical-align: middle;
}

.commonList {
  list-style: disc;
  margin-left: 30px;
}

.font13 {
  font-size: 13px !important;
}

.font18 {
  font-size: 18px !important;
}

.message {
  display: block;
  background: #a94442;
  font-size: 15px;
  color: #fff;
  text-align: center;
  padding: 10px;
  border: 1px solid #a94442;
}

.inlineB {
  display: inline-block !important;
}

.inline {
  display: inline !important;
}

.dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #000;
  border: 1px solid #fff;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-box-sizing: 50%;
  border-radius: 50%;
}

.vMiddle {
  vertical-align: middle;
}

.headTitle {
  font-size: 20px;
  color: #232f3a;
  line-height: 25px;
}

.lineH30 {
  line-height: 30px !important;
}

.pointer {
  cursor: pointer !important;
}

.noPointer {
  cursor: not-allowed !important;
}

.ui.dimmer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: rgba(35, 47, 58, 0.95);
  z-index: 10000 !important;
}
.ui.dimmer.modals {
  z-index: 9999 !important;
}

.noRecordMessage {
  display: block;
  width: 100%;
  font-size: 16px;
  color: #686c6d;
  margin: 80px 0 30px 0;
  text-align: center;
}

.threeLiner {
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

.twoLiner {
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.oneLiner {
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.validationError .ui.selection {
  border: 1px solid #e0b4b4 !important;
  background: #fff6f6 !important;
  color: #9f3a38;
}

.txtRed {
  color: #b13036 !important;
}

.errorMessage {
  display: block;
  margin-top: -10px;
  font-size: 14px;
  color: #a94442;
}

/*!
 * Font Awesome Free 5.0.4 by @fontawesome - http://fontawesome.com
 * License - http://fontawesome.com/license (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */
.fa,
.fab,
.fal,
.far,
.fas {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
}

.fa-lg {
  font-size: 1.33333em;
  line-height: 0.75em;
  vertical-align: -0.0667em;
}

.fa-xs {
  font-size: 0.75em;
}
.fa-xs:before {
  font-size: 0.75em;
}

.fa-sm {
  font-size: 0.875em;
}
.fa-sm:before {
  font-size: 0.875em;
}

.fa-1x {
  font-size: 1em;
}
.fa-1x:before {
  font-size: 1em;
}

.fa-1_2x {
  font-size: 1.25em;
}
.fa-1_2x:before {
  font-size: 1.25em;
}

.fa-2x {
  font-size: 2em;
}
.fa-2x:before {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}
.fa-3x:before {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}
.fa-4x:before {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}
.fa-5x:before {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: 2.5em;
  padding-left: 0;
}

.fa-ul > li {
  position: relative;
}

.fa-li {
  left: -2em;
  position: absolute;
  text-align: center;
  width: 2em;
  line-height: inherit;
}

.fa-border {
  border: 0.08em solid #eee;
  border-radius: 0.1em;
  padding: 0.2em 0.25em 0.15em;
}

.fa-pull-left {
  float: left;
}

.fa-pull-right {
  float: right;
}

.fa.fa-pull-left,
.fab.fa-pull-left,
.fal.fa-pull-left,
.far.fa-pull-left,
.fas.fa-pull-left {
  margin-right: 0.3em;
}

.fa.fa-pull-right,
.fab.fa-pull-right,
.fal.fa-pull-right,
.far.fa-pull-right,
.fas.fa-pull-right {
  margin-left: 0.3em;
}

.fa-spin {
  -webkit-animation: a 2s infinite linear;
  animation: a 2s infinite linear;
}

.fa-pulse {
  -webkit-animation: a 1s infinite steps(8);
  animation: a 1s infinite steps(8);
}

@-webkit-keyframes a {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}
@keyframes a {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}
.fa-rotate-90 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

.fa-rotate-180 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

.fa-rotate-270 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";
  -webkit-transform: rotate(270deg);
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}

.fa-flip-vertical {
  -webkit-transform: scaleY(-1);
  transform: scaleY(-1);
}

.fa-flip-horizontal.fa-flip-vertical,
.fa-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
}

.fa-flip-horizontal.fa-flip-vertical {
  -webkit-transform: scale(-1);
  transform: scale(-1);
}

:root .fa-flip-horizontal,
:root .fa-flip-vertical,
:root .fa-rotate-90,
:root .fa-rotate-180,
:root .fa-rotate-270 {
  -webkit-filter: none;
  filter: none;
}

.fa-stack {
  display: inline-block;
  height: 2em;
  line-height: 2em;
  position: relative;
  vertical-align: middle;
  width: 2em;
}

.fa-stack-1x,
.fa-stack-2x {
  left: 0;
  position: absolute;
  text-align: center;
  width: 100%;
}

.fa-stack-1x {
  line-height: inherit;
}

.fa-stack-2x {
  font-size: 2em;
}

.fa-inverse {
  color: #fff;
}

.fa-500px:before {
  content: "\\f26e";
}

.fa-accessible-icon:before {
  content: "\\f368";
}

.fa-accusoft:before {
  content: "\\f369";
}

.fa-address-book:before {
  content: "\\f2b9";
}

.fa-address-card:before {
  content: "\\f2bb";
}

.fa-adjust:before {
  content: "\\f042";
}

.fa-adn:before {
  content: "\\f170";
}

.fa-adversal:before {
  content: "\\f36a";
}

.fa-affiliatetheme:before {
  content: "\\f36b";
}

.fa-algolia:before {
  content: "\\f36c";
}

.fa-align-center:before {
  content: "\\f037";
}

.fa-align-justify:before {
  content: "\\f039";
}

.fa-align-left:before {
  content: "\\f036";
}

.fa-align-right:before {
  content: "\\f038";
}

.fa-amazon:before {
  content: "\\f270";
}

.fa-amazon-pay:before {
  content: "\\f42c";
}

.fa-ambulance:before {
  content: "\\f0f9";
}

.fa-american-sign-language-interpreting:before {
  content: "\\f2a3";
}

.fa-amilia:before {
  content: "\\f36d";
}

.fa-anchor:before {
  content: "\\f13d";
}

.fa-android:before {
  content: "\\f17b";
}

.fa-angellist:before {
  content: "\\f209";
}

.fa-angle-double-down:before {
  content: "\\f103";
}

.fa-angle-double-left:before {
  content: "\\f100";
}

.fa-angle-double-right:before {
  content: "\\f101";
}

.fa-angle-double-up:before {
  content: "\\f102";
}

.fa-angle-down:before {
  content: "\\f107";
}

.fa-angle-left:before {
  content: "\\f104";
}

.fa-angle-right:before {
  content: "\\f105";
}

.fa-angle-up:before {
  content: "\\f106";
}

.fa-angrycreative:before {
  content: "\\f36e";
}

.fa-angular:before {
  content: "\\f420";
}

.fa-app-store:before {
  content: "\\f36f";
}

.fa-app-store-ios:before {
  content: "\\f370";
}

.fa-apper:before {
  content: "\\f371";
}

.fa-apple:before {
  content: "\\f179";
}

.fa-apple-pay:before {
  content: "\\f415";
}

.fa-archive:before {
  content: "\\f187";
}

.fa-arrow-alt-circle-down:before {
  content: "\\f358";
}

.fa-arrow-alt-circle-left:before {
  content: "\\f359";
}

.fa-arrow-alt-circle-right:before {
  content: "\\f35a";
}

.fa-arrow-alt-circle-up:before {
  content: "\\f35b";
}

.fa-arrow-circle-down:before {
  content: "\\f0ab";
}

.fa-arrow-circle-left:before {
  content: "\\f0a8";
}

.fa-arrow-circle-right:before {
  content: "\\f0a9";
}

.fa-arrow-circle-up:before {
  content: "\\f0aa";
}

.fa-arrow-down:before {
  content: "\\f063";
}

.fa-arrow-left:before {
  content: "\\f060";
}

.fa-arrow-right:before {
  content: "\\f061";
}

.fa-arrow-up:before {
  content: "\\f062";
}

.fa-arrows-alt:before {
  content: "\\f0b2";
}

.fa-arrows-alt-h:before {
  content: "\\f337";
}

.fa-arrows-alt-v:before {
  content: "\\f338";
}

.fa-assistive-listening-systems:before {
  content: "\\f2a2";
}

.fa-asterisk:before {
  content: "\\f069";
}

.fa-asymmetrik:before {
  content: "\\f372";
}

.fa-at:before {
  content: "\\f1fa";
}

.fa-audible:before {
  content: "\\f373";
}

.fa-audio-description:before {
  content: "\\f29e";
}

.fa-autoprefixer:before {
  content: "\\f41c";
}

.fa-avianex:before {
  content: "\\f374";
}

.fa-aviato:before {
  content: "\\f421";
}

.fa-aws:before {
  content: "\\f375";
}

.fa-backward:before {
  content: "\\f04a";
}

.fa-balance-scale:before {
  content: "\\f24e";
}

.fa-ban:before {
  content: "\\f05e";
}

.fa-bandcamp:before {
  content: "\\f2d5";
}

.fa-barcode:before {
  content: "\\f02a";
}

.fa-bars:before {
  content: "\\f0c9";
}

.fa-bath:before {
  content: "\\f2cd";
}

.fa-battery-empty:before {
  content: "\\f244";
}

.fa-battery-full:before {
  content: "\\f240";
}

.fa-battery-half:before {
  content: "\\f242";
}

.fa-battery-quarter:before {
  content: "\\f243";
}

.fa-battery-three-quarters:before {
  content: "\\f241";
}

.fa-bed:before {
  content: "\\f236";
}

.fa-beer:before {
  content: "\\f0fc";
}

.fa-behance:before {
  content: "\\f1b4";
}

.fa-behance-square:before {
  content: "\\f1b5";
}

.fa-bell:before {
  content: "\\f0f3";
}

.fa-bell-slash:before {
  content: "\\f1f6";
}

.fa-bicycle:before {
  content: "\\f206";
}

.fa-bimobject:before {
  content: "\\f378";
}

.fa-binoculars:before {
  content: "\\f1e5";
}

.fa-birthday-cake:before {
  content: "\\f1fd";
}

.fa-bitbucket:before {
  content: "\\f171";
}

.fa-bitcoin:before {
  content: "\\f379";
}

.fa-bity:before {
  content: "\\f37a";
}

.fa-black-tie:before {
  content: "\\f27e";
}

.fa-blackberry:before {
  content: "\\f37b";
}

.fa-blind:before {
  content: "\\f29d";
}

.fa-blogger:before {
  content: "\\f37c";
}

.fa-blogger-b:before {
  content: "\\f37d";
}

.fa-bluetooth:before {
  content: "\\f293";
}

.fa-bluetooth-b:before {
  content: "\\f294";
}

.fa-bold:before {
  content: "\\f032";
}

.fa-bolt:before {
  content: "\\f0e7";
}

.fa-bomb:before {
  content: "\\f1e2";
}

.fa-book:before {
  content: "\\f02d";
}

.fa-bookmark:before {
  content: "\\f02e";
}

.fa-braille:before {
  content: "\\f2a1";
}

.fa-briefcase:before {
  content: "\\f0b1";
}

.fa-btc:before {
  content: "\\f15a";
}

.fa-bug:before {
  content: "\\f188";
}

.fa-building:before {
  content: "\\f1ad";
}

.fa-bullhorn:before {
  content: "\\f0a1";
}

.fa-bullseye:before {
  content: "\\f140";
}

.fa-buromobelexperte:before {
  content: "\\f37f";
}

.fa-bus:before {
  content: "\\f207";
}

.fa-buysellads:before {
  content: "\\f20d";
}

.fa-calculator:before {
  content: "\\f1ec";
}

.fa-calendar:before {
  content: "\\f133";
}

.fa-calendar-alt:before {
  content: "\\f073";
}

.fa-calendar-check:before {
  content: "\\f274";
}

.fa-calendar-minus:before {
  content: "\\f272";
}

.fa-calendar-plus:before {
  content: "\\f271";
}

.fa-calendar-times:before {
  content: "\\f273";
}

.fa-camera:before {
  content: "\\f030";
}

.fa-camera-retro:before {
  content: "\\f083";
}

.fa-car:before {
  content: "\\f1b9";
}

.fa-caret-down:before {
  content: "\\f0d7";
}

.fa-caret-left:before {
  content: "\\f0d9";
}

.fa-caret-right:before {
  content: "\\f0da";
}

.fa-caret-square-down:before {
  content: "\\f150";
}

.fa-caret-square-left:before {
  content: "\\f191";
}

.fa-caret-square-right:before {
  content: "\\f152";
}

.fa-caret-square-up:before {
  content: "\\f151";
}

.fa-caret-up:before {
  content: "\\f0d8";
}

.fa-cart-arrow-down:before {
  content: "\\f218";
}

.fa-cart-plus:before {
  content: "\\f217";
}

.fa-cc-amazon-pay:before {
  content: "\\f42d";
}

.fa-cc-amex:before {
  content: "\\f1f3";
}

.fa-cc-apple-pay:before {
  content: "\\f416";
}

.fa-cc-diners-club:before {
  content: "\\f24c";
}

.fa-cc-discover:before {
  content: "\\f1f2";
}

.fa-cc-jcb:before {
  content: "\\f24b";
}

.fa-cc-mastercard:before {
  content: "\\f1f1";
}

.fa-cc-paypal:before {
  content: "\\f1f4";
}

.fa-cc-stripe:before {
  content: "\\f1f5";
}

.fa-cc-visa:before {
  content: "\\f1f0";
}

.fa-centercode:before {
  content: "\\f380";
}

.fa-certificate:before {
  content: "\\f0a3";
}

.fa-chart-area:before {
  content: "\\f1fe";
}

.fa-chart-bar:before {
  content: "\\f080";
}

.fa-chart-line:before {
  content: "\\f201";
}

.fa-chart-pie:before {
  content: "\\f200";
}

.fa-check:before {
  content: "\\f00c";
}

.fa-check-circle:before {
  content: "\\f058";
}

.fa-check-square:before {
  content: "\\f14a";
}

.fa-chevron-circle-down:before {
  content: "\\f13a";
}

.fa-chevron-circle-left:before {
  content: "\\f137";
}

.fa-chevron-circle-right:before {
  content: "\\f138";
}

.fa-chevron-circle-up:before {
  content: "\\f139";
}

.fa-chevron-down:before {
  content: "\\f078";
}

.fa-chevron-left:before {
  content: "\\f053";
}

.fa-chevron-right:before {
  content: "\\f054";
}

.fa-chevron-up:before {
  content: "\\f077";
}

.fa-child:before {
  content: "\\f1ae";
}

.fa-chrome:before {
  content: "\\f268";
}

.fa-circle:before {
  content: "\\f111";
}

.fa-circle-notch:before {
  content: "\\f1ce";
}

.fa-clipboard:before {
  content: "\\f328";
}

.fa-clock:before {
  content: "\\f017";
}

.fa-clone:before {
  content: "\\f24d";
}

.fa-closed-captioning:before {
  content: "\\f20a";
}

.fa-cloud:before {
  content: "\\f0c2";
}

.fa-cloud-download-alt:before {
  content: "\\f381";
}

.fa-cloud-upload-alt:before {
  content: "\\f382";
}

.fa-cloudscale:before {
  content: "\\f383";
}

.fa-cloudsmith:before {
  content: "\\f384";
}

.fa-cloudversify:before {
  content: "\\f385";
}

.fa-code:before {
  content: "\\f121";
}

.fa-code-branch:before {
  content: "\\f126";
}

.fa-codepen:before {
  content: "\\f1cb";
}

.fa-codiepie:before {
  content: "\\f284";
}

.fa-coffee:before {
  content: "\\f0f4";
}

.fa-cog:before {
  content: "\\f013";
}

.fa-cogs:before {
  content: "\\f085";
}

.fa-columns:before {
  content: "\\f0db";
}

.fa-comment:before {
  content: "\\f075";
}

.fa-comment-alt:before {
  content: "\\f27a";
}

.fa-comments:before {
  content: "\\f086";
}

.fa-compass:before {
  content: "\\f14e";
}

.fa-compress:before {
  content: "\\f066";
}

.fa-connectdevelop:before {
  content: "\\f20e";
}

.fa-contao:before {
  content: "\\f26d";
}

.fa-copy:before {
  content: "\\f0c5";
}

.fa-copyright:before {
  content: "\\f1f9";
}

.fa-cpanel:before {
  content: "\\f388";
}

.fa-creative-commons:before {
  content: "\\f25e";
}

.fa-credit-card:before {
  content: "\\f09d";
}

.fa-crop:before {
  content: "\\f125";
}

.fa-crosshairs:before {
  content: "\\f05b";
}

.fa-css3:before {
  content: "\\f13c";
}

.fa-css3-alt:before {
  content: "\\f38b";
}

.fa-cube:before {
  content: "\\f1b2";
}

.fa-cubes:before {
  content: "\\f1b3";
}

.fa-cut:before {
  content: "\\f0c4";
}

.fa-cuttlefish:before {
  content: "\\f38c";
}

.fa-d-and-d:before {
  content: "\\f38d";
}

.fa-dashcube:before {
  content: "\\f210";
}

.fa-database:before {
  content: "\\f1c0";
}

.fa-deaf:before {
  content: "\\f2a4";
}

.fa-delicious:before {
  content: "\\f1a5";
}

.fa-deploydog:before {
  content: "\\f38e";
}

.fa-deskpro:before {
  content: "\\f38f";
}

.fa-desktop:before {
  content: "\\f108";
}

.fa-deviantart:before {
  content: "\\f1bd";
}

.fa-digg:before {
  content: "\\f1a6";
}

.fa-digital-ocean:before {
  content: "\\f391";
}

.fa-discord:before {
  content: "\\f392";
}

.fa-discourse:before {
  content: "\\f393";
}

.fa-dochub:before {
  content: "\\f394";
}

.fa-docker:before {
  content: "\\f395";
}

.fa-dollar-sign:before {
  content: "\\f155";
}

.fa-dot-circle:before {
  content: "\\f192";
}

.fa-download:before {
  content: "\\f019";
}

.fa-draft2digital:before {
  content: "\\f396";
}

.fa-dribbble:before {
  content: "\\f17d";
}

.fa-dribbble-square:before {
  content: "\\f397";
}

.fa-dropbox:before {
  content: "\\f16b";
}

.fa-drupal:before {
  content: "\\f1a9";
}

.fa-dyalog:before {
  content: "\\f399";
}

.fa-earlybirds:before {
  content: "\\f39a";
}

.fa-edge:before {
  content: "\\f282";
}

.fa-edit:before {
  content: "\\f044";
}

.fa-eject:before {
  content: "\\f052";
}

.fa-elementor:before {
  content: "\\f430";
}

.fa-ellipsis-h:before {
  content: "\\f141";
}

.fa-ellipsis-v:before {
  content: "\\f142";
}

.fa-ember:before {
  content: "\\f423";
}

.fa-empire:before {
  content: "\\f1d1";
}

.fa-envelope:before {
  content: "\\f0e0";
}

.fa-envelope-open:before {
  content: "\\f2b6";
}

.fa-envelope-square:before {
  content: "\\f199";
}

.fa-envira:before {
  content: "\\f299";
}

.fa-eraser:before {
  content: "\\f12d";
}

.fa-erlang:before {
  content: "\\f39d";
}

.fa-ethereum:before {
  content: "\\f42e";
}

.fa-etsy:before {
  content: "\\f2d7";
}

.fa-euro-sign:before {
  content: "\\f153";
}

.fa-exchange-alt:before {
  content: "\\f362";
}

.fa-exclamation:before {
  content: "\\f12a";
}

.fa-exclamation-circle:before {
  content: "\\f06a";
}

.fa-exclamation-triangle:before {
  content: "\\f071";
}

.fa-expand:before {
  content: "\\f065";
}

.fa-expand-arrows-alt:before {
  content: "\\f31e";
}

.fa-expeditedssl:before {
  content: "\\f23e";
}

.fa-external-link-alt:before {
  content: "\\f35d";
}

.fa-external-link-square-alt:before {
  content: "\\f360";
}

.fa-eye:before {
  content: "\\f06e";
}

.fa-eye-dropper:before {
  content: "\\f1fb";
}

.fa-eye-slash:before {
  content: "\\f070";
}

.fa-facebook:before {
  content: "\\f09a";
}

.fa-facebook-f:before {
  content: "\\f39e";
}

.fa-facebook-messenger:before {
  content: "\\f39f";
}

.fa-facebook-square:before {
  content: "\\f082";
}

.fa-fast-backward:before {
  content: "\\f049";
}

.fa-fast-forward:before {
  content: "\\f050";
}

.fa-fax:before {
  content: "\\f1ac";
}

.fa-female:before {
  content: "\\f182";
}

.fa-fighter-jet:before {
  content: "\\f0fb";
}

.fa-file:before {
  content: "\\f15b";
}

.fa-file-alt:before {
  content: "\\f15c";
}

.fa-file-archive:before {
  content: "\\f1c6";
}

.fa-file-audio:before {
  content: "\\f1c7";
}

.fa-file-code:before {
  content: "\\f1c9";
}

.fa-file-excel:before {
  content: "\\f1c3";
}

.fa-file-image:before {
  content: "\\f1c5";
}

.fa-file-pdf:before {
  content: "\\f1c1";
}

.fa-file-powerpoint:before {
  content: "\\f1c4";
}

.fa-file-video:before {
  content: "\\f1c8";
}

.fa-file-word:before {
  content: "\\f1c2";
}

.fa-film:before {
  content: "\\f008";
}

.fa-filter:before {
  content: "\\f0b0";
}

.fa-fire:before {
  content: "\\f06d";
}

.fa-fire-extinguisher:before {
  content: "\\f134";
}

.fa-firefox:before {
  content: "\\f269";
}

.fa-first-order:before {
  content: "\\f2b0";
}

.fa-firstdraft:before {
  content: "\\f3a1";
}

.fa-flag:before {
  content: "\\f024";
}

.fa-flag-checkered:before {
  content: "\\f11e";
}

.fa-flask:before {
  content: "\\f0c3";
}

.fa-flickr:before {
  content: "\\f16e";
}

.fa-fly:before {
  content: "\\f417";
}

.fa-folder:before {
  content: "\\f07b";
}

.fa-folder-open:before {
  content: "\\f07c";
}

.fa-font:before {
  content: "\\f031";
}

.fa-font-awesome:before {
  content: "\\f2b4";
}

.fa-font-awesome-alt:before {
  content: "\\f35c";
}

.fa-font-awesome-flag:before {
  content: "\\f425";
}

.fa-fonticons:before {
  content: "\\f280";
}

.fa-fonticons-fi:before {
  content: "\\f3a2";
}

.fa-fort-awesome:before {
  content: "\\f286";
}

.fa-fort-awesome-alt:before {
  content: "\\f3a3";
}

.fa-forumbee:before {
  content: "\\f211";
}

.fa-forward:before {
  content: "\\f04e";
}

.fa-foursquare:before {
  content: "\\f180";
}

.fa-free-code-camp:before {
  content: "\\f2c5";
}

.fa-freebsd:before {
  content: "\\f3a4";
}

.fa-frown:before {
  content: "\\f119";
}

.fa-futbol:before {
  content: "\\f1e3";
}

.fa-gamepad:before {
  content: "\\f11b";
}

.fa-gavel:before {
  content: "\\f0e3";
}

.fa-gem:before {
  content: "\\f3a5";
}

.fa-genderless:before {
  content: "\\f22d";
}

.fa-get-pocket:before {
  content: "\\f265";
}

.fa-gg:before {
  content: "\\f260";
}

.fa-gg-circle:before {
  content: "\\f261";
}

.fa-gift:before {
  content: "\\f06b";
}

.fa-git:before {
  content: "\\f1d3";
}

.fa-git-square:before {
  content: "\\f1d2";
}

.fa-github:before {
  content: "\\f09b";
}

.fa-github-alt:before {
  content: "\\f113";
}

.fa-github-square:before {
  content: "\\f092";
}

.fa-gitkraken:before {
  content: "\\f3a6";
}

.fa-gitlab:before {
  content: "\\f296";
}

.fa-gitter:before {
  content: "\\f426";
}

.fa-glass-martini:before {
  content: "\\f000";
}

.fa-glide:before {
  content: "\\f2a5";
}

.fa-glide-g:before {
  content: "\\f2a6";
}

.fa-globe:before {
  content: "\\f0ac";
}

.fa-gofore:before {
  content: "\\f3a7";
}

.fa-goodreads:before {
  content: "\\f3a8";
}

.fa-goodreads-g:before {
  content: "\\f3a9";
}

.fa-google:before {
  content: "\\f1a0";
}

.fa-google-drive:before {
  content: "\\f3aa";
}

.fa-google-play:before {
  content: "\\f3ab";
}

.fa-google-plus:before {
  content: "\\f2b3";
}

.fa-google-plus-g:before {
  content: "\\f0d5";
}

.fa-google-plus-square:before {
  content: "\\f0d4";
}

.fa-google-wallet:before {
  content: "\\f1ee";
}

.fa-graduation-cap:before {
  content: "\\f19d";
}

.fa-gratipay:before {
  content: "\\f184";
}

.fa-grav:before {
  content: "\\f2d6";
}

.fa-gripfire:before {
  content: "\\f3ac";
}

.fa-grunt:before {
  content: "\\f3ad";
}

.fa-gulp:before {
  content: "\\f3ae";
}

.fa-h-square:before {
  content: "\\f0fd";
}

.fa-hacker-news:before {
  content: "\\f1d4";
}

.fa-hacker-news-square:before {
  content: "\\f3af";
}

.fa-hand-lizard:before {
  content: "\\f258";
}

.fa-hand-paper:before {
  content: "\\f256";
}

.fa-hand-peace:before {
  content: "\\f25b";
}

.fa-hand-point-down:before {
  content: "\\f0a7";
}

.fa-hand-point-left:before {
  content: "\\f0a5";
}

.fa-hand-point-right:before {
  content: "\\f0a4";
}

.fa-hand-point-up:before {
  content: "\\f0a6";
}

.fa-hand-pointer:before {
  content: "\\f25a";
}

.fa-hand-rock:before {
  content: "\\f255";
}

.fa-hand-scissors:before {
  content: "\\f257";
}

.fa-hand-spock:before {
  content: "\\f259";
}

.fa-handshake:before {
  content: "\\f2b5";
}

.fa-hashtag:before {
  content: "\\f292";
}

.fa-hdd:before {
  content: "\\f0a0";
}

.fa-heading:before {
  content: "\\f1dc";
}

.fa-headphones:before {
  content: "\\f025";
}

.fa-heart:before {
  content: "\\f004";
}

.fa-heartbeat:before {
  content: "\\f21e";
}

.fa-hire-a-helper:before {
  content: "\\f3b0";
}

.fa-history:before {
  content: "\\f1da";
}

.fa-home:before {
  content: "\\f015";
}

.fa-hooli:before {
  content: "\\f427";
}

.fa-hospital:before {
  content: "\\f0f8";
}

.fa-hotjar:before {
  content: "\\f3b1";
}

.fa-hourglass:before {
  content: "\\f254";
}

.fa-hourglass-end:before {
  content: "\\f253";
}

.fa-hourglass-half:before {
  content: "\\f252";
}

.fa-hourglass-start:before {
  content: "\\f251";
}

.fa-houzz:before {
  content: "\\f27c";
}

.fa-html5:before {
  content: "\\f13b";
}

.fa-hubspot:before {
  content: "\\f3b2";
}

.fa-i-cursor:before {
  content: "\\f246";
}

.fa-id-badge:before {
  content: "\\f2c1";
}

.fa-id-card:before {
  content: "\\f2c2";
}

.fa-image:before {
  content: "\\f03e";
}

.fa-images:before {
  content: "\\f302";
}

.fa-imdb:before {
  content: "\\f2d8";
}

.fa-inbox:before {
  content: "\\f01c";
}

.fa-indent:before {
  content: "\\f03c";
}

.fa-industry:before {
  content: "\\f275";
}

.fa-info:before {
  content: "\\f129";
}

.fa-info-circle:before {
  content: "\\f05a";
}

.fa-instagram:before {
  content: "\\f16d";
}

.fa-internet-explorer:before {
  content: "\\f26b";
}

.fa-ioxhost:before {
  content: "\\f208";
}

.fa-italic:before {
  content: "\\f033";
}

.fa-itunes:before {
  content: "\\f3b4";
}

.fa-itunes-note:before {
  content: "\\f3b5";
}

.fa-jenkins:before {
  content: "\\f3b6";
}

.fa-joget:before {
  content: "\\f3b7";
}

.fa-joomla:before {
  content: "\\f1aa";
}

.fa-js:before {
  content: "\\f3b8";
}

.fa-js-square:before {
  content: "\\f3b9";
}

.fa-jsfiddle:before {
  content: "\\f1cc";
}

.fa-key:before {
  content: "\\f084";
}

.fa-keyboard:before {
  content: "\\f11c";
}

.fa-keycdn:before {
  content: "\\f3ba";
}

.fa-kickstarter:before {
  content: "\\f3bb";
}

.fa-kickstarter-k:before {
  content: "\\f3bc";
}

.fa-korvue:before {
  content: "\\f42f";
}

.fa-language:before {
  content: "\\f1ab";
}

.fa-laptop:before {
  content: "\\f109";
}

.fa-laravel:before {
  content: "\\f3bd";
}

.fa-lastfm:before {
  content: "\\f202";
}

.fa-lastfm-square:before {
  content: "\\f203";
}

.fa-leaf:before {
  content: "\\f06c";
}

.fa-leanpub:before {
  content: "\\f212";
}

.fa-lemon:before {
  content: "\\f094";
}

.fa-less:before {
  content: "\\f41d";
}

.fa-level-down-alt:before {
  content: "\\f3be";
}

.fa-level-up-alt:before {
  content: "\\f3bf";
}

.fa-life-ring:before {
  content: "\\f1cd";
}

.fa-lightbulb:before {
  content: "\\f0eb";
}

.fa-line:before {
  content: "\\f3c0";
}

.fa-link:before {
  content: "\\f0c1";
}

.fa-linkedin:before {
  content: "\\f08c";
}

.fa-linkedin-in:before {
  content: "\\f0e1";
}

.fa-linode:before {
  content: "\\f2b8";
}

.fa-linux:before {
  content: "\\f17c";
}

.fa-lira-sign:before {
  content: "\\f195";
}

.fa-list:before {
  content: "\\f03a";
}

.fa-list-alt:before {
  content: "\\f022";
}

.fa-list-ol:before {
  content: "\\f0cb";
}

.fa-list-ul:before {
  content: "\\f0ca";
}

.fa-location-arrow:before {
  content: "\\f124";
}

.fa-lock:before {
  content: "\\f023";
}

.fa-lock-open:before {
  content: "\\f3c1";
}

.fa-long-arrow-alt-down:before {
  content: "\\f309";
}

.fa-long-arrow-alt-left:before {
  content: "\\f30a";
}

.fa-long-arrow-alt-right:before {
  content: "\\f30b";
}

.fa-long-arrow-alt-up:before {
  content: "\\f30c";
}

.fa-low-vision:before {
  content: "\\f2a8";
}

.fa-lyft:before {
  content: "\\f3c3";
}

.fa-magento:before {
  content: "\\f3c4";
}

.fa-magic:before {
  content: "\\f0d0";
}

.fa-magnet:before {
  content: "\\f076";
}

.fa-male:before {
  content: "\\f183";
}

.fa-map:before {
  content: "\\f279";
}

.fa-map-marker:before {
  content: "\\f041";
}

.fa-map-marker-alt:before {
  content: "\\f3c5";
}

.fa-map-pin:before {
  content: "\\f276";
}

.fa-map-signs:before {
  content: "\\f277";
}

.fa-mars:before {
  content: "\\f222";
}

.fa-mars-double:before {
  content: "\\f227";
}

.fa-mars-stroke:before {
  content: "\\f229";
}

.fa-mars-stroke-h:before {
  content: "\\f22b";
}

.fa-mars-stroke-v:before {
  content: "\\f22a";
}

.fa-maxcdn:before {
  content: "\\f136";
}

.fa-medapps:before {
  content: "\\f3c6";
}

.fa-medium:before {
  content: "\\f23a";
}

.fa-medium-m:before {
  content: "\\f3c7";
}

.fa-medkit:before {
  content: "\\f0fa";
}

.fa-medrt:before {
  content: "\\f3c8";
}

.fa-meetup:before {
  content: "\\f2e0";
}

.fa-meh:before {
  content: "\\f11a";
}

.fa-mercury:before {
  content: "\\f223";
}

.fa-microchip:before {
  content: "\\f2db";
}

.fa-microphone:before {
  content: "\\f130";
}

.fa-microphone-slash:before {
  content: "\\f131";
}

.fa-microsoft:before {
  content: "\\f3ca";
}

.fa-minus:before {
  content: "\\f068";
}

.fa-minus-circle:before {
  content: "\\f056";
}

.fa-minus-square:before {
  content: "\\f146";
}

.fa-mix:before {
  content: "\\f3cb";
}

.fa-mixcloud:before {
  content: "\\f289";
}

.fa-mizuni:before {
  content: "\\f3cc";
}

.fa-mobile:before {
  content: "\\f10b";
}

.fa-mobile-alt:before {
  content: "\\f3cd";
}

.fa-modx:before {
  content: "\\f285";
}

.fa-monero:before {
  content: "\\f3d0";
}

.fa-money-bill-alt:before {
  content: "\\f3d1";
}

.fa-moon:before {
  content: "\\f186";
}

.fa-motorcycle:before {
  content: "\\f21c";
}

.fa-mouse-pointer:before {
  content: "\\f245";
}

.fa-music:before {
  content: "\\f001";
}

.fa-napster:before {
  content: "\\f3d2";
}

.fa-neuter:before {
  content: "\\f22c";
}

.fa-newspaper:before {
  content: "\\f1ea";
}

.fa-nintendo-switch:before {
  content: "\\f418";
}

.fa-node:before {
  content: "\\f419";
}

.fa-node-js:before {
  content: "\\f3d3";
}

.fa-npm:before {
  content: "\\f3d4";
}

.fa-ns8:before {
  content: "\\f3d5";
}

.fa-nutritionix:before {
  content: "\\f3d6";
}

.fa-object-group:before {
  content: "\\f247";
}

.fa-object-ungroup:before {
  content: "\\f248";
}

.fa-odnoklassniki:before {
  content: "\\f263";
}

.fa-odnoklassniki-square:before {
  content: "\\f264";
}

.fa-opencart:before {
  content: "\\f23d";
}

.fa-openid:before {
  content: "\\f19b";
}

.fa-opera:before {
  content: "\\f26a";
}

.fa-optin-monster:before {
  content: "\\f23c";
}

.fa-osi:before {
  content: "\\f41a";
}

.fa-outdent:before {
  content: "\\f03b";
}

.fa-page4:before {
  content: "\\f3d7";
}

.fa-pagelines:before {
  content: "\\f18c";
}

.fa-paint-brush:before {
  content: "\\f1fc";
}

.fa-palfed:before {
  content: "\\f3d8";
}

.fa-paper-plane:before {
  content: "\\f1d8";
}

.fa-paperclip:before {
  content: "\\f0c6";
}

.fa-paragraph:before {
  content: "\\f1dd";
}

.fa-paste:before {
  content: "\\f0ea";
}

.fa-patreon:before {
  content: "\\f3d9";
}

.fa-pause:before {
  content: "\\f04c";
}

.fa-pause-circle:before {
  content: "\\f28b";
}

.fa-paw:before {
  content: "\\f1b0";
}

.fa-paypal:before {
  content: "\\f1ed";
}

.fa-pen-square:before {
  content: "\\f14b";
}

.fa-pencil-alt:before {
  content: "\\f303";
}

.fa-percent:before {
  content: "\\f295";
}

.fa-periscope:before {
  content: "\\f3da";
}

.fa-phabricator:before {
  content: "\\f3db";
}

.fa-phoenix-framework:before {
  content: "\\f3dc";
}

.fa-phone:before {
  content: "\\f095";
}

.fa-phone-square:before {
  content: "\\f098";
}

.fa-phone-volume:before {
  content: "\\f2a0";
}

.fa-pied-piper:before {
  content: "\\f2ae";
}

.fa-pied-piper-alt:before {
  content: "\\f1a8";
}

.fa-pied-piper-pp:before {
  content: "\\f1a7";
}

.fa-pinterest:before {
  content: "\\f0d2";
}

.fa-pinterest-p:before {
  content: "\\f231";
}

.fa-pinterest-square:before {
  content: "\\f0d3";
}

.fa-plane:before {
  content: "\\f072";
}

.fa-play:before {
  content: "\\f04b";
}

.fa-play-circle:before {
  content: "\\f144";
}

.fa-playstation:before {
  content: "\\f3df";
}

.fa-plug:before {
  content: "\\f1e6";
}

.fa-plus:before {
  content: "\\f067";
}

.fa-plus-circle:before {
  content: "\\f055";
}

.fa-plus-square:before {
  content: "\\f0fe";
}

.fa-podcast:before {
  content: "\\f2ce";
}

.fa-pound-sign:before {
  content: "\\f154";
}

.fa-power-off:before {
  content: "\\f011";
}

.fa-print:before {
  content: "\\f02f";
}

.fa-product-hunt:before {
  content: "\\f288";
}

.fa-pushed:before {
  content: "\\f3e1";
}

.fa-puzzle-piece:before {
  content: "\\f12e";
}

.fa-python:before {
  content: "\\f3e2";
}

.fa-qq:before {
  content: "\\f1d6";
}

.fa-qrcode:before {
  content: "\\f029";
}

.fa-question:before {
  content: "\\f128";
}

.fa-question-circle:before {
  content: "\\f059";
}

.fa-quora:before {
  content: "\\f2c4";
}

.fa-quote-left:before {
  content: "\\f10d";
}

.fa-quote-right:before {
  content: "\\f10e";
}

.fa-random:before {
  content: "\\f074";
}

.fa-ravelry:before {
  content: "\\f2d9";
}

.fa-react:before {
  content: "\\f41b";
}

.fa-rebel:before {
  content: "\\f1d0";
}

.fa-recycle:before {
  content: "\\f1b8";
}

.fa-red-river:before {
  content: "\\f3e3";
}

.fa-reddit:before {
  content: "\\f1a1";
}

.fa-reddit-alien:before {
  content: "\\f281";
}

.fa-reddit-square:before {
  content: "\\f1a2";
}

.fa-redo:before {
  content: "\\f01e";
}

.fa-redo-alt:before {
  content: "\\f2f9";
}

.fa-registered:before {
  content: "\\f25d";
}

.fa-rendact:before {
  content: "\\f3e4";
}

.fa-renren:before {
  content: "\\f18b";
}

.fa-reply:before {
  content: "\\f3e5";
}

.fa-reply-all:before {
  content: "\\f122";
}

.fa-replyd:before {
  content: "\\f3e6";
}

.fa-resolving:before {
  content: "\\f3e7";
}

.fa-retweet:before {
  content: "\\f079";
}

.fa-road:before {
  content: "\\f018";
}

.fa-rocket:before {
  content: "\\f135";
}

.fa-rocketchat:before {
  content: "\\f3e8";
}

.fa-rockrms:before {
  content: "\\f3e9";
}

.fa-rss:before {
  content: "\\f09e";
}

.fa-rss-square:before {
  content: "\\f143";
}

.fa-ruble-sign:before {
  content: "\\f158";
}

.fa-rupee-sign:before {
  content: "\\f156";
}

.fa-safari:before {
  content: "\\f267";
}

.fa-sass:before {
  content: "\\f41e";
}

.fa-save:before {
  content: "\\f0c7";
}

.fa-schlix:before {
  content: "\\f3ea";
}

.fa-scribd:before {
  content: "\\f28a";
}

.fa-search:before {
  content: "\\f002";
}

.fa-search-minus:before {
  content: "\\f010";
}

.fa-search-plus:before {
  content: "\\f00e";
}

.fa-searchengin:before {
  content: "\\f3eb";
}

.fa-sellcast:before {
  content: "\\f2da";
}

.fa-sellsy:before {
  content: "\\f213";
}

.fa-server:before {
  content: "\\f233";
}

.fa-servicestack:before {
  content: "\\f3ec";
}

.fa-share:before {
  content: "\\f064";
}

.fa-share-alt:before {
  content: "\\f1e0";
}

.fa-share-alt-square:before {
  content: "\\f1e1";
}

.fa-share-square:before {
  content: "\\f14d";
}

.fa-shekel-sign:before {
  content: "\\f20b";
}

.fa-shield-alt:before {
  content: "\\f3ed";
}

.fa-ship:before {
  content: "\\f21a";
}

.fa-shirtsinbulk:before {
  content: "\\f214";
}

.fa-shopping-bag:before {
  content: "\\f290";
}

.fa-shopping-basket:before {
  content: "\\f291";
}

.fa-shopping-cart:before {
  content: "\\f07a";
}

.fa-shower:before {
  content: "\\f2cc";
}

.fa-sign-in-alt:before {
  content: "\\f2f6";
}

.fa-sign-language:before {
  content: "\\f2a7";
}

.fa-sign-out-alt:before {
  content: "\\f2f5";
}

.fa-signal:before {
  content: "\\f012";
}

.fa-simplybuilt:before {
  content: "\\f215";
}

.fa-sistrix:before {
  content: "\\f3ee";
}

.fa-sitemap:before {
  content: "\\f0e8";
}

.fa-skyatlas:before {
  content: "\\f216";
}

.fa-skype:before {
  content: "\\f17e";
}

.fa-slack:before {
  content: "\\f198";
}

.fa-slack-hash:before {
  content: "\\f3ef";
}

.fa-sliders-h:before {
  content: "\\f1de";
}

.fa-slideshare:before {
  content: "\\f1e7";
}

.fa-smile:before {
  content: "\\f118";
}

.fa-snapchat:before {
  content: "\\f2ab";
}

.fa-snapchat-ghost:before {
  content: "\\f2ac";
}

.fa-snapchat-square:before {
  content: "\\f2ad";
}

.fa-snowflake:before {
  content: "\\f2dc";
}

.fa-sort:before {
  content: "\\f0dc";
}

.fa-sort-alpha-down:before {
  content: "\\f15d";
}

.fa-sort-alpha-up:before {
  content: "\\f15e";
}

.fa-sort-amount-down:before {
  content: "\\f160";
}

.fa-sort-amount-up:before {
  content: "\\f161";
}

.fa-sort-down:before {
  content: "\\f0dd";
}

.fa-sort-numeric-down:before {
  content: "\\f162";
}

.fa-sort-numeric-up:before {
  content: "\\f163";
}

.fa-sort-up:before {
  content: "\\f0de";
}

.fa-soundcloud:before {
  content: "\\f1be";
}

.fa-space-shuttle:before {
  content: "\\f197";
}

.fa-speakap:before {
  content: "\\f3f3";
}

.fa-spinner:before {
  content: "\\f110";
}

.fa-spotify:before {
  content: "\\f1bc";
}

.fa-square:before {
  content: "\\f0c8";
}

.fa-stack-exchange:before {
  content: "\\f18d";
}

.fa-stack-overflow:before {
  content: "\\f16c";
}

.fa-star:before {
  content: "\\f005";
}

.fa-star-half:before {
  content: "\\f089";
}

.fa-staylinked:before {
  content: "\\f3f5";
}

.fa-steam:before {
  content: "\\f1b6";
}

.fa-steam-square:before {
  content: "\\f1b7";
}

.fa-steam-symbol:before {
  content: "\\f3f6";
}

.fa-step-backward:before {
  content: "\\f048";
}

.fa-step-forward:before {
  content: "\\f051";
}

.fa-stethoscope:before {
  content: "\\f0f1";
}

.fa-sticker-mule:before {
  content: "\\f3f7";
}

.fa-sticky-note:before {
  content: "\\f249";
}

.fa-stop:before {
  content: "\\f04d";
}

.fa-stop-circle:before {
  content: "\\f28d";
}

.fa-stopwatch:before {
  content: "\\f2f2";
}

.fa-strava:before {
  content: "\\f428";
}

.fa-street-view:before {
  content: "\\f21d";
}

.fa-strikethrough:before {
  content: "\\f0cc";
}

.fa-stripe:before {
  content: "\\f429";
}

.fa-stripe-s:before {
  content: "\\f42a";
}

.fa-studiovinari:before {
  content: "\\f3f8";
}

.fa-stumbleupon:before {
  content: "\\f1a4";
}

.fa-stumbleupon-circle:before {
  content: "\\f1a3";
}

.fa-subscript:before {
  content: "\\f12c";
}

.fa-subway:before {
  content: "\\f239";
}

.fa-suitcase:before {
  content: "\\f0f2";
}

.fa-sun:before {
  content: "\\f185";
}

.fa-superpowers:before {
  content: "\\f2dd";
}

.fa-superscript:before {
  content: "\\f12b";
}

.fa-supple:before {
  content: "\\f3f9";
}

.fa-sync:before {
  content: "\\f021";
}

.fa-sync-alt:before {
  content: "\\f2f1";
}

.fa-table:before {
  content: "\\f0ce";
}

.fa-tablet:before {
  content: "\\f10a";
}

.fa-tablet-alt:before {
  content: "\\f3fa";
}

.fa-tachometer-alt:before {
  content: "\\f3fd";
}

.fa-tag:before {
  content: "\\f02b";
}

.fa-tags:before {
  content: "\\f02c";
}

.fa-tasks:before {
  content: "\\f0ae";
}

.fa-taxi:before {
  content: "\\f1ba";
}

.fa-telegram:before {
  content: "\\f2c6";
}

.fa-telegram-plane:before {
  content: "\\f3fe";
}

.fa-tencent-weibo:before {
  content: "\\f1d5";
}

.fa-terminal:before {
  content: "\\f120";
}

.fa-text-height:before {
  content: "\\f034";
}

.fa-text-width:before {
  content: "\\f035";
}

.fa-th:before {
  content: "\\f00a";
}

.fa-th-large:before {
  content: "\\f009";
}

.fa-th-list:before {
  content: "\\f00b";
}

.fa-themeisle:before {
  content: "\\f2b2";
}

.fa-thermometer-empty:before {
  content: "\\f2cb";
}

.fa-thermometer-full:before {
  content: "\\f2c7";
}

.fa-thermometer-half:before {
  content: "\\f2c9";
}

.fa-thermometer-quarter:before {
  content: "\\f2ca";
}

.fa-thermometer-three-quarters:before {
  content: "\\f2c8";
}

.fa-thumbs-down:before {
  content: "\\f165";
}

.fa-thumbs-up:before {
  content: "\\f164";
}

.fa-thumbtack:before {
  content: "\\f08d";
}

.fa-ticket-alt:before {
  content: "\\f3ff";
}

.fa-times:before {
  content: "\\f00d";
}

.fa-times-circle:before {
  content: "\\f057";
}

.fa-tint:before {
  content: "\\f043";
}

.fa-toggle-off:before {
  content: "\\f204";
}

.fa-toggle-on:before {
  content: "\\f205";
}

.fa-trademark:before {
  content: "\\f25c";
}

.fa-train:before {
  content: "\\f238";
}

.fa-transgender:before {
  content: "\\f224";
}

.fa-transgender-alt:before {
  content: "\\f225";
}

.fa-trash:before {
  content: "\\f1f8";
}

.fa-trash-alt:before {
  content: "\\f2ed";
}

.fa-tree:before {
  content: "\\f1bb";
}

.fa-trello:before {
  content: "\\f181";
}

.fa-tripadvisor:before {
  content: "\\f262";
}

.fa-trophy:before {
  content: "\\f091";
}

.fa-truck:before {
  content: "\\f0d1";
}

.fa-tty:before {
  content: "\\f1e4";
}

.fa-tumblr:before {
  content: "\\f173";
}

.fa-tumblr-square:before {
  content: "\\f174";
}

.fa-tv:before {
  content: "\\f26c";
}

.fa-twitch:before {
  content: "\\f1e8";
}

.fa-twitter:before {
  content: "\\f099";
}

.fa-twitter-square:before {
  content: "\\f081";
}

.fa-typo3:before {
  content: "\\f42b";
}

.fa-uber:before {
  content: "\\f402";
}

.fa-uikit:before {
  content: "\\f403";
}

.fa-umbrella:before {
  content: "\\f0e9";
}

.fa-underline:before {
  content: "\\f0cd";
}

.fa-undo:before {
  content: "\\f0e2";
}

.fa-undo-alt:before {
  content: "\\f2ea";
}

.fa-uniregistry:before {
  content: "\\f404";
}

.fa-universal-access:before {
  content: "\\f29a";
}

.fa-university:before {
  content: "\\f19c";
}

.fa-unlink:before {
  content: "\\f127";
}

.fa-unlock:before {
  content: "\\f09c";
}

.fa-unlock-alt:before {
  content: "\\f13e";
}

.fa-untappd:before {
  content: "\\f405";
}

.fa-upload:before {
  content: "\\f093";
}

.fa-usb:before {
  content: "\\f287";
}

.fa-user:before {
  content: "\\f007";
}

.fa-user-circle:before {
  content: "\\f2bd";
}

.fa-user-md:before {
  content: "\\f0f0";
}

.fa-user-plus:before {
  content: "\\f234";
}

.fa-user-secret:before {
  content: "\\f21b";
}

.fa-user-times:before {
  content: "\\f235";
}

.fa-users:before {
  content: "\\f0c0";
}

.fa-ussunnah:before {
  content: "\\f407";
}

.fa-utensil-spoon:before {
  content: "\\f2e5";
}

.fa-utensils:before {
  content: "\\f2e7";
}

.fa-vaadin:before {
  content: "\\f408";
}

.fa-venus:before {
  content: "\\f221";
}

.fa-venus-double:before {
  content: "\\f226";
}

.fa-venus-mars:before {
  content: "\\f228";
}

.fa-viacoin:before {
  content: "\\f237";
}

.fa-viadeo:before {
  content: "\\f2a9";
}

.fa-viadeo-square:before {
  content: "\\f2aa";
}

.fa-viber:before {
  content: "\\f409";
}

.fa-video:before {
  content: "\\f03d";
}

.fa-vimeo:before {
  content: "\\f40a";
}

.fa-vimeo-square:before {
  content: "\\f194";
}

.fa-vimeo-v:before {
  content: "\\f27d";
}

.fa-vine:before {
  content: "\\f1ca";
}

.fa-vk:before {
  content: "\\f189";
}

.fa-vnv:before {
  content: "\\f40b";
}

.fa-volume-down:before {
  content: "\\f027";
}

.fa-volume-off:before {
  content: "\\f026";
}

.fa-volume-up:before {
  content: "\\f028";
}

.fa-vuejs:before {
  content: "\\f41f";
}

.fa-weibo:before {
  content: "\\f18a";
}

.fa-weixin:before {
  content: "\\f1d7";
}

.fa-whatsapp:before {
  content: "\\f232";
}

.fa-whatsapp-square:before {
  content: "\\f40c";
}

.fa-wheelchair:before {
  content: "\\f193";
}

.fa-whmcs:before {
  content: "\\f40d";
}

.fa-wifi:before {
  content: "\\f1eb";
}

.fa-wikipedia-w:before {
  content: "\\f266";
}

.fa-window-close:before {
  content: "\\f410";
}

.fa-window-maximize:before {
  content: "\\f2d0";
}

.fa-window-minimize:before {
  content: "\\f2d1";
}

.fa-window-restore:before {
  content: "\\f2d2";
}

.fa-windows:before {
  content: "\\f17a";
}

.fa-won-sign:before {
  content: "\\f159";
}

.fa-wordpress:before {
  content: "\\f19a";
}

.fa-wordpress-simple:before {
  content: "\\f411";
}

.fa-wpbeginner:before {
  content: "\\f297";
}

.fa-wpexplorer:before {
  content: "\\f2de";
}

.fa-wpforms:before {
  content: "\\f298";
}

.fa-wrench:before {
  content: "\\f0ad";
}

.fa-xbox:before {
  content: "\\f412";
}

.fa-xing:before {
  content: "\\f168";
}

.fa-xing-square:before {
  content: "\\f169";
}

.fa-y-combinator:before {
  content: "\\f23b";
}

.fa-yahoo:before {
  content: "\\f19e";
}

.fa-yandex:before {
  content: "\\f413";
}

.fa-yandex-international:before {
  content: "\\f414";
}

.fa-yelp:before {
  content: "\\f1e9";
}

.fa-yen-sign:before {
  content: "\\f157";
}

.fa-yoast:before {
  content: "\\f2b1";
}

.fa-youtube:before {
  content: "\\f167";
}

.fa-youtube-square:before {
  content: "\\f431";
}

.sr-only {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.sr-only-focusable:active,
.sr-only-focusable:focus {
  clip: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  position: static;
  width: auto;
}

@font-face {
  font-family: Font Awesome\\ 5 Brands;
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("svg");
}
.fab {
  font-family: Font Awesome\\ 5 Brands;
}
.fab:before {
  font-family: Font Awesome\\ 5 Brands;
}

@font-face {
  font-family: Font Awesome\\ 5 Free;
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("svg");
}
.far {
  font-weight: 400;
}
.far:before {
  font-weight: 400;
}

@font-face {
  font-family: Font Awesome\\ 5 Free;
  font-style: normal;
  font-weight: 900;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("svg");
}
.fa,
.far,
.fal,
.fas {
  font-family: Font Awesome\\ 5 Free;
}
.fa:before,
.far:before,
.fal:before,
.fas:before {
  font-family: Font Awesome\\ 5 Free;
}

.fa,
.fas {
  font-weight: 900;
}
.fa:before,
.fas:before {
  font-weight: 900;
}

.accordion {
  box-shadow: none;
  border-radius: 0;
}
.accordion .title {
  display: block;
  border: 1px solid #ccc;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  -ms-border-radius: 0;
  -o-box-sizing: 0;
  border-radius: 0;
  background-color: rgb(236, 236, 236);
  -webkit-box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);
  -moz-box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);
  -ms-box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);
  -o-box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);
  min-height: 43px;
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
  position: relative;
  padding-left: 20px !important;
  font-size: 20px !important;
  color: #232f3a !important;
}
.accordion .title i.dropdown {
  position: absolute;
  right: 0px;
  top: 10px;
  text-align: center !important;
}
.accordion .title i.dropdown:before {
  content: "\\f107" !important;
  color: #686c6d;
}
.accordion .title.active {
  border-radius: 0;
}
.accordion .title.active i.dropdown {
  top: 17px;
  transform: rotate(180deg) !important;
}
.accordion .title.active i.dropdown:before {
  color: #232f3a;
}
.accordion .content {
  border-radius: 0;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  padding: 20px !important;
  background: rgb(247, 248, 250);
}
.accordion .content table {
  border-radius: 0 0 0 0;
}
.accordion .content table th {
  padding: 10px 5px;
}
.accordion .title.active + .content.active {
  margin-top: -10px;
  border-top: none;
}

.ui.button {
  padding: 0.6em 1.5em 0.6em;
  font-size: 12px;
  line-height: 1;
  border: none;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  -ms-border-radius: 0;
  -o-box-sizing: 0;
  border-radius: 0;
  vertical-align: middle;
  text-transform: uppercase;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  min-width: 85px;
}
.ui.button a {
  font-size: 12px;
  line-height: 15px;
  color: #232f3a;
}
.ui.button i {
  margin-right: 0 !important;
  margin-top: -5px !important;
}
.ui.button i:before {
  color: #fff;
  font-size: 0.8em;
}
.ui.primary.button,
.ui.primary.buttons .button {
  background: #fdc92f;
  color: #232f3a;
}
.ui.primary.button i:before,
.ui.primary.buttons .button i:before {
  color: #232f3a;
}
.ui.primary.button:hover, .ui.primary.button:active, .ui.primary.button:focus,
.ui.primary.buttons .button:hover,
.ui.primary.buttons .button:active,
.ui.primary.buttons .button:focus {
  background: #f8a800;
  color: #232f3a;
}

.ui.secondary.button,
.ui.secondary.buttons .button {
  background: #285482;
  color: #fff;
}
.ui.secondary.button:hover, .ui.secondary.button:active, .ui.secondary.button:focus,
.ui.secondary.buttons .button:hover,
.ui.secondary.buttons .button:active,
.ui.secondary.buttons .button:focus {
  background: #009ada;
  color: #fff;
}

.ui.cancel.button,
.ui.cancel.buttons .button {
  background: #686c6d;
  color: #fff;
}
.ui.cancel.button:hover, .ui.cancel.button:active, .ui.cancel.button:focus,
.ui.cancel.buttons .button:hover,
.ui.cancel.buttons .button:active,
.ui.cancel.buttons .button:focus {
  background: #87959c;
  color: #fff;
}

button[disabled=disabled],
button:disabled,
.btn.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.editBtn {
  display: inline-block;
  background: #285482;
  width: 26px;
  height: 26px;
  color: #fff;
  text-align: center;
  cursor: pointer;
}
.editBtn i {
  padding-left: 4px;
}
.editBtn i:before {
  font-size: 0.7em;
  color: #fff;
}

.addBtn {
  display: inline-block;
  background: #285482;
  width: 26px;
  height: 26px;
  color: #fff;
  text-align: center;
  cursor: pointer;
}
.addBtn i {
  padding-left: 4px;
}
.addBtn i:before {
  font-size: 0.7em;
  color: #fff;
}

.closeBtn {
  display: inline-block;
  background: #686c6d;
  width: 26px;
  height: 26px;
  color: #fff;
  text-align: center;
  cursor: pointer;
}
.closeBtn i {
  padding-left: 4px;
  line-height: 26px;
}
.closeBtn i:before {
  font-size: 0.9em;
  color: #fff;
}

.ui.button.attachBtn {
  background: #285482 !important;
  color: #fff !important;
}
.ui.button.attachBtn i {
  margin-right: 10px !important;
}
.ui.button.attachBtn i:before {
  font-size: 1.1em !important;
  color: #fff;
}

.uploadBtn {
  display: block;
  width: 100%;
}
.uploadBtn input {
  display: inline-block !important;
  padding: 5px !important;
  font-size: 12px !important;
  -webkit-appearance: none !important;
}
.uploadBtn .errorMessage {
  margin-top: 0;
}

.pagerWrap {
  padding: 12px 0;
  border-radius: 2px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.02);
  background-color: rgb(255, 255, 255);
  height: 52px;
}
.pagerWrap .pager {
  float: left;
  padding-left: 3px;
  padding-top: 4px;
  min-width: 270px;
}
.pagerWrap .pager .ui.pagination {
  min-height: auto;
  border: none;
  box-shadow: none;
}
.pagerWrap .pager .ui.pagination .item {
  min-width: auto;
  width: 32px;
  height: 2spx;
  font-size: 13px;
  color: #686c6d;
  padding: 4px;
  justify-content: center;
  margin: 0 2px;
}
.pagerWrap .pager .ui.pagination .item i::before {
  font-size: 0.7em;
  color: #686c6d;
}
.pagerWrap .pager .ui.pagination .item i.caret::before {
  font-size: 0.9em;
  color: #686c6d;
}
.pagerWrap .pager .ui.pagination .item i.step {
  margin-top: -3px;
}
.pagerWrap .pager .ui.pagination .item::before {
  display: none;
}
.pagerWrap .pager .ui.pagination .item.active {
  background-color: #009ada;
  color: #fff;
  border-radius: 2px;
}
.pagerWrap .itemPerPage {
  float: left;
  margin: 0 20px;
  font-size: 14px;
  color: #686c6d;
}
.pagerWrap .itemPerPage .field {
  display: inline-block;
  vertical-align: middle;
  height: 30px;
}
.pagerWrap .itemPerPage .field .dropdown {
  display: inline-block;
  width: 66px;
  min-width: auto !important;
  margin-right: 10px;
}
.pagerWrap .itemPerPage .field .dropdown i.dropdown {
  top: 8px !important;
}
.pagerWrap .itemPerPage .field .dropdown .menu > .item {
  font-size: 14px;
  color: #686c6d;
  padding: 0.278571429rem 0.54285714rem !important;
}
.pagerWrap .itemPerPage .itemsPerPage {
  display: inline-block;
  font-size: 14px;
  color: #686c6d;
  margin-left: 10px;
  vertical-align: middle;
}
.pagerWrap .totalPage {
  float: right;
  font-size: 14px;
  color: #686c6d;
  padding-right: 10px;
  padding-top: 5px;
}

.label,
.ui.form .field > label {
  display: block;
  line-height: 17px;
  font-size: 14px;
  color: #232f3a;
  text-align: left;
  font-weight: 500;
  margin-bottom: 2px;
}
.label .icon.asterisk,
.label .icon.info,
.ui.form .field > label .icon.asterisk,
.ui.form .field > label .icon.info {
  margin-right: 0;
}
.label .icon.asterisk::before,
.label .icon.info::before,
.ui.form .field > label .icon.asterisk::before,
.ui.form .field > label .icon.info::before {
  font-size: 0.7em;
  color: #009ada;
}
.label .commonToolTip,
.ui.form .field > label .commonToolTip {
  display: inline-block;
}

.label2 {
  display: block;
  line-height: 17px;
  font-size: 14px;
  color: #686c6d;
  text-align: left;
  font-weight: 500;
  margin-bottom: 0;
}
.label2 .icon.asterisk,
.label2 .icon.info {
  margin-right: 0;
}
.label2 .icon.asterisk::before,
.label2 .icon.info::before {
  font-size: 0.7em;
  color: #009ada;
}
.label2 .commonToolTip {
  display: inline-block;
}

.labelData {
  font-size: 16px;
  color: #232f3a;
  font-weight: 500;
}

.ui.input input,
.ui.mini.input input {
  font-size: 14px;
  padding: 0.52em 0.5em;
  border-radius: 4px;
  box-shadow: inset 0 2px 3px 0 rgba(0, 0, 0, 0.1);
  background-color: rgb(255, 255, 255);
  color: #99928a;
}

.ui.selection.dropdown {
  padding: 0 1.8em 0 8px;
  height: 30px;
  min-height: 30px;
  line-height: 30px;
  border-radius: 4px;
}
.ui.selection.dropdown .dropdown.icon {
  top: 7px;
  right: 6px;
  margin: 0;
  padding: 0;
  opacity: 0.4;
}
.ui.selection.dropdown .dropdown.icon:before {
  content: "\\f078" !important;
  font-size: 1em;
}
.ui.selection.dropdown > .text {
  font-size: 14px;
  color: #232f3a !important;
  vertical-align: text-bottom;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}
.ui.selection.dropdown .menu > .item {
  padding: 5px 0.54285714rem !important;
  color: #232f3a !important;
}
.ui.selection.dropdown .menu span {
  font-size: 14px !important;
}
.ui.selection.dropdown .menu .message {
  text-overflow: ellipsis;
  overflow: hidden;
}
.ui.selection.dropdown.search .text {
  top: -2px;
}

.ui.dropdown .visible.menu .message {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
}

.ui.form .field {
  margin: 0 0 10px 0;
}
.ui.form .field .field.error {
  margin: 0 0 0 0;
}

.ui.form .disabled.field,
.ui.form .disabled.fields .field,
.ui.form .field :disabled,
.ui.disabled.input,
.ui.input:not(.disabled) input[disabled] {
  opacity: 0.85;
}

.ui.basic.red.label {
  margin: -10px 0 0 0;
  padding: 0;
  border: none;
  font-weight: 300;
}

.radioWrap .field {
  margin: 5px 20px 0 0 !important;
  display: inline-block !important;
}

.radioWrapCheckBoxOfficerTitle > div {
  margin-right: 10px;
}

.ui.radio.checkbox input:checked ~ .box:after,
.ui.radio.checkbox input:checked ~ label:after,
.ui.radio.checkbox input:focus:checked ~ .box:after,
.ui.radio.checkbox input:focus:checked ~ label:after {
  background-color: #fff;
}

.ui.radio.checkbox input:checked ~ .box:before,
.ui.radio.checkbox input:checked ~ label:before,
.ui.radio.checkbox input:focus:checked ~ .box:before,
.ui.radio.checkbox input:focus:checked ~ label:before {
  background-color: #009ada;
}

.ui.checkbox input:checked ~ .box:before,
.ui.checkbox input:checked ~ label:before {
  border-color: #009ada;
}

.ui.radio.checkbox .box,
.ui.radio.checkbox label {
  padding-left: 1.4em;
}

.ui.checkbox .box:before,
.ui.checkbox label:before {
  border-radius: 0;
  width: 16px;
  height: 16px;
}

.ui.checkbox input:checked ~ .box:before,
.ui.checkbox input:checked ~ label:before,
.ui.checkbox input:checked:focus ~ .box:before,
.ui.checkbox input:checked:focus ~ label:before {
  background: #009ada;
  color: #fff;
}

.ui.checkbox input:checked ~ .box:after,
.ui.checkbox input:checked ~ label:after,
.ui.checkbox input:checked:focus ~ .box:after,
.ui.checkbox input:checked:focus ~ label:after {
  font-size: 12px;
  color: #fff;
}

.ui.checkbox.partial .box:before,
.ui.checkbox.partial label:before {
  background: #686c6d;
}

.ui.form textarea {
  font-size: 14px;
  color: #232f3a;
  padding: 0.52em 0.5em;
  box-shadow: inset 0 2px 3px 0 rgba(0, 0, 0, 0.1);
}

.twoColInput {
  width: 300px !important;
  flex-grow: 0 !important;
  margin-right: 20px;
}

.dollarPrefix .input {
  position: relative !important;
}

.dollarPrefix .input:before {
  display: inline-block !important;
  content: "\$" !important;
  background-position: 0 50%;
  width: 13px;
  height: 13px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 16px;
}

.radioWrapper {
  display: block;
  margin-top: 10px;
}

.ui.tiny.modal {
  width: 640px;
}
@media (max-width: 600px) {
  .ui.tiny.modal {
    width: 100%;
  }
}

.ui.modal {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.5);
  background-color: rgb(241, 241, 241);
}
.ui.modal .header:not(.ui) {
  position: relative;
  background: #686c6d;
  font-size: 16px;
  line-height: 20px;
  color: #fff;
  padding: 9px 10px;
  border-bottom: none;
  text-transform: uppercase;
  font-weight: 400;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.ui.modal .header:not(.ui) > .close {
  position: absolute;
  top: 10px;
  right: 10px;
  color: #fff;
  font-style: normal;
  cursor: pointer;
  z-index: 2;
  z-index: 2;
}
.ui.modal .header:not(.ui) > .close:before {
  color: #fff;
}
.ui.modal .content {
  background-color: rgb(241, 241, 241);
  padding: 0 10px;
  max-height: 70vh;
  overflow-x: hidden;
  overflow-y: auto;
}
.ui.modal .content .description {
  min-height: 80px;
  padding-bottom: 45px;
}
.ui.modal .content .description .ui.dropdown .menu > .item > .description,
.ui.modal .content .description .ui.dropdown > .text > .description {
  min-height: auto;
}
.ui.modal .content .description .actions {
  position: fixed;
  bottom: 0;
  z-index: 1;
  width: 98% !important;
}
.ui.modal .actions {
  background-color: rgb(241, 241, 241);
  box-shadow: none;
  border-top: none;
  text-align: left;
  padding: 10px 10px 15px 10px;
}
.ui.modal .actions .button:first-child {
  margin-left: 0;
}
@media (max-width: 767px) {
  .ui.modal .actions .button {
    padding: 15px 20px;
  }
}
.ui.modal.infoBox {
  padding: 20px 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.ui.modal.infoBox .header:not(.ui) {
  background-color: rgb(241, 241, 241);
  padding: 0 10px;
}
.ui.modal.infoBox .header:not(.ui) > .close {
  color: #686c6d;
  right: 0;
  top: -10px;
  cursor: pointer;
}
.ui.modal.infoBox h4 {
  margin: 15px 0 20px 0;
}
.ui.modal.infoBox .actions {
  padding: 10px 10px 0 10px;
  bottom: 20px !important;
}

.confirmBox {
  border-radius: 4px !important;
}
.confirmBox > .header:not(.ui) {
  font-size: 16px;
}
.confirmBox .content {
  font-size: 16px !important;
  color: #232f3a;
  text-align: center;
  padding: 40px 15px 30px 15px !important;
}
.confirmBox .actions {
  text-align: center !important;
  padding-bottom: 40px !important;
}
.confirmBox .actions .ui.button {
  background: #285482;
  color: #fff;
}
.confirmBox.noCancelBtn .actions .ui.button {
  display: none;
}
.confirmBox.noCancelBtn .actions .ui.button.primary {
  display: inline-block;
}

.dblColData .colIcon {
  display: inline-block;
  width: 10%;
  text-align: center;
  vertical-align: top;
}
.dblColData .colText {
  display: inline-block;
  width: 90%;
  font-size: 16px;
}

.editorStyleFix .questionLabel {
  font-size: 16px;
  color: #009ada;
}
.editorStyleFix .questionLabel * {
  color: #009ada !important;
}
.editorStyleFix .answerLabel {
  font-size: 16px;
  color: #232f3a;
}
.editorStyleFix .answerLabel * a,
.editorStyleFix .answerLabel * a * {
  color: #009ada !important;
}
.editorStyleFix .questionLabel *,
.editorStyleFix .answerLabel * {
  background-color: transparent !important;
  vertical-align: initial !important;
}
.editorStyleFix .questionLabel i,
.editorStyleFix .questionLabel em,
.editorStyleFix .answerLabel i,
.editorStyleFix .answerLabel em {
  font-style: italic;
}
.editorStyleFix .questionLabel ol,
.editorStyleFix .answerLabel ol {
  list-style-position: inside;
  display: initial !important;
}
.editorStyleFix .questionLabel ul,
.editorStyleFix .answerLabel ul {
  list-style-position: inside;
  list-style-type: initial;
  margin-left: 17px;
}
.editorStyleFix .questionLabel ul li,
.editorStyleFix .answerLabel ul li {
  list-style-type: disc;
}

.viewModeForm .input input[disabled] {
  box-shadow: none;
  background: rgb(241, 241, 241);
}

.ui.modal.errormodalbox .header i:before {
  color: #fff;
  font-size: 14px;
  vertical-align: top;
}
.ui.modal.errormodalbox .content {
  padding: 20px 10px;
}
.ui.modal.errormodalbox .content ul li {
  list-style: disc;
  margin-left: 20px;
  line-height: 18px;
  margin-bottom: 10px;
}
.ui.modal.add-depends-tasks .content {
  height: 200px;
}
.ui.modal.add-depends-tasks .content .errorMessage {
  margin-top: 0px;
}

.passwordReset {
  max-width: 400px;
}
.passwordReset .description {
  text-align: center;
}
.passwordReset .description .passwordBox {
  display: block;
  margin: 5px auto 2px auto;
  background: #fff;
  width: 150px;
  padding: 10px;
  font-size: 16px;
  text-align: center;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  -ms-border-radius: 3px;
  -o-box-sizing: 3px;
  border-radius: 3px;
  box-shadow: 0 2px 8px 0 rgba(255, 255, 255, 0.5);
}
.passwordReset .description a {
  font-size: 14px;
  color: #009ada;
  cursor: pointer;
}

.breadcrumb {
  display: block;
  width: 100%;
  padding: 10px 0;
  position: fixed;
  top: 90px;
  left: 24px;
}
.breadcrumb * {
  font-size: 13px;
}
.breadcrumb .breadcrumbList li {
  display: block;
  float: left;
}
.breadcrumb .breadcrumbList li a,
.breadcrumb .breadcrumbList li span {
  display: inline-block;
  font-size: 12px;
  color: #87959c;
}
.breadcrumb .breadcrumbList li .current {
  color: #232f3a;
  cursor: default;
}
.breadcrumb .breadcrumbList li .sepert {
  display: inline-block;
  color: #87959c;
  margin: 0 15px;
  font-size: 22px;
}
.breadcrumb .breadcrumbList li .active.section {
  font-weight: 500 !important;
}
.breadcrumb a {
  color: #87959c !important;
  white-space: nowrap;
}
.breadcrumb a * {
  color: #87959c !important;
  white-space: nowrap;
}

.tableWrapper {
  display: block;
  width: 100%;
  margin: 10px 0 0 0;
  overflow-x: auto;
  overflow-y: hidden;
}

.customTable {
  width: 100%;
  table-layout: fixed;
  word-break: break-word;
  word-wrap: break-word;
  border-collapse: separate;
  border-spacing: 0 0.625em;
}
.customTable thead tr th {
  position: relative;
  height: 52px;
  padding: 6px 15px 6px 10px;
  color: #686c6d;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  font-family: "ProximaNovaBold";
  border-right: 1px solid rgba(220, 220, 220, 0.5);
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.02);
  background-color: rgb(255, 255, 255);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.customTable thead tr th:first-child {
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}
.customTable thead tr th:last-child {
  border-right: none;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}
.customTable thead tr th i {
  position: absolute;
  right: -4px;
  top: 15px;
  z-index: 1;
}
.customTable thead tr th i::before {
  color: rgba(220, 220, 220, 0.5);
}
.customTable thead tr th i.activeSort::before {
  color: #009ada;
}
@media (max-width: 1023px) {
  .customTable thead tr th {
    display: block;
    width: 100% !important;
    text-align: left !important;
    padding-left: 15px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
.customTable tbody tr td {
  padding: 11px 10px;
  color: #232f3a;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  vertical-align: middle;
  border: none;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.02);
  background-color: rgb(255, 255, 255);
}
.customTable tbody tr td:first-child {
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}
.customTable tbody tr td:last-child {
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}
.customTable tbody tr td a {
  font-size: 14px;
  color: #009ada;
  cursor: pointer;
}
.customTable tbody tr td a:hover {
  text-decoration: underline;
}
.customTable tbody tr td span {
  font-size: 14px;
}
.customTable tbody tr td i.icon {
  cursor: pointer;
}
.customTable tbody tr td img {
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
}
.customTable tbody tr td .dblColData {
  position: relative;
}
.customTable tbody tr td .dblColData .colIcon {
  display: inline-block;
  width: 24px;
  position: absolute;
  left: 0;
  top: -2px;
}
.customTable tbody tr td .dblColData .colText {
  display: inline-block;
  padding-left: 30px;
  font-size: 16px;
}
.customTable tbody tr td.action button {
  display: inline-block;
  vertical-align: top;
  border: none;
  background: none;
  margin-right: 4px;
}
.customTable tbody tr td.action button i.icon {
  width: 1.8em;
  height: 1.8em;
  line-height: 1.8em;
}
.customTable tbody tr td.action button i.icon::before {
  font-size: 1em;
  color: #fff;
  line-height: 1.7em;
}
@media (max-width: 1023px) {
  .customTable tbody tr td {
    display: block;
    width: 100% !important;
    text-align: left !important;
    padding-left: 15px;
  }
}
.customTable .customizeTableCol {
  width: 30px !important;
  background: #009ada;
  text-align: center;
}
.customTable .customizeTableCol i::before {
  color: #fff;
}

.appTable th.appName {
  width: 20%;
}
.appTable th.appId {
  width: 13%;
}
.appTable th.secureKey {
  width: 17%;
}
.appTable th.contactName {
  width: 15%;
}
.appTable th.emailId {
  width: 24%;
}
.appTable th.status {
  width: 11%;
}
.appTable td.appId {
  text-transform: uppercase;
}
.appTable td.secureKey {
  text-transform: uppercase;
}
.appTable td.contactName {
  text-transform: capitalize;
}

.faqTable tr {
  background: transparent !important;
}
.faqTable th.questions {
  width: 40%;
}
.faqTable th.answers {
  width: 40%;
}
.faqTable th.status {
  width: 10%;
}
.faqTable th.action {
  width: 10%;
}
.faqTable td i {
  display: none;
  text-decoration: none;
  display: inline-block;
  vertical-align: text-top;
  width: 26px;
}
.faqTable td i:before {
  color: #686c6d;
  font-size: 0.9em;
}
.faqTable td i:hover {
  text-decoration: none !important;
}
.faqTable td.question {
  font-size: 14px !important;
  color: #009ada !important;
}
.faqTable td.question * {
  font-size: 14px !important;
  color: #009ada !important;
  font-weight: normal !important;
}
.faqTable td.question *:hover {
  text-decoration: underline;
}
.faqTable td.question p {
  display: inline-block;
}
.faqTable td.question sup {
  vertical-align: -webkit-baseline-middle;
}
.faqTable td.question sub {
  vertical-align: 2px;
}
.faqTable td.question ol {
  list-style-position: inside;
}
.faqTable td.question ul {
  list-style-position: inside;
  list-style-type: initial;
  margin-left: 20px;
}
.faqTable td.question .truncatedText {
  display: inline-block;
  width: calc(100% - 30px);
  vertical-align: middle;
}
.faqTable td.answer {
  font-size: 14px !important;
  color: #232f3a !important;
}
.faqTable td.answer * {
  font-size: 14px !important;
  color: #232f3a !important;
  line-height: 20px !important;
}
.faqTable td.answer ol {
  list-style-position: inside;
}
.faqTable td.answer ol li {
  font-size: 14px !important;
  color: #232f3a !important;
  line-height: 20px !important;
}
.faqTable td.answer ul {
  list-style-position: inside;
  list-style-type: initial;
  margin-left: 20px;
}
.faqTable td.answer ul li {
  font-size: 14px !important;
  color: #232f3a !important;
  line-height: 20px !important;
  list-style-type: disc;
}
.faqTable td.answer a {
  color: #009ada !important;
}

.memberShipTable th.membershipName {
  width: 20%;
}
.memberShipTable th.membershipFee {
  width: 20%;
}
.memberShipTable th.isEnabled {
  width: 20%;
}
.memberShipTable th.membershiptypecode {
  width: 20%;
}
.memberShipTable th.stockcode {
  width: 20%;
}

.membershipClassifTable th.seqNo {
  width: 12%;
}
.membershipClassifTable th.classifType {
  width: 25%;
}
.membershipClassifTable th.description {
  width: 40%;
}
.membershipClassifTable th.isEnabled {
  width: 23%;
}
.membershipClassifTable td.seqNo i {
  height: 20px;
  vertical-align: middle;
}
.membershipClassifTable td.seqNo span {
  vertical-align: middle;
  font-size: 14px;
}

.membershipDocTable th.Name {
  width: 50%;
}
.membershipDocTable th.Type {
  width: 30%;
}
.membershipDocTable th.Status {
  width: 20%;
}

.officerTable th.officerTitle {
  width: 25%;
}
.officerTable th.description {
  width: 65%;
}
.officerTable th.status {
  width: 10%;
}

.responsibilitiesTable th.appName {
  width: 25%;
}
.responsibilitiesTable th.url {
  width: 65%;
}
.responsibilitiesTable th.status {
  width: 10%;
}

.meetingTypeTable th.meetingType {
  width: 40%;
}
.meetingTypeTable th.description {
  width: 45%;
}
.meetingTypeTable th.status {
  width: 15%;
}

.documentTable th.documentName {
  width: 65%;
}
.documentTable th.type {
  width: 20%;
}
.documentTable th.action {
  width: 15%;
  text-align: center;
  padding-left: 15px;
}

.userTable th.userName {
  width: 25%;
}
.userTable th.name {
  width: 25%;
}
.userTable th.email {
  width: 30%;
}
.userTable th.userType {
  width: 20%;
}
.userTable th.action {
  width: 7%;
}
.userTable td .viewOnly {
  display: none;
}
.userTable td .field .ui.selection.dropdown {
  min-width: auto;
  width: 100%;
}
.userTable td .field .ui.selection.dropdown .dropdown.icon {
  top: 5px;
  right: 5px;
}

.dg-menu.Container {
  background: #fff;
  position: absolute;
  left: auto !important;
  right: 20px;
  z-index: 2;
  width: 250px;
  padding: 20px;
  border-radius: 4px;
  border: solid 1px #99928a;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.05);
}

.message {
  display: block;
  width: 100%;
  max-width: 100%;
  position: fixed !important;
  right: 0;
  top: -16px;
  z-index: 9999999;
  border-radius: 0 !important;
  box-shadow: none !important;
  padding: 14px 30px 14px 10px !important;
  text-align: left;
}
.message .content p {
  font-size: 14px;
  color: #fff;
  font-weight: 500;
  opacity: 1;
}
.message i {
  opacity: 1 !important;
}
.message i::before {
  font-weight: normal;
  font-size: 0.9em;
  color: #fff;
}
.message.success {
  background: #34ab36 !important;
  color: #fff !important;
  border: 1px solid #34ab36 !important;
}
.message.error {
  background-color: #b13036 !important;
  color: #fff !important;
  border: 1px solid #b13036 !important;
}
.message.attention {
  color: #000 !important;
  border: 1px solid #fdc92f !important;
  background: #fdc92f !important;
}
@media (max-width: 767px) {
  .message {
    min-height: 60px;
    padding: 17px 20px;
  }
}

.sideMenuLeft {
  display: block;
  width: 290px;
  position: fixed;
  top: 140px;
  z-index: 1;
}
.sideMenuLeft .menuWrapper {
  margin-bottom: 2px;
}
.sideMenuLeft .menuWrapper .menuHeaderLabel {
  position: relative;
  font-size: 14px;
  color: #285482;
  background: #f1f1f1;
  padding: 4px 4px 4px 36px;
  margin-bottom: 0;
  cursor: pointer;
}
.sideMenuLeft .menuWrapper .menuHeaderLabel .icon {
  position: absolute;
  left: 5px;
  top: 4px;
}
.sideMenuLeft .menuWrapper .menuHeaderLabel .icon:before {
  font-size: 16px;
  color: #285482;
}
.sideMenuLeft .menuWrapper .menuHeaderLabel .icon.chevron.down,
.sideMenuLeft .menuWrapper .menuHeaderLabel .icon.chevron.up {
  position: absolute;
  left: auto;
  right: 0;
  top: 5px;
}
.sideMenuLeft .menuWrapper .menuHeaderLabel .icon.chevron.down:before,
.sideMenuLeft .menuWrapper .menuHeaderLabel .icon.chevron.up:before {
  color: #c8c8c8;
  font-size: 14px;
}
.sideMenuLeft .menuWrapper .menuHeaderLabel.active {
  background: #285482;
  color: #fff;
}
.sideMenuLeft .menuWrapper .menuHeaderLabel.active .icon:before {
  color: #fff;
}
.sideMenuLeft .menuWrapper .menuHeaderLabel.active .icon.chevron.down:before,
.sideMenuLeft .menuWrapper .menuHeaderLabel.active .icon.chevron.up:before {
  font-size: 14px;
  color: #fff;
}
.sideMenuLeft .menuWrapper .subMenu {
  background-color: rgb(236, 236, 236);
  padding: 14px 22px;
  position: relative;
}
.sideMenuLeft .menuWrapper .subMenu::before {
  display: block;
  content: " ";
  background-color: #c8c8c8;
  position: absolute;
  left: 26px;
  width: 2px;
  height: calc(100% - 42px);
  top: 22px;
}
.sideMenuLeft .menuWrapper .subMenu li {
  position: relative;
  font-size: 14px;
  color: #717575;
  padding-bottom: 5px;
  padding-left: 22px;
  cursor: pointer;
}
.sideMenuLeft .menuWrapper .subMenu li:last-child {
  padding-bottom: 0;
}
.sideMenuLeft .menuWrapper .subMenu li:before {
  display: inline-block;
  content: "•";
  position: absolute;
  left: 0;
  top: -1px;
  font-size: 28px;
  color: #717575;
}
.sideMenuLeft .menuWrapper .subMenu li.active, .sideMenuLeft .menuWrapper .subMenu li:active, .sideMenuLeft .menuWrapper .subMenu li:hover {
  color: #009ada;
  font-size: 15px;
}
.sideMenuLeft .menuWrapper .subMenu li.active:before, .sideMenuLeft .menuWrapper .subMenu li:active:before, .sideMenuLeft .menuWrapper .subMenu li:hover:before {
  color: #009ada;
}

.ui.inverted.popup {
  background: rgba(0, 0, 0, 0.8);
  padding: 6px 12px !important;
  z-index: 99999;
}
.ui.inverted.popup::before {
  background: rgba(41, 41, 41, 0.8) !important;
}
.ui.inverted.popup .content {
  font-size: 13px;
  color: #fff;
  text-align: center;
}
.ui.inverted.popup.leftAlignTolltip .content {
  text-align: left;
}

.ui.tabular.menu {
  border: none;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);
}
.ui.tabular.menu .item {
  font-size: 14px;
  color: #285482;
  background: #ececec;
  font-weight: 500;
  text-transform: uppercase;
  border: none;
}
.ui.tabular.menu .item.active {
  border-radius: 0;
  color: #009ada;
  margin-top: -10px;
}

.ui.segment[class*="bottom attached"] {
  border-radius: 0;
  border: none;
}

.tabWithBtn {
  position: relative;
}
.tabWithBtn .actionBtnWrap {
  position: absolute;
  right: 0;
  top: 10px;
  z-index: 2;
}

.ui.selection.dropdown.multiple {
  min-height: 30px !important;
  padding: 0 18px 0 5px !important;
  height: auto;
  max-width: 550px;
}
.ui.selection.dropdown.multiple > .text {
  font-size: 14px;
  color: #232f3a !important;
  padding-top: 6px !important;
  padding-left: 0 !important;
  top: 0;
  margin: 0;
}
.ui.selection.dropdown.multiple > .text.default {
  color: rgba(191, 191, 191, 0.87) !important;
}
.ui.selection.dropdown.multiple .menu {
  max-height: 130px;
}
.ui.selection.dropdown.multiple.search > .text {
  padding-left: 6px !important;
}
.ui.selection.dropdown.multiple.search input.search {
  height: 30px;
  padding-left: 0px !important;
  margin: 0 !important;
}
.ui.selection.dropdown.multiple > .label {
  margin: 1px 5px 2px 0;
  padding: 0 7px;
  font-size: 14px !important;
  display: inline-block !important;
  color: #232f3a !important;
  font-weight: normal;
  vertical-align: initial;
}
.ui.selection.dropdown.multiple > .label > .close.icon::before,
.ui.selection.dropdown.multiple > .label > .delete.icon::before {
  content: "✖";
  font-size: 12px;
  color: #686c6d !important;
}
.ui.selection.dropdown.multiple.active {
  border-bottom-left-radius: 4px !important;
  border-bottom-right-radius: 4px !important;
}

.ui.modal .ui.selection.dropdown.multiple {
  max-width: 100%;
}

.statusActive {
  display: inline-block;
  background: #009ada;
  -webkit-border-radius: 12.5px;
  -moz-border-radius: 12.5px;
  -ms-border-radius: 12.5px;
  -o-box-sizing: 12.5px;
  border-radius: 12.5px;
  font-size: 14px;
  line-height: 25px;
  text-align: center;
  color: #fff;
  padding: 0 14px;
}

.statusInactive {
  display: inline-block;
  background: #fdc92f;
  -webkit-border-radius: 12.5px;
  -moz-border-radius: 12.5px;
  -ms-border-radius: 12.5px;
  -o-box-sizing: 12.5px;
  border-radius: 12.5px;
  font-size: 14px;
  line-height: 25px;
  text-align: center;
  color: #fff;
  padding: 0 14px;
}

.rdw-editor-wrapper {
  border: 1px solid #c8c8c8;
  margin-bottom: 10px;
}
.rdw-editor-wrapper .rdw-editor-toolbar {
  margin-bottom: 0;
  border-bottom: 1px solid #c8c8c8;
}
.rdw-editor-wrapper .rdw-editor-main {
  background-color: #fff;
  min-height: 150px;
  max-height: 150px;
  border: 1px solid rgba(220, 220, 220, 0.5);
  border-bottom: 28px solid #f1f1f1;
}
.rdw-editor-wrapper .rdw-editor-main .public-DraftStyleDefault-block {
  margin: 0.5em 0.75em;
}
.rdw-editor-wrapper .rdw-emoji-wrapper {
  display: none !important;
}
.rdw-editor-wrapper .rdw-image-modal,
.rdw-editor-wrapper .rdw-link-modal,
.rdw-editor-wrapper .rdw-colorpicker-modal,
.rdw-editor-wrapper .rdw-embedded-modal {
  left: auto !important;
  right: 5px !important;
}

.fa-1:before {
  font-size: 1.4em;
}

@media (min-width: 800px) and (max-width: 1000px) {
  .floatRight .selection {
    min-width: 10em !important;
  }
}

.PagingOption {
  min-width: 10em !important;
}

.inputIconWrapper {
  position: relative;
}
.inputIconWrapper .input input {
  padding-right: 30px !important;
}
.inputIconWrapper .refeshIcon {
  position: absolute;
  right: 20px;
  top: 22px;
  z-index: 2;
  cursor: pointer;
}
.inputIconWrapper .refeshIcon i::before {
  font-size: 0.9em;
  color: #c8c8c8;
}
.inputIconWrapper .refeshIcon:hover i::before {
  color: #686c6d;
}

header {
  display: block;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 9999;
  background: #fff;
  padding: 10px 0;
  min-height: 88px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
}
header .logoWrap {
  float: left;
}
header .loggedUserWrap {
  float: right;
  margin-top: 20px;
  background: #fdc92f;
  padding: 6px 10px;
}
header .loggedUserWrap .ui.dropdown .menu {
  left: auto;
  right: -11px;
  top: 31px;
  width: 192px;
  box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.2);
  background-color: #fff;
  border-radius: 0;
}
header .loggedUserWrap .ui.dropdown .menu .item {
  padding: 5px 1.14285714rem !important;
}
header .loggedUserWrap .ui.dropdown .menu > .item:hover, header .loggedUserWrap .ui.dropdown .menu .selected.item, header .loggedUserWrap .ui.dropdown .menu .selected {
  background: #285482;
  color: #fff;
}
header .loggedUserWrap .ui.dropdown .menu > .item:hover .text, header .loggedUserWrap .ui.dropdown .menu .selected.item .text, header .loggedUserWrap .ui.dropdown .menu .selected .text {
  color: #fff;
}
header .loggedUserWrap .maxName {
  display: inline-block;
  vertical-align: bottom;
  width: 75px;
}

#root,
.appWrapper,
.App {
  height: 100%;
}

#root {
  height: 100%;
  overflow: auto;
}

.mainWrapperRight {
  display: block;
  width: calc(100% - 290px);
  float: right;
  padding-left: 32px;
}
.mainWrapperRight .headingTitle {
  position: relative;
  margin-bottom: 10px;
}
.mainWrapperRight .headingTitle h2 {
  float: left;
}
.mainWrapperRight .headingTitle h2 .recordCount {
  display: block;
  font-size: 14px;
  color: #009ada;
}
.mainWrapperRight .headingTitle .editBtn {
  float: right;
  margin-top: 7px;
}
.mainWrapperRight .headingTitle .editBtn i {
  line-height: inherit;
}
.mainWrapperRight .headingTitle .button {
  float: right;
  margin-top: 7px;
}
.mainWrapperRight .headingTitle .button i {
  line-height: inherit;
}
.mainWrapperRight .headingTitle .searchBx {
  width: 400px;
  position: absolute;
  right: 0;
  top: 40px;
  z-index: 99;
}
.mainWrapperRight .headingTitle .searchBx div {
  width: 100%;
  background-color: #fff;
}
.mainWrapperRight .headingTitle .searchBx div input {
  border-radius: 2px;
  padding: 0.42em 0.5em;
}
.mainWrapperRight .headingTitle .searchBx .ui.icon.input > i.circular.icon {
  top: 0.15em;
  right: 0.5em;
}
.mainWrapperRight .headingTitle .searchBx .results.visible {
  max-height: 300px;
  overflow: auto;
}
.mainWrapperRight .headingTitle .searchBx .results .message {
  border: 1px solid #99928a !important;
  position: static !important;
  padding: 10px !important;
}
.mainWrapperRight .headingTitle .searchBx .results .message .header {
  font-size: 14px;
  color: #232f3a;
}
.mainWrapperRight .headingTitle .searchBx .hiddenSearchIcon {
  display: inline-block;
  width: 30px;
  height: 30px;
  position: absolute;
  right: 5px;
  top: 0;
  opacity: 0;
  cursor: pointer;
}
.mainWrapperRight .headingTitle .selectDrop {
  display: inline-block;
  position: absolute;
  right: 410px;
  top: 40px;
  z-index: 99;
}
.mainWrapperRight .headingTitle .selectDrop .ui.selection.dropdown {
  min-width: 9em;
}
.mainWrapperRight .headingTitle .exportAction {
  display: block;
  float: right;
  min-width: 270px;
}
.mainWrapperRight .headingTitle .exportAction .label2 {
  padding-top: 12px;
}
.mainWrapperRight .headingTitle .lastLogin {
  position: absolute;
  right: 0;
  top: 0;
}
.mainWrapperRight.type2 {
  width: 100%;
  padding-left: 0;
}
.mainWrapperRight.bg {
  width: 100%;
  background: #fff;
  padding: 20px;
}

.commonLoader {
  display: none;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
  z-index: 9999;
}
.commonLoader .loaderWrap {
  position: absolute;
  left: 50%;
  top: 50%;
  border-radius: 14px;
  width: 104px;
  height: 116px;
  display: block;
  margin: -52px 0 0 -58px;
  text-align: center;
}
.commonLoader .loaderWrap img {
  display: block;
  margin: 8px auto;
  max-width: 100%;
  height: 60px;
  width: auto;
}
.commonLoader .loaderWrap span {
  display: block;
  font-size: 14px;
  color: #fff;
}

.loginPage {
  height: 100%;
}
.loginPage .loginWrap {
  display: block;
  width: 100%;
  max-width: 380px;
  margin: 0 auto;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  -ms-border-radius: 4px;
  -o-box-sizing: 4px;
  border-radius: 4px;
  position: relative;
  top: 50%;
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -khtml-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
}
.loginPage .loginWrap .loginCard {
  padding: 30px 40px 40px 40px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);
  background-color: rgb(255, 255, 255);
}
.loginPage .loginWrap .loginCard .field {
  margin: 0 0 10px 0;
}
.loginPage .loginWrap .loginCard .field .field.error {
  margin: 0 0 0 0;
}
.loginPage .loginWrap .titleHead {
  font-size: 33px;
  line-height: 40px;
  text-align: center;
  margin-bottom: 30px;
}
.loginPage .loginWrap .logo {
  display: block;
  height: 85px;
  width: auto;
  margin: 0 auto 60px auto;
}
.loginPage .loginWrap .actionBtnWrap {
  text-align: center;
  padding-top: 20px;
}

.privligeWrap figure {
  display: block;
  background: #fff;
  padding: 10px 20px;
  margin: 0;
}
.privligeWrap figure img.ui.image {
  display: inline-block;
  height: 65px;
}

.validateAD {
  position: relative;
}
.validateAD .searchBx {
  height: 32px;
  width: 100%;
}
.validateAD .editBtn {
  position: absolute;
  right: 5px;
  top: 1px;
  z-index: 1;
}

.userRelatedInfo {
  margin: 20px 0;
  border-top: dashed 1px #ccc;
  border-bottom: dashed 1px #ccc;
}

.titleLabel {
  display: block;
  font-size: 14px;
  color: #99928a;
}

.titleInfo {
  display: inline-block;
  font-size: 16px;
  color: #232f3a;
  word-break: break-word;
}

.viewModeFix ol {
  list-style-position: inside;
  margin-left: 20px;
}
.viewModeFix ol li {
  font-size: 16px;
  color: #232f3a;
}
.viewModeFix ul {
  list-style-position: inside;
  margin-left: 40px;
}
.viewModeFix ul li {
  list-style-type: disc;
  font-size: 16px;
  color: #232f3a;
}
.viewModeFix .titleInfo {
  margin-top: 5px;
}
.viewModeFix .titleInfo p {
  margin-bottom: 0;
}
.viewModeFix .titleInfo sup {
  margin-top: 15px;
  display: inline-block;
}
.viewModeFix .titleInfo sub {
  margin-bottom: 15px;
  display: inline-block;
}
.viewModeFix .titleInfo em {
  font-style: italic;
}

.colorBoxActive {
  display: inline-block;
  width: 16px;
  height: 16px;
  background: #653294;
  vertical-align: middle;
}

.selectedColor {
  position: relative;
  width: 100%;
  min-height: 33px;
  border-radius: 0.28571429rem;
  background-color: rgb(255, 255, 255);
  box-shadow: inset 1px apx apx #ccc;
  border: 1px solid rgba(34, 36, 38, 0.15);
  color: rgba(0, 0, 0, 0.87);
  cursor: pointer;
  padding: 0 10px;
}
.selectedColor .dropdown.icon {
  top: 6px;
  right: 6px;
  position: absolute;
  width: auto;
  height: auto;
  line-height: 1.21428571em;
  opacity: 0.4;
}
.selectedColor .dropdown.icon:before {
  content: "\\f078" !important;
  font-size: 1em;
}
.selectedColor .colorNameActive {
  display: inline-block;
  vertical-align: -3px;
  font-size: 14px;
  color: #232f3a;
  padding-left: 10px;
  height: 16px;
}

.customColorChooser {
  position: relative;
  z-index: 2;
}
.customColorChooser .allColors {
  width: 100%;
  min-height: 120px;
}
.customColorChooser .allColors .defaultColor {
  display: inline-grid;
  grid-template-columns: auto auto auto auto auto auto auto;
  grid-column-gap: 0;
  grid-row-gap: 0;
  width: 100%;
  margin-bottom: 10px;
  margin-left: 2px;
  max-height: 136px;
  overflow: auto;
}
.customColorChooser .allColors .defaultColor:last-child {
  margin-bottom: 0;
}
.customColorChooser .allColors .defaultColor .commonToolTip {
  margin: 2px 14px;
}
.customColorChooser .allColors .defaultColor .commonToolTip:nth-child(7n+7) {
  margin-right: 0;
  padding-right: 0;
}
.customColorChooser .allColors .defaultColor .commonToolTip:nth-child(7n+1) {
  margin-left: 0;
  padding-left: 0;
}
.customColorChooser .allColors .defaultColor .colorDV {
  display: inline-block;
  width: 26px;
  height: 26px;
  cursor: pointer;
}
.customColorChooser .allColors .defaultColor .colorDV.addColor {
  background: #fff;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
  font-size: 20px;
  line-height: 26px;
  text-align: center;
  color: #686c6d;
  font-weight: 700;
}
.customColorChooser .allColors .defaultColor .colorDV.used::before {
  display: inline-block;
  width: 26px;
  height: 26px;
  content: "✕";
  font-size: 26px;
  line-height: 28px;
  text-align: center;
  color: #fff;
  opacity: 0.4;
}
.customColorChooser .allColors .defaultColor .colorDV.active::before {
  display: inline-block;
  width: 26px;
  height: 26px;
  content: "\\f00c";
  font-family: Icons;
  font-size: 12px;
  line-height: 26px;
  text-align: center;
  color: #fff;
}

.addNewColor > div {
  width: 80%;
  display: inline-block;
}

.checkBoxWrapper .ui.grid > .row > .column {
  margin-top: 0.7rem;
  margin-bottom: 0.5rem;
}

.slider-picker {
  display: block;
  position: relative;
  width: 100%;
}

.statusIndicator {
  display: inline-block;
  background: #99928a;
  font-size: 16px;
  line-height: 25px;
  text-align: center;
  color: #fff;
  padding: 0 10px;
  border-radius: 15px;
}
.statusIndicator.active {
  background: #009ada;
}
.statusIndicator.inactive {
  background: #fdc92f;
}

.permissionIndicator.full::before {
  color: #34ab36;
}
.permissionIndicator.partial::before {
  color: #fdc92f;
}
.permissionIndicator.none::before {
  color: #b13036;
}

.contentWrapper.type2 {
  margin-top: 80px;
}

.chBoxLegend {
  position: absolute;
  right: 0;
  top: 85px;
}
.chBoxLegend ul {
  margin: 0;
  padding: 0;
}
.chBoxLegend ul li {
  display: inline-block;
}
.chBoxLegend ul li .ui.checkbox {
  vertical-align: middle;
  margin: 0 12px 0 20px;
}
.chBoxLegend ul li span {
  vertical-align: middle;
}

.helper, .manageRoleWrap .ui.cards {
  width: 100%;
  border-radius: 2px;
  box-shadow: none;
  background-color: transparent;
  margin: 0 !important;
}
.helper .roleCard, .manageRoleWrap .ui.cards .roleCard {
  position: relative;
  padding: 20px 20px 0 20px;
  height: 100%;
  border-top: 4px solid #009ada !important;
}
.helper .roleCard.inactive, .manageRoleWrap .ui.cards .roleCard.inactive {
  border-top: 4px solid #fdc92f !important;
}
.helper .roleCard .roleStatus, .manageRoleWrap .ui.cards .roleCard .roleStatus {
  margin: 0 0 20px 0;
}
.helper .roleCard .roleStatus .positionMumber, .manageRoleWrap .ui.cards .roleCard .roleStatus .positionMumber {
  display: inline-block;
  width: 24px;
  height: 24px;
  background: #c8c8c8;
  border-radius: 50%;
  font-family: "ProximaNovaBold";
  font-size: 14px;
  color: #fff;
  line-height: 26px;
  text-align: center;
  vertical-align: top;
}
.helper .roleCard .roleStatus i, .manageRoleWrap .ui.cards .roleCard .roleStatus i {
  margin-left: 10px;
  cursor: pointer;
}
.helper .roleCard .roleStatus i::before, .manageRoleWrap .ui.cards .roleCard .roleStatus i::before {
  font-size: 1em;
  color: #c8c8c8;
}
.helper .roleCard .roleStatus i:hover::before, .manageRoleWrap .ui.cards .roleCard .roleStatus i:hover::before {
  color: #285482;
}
.helper .roleCard .roleStatus .descHead, .manageRoleWrap .ui.cards .roleCard .roleStatus .descHead {
  font-size: 16px;
  color: #232f3a;
  font-family: "ProximaNovaBold";
}
.helper .roleCard .officerSubInfo, .manageRoleWrap .ui.cards .roleCard .officerSubInfo {
  margin-bottom: 20px;
}
.helper .roleCard .officerSubInfo span, .manageRoleWrap .ui.cards .roleCard .officerSubInfo span {
  font-size: 14px;
  color: #686c6d;
}
.helper .roleCard .privileges .privelegeHead, .manageRoleWrap .ui.cards .roleCard .privileges .privelegeHead {
  display: block;
  font-size: 12px;
  color: #c8c8c8;
  font-family: "ProximaNovaBold";
  text-transform: uppercase;
  margin-bottom: 10px;
}
.helper .roleCard .privileges ul, .manageRoleWrap .ui.cards .roleCard .privileges ul {
  margin: 0 -20px;
  min-height: 130px;
  max-height: 180px;
  overflow: auto;
}
.helper .roleCard .privileges ul li, .manageRoleWrap .ui.cards .roleCard .privileges ul li {
  padding: 9px 10px 7px 15px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.helper .roleCard .privileges ul li .ui.checkbox.partial .box:before, .manageRoleWrap .ui.cards .roleCard .privileges ul li .ui.checkbox.partial .box:before,
.helper .roleCard .privileges ul li .ui.checkbox.partial label:before,
.manageRoleWrap .ui.cards .roleCard .privileges ul li .ui.checkbox.partial label:before {
  background: #686c6d;
}
.helper .roleCard .privileges ul li .ui.checkbox, .manageRoleWrap .ui.cards .roleCard .privileges ul li .ui.checkbox {
  vertical-align: middle;
}
.helper .roleCard .privileges ul li .privelegeName, .manageRoleWrap .ui.cards .roleCard .privileges ul li .privelegeName {
  display: inline-block;
  font-size: 16px;
  color: #232f3a;
  vertical-align: text-top;
  margin-left: 10px;
  width: calc(100% - 30px);
}
.helper .roleCard .privileges ul li:hover, .manageRoleWrap .ui.cards .roleCard .privileges ul li:hover, .helper .roleCard .privileges ul li:active, .manageRoleWrap .ui.cards .roleCard .privileges ul li:active {
  background: #f7f8fa;
}
.helper .roleCard .privileges ul li:last-child, .manageRoleWrap .ui.cards .roleCard .privileges ul li:last-child {
  border-bottom: none;
}

.manageRoleWrap {
  margin: 0 -10px;
  position: relative;
  max-height: calc(100vh - 290px);
  overflow: auto;
}
.manageRoleWrap .ui.cards.waterMark {
  position: absolute;
  top: 0;
}
.manageRoleWrap .ui.cards.waterMark .ui.card {
  position: relative;
  background: #f7f8fa;
}
.manageRoleWrap .ui.cards.waterMark .ui.card .bookmarkNum {
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  font-size: 8em;
  line-height: 290px;
  color: #ccc;
  text-align: center;
}
.manageRoleWrap .ui.cards.waterMark .ui.card .roleCard {
  border-top: 4px solid transparent !important;
  visibility: hidden;
}

.helper {
  z-index: 999;
}

.privListTooltip {
  padding: 20px;
  width: 600px;
  background: #fff;
  box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.2);
}
.privListTooltip .ui.grid > .column:not(.row) {
  padding-top: 0.5em !important;
  padding-bottom: 0.5em !important;
}
.privListTooltip .privActionList {
  border-bottom: dashed 1px #686c6d;
}
.privListTooltip .privActionList .ui.fitted.checkbox {
  display: inline-block;
  width: 26px;
  vertical-align: sub;
}
.privListTooltip .privActionList .ui.checkbox.partial .box:before,
.privListTooltip .privActionList .ui.checkbox.partial label:before {
  background: #686c6d;
}
.privListTooltip .privActionList .permsnName {
  display: inline-block;
  width: calc(100% - 26px);
  vertical-align: top;
  font-size: 14px;
  color: #232f3a;
}
.privListTooltip .privActionList.noBottBorder {
  border-bottom: none;
}
.privListTooltip .privGrroupname {
  font-size: 16px;
  color: #686c6d;
  font-family: "ProximaNovaBold";
  margin-top: 20px;
  margin-bottom: 20px;
}
.privListTooltip .privGrroupname:first-child {
  margin-top: 0;
}

.ui.modal.addOfficerModal .accordHead {
  display: block;
  font-size: 16px;
  text-transform: uppercase;
  padding-top: 10px;
  padding-left: 12px;
  margin-bottom: 10px;
}
.ui.modal.addOfficerModal .accordion {
  padding: 0 10px;
}
.ui.modal.addOfficerModal .accordion .content {
  background: #f7f8fa;
}
.ui.modal.addOfficerModal .accordion .content .commonTitle {
  font-family: "ProximaNovaBold";
  font-size: 16px;
  color: #686c6d;
  margin-bottom: 0;
}
.ui.modal.addOfficerModal .accordion .content .commonTitle + .checkBoxWrapper {
  border-bottom: dashed 1px #8d939a;
  margin-bottom: 20px;
}
.ui.modal.addOfficerModal .accordion .content .commonTitle + .checkBoxWrapper:last-child {
  border-bottom: none;
  margin-bottom: 0;
}
.ui.modal.addOfficerModal .accordion .content .commonTitle + .checkBoxWrapper .ui.grid {
  margin-top: 0;
}
.ui.modal.addOfficerModal .accordion .content .privActionList .ui.fitted.checkbox {
  display: inline-block;
  width: 26px;
  vertical-align: sub;
}
.ui.modal.addOfficerModal .accordion .content .privActionList .permsnName {
  display: inline-block;
  width: calc(100% - 26px);
  font-size: 14px;
  color: #232f3a;
  vertical-align: inherit;
}

.comApplyRemove {
  position: relative;
  border: 1px solid rgba(220, 220, 220, 0.5);
  padding: 10px;
  background: #f7f8fa;
}
.comApplyRemove .tableWrapper {
  width: calc(100% - 40px);
  margin-top: 0;
  overflow-x: initial;
  overflow-y: initial;
}
.comApplyRemove .tableWrapper td {
  vertical-align: top;
}
.comApplyRemove .tableWrapper td button {
  display: inline-block;
  margin-top: 22px;
}
.comApplyRemove .tableWrapper td button i.icon {
  width: 1.8em;
  height: 1.8em;
  line-height: 1.8em;
}
.comApplyRemove .tableWrapper td button i.icon::before {
  font-size: 1em;
}
.comApplyRemove .deletAction {
  position: absolute;
  right: 10px;
  bottom: 34px;
  z-index: 1;
  cursor: pointer;
}

.react-grid-item {
  border: 2px solid #000;
}

.react-grid-layout {
  position: relative;
  transition: height 200ms ease;
}

.react-grid-item {
  transition: all 200ms ease;
  transition-property: left, top;
}

.react-grid-item.cssTransforms {
  transition-property: transform;
}

.react-grid-item.resizing {
  z-index: 1;
  will-change: width, height;
}

.react-grid-item.react-draggable-dragging {
  transition: none;
  z-index: 3;
  will-change: transform;
}

.react-grid-item.react-grid-placeholder {
  background: red;
  opacity: 0.2;
  transition-duration: 100ms;
  z-index: 2;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
}

.react-grid-item > .react-resizable-handle {
  position: absolute;
  width: 20px;
  height: 20px;
  bottom: 0;
  right: 0;
  cursor: se-resize;
}

.react-grid-item > .react-resizable-handle::after {
  content: "";
  position: absolute;
  right: 3px;
  bottom: 3px;
  width: 5px;
  height: 5px;
  border-right: 2px solid rgba(0, 0, 0, 0.4);
  border-bottom: 2px solid rgba(0, 0, 0, 0.4);
}

.addCommitteeWrap {
  padding: 5px 10px;
  background: #fff;
}
.addCommitteeWrap h5 {
  border-top: dashed 1px #ccc;
  padding-top: 10px;
  margin-top: 10px;
}
.addCommitteeWrap .labelList li {
  background: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.02);
  padding: 9px;
  margin-bottom: 10px;
}
.addCommitteeWrap .labelList li .comitteName {
  font-size: 14px;
  color: #232f3a;
}
.addCommitteeWrap .labelList li .eligibleFields {
  display: inline-block;
  float: right;
  font-size: 14px;
  color: #009ada;
  margin-right: 20px;
  margin-top: 3px;
  cursor: pointer;
}
.addCommitteeWrap .labelList li .closeIcon {
  float: right;
  cursor: pointer;
}
.addCommitteeWrap .labelList li .closeIcon .icon::before {
  font-weight: 400;
  color: #99928a;
}
.addCommitteeWrap .addNewLabel .specify {
  display: inline-block;
  width: calc(100% - 40px);
}
.addCommitteeWrap .addNewLabel .addAction {
  float: right;
  display: inline-block;
  width: 40px;
  text-align: right;
  margin-top: 5px;
}
.addCommitteeWrap .memClassType {
  display: block;
  float: left;
  width: 33%;
}
.addCommitteeWrap .memClassType .memClassTypeTitle {
  display: block;
  font-size: 14px;
  color: #232f3a;
  margin-bottom: 5px;
}
.addCommitteeWrap .memClassType .memClassTypeList {
  display: block;
  background: #fff;
  padding: 20px;
  border-radius: 2px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.02);
  max-height: 320px;
  overflow-y: auto;
}
.addCommitteeWrap .memClassType .memClassTypeList li {
  font-size: 14px;
  color: #232f3a;
  margin: 5px 0;
}
.addCommitteeWrap .memClassType .memClassTypeList li .checkbox {
  margin-right: 10px;
  vertical-align: bottom;
}
.addCommitteeWrap .operator {
  display: block;
  width: 30%;
  float: left;
  margin: 0 2%;
}
.addCommitteeWrap .sc-ifAKCX {
  position: relative;
  margin-top: 10px;
}
.addCommitteeWrap .sc-ifAKCX .KYUqY {
  max-height: 320px;
  overflow-y: auto;
}
.addCommitteeWrap .sc-ifAKCX .bpKHpE {
  background-color: #f7f8fa;
  padding: 15px;
  min-height: auto !important;
}
.addCommitteeWrap .sc-ifAKCX .bpKHpE .gmcSqE {
  border: none;
  font-size: 16px;
  color: #232f3a;
  padding: 8px 20px;
}
.addCommitteeWrap .sc-ifAKCX .bpKHpE .iQCjkp {
  font-size: 16px;
  color: #232f3a;
  padding: 8px 20px;
}
.addCommitteeWrap .sc-ifAKCX h3 {
  font-size: 14px;
  color: #232f3a;
  position: absolute;
  top: -20px;
  margin-left: -8px;
}
.addCommitteeWrap .comitteeAccord .chbx {
  display: inline-block;
  margin-right: 10px;
}
.addCommitteeWrap .comitteeAccord .chbx > label {
  display: inline-block;
}
.addCommitteeWrap .comitteeAccord .checkBoxWrapper .checkbox {
  vertical-align: middle;
  margin-right: 10px;
}
.addCommitteeWrap .comitteeAccord .checkBoxWrapper label {
  font-size: 14px;
}
.addCommitteeWrap .column .committee-droparea {
  height: 100%;
}
.addCommitteeWrap .column .committee-droparea > div {
  height: 100%;
}

.greyBox {
  display: block;
  padding: 20px;
  border: solid 1px #ccc;
  background-color: #f7f8fa;
  max-height: 320px;
  overflow-y: auto;
}
.greyBox.type2 {
  max-height: none;
  overflow-y: inherit;
}

.borderDashed {
  display: block;
  width: 100%;
  border-top: dashed 1px #ccc;
  padding-top: 10px;
  margin-top: 10px;
}

.levelPills {
  display: inline-block;
  background: rgb(236, 236, 236);
  padding: 3px 8px 2px 8px;
  font-size: 14px;
  color: #232f3a;
  text-align: center;
  margin-right: 10px;
  margin-bottom: 10px;
}
.levelPills .icon {
  display: inline-block;
  margin-left: 10px;
  cursor: pointer;
}
.levelPills .icon::before {
  font-size: 0.9em;
  color: #009ada;
}

.manageFields {
  width: 436px;
  padding: 20px !important;
  border: none !important;
  box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.2) !important;
  border-radius: 0 !important;
}
.manageFields .privGrroupname {
  font-size: 16px;
  color: #686c6d;
  font-family: "ProximaNovaBold";
  margin-bottom: 15px;
}
.manageFields .ui.checkbox .box,
.manageFields .ui.checkbox label {
  font-size: 14px;
  padding-left: 1.5em;
}

.dashed-Border {
  display: block;
  width: 100%;
  border-top: dashed 1px #ccc;
  padding-top: 20px;
  margin-top: 20px;
}

.unAuthorizeDv {
  padding: 150px 0 50px 0;
  text-align: center;
}
.unAuthorizeDv .dontSign {
  display: block;
  margin-bottom: 30px;
}
.unAuthorizeDv .dontSign i {
  text-align: center;
  display: initial;
}
.unAuthorizeDv .dontSign i::before {
  font-size: 3.7em;
  color: #c8c8c8;
}
.unAuthorizeDv .permissionHead {
  display: block;
  font-size: 20px;
  color: #686c6d;
}
.unAuthorizeDv .permissionSub {
  font-size: 16px;
  color: #686c6d;
}`, "",{"version":3,"sources":["webpack://./src/components/themes/main.scss","webpack://./src/components/themes/base/_reset.scss","webpack://./src/components/themes/base/_colors.scss","webpack://./src/components/themes/base/_typography.scss","webpack://./src/components/themes/base/_common.scss","webpack://./src/components/themes/base/_mixins.scss","webpack://./src/components/themes/vendors/_fontall.scss","webpack://./src/components/themes/components/_accordian.scss","webpack://./src/components/themes/components/_buttons.scss","webpack://./src/components/themes/components/_pagination.scss","webpack://./src/components/themes/components/_forms.scss","webpack://./src/components/themes/components/_popup.scss","webpack://./src/components/themes/components/_breadcrumb.scss","webpack://./src/components/themes/components/_table.scss","webpack://./src/components/themes/components/_toast.scss","webpack://./src/components/themes/components/_menu.scss","webpack://./src/components/themes/components/_tooltip.scss","webpack://./src/components/themes/components/_tab.scss","webpack://./src/components/themes/components/_multiselect.scss","webpack://./src/components/themes/helpers/_helper.scss","webpack://./src/components/themes/layout/_header.scss","webpack://./src/components/themes/layout/_template.scss","webpack://./src/components/themes/pages/_login.scss","webpack://./src/components/themes/pages/_home.scss","webpack://./src/components/themes/pages/_officertitle.scss","webpack://./src/components/themes/pages/_comittee.scss","webpack://./src/components/themes/pages/_notFound.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB,gBAAA;AAEA,kFAAA;AAEA;EACI,iCAAA;EACA,qHAAA;EAEA,mBAAA;EACA,kBAAA;ADDJ;ACIA;EACI,8BAAA;EACA,4DAAA;EACA,mBAAA;EACA,kBAAA;ADFJ;ACMA;;;EAGI,8BAAA;EACA,2BAAA;EACA,sBAAA;EACA,aAAA;EACA,+CAAA;EACA,SAAA;EACA,UAAA;EACA,8BAAA;EACA,2BAAA;EACA,0BAAA;EACA,8BAAA;EACA,iCAAA;EACA,eAAA;EACA,cC7BK;ED8BL,6CAAA;EACA,mBAAA;EACA,qBAAA;ADJJ;;ACOA;;;;;;;;;;;;;EAaI,mCAAA;EACA,kCAAA;EACA,8BAAA;EACA,2BAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,6CAAA;ADJJ;;ACOA;;EAEI,8BAAA;EACA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,WCtEG;EDuEH,mBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,mBClEK;EDmEL,6CAAA;ADJJ;;ACOA;EACI,cAAA;EACA,cAAA;EACA,eAAA;ADJJ;;ACOA;EACI,SAAA;EACA,UAAA;EACA,gBAAA;ADJJ;ACMI;EACI,gBAAA;ADJR;;ACQA;EACI,eAAA;EACA,WAAA;ADLJ;ACOI;EAJJ;IAKQ,WAAA;IACA,eAAA;EDJN;AACF;;ACOA;EACI,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;ADJJ;ACMI;EACI,cAAA;EACA,iBAAA;EACA,mBAAA;ADJR;;ACQA;EACI,2BAAA;ADLJ;;ACQA;EACI,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,qBAAA;ADLJ;;ACQA;EACI,qBAAA;ADLJ;;ACQA;EACI,WAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;ADLJ;;ACQA;GACI,OAAA;ADLJ;;ACQA;;EAEI,WAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;ADLJ;;ACoBA;EACI,mBAAA;EACA,UAAA;EACA,SAAA;ADjBJ;;ACoBA;;EAEI,aAAA;ADjBJ;;ACoBA;EACI,UAAA;EACA,WAAA;ADjBJ;;ACoBA;EACI,oDAAA;EACA,kBAAA;ADjBJ;;ACoBA;EACI,kBAAA;EACA,oDAAA;ADjBJ;;ACoBA;EACI,kBAAA;ADjBJ;;ACoBA;EACI,0BAAA;ADjBJ;ACmBI;EACI,0BAAA;ADjBR;;ACqBA;EACI,YAAA;EACA,gBChLY;AF8JhB;;ACqBA;EACI,cAAA;EACA,YAAA;EACA,gBCtLY;EDuLZ,cAAA;ADlBJ;;ACqBA;EACI,yBCpNK;AFkMT;ACoBI;EACI,sBAAA;EACA,gBAAA;ADlBR;;AG9MA;EACI,iCAAA;EACA,iBAAA;EACA,kBAAA;EACA,cDGK;ECFL,mBAAA;AHiNJ;;AG9MA;EACI,iCAAA;EACA,iBAAA;EACA,kBAAA;EACA,cDLK;ECML,mBAAA;AHiNJ;;AG9MA;EACI,iCAAA;EACA,iBAAA;EACA,kBAAA;EACA,cDbK;ECcL,mBAAA;AHiNJ;;AG9MA;EACI,iCAAA;EACA,iBAAA;EACA,kBAAA;EACA,cDrBK;ECsBL,mBAAA;AHiNJ;;AG9MA;EACI,iCAAA;EACA,iBAAA;EACA,kBAAA;EACA,cD7BK;EC8BL,mBAAA;AHiNJ;;AG9MA;EACI,iCAAA;EACA,iBAAA;EACA,kBAAA;EACA,cDrCK;ECsCL,mBAAA;AHiNJ;;AG9MA;;;EAGI,iCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cDjDK;ECkDL,oBAAA;AHiNJ;;AG7MA;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cD3DK;EC4DL,qBAAA;AHgNJ;;AInRA,iBAAA;AAEA;EACI,qBAAA;EACA,kBAAA;AJqRJ;AInRI;EACI,cAAA;EACA,mBAAA;AJqRR;AInRQ;EACI,kBAAA;EACA,gBAAA;AJqRZ;AInRY;EACI,gBAAA;EACA,cFNN;AF2RV;;AI/QA;EACI,sBAAA;AJkRJ;;AI/QA;EACI,uBAAA;AJkRJ;;AI/QA;EACI,sBAAA;AJkRJ;;AI/QA;EACI,6BAAA;AJkRJ;;AI/QA;EACI,gBAAA;AJkRJ;;AI/QA;EACI,iBAAA;AJkRJ;;AI/QA;EACI,mBAAA;AJkRJ;;AI/QA;EACI,mBAAA;AJkRJ;;AI/QA;EACI,oCAAA;AJkRJ;;AI/QA;EACI,oCAAA;AJkRJ;;AI/QA;EACI,qCAAA;AJkRJ;;AI/QA;EACI,+BAAA;AJkRJ;;AI/QA;EACI,kBAAA;AJkRJ;;AI/QA;EACI,uBAAA;EACA,gBAAA;AJkRJ;;AI/QA;EACI,mBAAA;EACA,gBAAA;EACA,uBAAA;AJkRJ;;AI/QA;EACI,qBAAA;AJkRJ;;AI/QA;EACI,6BAAA;AJkRJ;;AI/QA;EACI,2BAAA;AJkRJ;;AI/QA;EACI,2BAAA;AJkRJ;;AI/QA;EACI,uBAAA;AJkRJ;;AI/QA;EACI,8BAAA;AJkRJ;;AI/QA;EACI,6BAAA;AJkRJ;;AI/QA;EACI,+BAAA;AJkRJ;;AI/QA;EACI,gCAAA;AJkRJ;;AI9QA;EACI,cAAA;EACA,kBAAA;EACA,iBAAA;AJiRJ;;AI9QA;EACI,wBAAA;AJiRJ;;AI9QA;EACI,yBAAA;AJiRJ;;AI9QA;EACI,kBAAA;AJiRJ;;AI9QA;EACI,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,SAAA;AJiRJ;;AI7QA;EACI,4BAAA;EACA,6BAAA;AJgRJ;;AI7QA;EACI,yBAAA;AJgRJ;;AI7QA;EACI,2BAAA;AJgRJ;;AI7QA;EACI,4BAAA;AJgRJ;;AI7QA;EACI,kBAAA;EACA,6BAAA;EACA,+BAAA;AJgRJ;;AI7QA;EACI,+BAAA;AJgRJ;;AI7QA;EACI,4BAAA;AJgRJ;;AI7QA;EACI,+BAAA;AJgRJ;;AI7QA;EACI,6BAAA;AJgRJ;;AI7QA;EACI,oBAAA;AJgRJ;;AI7QA;EACI,wBAAA;AJgRJ;;AI7QA;EACI,0BAAA;AJgRJ;;AI7QA;EACI,2BAAA;AJgRJ;;AI7QA;EACI,2BAAA;AJgRJ;;AI7QA;EACI,2BAAA;AJgRJ;;AI7QA;EACI,4BAAA;AJgRJ;;AI7QA;EACI,2BAAA;AJgRJ;;AI7QA;EACI,6BAAA;AJgRJ;;AI7QA;EACI,8BAAA;AJgRJ;;AI7QA;EACI,8BAAA;AJgRJ;;AI7QA;EACI,8BAAA;AJgRJ;;AI7QA;EACI,4BAAA;AJgRJ;;AI7QA;EACI,6BAAA;AJgRJ;;AI7QA;EACI,6BAAA;AJgRJ;;AI7QA;EACI,6BAAA;AJgRJ;;AI7QA;EACI,2BAAA;AJgRJ;;AI7QA;EACI,4BAAA;AJgRJ;;AI7QA;EACI,4BAAA;AJgRJ;;AI7QA;EACI,4BAAA;AJgRJ;;AI7QA;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;AJgRJ;;AI7QA;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AJgRJ;;AI7QA;EACI,gBAAA;EACA,iBAAA;AJgRJ;;AI7QA;EACI,0BAAA;AJgRJ;;AI7QA;EACI,0BAAA;AJgRJ;;AI7QA;EACI,cAAA;EACA,mBFvRM;EEwRN,eAAA;EACA,WF3SI;EE4SJ,kBAAA;EACA,aAAA;EACA,yBAAA;AJgRJ;;AI7QA;EACI,gCAAA;AJgRJ;;AI7QA;EACI,0BAAA;AJgRJ;;AI7QA;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBF9TG;EE+TH,sBAAA;EC7ID,0BD8IwB;EC7ItB,uBD6IsB;EC5IrB,sBD4IqB;EC3ItB,kBD2IsB;EC1IjB,kBD0IiB;AJoR3B;;AIjRA;EACI,sBAAA;AJoRJ;;AIjRA;EACI,eAAA;EACA,cFnUK;EEoUL,iBAAA;AJoRJ;;AIjRA;EACI,4BAAA;AJoRJ;;AIjRA;EACI,0BAAA;AJoRJ;;AIjRA;EACI,8BAAA;AJoRJ;;AIjRA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,kCAAA;EACA,yBAAA;AJoRJ;AIlRI;EACI,wBAAA;AJoRR;;AI/QA;EACI,cAAA;EACA,WAAA;EACA,eAAA;EACA,cFlWO;EEmWP,qBAAA;EACA,kBAAA;AJkRJ;;AI9QA;EACI,WAAA;EACA,oBAAA;EACA,qBAAA;EACA,gBAAA;AJiRJ;;AI9QA;EACI,WAAA;EACA,oBAAA;EACA,qBAAA;EACA,gBAAA;AJiRJ;;AI9QA;EACI,WAAA;EACA,oBAAA;EACA,qBAAA;EACA,gBAAA;AJiRJ;;AI7QI;EACI,oCAAA;EACA,8BAAA;EACA,cAAA;AJgRR;;AI5QA;EACI,yBAAA;AJ+QJ;;AI5QA;EACI,cAAA;EACA,iBAAA;EACA,eAAA;EACA,cFtYM;AFqpBV;;AMzqBA;;;EAAA;AAKA;;;;;EAKI,kCAAA;EACA,mCAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;AN2qBJ;;AMxqBA;EACI,oBAAA;EACA,mBAAA;EACA,yBAAA;AN2qBJ;;AMxqBA;EACI,iBAAA;AN2qBJ;AM1qBI;EACI,iBAAA;AN4qBR;;AMxqBA;EACI,kBAAA;AN2qBJ;AM1qBI;EACI,kBAAA;AN4qBR;;AMxqBA;EACI,cAAA;AN2qBJ;AM1qBI;EACI,cAAA;AN4qBR;;AMzqBA;EACI,iBAAA;AN4qBJ;AM3qBI;EACI,iBAAA;AN6qBR;;AMzqBA;EACI,cAAA;AN4qBJ;AM3qBI;EACI,cAAA;AN6qBR;;AMzqBA;EACI,cAAA;AN4qBJ;AM3qBI;EACI,cAAA;AN6qBR;;AMzqBA;EACI,cAAA;AN4qBJ;AM3qBI;EACI,cAAA;AN6qBR;;AMzqBA;EACI,cAAA;AN4qBJ;AM3qBI;EACI,cAAA;AN6qBR;;AMzqBA;EACI,cAAA;AN4qBJ;;AMzqBA;EACI,cAAA;AN4qBJ;;AMzqBA;EACI,cAAA;AN4qBJ;;AMzqBA;EACI,cAAA;AN4qBJ;;AMzqBA;EACI,eAAA;AN4qBJ;;AMzqBA;EACI,kBAAA;EACA,aAAA;AN4qBJ;;AMzqBA;EACI,qBAAA;EACA,kBAAA;EACA,eAAA;AN4qBJ;;AMzqBA;EACI,kBAAA;AN4qBJ;;AMzqBA;EACI,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;AN4qBJ;;AMzqBA;EACI,yBAAA;EACA,oBAAA;EACA,4BAAA;AN4qBJ;;AMzqBA;EACI,WAAA;AN4qBJ;;AMzqBA;EACI,YAAA;AN4qBJ;;AMzqBA;;;;;EAKI,mBAAA;AN4qBJ;;AMzqBA;;;;;EAKI,kBAAA;AN4qBJ;;AMzqBA;EACI,uCAAA;EACA,+BAAA;AN4qBJ;;AMzqBA;EACI,yCAAA;EACA,iCAAA;AN4qBJ;;AMzqBA;EACI;IACI,+BAAA;IACA,uBAAA;EN4qBN;EM1qBE;IACI,gCAAA;IACA,wBAAA;EN4qBN;AACF;AMzqBA;EACI;IACI,+BAAA;IACA,uBAAA;EN2qBN;EMzqBE;IACI,gCAAA;IACA,wBAAA;EN2qBN;AACF;AMxqBA;EACI,sEAAA;EACA,gCAAA;EACA,wBAAA;AN0qBJ;;AMvqBA;EACI,sEAAA;EACA,iCAAA;EACA,yBAAA;AN0qBJ;;AMvqBA;EACI,sEAAA;EACA,iCAAA;EACA,yBAAA;AN0qBJ;;AMvqBA;EACI,gFAAA;EACA,6BAAA;EACA,qBAAA;AN0qBJ;;AMvqBA;EACI,6BAAA;EACA,qBAAA;AN0qBJ;;AMvqBA;;EAEI,gFAAA;AN0qBJ;;AMvqBA;EACI,4BAAA;EACA,oBAAA;AN0qBJ;;AMvqBA;;;;;EAKI,oBAAA;EACA,YAAA;AN0qBJ;;AMvqBA;EACI,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,UAAA;AN0qBJ;;AMvqBA;;EAEI,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AN0qBJ;;AMvqBA;EACI,oBAAA;AN0qBJ;;AMvqBA;EACI,cAAA;AN0qBJ;;AMvqBA;EACI,WAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,gBAAA;AN0qBJ;;AMvqBA;EACI,SAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AN0qBJ;;AMvqBA;;EAEI,UAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AN0qBJ;;AMvqBA;EACI,mCAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;EACA,4SAAA;AN0qBJ;AMvqBA;EACI,mCAAA;ANyqBJ;AMxqBI;EACI,mCAAA;AN0qBR;;AMtqBA;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;EACA,iTAAA;ANyqBJ;AMtqBA;EACI,gBAAA;ANwqBJ;AMvqBI;EACI,gBAAA;ANyqBR;;AMrqBA;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;EACA,iTAAA;ANwqBJ;AMrqBA;;;;EAII,iCAAA;ANuqBJ;AMtqBI;;;;EACI,iCAAA;AN2qBR;;AMvqBA;;EAEI,gBAAA;AN0qBJ;AMzqBI;;EACI,gBAAA;AN4qBR;;AOvlIA;EACI,gBAAA;EACA,gBAAA;AP0lIJ;AOzlII;EACI,cAAA;EACA,sBAAA;EF8KL,wBE7K4B;EF8K1B,qBE9K0B;EF+KzB,oBE/KyB;EFgL1B,gBEhL0B;EFiLrB,gBEjLqB;EACvB,oCLWG;EGWP,mDErByB;EFsBzB,gDEtByB;EFuBzB,+CEvByB;EFwBzB,8CExByB;EFyBzB,2CEzByB;EACrB,gBAAA;EACA,6BAAA;EACA,mBAAA;EACA,kBAAA;EACA,6BAAA;EACA,0BAAA;EACA,yBAAA;APmmIR;AOlmIQ;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,6BAAA;APomIZ;AOnmIY;EACI,2BAAA;EACA,cLVL;AF+mIX;AOjmIQ;EACI,gBAAA;APmmIZ;AOlmIY;EACI,SAAA;EACA,oCAAA;APomIhB;AOlmIY;EACI,cL3BP;AF+nIT;AOhmII;EACI,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,wBAAA;EACA,8BAAA;APkmIR;AOjmIQ;EACI,sBAAA;APmmIZ;AOlmIY;EACI,iBAAA;APomIhB;AO9lIQ;EACE,iBAAA;EACA,gBAAA;APgmIV;;AQtpIA;EACI,0BAAA;EACA,eAAA;EACA,cAAA;EAGA,YAAA;EH4KD,wBG3KwB;EH4KtB,qBG5KsB;EH6KrB,oBG7KqB;EH8KtB,gBG9KsB;EH+KjB,gBG/KiB;EACvB,sBAAA;EACA,yBAAA;EACA,8BAAA;EACA,0BAAA;EACA,eAAA;EACA,eAAA;AR2pIJ;AQzpII;EACI,eAAA;EACA,iBAAA;EACA,cNZC;AFuqIT;AQxpII;EACI,0BAAA;EACA,2BAAA;AR0pIR;AQxpIQ;EACI,WNzBJ;EM0BI,gBAAA;AR0pIZ;AQhpIA;;EAEI,mBNnCK;EMoCL,cNlCK;AForIT;AQ/oIQ;;EACI,cNtCH;AFwrIT;AQ7oII;;;;EAGI,mBN/CG;EMgDH,cN/CC;AF+rIT;;AQ5oIA;;EAEI,mBNpDK;EMqDL,WN3DI;AF0sIR;AQ7oII;;;;EAGI,mBNtDE;EMuDF,WNjEA;AFitIR;;AQ5oIA;;EAEI,mBN5DO;EM6DP,WNxEI;AFutIR;AQ7oII;;;;EAGI,mBNjEQ;EMkER,WN9EA;AF8tIR;;AQ5oIA;;;EAGI,YAAA;EACA,mBAAA;AR+oIJ;;AQ3oIA;EACI,qBAAA;EACA,mBNtFK;EMuFL,WAAA;EACA,YAAA;EACA,WN/FI;EMgGJ,kBAAA;EACA,eAAA;AR8oIJ;AQ5oII;EACI,iBAAA;AR8oIR;AQ5oIQ;EACI,gBAAA;EACA,WNxGJ;AFsvIR;;AQzoIA;EACI,qBAAA;EACA,mBNzGK;EM0GL,WAAA;EACA,YAAA;EACA,WNlHI;EMmHJ,kBAAA;EACA,eAAA;AR4oIJ;AQ1oII;EACI,iBAAA;AR4oIR;AQ1oIQ;EACI,gBAAA;EACA,WN3HJ;AFuwIR;;AQvoIA;EACI,qBAAA;EACA,mBNvHO;EMwHP,WAAA;EACA,YAAA;EACA,WNrII;EMsIJ,kBAAA;EACA,eAAA;AR0oIJ;AQxoII;EACI,iBAAA;EACA,iBAAA;AR0oIR;AQxoIQ;EACI,gBAAA;EACA,WN/IJ;AFyxIR;;AQpoIA;EACI,8BAAA;EACA,sBAAA;ARuoIJ;AQroII;EACI,6BAAA;ARuoIR;AQroIQ;EACI,2BAAA;EACA,WN9JJ;AFqyIR;;AQloIA;EACI,cAAA;EACA,WAAA;ARqoIJ;AQjoII;EACI,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,mCAAA;ARmoIR;AQhoII;EACI,aAAA;ARkoIR;;ASrzIA;EACI,eAAA;EACA,kBAAA;EACA,2CAAA;EACA,oCAAA;EACA,YAAA;ATwzIJ;AStzII;EACI,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;ATwzIR;AStzIQ;EACI,gBAAA;EACA,YAAA;EACA,gBAAA;ATwzIZ;AStzIY;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,cPVL;EOWK,YAAA;EACA,uBAAA;EACA,aAAA;ATwzIhB;ASrzIoB;EACI,gBAAA;EACA,cPlBb;AFy0IX;ASnzIwB;EACI,gBAAA;EACA,cPxBjB;AF60IX;ASjzIoB;EACI,gBAAA;ATmzIxB;AS/yIgB;EACI,aAAA;ATizIpB;AS9yIgB;EACI,yBPvCV;EOwCU,WPlDZ;EOmDY,kBAAA;ATgzIpB;ASzyII;EACI,WAAA;EACA,cAAA;EACA,eAAA;EACA,cPnDG;AF81IX;ASzyIQ;EACI,qBAAA;EACA,sBAAA;EACA,YAAA;AT2yIZ;ASzyIY;EACI,qBAAA;EACA,WAAA;EACA,0BAAA;EACA,kBAAA;AT2yIhB;ASzyIgB;EACI,mBAAA;AT2yIpB;ASxyIgB;EACI,eAAA;EACA,cPtET;EOuES,gDAAA;AT0yIpB;ASryIQ;EACI,qBAAA;EACA,eAAA;EACA,cP/ED;EOgFC,iBAAA;EACA,sBAAA;ATuyIZ;ASnyII;EACI,YAAA;EACA,eAAA;EACA,cPxFG;EOyFH,mBAAA;EACA,gBAAA;ATqyIR;;AU54IA;;EAEI,cAAA;EACA,iBAAA;EACA,eAAA;EACA,cREK;EQDL,gBAAA;EACA,gBRyBY;EQxBZ,kBAAA;AV+4IJ;AU74II;;;;EAEI,eAAA;AVi5IR;AU/4IQ;;;;EACI,gBAAA;EACA,cRJF;AFw5IV;AUh5II;;EACI,qBAAA;AVm5IR;;AU/4IA;EACI,cAAA;EACA,iBAAA;EACA,eAAA;EACA,cRhBO;EQiBP,gBAAA;EACA,gBRCY;EQAZ,gBAAA;AVk5IJ;AUh5II;;EAEI,eAAA;AVk5IR;AUh5IQ;;EACI,gBAAA;EACA,cR5BF;AF+6IV;AU/4II;EACI,qBAAA;AVi5IR;;AU74IA;EACI,eAAA;EACA,cR5CK;EQ6CL,gBRpBY;AFo6IhB;;AU34II;;EACI,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,gDAAA;EACA,oCAAA;EACA,cRtDC;AFq8IT;;AU34IA;EACI,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AV84IJ;AU54II;EACI,QAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AV84IR;AU54IQ;EACI,2BAAA;EACA,cAAA;AV84IZ;AU14II;EACI,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;AV44IR;AUx4IQ;EACI,qCAAA;EACA,yBAAA;AV04IZ;AUv4IQ;EACI,0BAAA;AVy4IZ;AUt4IQ;EACI,uBAAA;EACA,gBAAA;AVw4IZ;AUn4IQ;EACI,SAAA;AVq4IZ;;AU93IQ;EACI,eAAA;EACA,0BAAA;AVi4IZ;;AU13II;EACI,kBAAA;AV63IR;AU33IQ;EACI,eAAA;AV63IZ;;AUv3IA;;;;;EAKI,aAAA;AV03IJ;;AUv3IA;EACI,mBAAA;EACA,UAAA;EACA,YAAA;EACA,gBR3HY;AFq/IhB;;AUr3II;EACI,+BAAA;EACA,gCAAA;AVw3IR;;AUp3IA;EACI,kBAAA;AVu3IJ;;AUp3IA;;;;EAII,sBR1KI;AFiiJR;;AUp3IA;;;;EAII,yBRvKM;AF8hJV;;AUp3IA;;EAEI,qBR5KM;AFmiJV;;AUp3IA;;EAEI,mBAAA;AVu3IJ;;AUn3IA;;EAEI,gBAAA;EACA,WAAA;EACA,YAAA;AVs3IJ;;AUn3IA;;;;EAII,mBRhMM;EQiMN,WR3MI;AFikJR;;AUn3IA;;;;EAII,eAAA;EACA,WRnNI;AFykJR;;AUn3IA;;EAEI,mBR7MO;AFmkJX;;AUl3IA;EACI,eAAA;EACA,cRzNK;EQ0NL,qBAAA;EACA,gDAAA;AVq3IJ;;AUl3IA;EACI,uBAAA;EACA,uBAAA;EACA,kBAAA;AVq3IJ;;AUl3IA;EACI,6BAAA;AVq3IJ;;AUl3IA;EACI,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,eAAA;AVq3IJ;;AUl3IA;EACI,cAAA;EACA,gBAAA;AVq3IJ;;AWlnJA;EACI,YAAA;AXqnJJ;AWnnJI;EAHJ;IAIQ,WAAA;EXsnJN;AACF;;AWnnJA;EACI,4BAAA;EACA,6BAAA;EACA,0CAAA;EACA,oCTKM;AFinJV;AWpnJI;EACI,kBAAA;EACA,mBTHG;ESIH,eAAA;EACA,iBAAA;EACA,WTjBA;ESkBA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBTQQ;ESPR,yBAAA;EACA,0BAAA;AXsnJR;AWpnJQ;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;AXsnJZ;AWpnJY;EACI,WTpCR;AF0pJR;AWjnJI;EACI,oCT3BE;ES4BF,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AXmnJR;AWjnJQ;EACI,gBAAA;EACA,oBAAA;AXmnJZ;AWjnJY;;EAEI,gBAAA;AXmnJhB;AWhnJY;EACI,eAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;AXknJhB;AW7mJI;EACI,oCTpDE;ESqDF,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;AX+mJR;AW7mJQ;EACI,cAAA;AX+mJZ;AW5mJQ;EACI;IACI,kBAAA;EX8mJd;AACF;AW1mJI;EACI,kBAAA;EACA,yBAAA;EACA,0BAAA;AX4mJR;AW1mJQ;EACI,oCT3EF;ES4EE,eAAA;AX4mJZ;AW1mJY;EACI,cTnFL;ESoFK,QAAA;EACA,UAAA;EACA,eAAA;AX4mJhB;AWxmJQ;EACI,qBAAA;AX0mJZ;AWvmJQ;EACI,yBAAA;EACA,uBAAA;AXymJZ;;AWpmJA;EACI,6BAAA;AXumJJ;AWrmJI;EACI,eAAA;AXumJR;AWpmJI;EACI,0BAAA;EACA,cTpHC;ESqHD,kBAAA;EACA,uCAAA;AXsmJR;AWnmJI;EACI,6BAAA;EACA,+BAAA;AXqmJR;AWnmJQ;EACI,mBT7HH;ES8HG,WTpIJ;AFyuJR;AW/lJY;EACI,aAAA;AXimJhB;AW9lJY;EACI,qBAAA;AXgmJhB;;AWzlJI;EACI,qBAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;AX4lJR;AWzlJI;EACI,qBAAA;EACA,UAAA;EACA,eAAA;AX2lJR;;AWtlJI;EACI,eAAA;EACA,cT7JE;AFsvJV;AWvlJQ;EACI,yBAAA;AXylJZ;AWrlJI;EACI,eAAA;EACA,cT3KC;AFkwJT;AWnlJY;;EAEI,yBAAA;AXqlJhB;AW9kJQ;;EACI,wCAAA;EACA,kCAAA;AXilJZ;AW9kJQ;;;;EAEI,kBAAA;AXklJZ;AW/kJQ;;EACI,2BAAA;EACA,2BAAA;AXklJZ;AW/kJQ;;EACI,2BAAA;EACA,wBAAA;EACA,iBAAA;AXklJZ;AWhlJY;;EACI,qBAAA;AXmlJhB;;AW5kJI;EACI,gBAAA;EACA,8BT5ME;AF2xJV;;AWrkJgB;EACI,WTtOZ;ESuOY,eAAA;EACA,mBAAA;AXwkJpB;AWnkJQ;EACI,kBAAA;AXqkJZ;AWlkJgB;EACI,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;AXokJpB;AW5jJQ;EACI,aAAA;AX8jJZ;AW5jJY;EACI,eAAA;AX8jJhB;;AWxjJA;EACI,gBAAA;AX2jJJ;AWzjJI;EACI,kBAAA;AX2jJR;AWzjJQ;EACI,cAAA;EACA,yBAAA;EACA,gBThRJ;ESiRI,YAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;ENnGT,0BMoGgC;ENnG9B,uBMmG8B;ENlG7B,sBMkG6B;ENjG9B,kBMiG8B;ENhGzB,kBMgGyB;EACvB,gDAAA;AX+jJZ;AW5jJQ;EACI,eAAA;EACA,cTjRF;ESkRE,eAAA;AX8jJZ;;AY51JA;EACI,cAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;AZ+1JJ;AY71JI;EACI,eAAA;AZ+1JR;AY31JQ;EACI,cAAA;EACA,WAAA;AZ61JZ;AY31JY;;EAEI,qBAAA;EACA,eAAA;EACA,cAAA;AZ61JhB;AY11JY;EACI,cAAA;EAEA,eAAA;AZ21JhB;AYx1JY;EACI,qBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AZ01JhB;AYv1JY;EACI,2BAAA;AZy1JhB;AYp1JI;EACI,yBAAA;EACA,mBAAA;AZs1JR;AYp1JQ;EACI,yBAAA;EACA,mBAAA;AZs1JZ;;Aav4JA;EACI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;Ab04JJ;;Aav4JA;EACI,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,yBAAA;EACA,yBAAA;Ab04JJ;Aav4JQ;EACI,kBAAA;EACA,YAAA;EACA,0BAAA;EACA,cXRD;EWSC,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAAA;EACA,gDAAA;EACA,2CAAA;EACA,oCAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;Aby4JZ;Aav4JY;EACI,2BAAA;EACA,8BAAA;Aby4JhB;Aat4JY;EACI,kBAAA;EACA,4BAAA;EACA,+BAAA;Abw4JhB;Aar4JY;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;Abu4JhB;Aar4JgB;EACI,+BXnCN;AF06Jd;Aan4JoB;EACI,cX5Cd;AFi7JV;Aah4JY;EA5CJ;IA6CQ,cAAA;IACA,sBAAA;IACA,2BAAA;IACA,kBAAA;IACA,iBAAA;IACA,oBAAA;Ebm4Jd;AACF;Aa93JQ;EACI,kBAAA;EACA,cXpEH;EWqEG,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,2CAAA;EACA,oCAAA;Abg4JZ;Aa93JY;EACI,2BAAA;EACA,8BAAA;Abg4JhB;Aa73JY;EACI,4BAAA;EACA,+BAAA;Ab+3JhB;Aa53JY;EACI,eAAA;EACA,cXpFN;EWqFM,eAAA;Ab83JhB;Aa53JgB;EACI,0BAAA;Ab83JpB;Aa13JY;EACI,eAAA;Ab43JhB;Aaz3JY;EACI,eAAA;Ab23JhB;Aax3JY;EACI,qBAAA;EACA,sBAAA;EACA,kBAAA;Ab03JhB;Aav3JY;EACI,kBAAA;Aby3JhB;Aav3JgB;EACI,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;Aby3JpB;Aat3JgB;EACI,qBAAA;EACA,kBAAA;EACA,eAAA;Abw3JpB;Aan3JgB;EACI,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;Abq3JpB;Aan3JoB;EACI,YAAA;EACA,aAAA;EACA,kBAAA;Abq3JxB;Aan3JwB;EACI,cAAA;EACA,WXrJpB;EWsJoB,kBAAA;Abq3J5B;Aa92JY;EAtFJ;IAuFQ,cAAA;IACA,sBAAA;IACA,2BAAA;IACA,kBAAA;Ebi3Jd;AACF;Aa72JI;EACI,sBAAA;EACA,mBX9JE;EW+JF,kBAAA;Ab+2JR;Aa52JY;EACI,WX7KR;AF2hKR;;Aar2JI;EACI,UAAA;Abw2JR;Aar2JI;EACI,UAAA;Abu2JR;Aap2JI;EACI,UAAA;Abs2JR;Aan2JI;EACI,UAAA;Abq2JR;Aal2JI;EACI,UAAA;Abo2JR;Aaj2JI;EACI,UAAA;Abm2JR;Aah2JI;EACI,yBAAA;Abk2JR;Aa/1JI;EACI,yBAAA;Abi2JR;Aa91JI;EACI,0BAAA;Abg2JR;;Aa11JI;EACI,kCAAA;Ab61JR;Aa11JI;EACI,UAAA;Ab41JR;Aaz1JI;EACI,UAAA;Ab21JR;Aax1JI;EACI,UAAA;Ab01JR;Aav1JI;EACI,UAAA;Aby1JR;Aar1JQ;EACI,aAAA;EACA,qBAAA;EACA,qBAAA;EACA,wBAAA;EACA,WAAA;Abu1JZ;Aar1JY;EACI,cX/OL;EWgPK,gBAAA;Abu1JhB;Aap1JY;EACI,gCAAA;Abs1JhB;Aaj1JI;EACI,0BAAA;EACA,yBAAA;Abm1JR;Aaj1JQ;EACI,0BAAA;EACA,yBAAA;EACA,8BAAA;Abm1JZ;Aaj1JY;EACI,0BAAA;Abm1JhB;Aa/0JQ;EACI,qBAAA;Abi1JZ;Aa90JQ;EACI,uCAAA;Abg1JZ;Aa70JQ;EACI,mBAAA;Ab+0JZ;Aa50JQ;EACI,2BAAA;Ab80JZ;Aa10JQ;EACI,2BAAA;EACA,wBAAA;EACA,iBAAA;Ab40JZ;Aax0JQ;EACI,qBAAA;EACA,wBAAA;EACA,sBAAA;Ab00JZ;Aat0JI;EACI,0BAAA;EACA,yBAAA;Abw0JR;Aat0JQ;EACI,0BAAA;EACA,yBAAA;EACA,4BAAA;Abw0JZ;Aar0JQ;EACI,2BAAA;Abu0JZ;Aar0JY;EACI,0BAAA;EACA,yBAAA;EACA,4BAAA;Abu0JhB;Aan0JQ;EACI,2BAAA;EACA,wBAAA;EACA,iBAAA;Abq0JZ;Aan0JY;EACI,0BAAA;EACA,yBAAA;EACA,4BAAA;EACA,qBAAA;Abq0JhB;Aaj0JQ;EACI,yBAAA;Abm0JZ;;Aa3zJI;EACI,UAAA;Ab8zJR;Aa3zJI;EACI,UAAA;Ab6zJR;Aa1zJI;EACI,UAAA;Ab4zJR;AazzJI;EACI,UAAA;Ab2zJR;AaxzJI;EACI,UAAA;Ab0zJR;;AapzJI;EACI,UAAA;AbuzJR;AapzJI;EACI,UAAA;AbszJR;AanzJI;EACI,UAAA;AbqzJR;AalzJI;EACI,UAAA;AbozJR;AahzJQ;EACI,YAAA;EACA,sBAAA;AbkzJZ;Aa/yJQ;EACI,sBAAA;EACA,eAAA;AbizJZ;;Aa3yJI;EACI,UAAA;Ab8yJR;Aa3yJI;EACI,UAAA;Ab6yJR;Aa1yJI;EACI,UAAA;Ab4yJR;;AapyJI;EACI,UAAA;AbuyJR;AapyJI;EACI,UAAA;AbsyJR;AanyJI;EACI,UAAA;AbqyJR;;Aa9xJI;EACI,UAAA;AbiyJR;Aa9xJI;EACI,UAAA;AbgyJR;Aa7xJI;EACI,UAAA;Ab+xJR;;AazxJI;EACI,UAAA;Ab4xJR;AazxJI;EACI,UAAA;Ab2xJR;AaxxJI;EACI,UAAA;Ab0xJR;;AahxJI;EACI,UAAA;AbmxJR;AahxJI;EACI,UAAA;AbkxJR;Aa/wJI;EACI,UAAA;EACA,kBAAA;EACA,kBAAA;AbixJR;;Aa1wJI;EACI,UAAA;Ab6wJR;Aa1wJI;EACI,UAAA;Ab4wJR;AazwJI;EACI,UAAA;Ab2wJR;AaxwJI;EACI,UAAA;Ab0wJR;AavwJI;EACI,SAAA;AbywJR;AapwJQ;EACI,aAAA;AbswJZ;AalwJY;EACI,eAAA;EACA,WAAA;AbowJhB;AalwJgB;EACI,QAAA;EACA,UAAA;AbowJpB;;Aa7vJA;EACI,gBX9gBI;EW+gBJ,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,2CAAA;AbgwJJ;;AczxKA;EACI,cAAA;EACA,WAAA;EACA,eAAA;EACA,0BAAA;EACA,QAAA;EACA,UAAA;EACA,gBAAA;EACA,2BAAA;EACA,2BAAA;EACA,uCAAA;EACA,gBAAA;Ad4xKJ;Ac1xKQ;EACI,eAAA;EACA,WZbJ;EYcI,gBZgBI;EYfJ,UAAA;Ad4xKZ;AczxKI;EACI,qBAAA;Ad2xKR;Ac1xKQ;EACI,mBAAA;EACA,gBAAA;EACA,WZvBJ;AFmzKR;AczxKI;EAEQ,8BAAA;EACA,sBAAA;EACA,oCAAA;Ad0xKZ;AcvxKI;EACQ,oCAAA;EACA,sBAAA;EACA,oCAAA;AdyxKZ;ActxKI;EAEQ,sBAAA;EACA,oCAAA;EACA,8BAAA;AduxKZ;AcpxKI;EAhDJ;IAiDQ,gBAAA;IACA,kBAAA;EduxKN;AACF;;Ae10KA;EACI,cAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;Af60KJ;Ae30KI;EACI,kBAAA;Af60KR;Ae30KQ;EACI,kBAAA;EACA,eAAA;EACA,cbLH;EaMG,mBbCE;EaAF,yBAAA;EACA,gBAAA;EACA,eAAA;Af60KZ;Ae30KY;EACI,kBAAA;EACA,SAAA;EACA,QAAA;Af60KhB;Ae30KgB;EACI,eAAA;EACA,cblBX;AF+1KT;Aez0KY;;EAEI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,QAAA;Af20KhB;Aez0KgB;;EACI,cb5BV;Ea6BU,eAAA;Af40KpB;Aex0KY;EACI,mBbpCP;EaqCO,Wb3CR;AFq3KR;Aev0KoB;EACI,Wb/ChB;AFw3KR;Aen0KoB;;EACI,eAAA;EACA,WbvDhB;AF63KR;Aeh0KQ;EACI,oCb9CD;Ea+CC,kBAAA;EACA,kBAAA;Afk0KZ;Aeh0KY;EACI,cAAA;EACA,YAAA;EACA,yBb7DN;Ea8DM,kBAAA;EACA,UAAA;EACA,UAAA;EACA,yBAAA;EACA,SAAA;Afk0KhB;Ae/zKY;EACI,kBAAA;EACA,eAAA;EACA,cb/DJ;EagEI,mBAAA;EACA,kBAAA;EACA,eAAA;Afi0KhB;Ae/zKgB;EACI,iBAAA;Afi0KpB;Ae9zKgB;EACI,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,eAAA;EACA,cb/ER;AF+4KZ;Ae7zKgB;EAGI,cb5FV;Ea6FU,eAAA;Af6zKpB;Ae3zKoB;EACI,cbhGd;AF65KV;;AgBz6KA;EACI,8BdsBM;EcrBN,4BAAA;EACA,cAAA;AhB46KJ;AgB16KI;EACI,4CAAA;AhB46KR;AgBz6KI;EACI,eAAA;EACA,WdTA;EcUA,kBAAA;AhB26KR;AgBv6KQ;EACI,gBAAA;AhBy6KZ;;AiB17KA;EACI,YAAA;EACA,2CAAA;AjB67KJ;AiB57KI;EACI,eAAA;EACA,cfGC;EeFD,mBfkBA;EejBA,gBfyBQ;EexBR,yBAAA;EACA,YAAA;AjB87KR;AiB77KQ;EACI,gBAAA;EACA,cAAA;EACA,iBAAA;AjB+7KZ;;AiB17KA;EACI,gBAAA;EACA,YAAA;AjB67KJ;;AiB17KA;EACI,kBAAA;AjB67KJ;AiB57KI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;AjB87KR;;AkB39KA;EACE,2BAAA;EACA,gCAAA;EACA,YAAA;EACA,gBAAA;AlB89KF;AkB59KE;EACE,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,0BAAA;EACA,MAAA;EACA,SAAA;AlB89KJ;AkB59KI;EACE,2CAAA;AlB89KN;AkB19KE;EACE,iBAAA;AlB49KJ;AkBv9KI;EACE,4BAAA;AlBy9KN;AkBt9KI;EACE,YAAA;EACA,4BAAA;EACA,oBAAA;AlBw9KN;AkBn9KE;EACE,qBAAA;EACA,cAAA;EACA,0BAAA;EACA,gCAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;AlBq9KJ;AkBj9KM;;EACE,YAAA;EACA,eAAA;EACA,yBAAA;AlBo9KR;AkB/8KE;EACE,yCAAA;EACA,0CAAA;AlBi9KJ;;AkB58KE;EACE,eAAA;AlB+8KJ;;AmB/gLA;EACE,qBAAA;EACA,mBjBUQ;EGuKP,6BchLsB;EdiLpB,0BcjLoB;EdkLnB,yBclLmB;EdmLpB,qBcnLoB;EdoLf,qBcpLe;EACvB,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WjBLM;EiBMN,eAAA;AnBshLF;;AmBnhLA;EACE,qBAAA;EACA,mBjBRO;EG8KN,6BcrKsB;EdsKpB,0BctKoB;EduKnB,yBcvKmB;EdwKpB,qBcxKoB;EdyKf,qBczKe;EACvB,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WjBhBM;EiBiBN,eAAA;AnB0hLF;;AmBrhLA;EACE,yBAAA;EACA,mBAAA;AnBwhLF;AmBthLE;EACE,gBAAA;EACA,gCAAA;AnBwhLJ;AmBrhLE;EACE,sBjBhCI;EiBiCJ,iBAAA;EACA,iBAAA;EACA,0CAAA;EACA,iCAAA;AnBuhLJ;AmBrhLI;EACE,oBAAA;AnBuhLN;AmBnhLE;EACE,wBAAA;AnBqhLJ;AmBlhLE;;;;EAIE,qBAAA;EACA,qBAAA;AnBohLJ;;AmB/gLE;EACE,gBAAA;AnBkhLJ;;AmBvgLI;EADF;IAEI,0BAAA;EnB2gLJ;AACF;;AmBvgLA;EACE,0BAAA;AnB0gLF;;AmBvgLA;EACE,kBAAA;AnB0gLF;AmBxgLE;EACE,8BAAA;AnB0gLJ;AmBvgLE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;AnBygLJ;AmBvgLI;EACE,gBAAA;EACA,cjBvFI;AFgmLV;AmBrgLM;EACE,cjBzFG;AFgmLX;;AoB7mLA;EACI,cAAA;EACA,WAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;EACA,gBlBNI;EkBOJ,eAAA;EACA,gBAAA;EACA,0CAAA;ApBgnLJ;AoB9mLI;EACI,WAAA;ApBgnLR;AoB7mLI;EACI,YAAA;EACA,gBAAA;EACA,mBlBfC;EkBgBD,iBAAA;ApB+mLR;AoB7mLQ;EACI,UAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;EACA,2CAAA;EACA,sBlB3BJ;EkB4BI,gBAAA;ApB+mLZ;AoB7mLY;EACI,qCAAA;ApB+mLhB;AoB5mLY;EAGI,mBlB/BP;EkBgCO,WlBtCR;AFkpLR;AoB1mLgB;EACI,WlBzCZ;AFqpLR;AoBvmLQ;EACI,qBAAA;EACA,sBAAA;EACA,WAAA;ApBymLZ;;AqB5pLA;;;EAGI,YAAA;ArB+pLJ;;AqB5pLA;EACI,YAAA;EACA,cAAA;ArB+pLJ;;AqB5pLA;EACI,cAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;ArB+pLJ;AqB7pLI;EACI,kBAAA;EACA,mBAAA;ArB+pLR;AqB7pLQ;EACI,WAAA;ArB+pLZ;AqB7pLY;EACI,cAAA;EACA,eAAA;EACA,cnBfN;AF8qLV;AqB3pLQ;EACI,YAAA;EACA,eAAA;ArB6pLZ;AqB3pLY;EACI,oBAAA;ArB6pLhB;AqBzpLQ;EACI,YAAA;EACA,eAAA;ArB2pLZ;AqBzpLY;EACI,oBAAA;ArB2pLhB;AqBvpLQ;EACI,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;ArBypLZ;AqBtpLY;EACI,WAAA;EACA,sBnBzDR;AFitLR;AqBtpLgB;EACI,kBAAA;EACA,qBAAA;ArBwpLpB;AqBppLY;EACI,WAAA;EACA,YAAA;ArBspLhB;AqBlpLgB;EACI,iBAAA;EACA,cAAA;ArBopLpB;AqBjpLgB;EACI,oCAAA;EACA,2BAAA;EACA,wBAAA;ArBmpLpB;AqBjpLoB;EACI,eAAA;EACA,cnB9Ef;AFiuLT;AqB9oLY;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,UAAA;EACA,eAAA;ArBgpLhB;AqB5oLQ;EACI,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;ArB8oLZ;AqB5oLY;EACI,cAAA;ArB8oLhB;AqB1oLQ;EACI,cAAA;EACA,YAAA;EACA,gBAAA;ArB4oLZ;AqB1oLY;EACI,iBAAA;ArB4oLhB;AqBvoLQ;EACI,kBAAA;EACA,QAAA;EACA,MAAA;ArByoLZ;AqBroLI;EACI,WAAA;EACA,eAAA;ArBuoLR;AqBpoLI;EACI,WAAA;EACA,gBnBzIA;EmB0IA,aAAA;ArBsoLR;;AqBhoLA;EACI,aAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,aAAA;ArBmoLJ;AqBjoLI;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;ArBmoLR;AqBjoLQ;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;ArBmoLZ;AqBhoLQ;EACI,cAAA;EACA,eAAA;EACA,WAAA;ArBkoLZ;;AsBpzLA;EACI,YAAA;AtBuzLJ;AsBtzLI;EACI,cAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EjB6KL,0BiB5K4B;EjB6K1B,uBiB7K0B;EjB8KzB,sBiB9KyB;EjB+K1B,kBiB/K0B;EjBgLrB,kBiBhLqB;EACvB,kBAAA;EACA,QAAA;EjByDJ,gCAAA;EACA,+BAAA;EACA,mCAAA;EACA,kCAAA;EACA,8BAAA;EACA,2BAAA;ALowLJ;AsBh0LQ;EACI,4BAAA;EACA,2CAAA;EACA,oCAAA;AtBk0LZ;AsBj0LY;EACI,kBAAA;AtBm0LhB;AsBl0LgB;EACI,eAAA;AtBo0LpB;AsBh0LQ;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AtBk0LZ;AsBh0LQ;EACI,cAAA;EACA,YAAA;EACA,WAAA;EACA,wBAAA;AtBk0LZ;AsBh0LQ;EACI,kBAAA;EACA,iBAAA;AtBk0LZ;;AsB7zLI;EACI,cAAA;EACA,gBpBzCA;EoB0CA,kBAAA;EACA,SAAA;AtBg0LR;AsB9zLQ;EACI,qBAAA;EACA,YAAA;AtBg0LZ;;AuBj3LA;EACI,kBAAA;AvBo3LJ;AuBl3LI;EACI,YAAA;EACA,WAAA;AvBo3LR;AuBj3LI;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;AvBm3LR;;AuB/2LA;EACI,cAAA;EACA,2BAAA;EACA,8BAAA;AvBk3LJ;;AuB/2LA;EACI,cAAA;EACA,eAAA;EACA,crBhBK;AFk4LT;;AuB/2LA;EACI,qBAAA;EACA,eAAA;EACA,crBxBK;EqByBL,sBAAA;AvBk3LJ;;AuB92LI;EACI,2BAAA;EACA,iBAAA;AvBi3LR;AuB/2LQ;EACI,eAAA;EACA,crBnCH;AFo5LT;AuB72LI;EACI,2BAAA;EACA,iBAAA;AvB+2LR;AuB72LQ;EACI,qBAAA;EACA,eAAA;EACA,crB9CH;AF65LT;AuB32LI;EACI,eAAA;AvB62LR;AuB32LQ;EACI,gBAAA;AvB62LZ;AuB12LQ;EACI,gBAAA;EACA,qBAAA;AvB42LZ;AuBz2LQ;EACI,mBAAA;EACA,qBAAA;AvB22LZ;AuBx2LQ;EACI,kBAAA;AvB02LZ;;AuBr2LA;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;AvBw2LJ;;AuBr2LA;EACI,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,4BAAA;EACA,oCAAA;EACA,kCAAA;EACA,wCAAA;EACA,0BAAA;EACA,eAAA;EACA,eAAA;AvBw2LJ;AuBt2LI;EACI,QAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;AvBw2LR;AuBt2LQ;EACI,2BAAA;EACA,cAAA;AvBw2LZ;AuBp2LI;EACI,qBAAA;EACA,oBAAA;EACA,eAAA;EACA,crBhHC;EqBiHD,kBAAA;EACA,YAAA;AvBs2LR;;AuBh2LA;EACI,kBAAA;EACA,UAAA;AvBm2LJ;AuBj2LI;EACI,WAAA;EACA,iBAAA;AvBm2LR;AuBj2LQ;EACI,oBAAA;EACA,yDAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AvBm2LZ;AuBj2LY;EACI,gBAAA;AvBm2LhB;AuB/1LY;EACI,gBAAA;AvBi2LhB;AuB/1LgB;EACI,eAAA;EACA,gBAAA;AvBi2LpB;AuB91LgB;EACI,cAAA;EACA,eAAA;AvBg2LpB;AuB51LY;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AvB81LhB;AuBz1LgB;EACI,gBrB7KZ;EqB8KY,0CAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,crBvKT;EqBwKS,gBrBnJJ;AF8+LhB;AuBv1LoB;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WrB/LhB;EqBgMgB,YAAA;AvBy1LxB;AuBp1LoB;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WrB9MhB;AFoiMR;;AuBx0LI;EACI,UAAA;EACA,qBAAA;AvB20LR;;AuBp0LI;EACI,kBAAA;EACA,qBAAA;AvBu0LR;;AuBj0LA;EACI,cAAA;EACA,kBAAA;EACA,WAAA;AvBo0LJ;;AwBtjMA;EACI,qBAAA;EACA,mBtBOK;EsBNL,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WtBJI;EsBKJ,eAAA;EACA,mBAAA;AxByjMJ;AwBvjMI;EACI,mBtBCE;AFwjMV;AwBtjMI;EACI,mBtBVC;AFkkMT;;AwBhjMQ;EACI,ctBCJ;AFkjMR;AwB7iMQ;EACI,ctB1BH;AFykMT;AwBziMQ;EACI,ctBjBN;AF4jMN;;AwBniMA;EACI,gBAAA;AxBsiMJ;;AwBniMA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;AxBsiMJ;AwBpiMI;EACI,SAAA;EACA,UAAA;AxBsiMR;AwBpiMQ;EACI,qBAAA;AxBsiMZ;AwBpiMY;EACI,sBAAA;EACA,qBAAA;AxBsiMhB;AwBniMY;EACI,sBAAA;AxBqiMhB;;AwB/hMA;EACI,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,oBAAA;AxBkiMJ;AwBhiMI;EACI,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,wCAAA;AxBkiMR;AwBhiMQ;EACI,wCAAA;AxBkiMZ;AwB/hMQ;EACI,kBAAA;AxBiiMZ;AwB/hMY;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,mBtBxFN;EsByFM,kBAAA;EACA,8BAAA;EACA,eAAA;EACA,WtBpGR;EsBqGQ,iBAAA;EACA,kBAAA;EACA,mBAAA;AxBiiMhB;AwB9hMY;EACI,iBAAA;EACA,eAAA;AxBgiMhB;AwB9hMgB;EACI,cAAA;EACA,ctBxGV;AFwoMV;AwB5hMoB;EACI,ctB/Gf;AF6oMT;AwBzhMY;EACI,eAAA;EACA,ctBvHP;EsBwHO,8BAAA;AxB2hMhB;AwBrhMQ;EACI,mBAAA;AxBuhMZ;AwBrhMY;EACI,eAAA;EACA,ctB7HL;AFopMX;AwB/gMY;EACI,cAAA;EACA,eAAA;EACA,ctB3IN;EsB4IM,8BAAA;EACA,yBAAA;EACA,mBAAA;AxBihMhB;AwB9gMY;EACI,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AxBghMhB;AwB9gMgB;EACI,0BAAA;EACA,wCAAA;AxBghMpB;AwB9gMoB;;;EAEI,mBtB1Jb;AF2qMX;AwB9gMoB;EACI,sBAAA;AxBghMxB;AwB7gMoB;EACI,qBAAA;EACA,eAAA;EACA,ctB1Kf;EsB2Ke,wBAAA;EACA,iBAAA;EACA,wBAAA;AxB+gMxB;AwB5gMoB;EAEI,mBtB9Kf;AF2rMT;AwB1gMoB;EACI,mBAAA;AxB4gMxB;;AwBjgMA;EACI,eAAA;EACA,kBAAA;EACA,+BAAA;EACA,cAAA;AxBogMJ;AwB7/LQ;EACI,kBAAA;EACA,MAAA;AxB+/LZ;AwB7/LY;EACI,kBAAA;EACA,mBtB9MP;AF6sMT;AwB5/LgB;EACI,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,WtB/NJ;EsBgOI,kBAAA;AxB8/LpB;AwB3/LgB;EACI,4CAAA;EACA,kBAAA;AxB6/LpB;;AwBn/LA;EACI,YAAA;AxBs/LJ;;AwBh/LA;EACI,aAAA;EACA,YAAA;EACA,gBtB3PI;EsB4PJ,2CAAA;AxBm/LJ;AwBj/LI;EACI,6BAAA;EACA,gCAAA;AxBm/LR;AwB/+LI;EACI,iCAAA;AxBi/LR;AwB/+LQ;EACI,qBAAA;EACA,WAAA;EACA,mBAAA;AxBi/LZ;AwB9+LQ;;EAEI,mBtBpQD;AFovMX;AwB7+LQ;EACI,qBAAA;EACA,wBAAA;EACA,mBAAA;EACA,eAAA;EACA,ctBlRH;AFiwMT;AwB5+LQ;EAEI,mBAAA;AxB6+LZ;AwBz+LI;EACI,eAAA;EACA,ctBvRG;EsBwRH,8BAAA;EACA,gBAAA;EACA,mBAAA;AxB2+LR;AwBz+LQ;EACI,aAAA;AxB2+LZ;;AwBl+LI;EACI,cAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AxBq+LR;AwBl+LI;EACI,eAAA;AxBo+LR;AwBl+LQ;EACI,mBtBrTH;AFyxMT;AwBl+LY;EACI,8BAAA;EACA,eAAA;EACA,ctBxTL;EsByTK,gBAAA;AxBo+LhB;AwBl+LgB;EACI,iCAAA;EACA,mBAAA;AxBo+LpB;AwBl+LoB;EACI,mBAAA;EACA,gBAAA;AxBo+LxB;AwBj+LoB;EACI,aAAA;AxBm+LxB;AwB79LgB;EACI,qBAAA;EACA,WAAA;EACA,mBAAA;AxB+9LpB;AwB59LgB;EACI,qBAAA;EACA,wBAAA;EACA,eAAA;EACA,ctB3VX;EsB4VW,uBAAA;AxB89LpB;;AwBp9LA;EACI,kBAAA;EACA,0CAAA;EACA,aAAA;EACA,mBtBtWK;AF6zMT;AwBr9LI;EACI,wBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AxBu9LR;AwBr9LQ;EACI,mBAAA;AxBu9LZ;AwBr9LY;EACI,qBAAA;EACA,gBAAA;AxBu9LhB;AwBr9LgB;EACI,YAAA;EACA,aAAA;EACA,kBAAA;AxBu9LpB;AwBr9LoB;EACI,cAAA;AxBu9LxB;AwB98LI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AxBg9LR;;AwB38LA;EAEI,sBAAA;AxB68LJ;;AwB18LA;EACI,kBAAA;EACA,6BAAA;AxB68LJ;;AwB18LA;EACI,0BAAA;EACA,8BAAA;AxB68LJ;;AwB18LA;EACI,8BAAA;AxB68LJ;;AwB18LA;EACI,UAAA;EACA,0BAAA;AxB68LJ;;AwB18LA;EACI,gBAAA;EACA,UAAA;EACA,sBAAA;AxB68LJ;;AwB18LA;EACI,eAAA;EACA,YAAA;EACA,0BAAA;EACA,UAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,oBAAA;EACA,iBAAA;AxB68LJ;;AwB18LA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;AxB68LJ;;AwB18LA;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,0CAAA;EACA,2CAAA;AxB68LJ;;AyBj6MA;EACI,iBAAA;EACA,gBAAA;AzBo6MJ;AyBl6MI;EACI,2BAAA;EACA,iBAAA;EACA,gBAAA;AzBo6MR;AyBh6MQ;EACI,gBvBVJ;EuBWI,kBAAA;EACA,2CAAA;EACA,YAAA;EACA,mBAAA;AzBk6MZ;AyBh6MY;EACI,eAAA;EACA,cvBbP;AF+6MT;AyB/5MY;EACI,qBAAA;EACA,YAAA;EACA,eAAA;EACA,cvBfN;EuBgBM,kBAAA;EACA,eAAA;EACA,eAAA;AzBi6MhB;AyB95MY;EACI,YAAA;EACA,eAAA;AzBg6MhB;AyB75MoB;EACI,gBvBRR;EuBSQ,cvB/Bf;AF87MT;AyBv5MQ;EACI,qBAAA;EACA,wBAAA;AzBy5MZ;AyBt5MQ;EACI,YAAA;EACA,qBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;AzBw5MZ;AyBp5MI;EACI,cAAA;EACA,WAAA;EACA,UAAA;AzBs5MR;AyBp5MQ;EACI,cAAA;EACA,eAAA;EACA,cvB/DH;EuBgEG,kBAAA;AzBs5MZ;AyBn5MQ;EACI,cAAA;EACA,gBvB1EJ;EuB2EI,aAAA;EACA,kBAAA;EACA,2CAAA;EACA,iBAAA;EACA,gBAAA;AzBq5MZ;AyBn5MY;EACI,eAAA;EACA,cvB9EP;EuB+EO,aAAA;AzBq5MhB;AyBn5MgB;EACI,kBAAA;EACA,sBAAA;AzBq5MpB;AyB74MI;EACI,cAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AzB+4MR;AyB54MI;EACI,kBAAA;EACA,gBAAA;AzB84MR;AyB54MQ;EACI,iBAAA;EACA,gBAAA;AzB84MZ;AyB34MQ;EACI,yBvBxGH;EuByGG,aAAA;EACA,2BAAA;AzB64MZ;AyB34MY;EACI,YAAA;EACA,eAAA;EACA,cvBnHP;EuBoHO,iBAAA;AzB64MhB;AyB14MY;EACI,eAAA;EACA,cvBzHP;EuB0HO,iBAAA;AzB44MhB;AyBx4MQ;EACI,eAAA;EACA,cvBhIH;EuBiIG,kBAAA;EACA,UAAA;EACA,iBAAA;AzB04MZ;AyBr4MQ;EACI,qBAAA;EACA,kBAAA;AzBu4MZ;AyBr4MY;EACI,qBAAA;AzBu4MhB;AyBl4MY;EACI,sBAAA;EACA,kBAAA;AzBo4MhB;AyBj4MY;EACI,eAAA;AzBm4MhB;AyB93MQ;EACI,YAAA;AzBg4MZ;AyB/3MY;EACI,YAAA;AzBi4MhB;;AyB33MA;EACI,cAAA;EACA,aAAA;EACA,sBAAA;EACA,yBvBtKK;EuBuKL,iBAAA;EACA,gBAAA;AzB83MJ;AyB53MI;EACI,gBAAA;EACA,mBAAA;AzB83MR;;AyB13MA;EACI,cAAA;EACA,WAAA;EACA,2BAAA;EACA,iBAAA;EACA,gBAAA;AzB63MJ;;AyBz3MA;EACI,qBAAA;EACA,8BvBpLO;EuBqLP,wBAAA;EACA,eAAA;EACA,cvBlMK;EuBmML,kBAAA;EACA,kBAAA;EACA,mBAAA;AzB43MJ;AyB13MI;EACI,qBAAA;EACA,iBAAA;EACA,eAAA;AzB43MR;AyB13MQ;EACI,gBAAA;EACA,cvBzMF;AFqkNV;;AyBv3MA;EACI,YAAA;EACA,wBAAA;EACA,uBAAA;EACA,sDAAA;EACA,2BAAA;AzB03MJ;AyBx3MI;EACI,eAAA;EACA,cvBtNG;EuBuNH,8BAAA;EACA,mBAAA;AzB03MR;AyBt3MI;;EAEI,eAAA;EACA,mBAAA;AzBw3MR;;AyBn3MA;EACI,cAAA;EACA,WAAA;EACA,2BAAA;EACA,iBAAA;EACA,gBAAA;AzBs3MJ;;A0B5mNA;EACI,uBAAA;EACA,kBAAA;A1B+mNJ;A0B7mNI;EACI,cAAA;EACA,mBAAA;A1B+mNR;A0B7mNQ;EACI,kBAAA;EACA,gBAAA;A1B+mNZ;A0B7mNY;EACI,gBAAA;EACA,cxBJN;AFmnNV;A0B1mNI;EACI,cAAA;EACA,eAAA;EACA,cxBTG;AFqnNX;A0BzmNI;EACI,eAAA;EACA,cxBdG;AFynNX","sourcesContent":["@charset \"UTF-8\";\n/*COMMON STYLES*/\n/*! Generated by Font Squirrel (https://www.fontsquirrel.com) on January 7, 2019 */\n@font-face {\n  font-family: \"ProximaNovaRegular\";\n  src: url(\"../../assets/fonts/proxima-nova-regular-webfont.woff\") format(\"woff2\"), url(\"../../assets/fonts/proxima-nova-regular-webfont.woff2\") format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"ProximaNovaBold\";\n  src: url(\"../../assets/fonts/PN-Bold.woff2\") format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n}\n*,\n*:before,\n*:after {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  outline: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.5);\n  margin: 0;\n  padding: 0;\n  -webkit-text-size-adjust: 100%;\n  -moz-text-size-adjust: 100%;\n  -ms-text-size-adjust: 100%;\n  -webkit-touch-callout: default;\n  -webkit-overflow-scrolling: touch;\n  font-size: 16px;\n  color: #232f3a;\n  font-family: \"ProximaNovaRegular\", sans-serif;\n  white-space: normal;\n  word-wrap: break-word;\n}\n\nbody,\nform,\ninput,\nselect,\ntextarea,\nbutton,\nlabel,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  font-family: \"ProximaNovaRegular\", sans-serif;\n}\n\nhtml,\nbody {\n  -webkit-text-size-adjust: 100%;\n  -ms-text-size-adjust: 100%;\n  font-size: 16px;\n  line-height: 24px;\n  color: #000;\n  font-weight: normal;\n  height: 100%;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  background: #f7f8fa;\n  font-family: \"ProximaNovaRegular\", sans-serif;\n}\n\nimg {\n  display: block;\n  margin: 0 auto;\n  max-width: 100%;\n}\n\nul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\nul li {\n  list-style: none;\n}\n\n.ui.container {\n  padding: 0 20px;\n  width: 100%;\n}\n@media only screen and (min-width: 1200px) {\n  .ui.container {\n    width: 100%;\n    max-width: 100%;\n  }\n}\n\n.ui.grid {\n  margin-top: 10px;\n  margin-bottom: 0;\n  margin-left: -0.5rem;\n  margin-right: -0.5rem;\n}\n.ui.grid > .row {\n  padding-top: 0;\n  padding-bottom: 0;\n  margin-bottom: 10px;\n}\n\n.ui.grid > .row:before {\n  box-shadow: none !important;\n}\n\n.ui.grid > .row > .column {\n  margin-top: 0.1rem;\n  margin-bottom: 0.1rem;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n\n.nopadding {\n  padding: 0 !important;\n}\n\n.clear {\n  clear: both;\n  line-height: 0;\n  font-size: 0;\n  overflow: hidden;\n}\n\n.clearfix {\n  *zoom: 1;\n}\n\n.clearfix:after,\n.container:after {\n  clear: both;\n  content: \".\";\n  display: block;\n  font-size: 0;\n  height: 0;\n  line-height: 0;\n  visibility: hidden;\n}\n\nsup {\n  vertical-align: top;\n  padding: 0;\n  margin: 0;\n}\n\n:focus,\na {\n  outline: none;\n}\n\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);\n  border-radius: 5px;\n}\n\n::-webkit-scrollbar-thumb {\n  border-radius: 5px;\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.7);\n}\n\ni.icon:before {\n  font-family: Icons;\n}\n\ni.icon.outline {\n  font-family: outline-icons;\n}\ni.icon.outline::before {\n  font-family: outline-icons;\n}\n\ni.icon.close:before {\n  content: \"✖\";\n  font-weight: 600;\n}\n\ni.icon.equal:before {\n  font-size: 2em;\n  content: \"=\";\n  font-weight: 600;\n  color: #dcdcdc;\n}\n\ni.squareIcon {\n  background-color: #285482;\n}\ni.squareIcon::before {\n  color: #fff !important;\n  font-size: 0.9em;\n}\n\nh1 {\n  font-family: \"ProximaNovaRegular\";\n  font-size: 2.49em;\n  line-height: 1.2em;\n  color: #232f3a;\n  font-weight: normal;\n}\n\nh2 {\n  font-family: \"ProximaNovaRegular\";\n  font-size: 2.07em;\n  line-height: 1.2em;\n  color: #232f3a;\n  font-weight: normal;\n}\n\nh3 {\n  font-family: \"ProximaNovaRegular\";\n  font-size: 1.73em;\n  line-height: 1.2em;\n  color: #232f3a;\n  font-weight: normal;\n}\n\nh4 {\n  font-family: \"ProximaNovaRegular\";\n  font-size: 1.44em;\n  line-height: 1.2em;\n  color: #232f3a;\n  font-weight: normal;\n}\n\nh5 {\n  font-family: \"ProximaNovaRegular\";\n  font-size: 1.44em;\n  line-height: 1.2em;\n  color: #232f3a;\n  font-weight: normal;\n}\n\nh6 {\n  font-family: \"ProximaNovaRegular\";\n  font-size: 11.9px;\n  line-height: 1.2em;\n  color: #232f3a;\n  font-weight: normal;\n}\n\np,\nli,\nspan {\n  font-family: \"ProximaNovaRegular\";\n  font-size: 16px;\n  line-height: 1.5em;\n  font-weight: 400;\n  font-style: normal;\n  color: #232f3a;\n  text-transform: none;\n}\n\na {\n  font-size: 16px;\n  line-height: 1.5em;\n  font-weight: 400;\n  font-style: normal;\n  color: #232f3a;\n  text-decoration: none;\n}\n\n/*COMMON CLASSES*/\n.noPrivilege {\n  padding: 0px 0 50px 0;\n  text-align: center;\n}\n.noPrivilege .dontSign {\n  display: block;\n  margin-bottom: 30px;\n}\n.noPrivilege .dontSign i {\n  text-align: center;\n  display: initial;\n}\n.noPrivilege .dontSign i::before {\n  font-size: 3.7em;\n  color: #c8c8c8;\n}\n\n.floatLeft {\n  float: left !important;\n}\n\n.floatRight {\n  float: right !important;\n}\n\n.floatNone {\n  float: none !important;\n}\n\n.txtCenter {\n  text-align: center !important;\n}\n\n.txtLeft {\n  text-align: left;\n}\n\n.txtRight {\n  text-align: right;\n}\n\n.textJustify {\n  text-align: justify;\n}\n\n.textNowrap {\n  white-space: nowrap;\n}\n\n.lowercase {\n  text-transform: lowercase !important;\n}\n\n.uppercase {\n  text-transform: uppercase !important;\n}\n\n.capitalize {\n  text-transform: capitalize !important;\n}\n\n.transformNone {\n  text-transform: none !important;\n}\n\n.relative {\n  position: relative;\n}\n\n.heightAuto {\n  height: auto !important;\n  min-height: 100%;\n}\n\n.ellip {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.breakAll {\n  word-break: break-all;\n}\n\n.noBreak {\n  word-break: normal !important;\n}\n\n.noScroll {\n  overflow: hidden !important;\n}\n\n.no_bg {\n  background: none !important;\n}\n\n.noBorder {\n  border: none !important;\n}\n\n.borderLeft {\n  border-left: 1px solid #99928a;\n}\n\n.borderTop {\n  border-top: 1px solid #99928a;\n}\n\n.borderRight {\n  border-right: 1px solid #99928a;\n}\n\n.borderBottom {\n  border-bottom: 1px solid #99928a;\n}\n\n.center-block {\n  display: block;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.hide {\n  display: none !important;\n}\n\n.show {\n  display: block !important;\n}\n\n.invisible {\n  visibility: hidden;\n}\n\n.text-hide {\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n}\n\n.paddingLR0 {\n  padding-left: 0px !important;\n  padding-right: 0px !important;\n}\n\n.pt0 {\n  padding-top: 0 !important;\n}\n\n.pt5 {\n  padding-top: 5px !important;\n}\n\n.pt10 {\n  padding-top: 10px !important;\n}\n\n.padTopBot50 {\n  position: relative;\n  padding-top: 140px !important;\n  padding-bottom: 30px !important;\n}\n\n.pb10 {\n  padding-bottom: 10px !important;\n}\n\n.pt20 {\n  padding-top: 20px !important;\n}\n\n.pb20 {\n  padding-bottom: 20px !important;\n}\n\n.pl10 {\n  padding-left: 10px !important;\n}\n\n.margin0 {\n  margin: 0 !important;\n}\n\n.mt0 {\n  margin-top: 0 !important;\n}\n\n.mt5 {\n  margin-top: 5px !important;\n}\n\n.mt10 {\n  margin-top: 10px !important;\n}\n\n.mt20 {\n  margin-top: 20px !important;\n}\n\n.mt30 {\n  margin-top: 30px !important;\n}\n\n.mt-20 {\n  margin-top: -20px !important;\n}\n\n.mb0 {\n  margin-bottom: 0 !important;\n}\n\n.mb5 {\n  margin-bottom: 5px !important;\n}\n\n.mb10 {\n  margin-bottom: 10px !important;\n}\n\n.mb20 {\n  margin-bottom: 20px !important;\n}\n\n.mb30 {\n  margin-bottom: 30px !important;\n}\n\n.mr5 {\n  margin-right: 5px !important;\n}\n\n.mr10 {\n  margin-right: 10px !important;\n}\n\n.mr20 {\n  margin-right: 20px !important;\n}\n\n.mr30 {\n  margin-right: 30px !important;\n}\n\n.ml5 {\n  margin-left: 5px !important;\n}\n\n.ml10 {\n  margin-left: 10px !important;\n}\n\n.ml20 {\n  margin-left: 20px !important;\n}\n\n.ml30 {\n  margin-left: 30px !important;\n}\n\n.middleIcon {\n  display: inline-block;\n  width: 24px;\n  height: 22px;\n  margin: 0 10px;\n  vertical-align: middle;\n}\n\n.leftIcon {\n  display: inline-block;\n  width: 24px;\n  height: 22px;\n  margin: 0 10px 0 0;\n  vertical-align: middle;\n}\n\n.commonList {\n  list-style: disc;\n  margin-left: 30px;\n}\n\n.font13 {\n  font-size: 13px !important;\n}\n\n.font18 {\n  font-size: 18px !important;\n}\n\n.message {\n  display: block;\n  background: #a94442;\n  font-size: 15px;\n  color: #fff;\n  text-align: center;\n  padding: 10px;\n  border: 1px solid #a94442;\n}\n\n.inlineB {\n  display: inline-block !important;\n}\n\n.inline {\n  display: inline !important;\n}\n\n.dot {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  background: #000;\n  border: 1px solid #fff;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-box-sizing: 50%;\n  border-radius: 50%;\n}\n\n.vMiddle {\n  vertical-align: middle;\n}\n\n.headTitle {\n  font-size: 20px;\n  color: #232f3a;\n  line-height: 25px;\n}\n\n.lineH30 {\n  line-height: 30px !important;\n}\n\n.pointer {\n  cursor: pointer !important;\n}\n\n.noPointer {\n  cursor: not-allowed !important;\n}\n\n.ui.dimmer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 100%;\n  width: 100%;\n  background: rgba(35, 47, 58, 0.95);\n  z-index: 10000 !important;\n}\n.ui.dimmer.modals {\n  z-index: 9999 !important;\n}\n\n.noRecordMessage {\n  display: block;\n  width: 100%;\n  font-size: 16px;\n  color: #686c6d;\n  margin: 80px 0 30px 0;\n  text-align: center;\n}\n\n.threeLiner {\n  width: 100%;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  overflow: hidden;\n}\n\n.twoLiner {\n  width: 100%;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n}\n\n.oneLiner {\n  width: 100%;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  overflow: hidden;\n}\n\n.validationError .ui.selection {\n  border: 1px solid #e0b4b4 !important;\n  background: #fff6f6 !important;\n  color: #9f3a38;\n}\n\n.txtRed {\n  color: #b13036 !important;\n}\n\n.errorMessage {\n  display: block;\n  margin-top: -10px;\n  font-size: 14px;\n  color: #a94442;\n}\n\n/*!\n * Font Awesome Free 5.0.4 by @fontawesome - http://fontawesome.com\n * License - http://fontawesome.com/license (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)\n */\n.fa,\n.fab,\n.fal,\n.far,\n.fas {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  display: inline-block;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n  line-height: 1;\n}\n\n.fa-lg {\n  font-size: 1.33333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n}\n.fa-xs:before {\n  font-size: 0.75em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n}\n.fa-sm:before {\n  font-size: 0.875em;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n.fa-1x:before {\n  font-size: 1em;\n}\n\n.fa-1_2x {\n  font-size: 1.25em;\n}\n.fa-1_2x:before {\n  font-size: 1.25em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n.fa-2x:before {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n.fa-3x:before {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n.fa-4x:before {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n.fa-5x:before {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n}\n\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n\n.fa-border {\n  border: 0.08em solid #eee;\n  border-radius: 0.1em;\n  padding: 0.2em 0.25em 0.15em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left,\n.fab.fa-pull-left,\n.fal.fa-pull-left,\n.far.fa-pull-left,\n.fas.fa-pull-left {\n  margin-right: 0.3em;\n}\n\n.fa.fa-pull-right,\n.fab.fa-pull-right,\n.fal.fa-pull-right,\n.far.fa-pull-right,\n.fas.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  -webkit-animation: a 2s infinite linear;\n  animation: a 2s infinite linear;\n}\n\n.fa-pulse {\n  -webkit-animation: a 1s infinite steps(8);\n  animation: a 1s infinite steps(8);\n}\n\n@-webkit-keyframes a {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(1turn);\n    transform: rotate(1turn);\n  }\n}\n@keyframes a {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(1turn);\n    transform: rotate(1turn);\n  }\n}\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scaleX(-1);\n  transform: scaleX(-1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scaleY(-1);\n  transform: scaleY(-1);\n}\n\n.fa-flip-horizontal.fa-flip-vertical,\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n}\n\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1);\n  transform: scale(-1);\n}\n\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270 {\n  -webkit-filter: none;\n  filter: none;\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  line-height: 2em;\n  position: relative;\n  vertical-align: middle;\n  width: 2em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  left: 0;\n  position: absolute;\n  text-align: center;\n  width: 100%;\n}\n\n.fa-stack-1x {\n  line-height: inherit;\n}\n\n.fa-stack-2x {\n  font-size: 2em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.fa-500px:before {\n  content: \"\\f26e\";\n}\n\n.fa-accessible-icon:before {\n  content: \"\\f368\";\n}\n\n.fa-accusoft:before {\n  content: \"\\f369\";\n}\n\n.fa-address-book:before {\n  content: \"\\f2b9\";\n}\n\n.fa-address-card:before {\n  content: \"\\f2bb\";\n}\n\n.fa-adjust:before {\n  content: \"\\f042\";\n}\n\n.fa-adn:before {\n  content: \"\\f170\";\n}\n\n.fa-adversal:before {\n  content: \"\\f36a\";\n}\n\n.fa-affiliatetheme:before {\n  content: \"\\f36b\";\n}\n\n.fa-algolia:before {\n  content: \"\\f36c\";\n}\n\n.fa-align-center:before {\n  content: \"\\f037\";\n}\n\n.fa-align-justify:before {\n  content: \"\\f039\";\n}\n\n.fa-align-left:before {\n  content: \"\\f036\";\n}\n\n.fa-align-right:before {\n  content: \"\\f038\";\n}\n\n.fa-amazon:before {\n  content: \"\\f270\";\n}\n\n.fa-amazon-pay:before {\n  content: \"\\f42c\";\n}\n\n.fa-ambulance:before {\n  content: \"\\f0f9\";\n}\n\n.fa-american-sign-language-interpreting:before {\n  content: \"\\f2a3\";\n}\n\n.fa-amilia:before {\n  content: \"\\f36d\";\n}\n\n.fa-anchor:before {\n  content: \"\\f13d\";\n}\n\n.fa-android:before {\n  content: \"\\f17b\";\n}\n\n.fa-angellist:before {\n  content: \"\\f209\";\n}\n\n.fa-angle-double-down:before {\n  content: \"\\f103\";\n}\n\n.fa-angle-double-left:before {\n  content: \"\\f100\";\n}\n\n.fa-angle-double-right:before {\n  content: \"\\f101\";\n}\n\n.fa-angle-double-up:before {\n  content: \"\\f102\";\n}\n\n.fa-angle-down:before {\n  content: \"\\f107\";\n}\n\n.fa-angle-left:before {\n  content: \"\\f104\";\n}\n\n.fa-angle-right:before {\n  content: \"\\f105\";\n}\n\n.fa-angle-up:before {\n  content: \"\\f106\";\n}\n\n.fa-angrycreative:before {\n  content: \"\\f36e\";\n}\n\n.fa-angular:before {\n  content: \"\\f420\";\n}\n\n.fa-app-store:before {\n  content: \"\\f36f\";\n}\n\n.fa-app-store-ios:before {\n  content: \"\\f370\";\n}\n\n.fa-apper:before {\n  content: \"\\f371\";\n}\n\n.fa-apple:before {\n  content: \"\\f179\";\n}\n\n.fa-apple-pay:before {\n  content: \"\\f415\";\n}\n\n.fa-archive:before {\n  content: \"\\f187\";\n}\n\n.fa-arrow-alt-circle-down:before {\n  content: \"\\f358\";\n}\n\n.fa-arrow-alt-circle-left:before {\n  content: \"\\f359\";\n}\n\n.fa-arrow-alt-circle-right:before {\n  content: \"\\f35a\";\n}\n\n.fa-arrow-alt-circle-up:before {\n  content: \"\\f35b\";\n}\n\n.fa-arrow-circle-down:before {\n  content: \"\\f0ab\";\n}\n\n.fa-arrow-circle-left:before {\n  content: \"\\f0a8\";\n}\n\n.fa-arrow-circle-right:before {\n  content: \"\\f0a9\";\n}\n\n.fa-arrow-circle-up:before {\n  content: \"\\f0aa\";\n}\n\n.fa-arrow-down:before {\n  content: \"\\f063\";\n}\n\n.fa-arrow-left:before {\n  content: \"\\f060\";\n}\n\n.fa-arrow-right:before {\n  content: \"\\f061\";\n}\n\n.fa-arrow-up:before {\n  content: \"\\f062\";\n}\n\n.fa-arrows-alt:before {\n  content: \"\\f0b2\";\n}\n\n.fa-arrows-alt-h:before {\n  content: \"\\f337\";\n}\n\n.fa-arrows-alt-v:before {\n  content: \"\\f338\";\n}\n\n.fa-assistive-listening-systems:before {\n  content: \"\\f2a2\";\n}\n\n.fa-asterisk:before {\n  content: \"\\f069\";\n}\n\n.fa-asymmetrik:before {\n  content: \"\\f372\";\n}\n\n.fa-at:before {\n  content: \"\\f1fa\";\n}\n\n.fa-audible:before {\n  content: \"\\f373\";\n}\n\n.fa-audio-description:before {\n  content: \"\\f29e\";\n}\n\n.fa-autoprefixer:before {\n  content: \"\\f41c\";\n}\n\n.fa-avianex:before {\n  content: \"\\f374\";\n}\n\n.fa-aviato:before {\n  content: \"\\f421\";\n}\n\n.fa-aws:before {\n  content: \"\\f375\";\n}\n\n.fa-backward:before {\n  content: \"\\f04a\";\n}\n\n.fa-balance-scale:before {\n  content: \"\\f24e\";\n}\n\n.fa-ban:before {\n  content: \"\\f05e\";\n}\n\n.fa-bandcamp:before {\n  content: \"\\f2d5\";\n}\n\n.fa-barcode:before {\n  content: \"\\f02a\";\n}\n\n.fa-bars:before {\n  content: \"\\f0c9\";\n}\n\n.fa-bath:before {\n  content: \"\\f2cd\";\n}\n\n.fa-battery-empty:before {\n  content: \"\\f244\";\n}\n\n.fa-battery-full:before {\n  content: \"\\f240\";\n}\n\n.fa-battery-half:before {\n  content: \"\\f242\";\n}\n\n.fa-battery-quarter:before {\n  content: \"\\f243\";\n}\n\n.fa-battery-three-quarters:before {\n  content: \"\\f241\";\n}\n\n.fa-bed:before {\n  content: \"\\f236\";\n}\n\n.fa-beer:before {\n  content: \"\\f0fc\";\n}\n\n.fa-behance:before {\n  content: \"\\f1b4\";\n}\n\n.fa-behance-square:before {\n  content: \"\\f1b5\";\n}\n\n.fa-bell:before {\n  content: \"\\f0f3\";\n}\n\n.fa-bell-slash:before {\n  content: \"\\f1f6\";\n}\n\n.fa-bicycle:before {\n  content: \"\\f206\";\n}\n\n.fa-bimobject:before {\n  content: \"\\f378\";\n}\n\n.fa-binoculars:before {\n  content: \"\\f1e5\";\n}\n\n.fa-birthday-cake:before {\n  content: \"\\f1fd\";\n}\n\n.fa-bitbucket:before {\n  content: \"\\f171\";\n}\n\n.fa-bitcoin:before {\n  content: \"\\f379\";\n}\n\n.fa-bity:before {\n  content: \"\\f37a\";\n}\n\n.fa-black-tie:before {\n  content: \"\\f27e\";\n}\n\n.fa-blackberry:before {\n  content: \"\\f37b\";\n}\n\n.fa-blind:before {\n  content: \"\\f29d\";\n}\n\n.fa-blogger:before {\n  content: \"\\f37c\";\n}\n\n.fa-blogger-b:before {\n  content: \"\\f37d\";\n}\n\n.fa-bluetooth:before {\n  content: \"\\f293\";\n}\n\n.fa-bluetooth-b:before {\n  content: \"\\f294\";\n}\n\n.fa-bold:before {\n  content: \"\\f032\";\n}\n\n.fa-bolt:before {\n  content: \"\\f0e7\";\n}\n\n.fa-bomb:before {\n  content: \"\\f1e2\";\n}\n\n.fa-book:before {\n  content: \"\\f02d\";\n}\n\n.fa-bookmark:before {\n  content: \"\\f02e\";\n}\n\n.fa-braille:before {\n  content: \"\\f2a1\";\n}\n\n.fa-briefcase:before {\n  content: \"\\f0b1\";\n}\n\n.fa-btc:before {\n  content: \"\\f15a\";\n}\n\n.fa-bug:before {\n  content: \"\\f188\";\n}\n\n.fa-building:before {\n  content: \"\\f1ad\";\n}\n\n.fa-bullhorn:before {\n  content: \"\\f0a1\";\n}\n\n.fa-bullseye:before {\n  content: \"\\f140\";\n}\n\n.fa-buromobelexperte:before {\n  content: \"\\f37f\";\n}\n\n.fa-bus:before {\n  content: \"\\f207\";\n}\n\n.fa-buysellads:before {\n  content: \"\\f20d\";\n}\n\n.fa-calculator:before {\n  content: \"\\f1ec\";\n}\n\n.fa-calendar:before {\n  content: \"\\f133\";\n}\n\n.fa-calendar-alt:before {\n  content: \"\\f073\";\n}\n\n.fa-calendar-check:before {\n  content: \"\\f274\";\n}\n\n.fa-calendar-minus:before {\n  content: \"\\f272\";\n}\n\n.fa-calendar-plus:before {\n  content: \"\\f271\";\n}\n\n.fa-calendar-times:before {\n  content: \"\\f273\";\n}\n\n.fa-camera:before {\n  content: \"\\f030\";\n}\n\n.fa-camera-retro:before {\n  content: \"\\f083\";\n}\n\n.fa-car:before {\n  content: \"\\f1b9\";\n}\n\n.fa-caret-down:before {\n  content: \"\\f0d7\";\n}\n\n.fa-caret-left:before {\n  content: \"\\f0d9\";\n}\n\n.fa-caret-right:before {\n  content: \"\\f0da\";\n}\n\n.fa-caret-square-down:before {\n  content: \"\\f150\";\n}\n\n.fa-caret-square-left:before {\n  content: \"\\f191\";\n}\n\n.fa-caret-square-right:before {\n  content: \"\\f152\";\n}\n\n.fa-caret-square-up:before {\n  content: \"\\f151\";\n}\n\n.fa-caret-up:before {\n  content: \"\\f0d8\";\n}\n\n.fa-cart-arrow-down:before {\n  content: \"\\f218\";\n}\n\n.fa-cart-plus:before {\n  content: \"\\f217\";\n}\n\n.fa-cc-amazon-pay:before {\n  content: \"\\f42d\";\n}\n\n.fa-cc-amex:before {\n  content: \"\\f1f3\";\n}\n\n.fa-cc-apple-pay:before {\n  content: \"\\f416\";\n}\n\n.fa-cc-diners-club:before {\n  content: \"\\f24c\";\n}\n\n.fa-cc-discover:before {\n  content: \"\\f1f2\";\n}\n\n.fa-cc-jcb:before {\n  content: \"\\f24b\";\n}\n\n.fa-cc-mastercard:before {\n  content: \"\\f1f1\";\n}\n\n.fa-cc-paypal:before {\n  content: \"\\f1f4\";\n}\n\n.fa-cc-stripe:before {\n  content: \"\\f1f5\";\n}\n\n.fa-cc-visa:before {\n  content: \"\\f1f0\";\n}\n\n.fa-centercode:before {\n  content: \"\\f380\";\n}\n\n.fa-certificate:before {\n  content: \"\\f0a3\";\n}\n\n.fa-chart-area:before {\n  content: \"\\f1fe\";\n}\n\n.fa-chart-bar:before {\n  content: \"\\f080\";\n}\n\n.fa-chart-line:before {\n  content: \"\\f201\";\n}\n\n.fa-chart-pie:before {\n  content: \"\\f200\";\n}\n\n.fa-check:before {\n  content: \"\\f00c\";\n}\n\n.fa-check-circle:before {\n  content: \"\\f058\";\n}\n\n.fa-check-square:before {\n  content: \"\\f14a\";\n}\n\n.fa-chevron-circle-down:before {\n  content: \"\\f13a\";\n}\n\n.fa-chevron-circle-left:before {\n  content: \"\\f137\";\n}\n\n.fa-chevron-circle-right:before {\n  content: \"\\f138\";\n}\n\n.fa-chevron-circle-up:before {\n  content: \"\\f139\";\n}\n\n.fa-chevron-down:before {\n  content: \"\\f078\";\n}\n\n.fa-chevron-left:before {\n  content: \"\\f053\";\n}\n\n.fa-chevron-right:before {\n  content: \"\\f054\";\n}\n\n.fa-chevron-up:before {\n  content: \"\\f077\";\n}\n\n.fa-child:before {\n  content: \"\\f1ae\";\n}\n\n.fa-chrome:before {\n  content: \"\\f268\";\n}\n\n.fa-circle:before {\n  content: \"\\f111\";\n}\n\n.fa-circle-notch:before {\n  content: \"\\f1ce\";\n}\n\n.fa-clipboard:before {\n  content: \"\\f328\";\n}\n\n.fa-clock:before {\n  content: \"\\f017\";\n}\n\n.fa-clone:before {\n  content: \"\\f24d\";\n}\n\n.fa-closed-captioning:before {\n  content: \"\\f20a\";\n}\n\n.fa-cloud:before {\n  content: \"\\f0c2\";\n}\n\n.fa-cloud-download-alt:before {\n  content: \"\\f381\";\n}\n\n.fa-cloud-upload-alt:before {\n  content: \"\\f382\";\n}\n\n.fa-cloudscale:before {\n  content: \"\\f383\";\n}\n\n.fa-cloudsmith:before {\n  content: \"\\f384\";\n}\n\n.fa-cloudversify:before {\n  content: \"\\f385\";\n}\n\n.fa-code:before {\n  content: \"\\f121\";\n}\n\n.fa-code-branch:before {\n  content: \"\\f126\";\n}\n\n.fa-codepen:before {\n  content: \"\\f1cb\";\n}\n\n.fa-codiepie:before {\n  content: \"\\f284\";\n}\n\n.fa-coffee:before {\n  content: \"\\f0f4\";\n}\n\n.fa-cog:before {\n  content: \"\\f013\";\n}\n\n.fa-cogs:before {\n  content: \"\\f085\";\n}\n\n.fa-columns:before {\n  content: \"\\f0db\";\n}\n\n.fa-comment:before {\n  content: \"\\f075\";\n}\n\n.fa-comment-alt:before {\n  content: \"\\f27a\";\n}\n\n.fa-comments:before {\n  content: \"\\f086\";\n}\n\n.fa-compass:before {\n  content: \"\\f14e\";\n}\n\n.fa-compress:before {\n  content: \"\\f066\";\n}\n\n.fa-connectdevelop:before {\n  content: \"\\f20e\";\n}\n\n.fa-contao:before {\n  content: \"\\f26d\";\n}\n\n.fa-copy:before {\n  content: \"\\f0c5\";\n}\n\n.fa-copyright:before {\n  content: \"\\f1f9\";\n}\n\n.fa-cpanel:before {\n  content: \"\\f388\";\n}\n\n.fa-creative-commons:before {\n  content: \"\\f25e\";\n}\n\n.fa-credit-card:before {\n  content: \"\\f09d\";\n}\n\n.fa-crop:before {\n  content: \"\\f125\";\n}\n\n.fa-crosshairs:before {\n  content: \"\\f05b\";\n}\n\n.fa-css3:before {\n  content: \"\\f13c\";\n}\n\n.fa-css3-alt:before {\n  content: \"\\f38b\";\n}\n\n.fa-cube:before {\n  content: \"\\f1b2\";\n}\n\n.fa-cubes:before {\n  content: \"\\f1b3\";\n}\n\n.fa-cut:before {\n  content: \"\\f0c4\";\n}\n\n.fa-cuttlefish:before {\n  content: \"\\f38c\";\n}\n\n.fa-d-and-d:before {\n  content: \"\\f38d\";\n}\n\n.fa-dashcube:before {\n  content: \"\\f210\";\n}\n\n.fa-database:before {\n  content: \"\\f1c0\";\n}\n\n.fa-deaf:before {\n  content: \"\\f2a4\";\n}\n\n.fa-delicious:before {\n  content: \"\\f1a5\";\n}\n\n.fa-deploydog:before {\n  content: \"\\f38e\";\n}\n\n.fa-deskpro:before {\n  content: \"\\f38f\";\n}\n\n.fa-desktop:before {\n  content: \"\\f108\";\n}\n\n.fa-deviantart:before {\n  content: \"\\f1bd\";\n}\n\n.fa-digg:before {\n  content: \"\\f1a6\";\n}\n\n.fa-digital-ocean:before {\n  content: \"\\f391\";\n}\n\n.fa-discord:before {\n  content: \"\\f392\";\n}\n\n.fa-discourse:before {\n  content: \"\\f393\";\n}\n\n.fa-dochub:before {\n  content: \"\\f394\";\n}\n\n.fa-docker:before {\n  content: \"\\f395\";\n}\n\n.fa-dollar-sign:before {\n  content: \"\\f155\";\n}\n\n.fa-dot-circle:before {\n  content: \"\\f192\";\n}\n\n.fa-download:before {\n  content: \"\\f019\";\n}\n\n.fa-draft2digital:before {\n  content: \"\\f396\";\n}\n\n.fa-dribbble:before {\n  content: \"\\f17d\";\n}\n\n.fa-dribbble-square:before {\n  content: \"\\f397\";\n}\n\n.fa-dropbox:before {\n  content: \"\\f16b\";\n}\n\n.fa-drupal:before {\n  content: \"\\f1a9\";\n}\n\n.fa-dyalog:before {\n  content: \"\\f399\";\n}\n\n.fa-earlybirds:before {\n  content: \"\\f39a\";\n}\n\n.fa-edge:before {\n  content: \"\\f282\";\n}\n\n.fa-edit:before {\n  content: \"\\f044\";\n}\n\n.fa-eject:before {\n  content: \"\\f052\";\n}\n\n.fa-elementor:before {\n  content: \"\\f430\";\n}\n\n.fa-ellipsis-h:before {\n  content: \"\\f141\";\n}\n\n.fa-ellipsis-v:before {\n  content: \"\\f142\";\n}\n\n.fa-ember:before {\n  content: \"\\f423\";\n}\n\n.fa-empire:before {\n  content: \"\\f1d1\";\n}\n\n.fa-envelope:before {\n  content: \"\\f0e0\";\n}\n\n.fa-envelope-open:before {\n  content: \"\\f2b6\";\n}\n\n.fa-envelope-square:before {\n  content: \"\\f199\";\n}\n\n.fa-envira:before {\n  content: \"\\f299\";\n}\n\n.fa-eraser:before {\n  content: \"\\f12d\";\n}\n\n.fa-erlang:before {\n  content: \"\\f39d\";\n}\n\n.fa-ethereum:before {\n  content: \"\\f42e\";\n}\n\n.fa-etsy:before {\n  content: \"\\f2d7\";\n}\n\n.fa-euro-sign:before {\n  content: \"\\f153\";\n}\n\n.fa-exchange-alt:before {\n  content: \"\\f362\";\n}\n\n.fa-exclamation:before {\n  content: \"\\f12a\";\n}\n\n.fa-exclamation-circle:before {\n  content: \"\\f06a\";\n}\n\n.fa-exclamation-triangle:before {\n  content: \"\\f071\";\n}\n\n.fa-expand:before {\n  content: \"\\f065\";\n}\n\n.fa-expand-arrows-alt:before {\n  content: \"\\f31e\";\n}\n\n.fa-expeditedssl:before {\n  content: \"\\f23e\";\n}\n\n.fa-external-link-alt:before {\n  content: \"\\f35d\";\n}\n\n.fa-external-link-square-alt:before {\n  content: \"\\f360\";\n}\n\n.fa-eye:before {\n  content: \"\\f06e\";\n}\n\n.fa-eye-dropper:before {\n  content: \"\\f1fb\";\n}\n\n.fa-eye-slash:before {\n  content: \"\\f070\";\n}\n\n.fa-facebook:before {\n  content: \"\\f09a\";\n}\n\n.fa-facebook-f:before {\n  content: \"\\f39e\";\n}\n\n.fa-facebook-messenger:before {\n  content: \"\\f39f\";\n}\n\n.fa-facebook-square:before {\n  content: \"\\f082\";\n}\n\n.fa-fast-backward:before {\n  content: \"\\f049\";\n}\n\n.fa-fast-forward:before {\n  content: \"\\f050\";\n}\n\n.fa-fax:before {\n  content: \"\\f1ac\";\n}\n\n.fa-female:before {\n  content: \"\\f182\";\n}\n\n.fa-fighter-jet:before {\n  content: \"\\f0fb\";\n}\n\n.fa-file:before {\n  content: \"\\f15b\";\n}\n\n.fa-file-alt:before {\n  content: \"\\f15c\";\n}\n\n.fa-file-archive:before {\n  content: \"\\f1c6\";\n}\n\n.fa-file-audio:before {\n  content: \"\\f1c7\";\n}\n\n.fa-file-code:before {\n  content: \"\\f1c9\";\n}\n\n.fa-file-excel:before {\n  content: \"\\f1c3\";\n}\n\n.fa-file-image:before {\n  content: \"\\f1c5\";\n}\n\n.fa-file-pdf:before {\n  content: \"\\f1c1\";\n}\n\n.fa-file-powerpoint:before {\n  content: \"\\f1c4\";\n}\n\n.fa-file-video:before {\n  content: \"\\f1c8\";\n}\n\n.fa-file-word:before {\n  content: \"\\f1c2\";\n}\n\n.fa-film:before {\n  content: \"\\f008\";\n}\n\n.fa-filter:before {\n  content: \"\\f0b0\";\n}\n\n.fa-fire:before {\n  content: \"\\f06d\";\n}\n\n.fa-fire-extinguisher:before {\n  content: \"\\f134\";\n}\n\n.fa-firefox:before {\n  content: \"\\f269\";\n}\n\n.fa-first-order:before {\n  content: \"\\f2b0\";\n}\n\n.fa-firstdraft:before {\n  content: \"\\f3a1\";\n}\n\n.fa-flag:before {\n  content: \"\\f024\";\n}\n\n.fa-flag-checkered:before {\n  content: \"\\f11e\";\n}\n\n.fa-flask:before {\n  content: \"\\f0c3\";\n}\n\n.fa-flickr:before {\n  content: \"\\f16e\";\n}\n\n.fa-fly:before {\n  content: \"\\f417\";\n}\n\n.fa-folder:before {\n  content: \"\\f07b\";\n}\n\n.fa-folder-open:before {\n  content: \"\\f07c\";\n}\n\n.fa-font:before {\n  content: \"\\f031\";\n}\n\n.fa-font-awesome:before {\n  content: \"\\f2b4\";\n}\n\n.fa-font-awesome-alt:before {\n  content: \"\\f35c\";\n}\n\n.fa-font-awesome-flag:before {\n  content: \"\\f425\";\n}\n\n.fa-fonticons:before {\n  content: \"\\f280\";\n}\n\n.fa-fonticons-fi:before {\n  content: \"\\f3a2\";\n}\n\n.fa-fort-awesome:before {\n  content: \"\\f286\";\n}\n\n.fa-fort-awesome-alt:before {\n  content: \"\\f3a3\";\n}\n\n.fa-forumbee:before {\n  content: \"\\f211\";\n}\n\n.fa-forward:before {\n  content: \"\\f04e\";\n}\n\n.fa-foursquare:before {\n  content: \"\\f180\";\n}\n\n.fa-free-code-camp:before {\n  content: \"\\f2c5\";\n}\n\n.fa-freebsd:before {\n  content: \"\\f3a4\";\n}\n\n.fa-frown:before {\n  content: \"\\f119\";\n}\n\n.fa-futbol:before {\n  content: \"\\f1e3\";\n}\n\n.fa-gamepad:before {\n  content: \"\\f11b\";\n}\n\n.fa-gavel:before {\n  content: \"\\f0e3\";\n}\n\n.fa-gem:before {\n  content: \"\\f3a5\";\n}\n\n.fa-genderless:before {\n  content: \"\\f22d\";\n}\n\n.fa-get-pocket:before {\n  content: \"\\f265\";\n}\n\n.fa-gg:before {\n  content: \"\\f260\";\n}\n\n.fa-gg-circle:before {\n  content: \"\\f261\";\n}\n\n.fa-gift:before {\n  content: \"\\f06b\";\n}\n\n.fa-git:before {\n  content: \"\\f1d3\";\n}\n\n.fa-git-square:before {\n  content: \"\\f1d2\";\n}\n\n.fa-github:before {\n  content: \"\\f09b\";\n}\n\n.fa-github-alt:before {\n  content: \"\\f113\";\n}\n\n.fa-github-square:before {\n  content: \"\\f092\";\n}\n\n.fa-gitkraken:before {\n  content: \"\\f3a6\";\n}\n\n.fa-gitlab:before {\n  content: \"\\f296\";\n}\n\n.fa-gitter:before {\n  content: \"\\f426\";\n}\n\n.fa-glass-martini:before {\n  content: \"\\f000\";\n}\n\n.fa-glide:before {\n  content: \"\\f2a5\";\n}\n\n.fa-glide-g:before {\n  content: \"\\f2a6\";\n}\n\n.fa-globe:before {\n  content: \"\\f0ac\";\n}\n\n.fa-gofore:before {\n  content: \"\\f3a7\";\n}\n\n.fa-goodreads:before {\n  content: \"\\f3a8\";\n}\n\n.fa-goodreads-g:before {\n  content: \"\\f3a9\";\n}\n\n.fa-google:before {\n  content: \"\\f1a0\";\n}\n\n.fa-google-drive:before {\n  content: \"\\f3aa\";\n}\n\n.fa-google-play:before {\n  content: \"\\f3ab\";\n}\n\n.fa-google-plus:before {\n  content: \"\\f2b3\";\n}\n\n.fa-google-plus-g:before {\n  content: \"\\f0d5\";\n}\n\n.fa-google-plus-square:before {\n  content: \"\\f0d4\";\n}\n\n.fa-google-wallet:before {\n  content: \"\\f1ee\";\n}\n\n.fa-graduation-cap:before {\n  content: \"\\f19d\";\n}\n\n.fa-gratipay:before {\n  content: \"\\f184\";\n}\n\n.fa-grav:before {\n  content: \"\\f2d6\";\n}\n\n.fa-gripfire:before {\n  content: \"\\f3ac\";\n}\n\n.fa-grunt:before {\n  content: \"\\f3ad\";\n}\n\n.fa-gulp:before {\n  content: \"\\f3ae\";\n}\n\n.fa-h-square:before {\n  content: \"\\f0fd\";\n}\n\n.fa-hacker-news:before {\n  content: \"\\f1d4\";\n}\n\n.fa-hacker-news-square:before {\n  content: \"\\f3af\";\n}\n\n.fa-hand-lizard:before {\n  content: \"\\f258\";\n}\n\n.fa-hand-paper:before {\n  content: \"\\f256\";\n}\n\n.fa-hand-peace:before {\n  content: \"\\f25b\";\n}\n\n.fa-hand-point-down:before {\n  content: \"\\f0a7\";\n}\n\n.fa-hand-point-left:before {\n  content: \"\\f0a5\";\n}\n\n.fa-hand-point-right:before {\n  content: \"\\f0a4\";\n}\n\n.fa-hand-point-up:before {\n  content: \"\\f0a6\";\n}\n\n.fa-hand-pointer:before {\n  content: \"\\f25a\";\n}\n\n.fa-hand-rock:before {\n  content: \"\\f255\";\n}\n\n.fa-hand-scissors:before {\n  content: \"\\f257\";\n}\n\n.fa-hand-spock:before {\n  content: \"\\f259\";\n}\n\n.fa-handshake:before {\n  content: \"\\f2b5\";\n}\n\n.fa-hashtag:before {\n  content: \"\\f292\";\n}\n\n.fa-hdd:before {\n  content: \"\\f0a0\";\n}\n\n.fa-heading:before {\n  content: \"\\f1dc\";\n}\n\n.fa-headphones:before {\n  content: \"\\f025\";\n}\n\n.fa-heart:before {\n  content: \"\\f004\";\n}\n\n.fa-heartbeat:before {\n  content: \"\\f21e\";\n}\n\n.fa-hire-a-helper:before {\n  content: \"\\f3b0\";\n}\n\n.fa-history:before {\n  content: \"\\f1da\";\n}\n\n.fa-home:before {\n  content: \"\\f015\";\n}\n\n.fa-hooli:before {\n  content: \"\\f427\";\n}\n\n.fa-hospital:before {\n  content: \"\\f0f8\";\n}\n\n.fa-hotjar:before {\n  content: \"\\f3b1\";\n}\n\n.fa-hourglass:before {\n  content: \"\\f254\";\n}\n\n.fa-hourglass-end:before {\n  content: \"\\f253\";\n}\n\n.fa-hourglass-half:before {\n  content: \"\\f252\";\n}\n\n.fa-hourglass-start:before {\n  content: \"\\f251\";\n}\n\n.fa-houzz:before {\n  content: \"\\f27c\";\n}\n\n.fa-html5:before {\n  content: \"\\f13b\";\n}\n\n.fa-hubspot:before {\n  content: \"\\f3b2\";\n}\n\n.fa-i-cursor:before {\n  content: \"\\f246\";\n}\n\n.fa-id-badge:before {\n  content: \"\\f2c1\";\n}\n\n.fa-id-card:before {\n  content: \"\\f2c2\";\n}\n\n.fa-image:before {\n  content: \"\\f03e\";\n}\n\n.fa-images:before {\n  content: \"\\f302\";\n}\n\n.fa-imdb:before {\n  content: \"\\f2d8\";\n}\n\n.fa-inbox:before {\n  content: \"\\f01c\";\n}\n\n.fa-indent:before {\n  content: \"\\f03c\";\n}\n\n.fa-industry:before {\n  content: \"\\f275\";\n}\n\n.fa-info:before {\n  content: \"\\f129\";\n}\n\n.fa-info-circle:before {\n  content: \"\\f05a\";\n}\n\n.fa-instagram:before {\n  content: \"\\f16d\";\n}\n\n.fa-internet-explorer:before {\n  content: \"\\f26b\";\n}\n\n.fa-ioxhost:before {\n  content: \"\\f208\";\n}\n\n.fa-italic:before {\n  content: \"\\f033\";\n}\n\n.fa-itunes:before {\n  content: \"\\f3b4\";\n}\n\n.fa-itunes-note:before {\n  content: \"\\f3b5\";\n}\n\n.fa-jenkins:before {\n  content: \"\\f3b6\";\n}\n\n.fa-joget:before {\n  content: \"\\f3b7\";\n}\n\n.fa-joomla:before {\n  content: \"\\f1aa\";\n}\n\n.fa-js:before {\n  content: \"\\f3b8\";\n}\n\n.fa-js-square:before {\n  content: \"\\f3b9\";\n}\n\n.fa-jsfiddle:before {\n  content: \"\\f1cc\";\n}\n\n.fa-key:before {\n  content: \"\\f084\";\n}\n\n.fa-keyboard:before {\n  content: \"\\f11c\";\n}\n\n.fa-keycdn:before {\n  content: \"\\f3ba\";\n}\n\n.fa-kickstarter:before {\n  content: \"\\f3bb\";\n}\n\n.fa-kickstarter-k:before {\n  content: \"\\f3bc\";\n}\n\n.fa-korvue:before {\n  content: \"\\f42f\";\n}\n\n.fa-language:before {\n  content: \"\\f1ab\";\n}\n\n.fa-laptop:before {\n  content: \"\\f109\";\n}\n\n.fa-laravel:before {\n  content: \"\\f3bd\";\n}\n\n.fa-lastfm:before {\n  content: \"\\f202\";\n}\n\n.fa-lastfm-square:before {\n  content: \"\\f203\";\n}\n\n.fa-leaf:before {\n  content: \"\\f06c\";\n}\n\n.fa-leanpub:before {\n  content: \"\\f212\";\n}\n\n.fa-lemon:before {\n  content: \"\\f094\";\n}\n\n.fa-less:before {\n  content: \"\\f41d\";\n}\n\n.fa-level-down-alt:before {\n  content: \"\\f3be\";\n}\n\n.fa-level-up-alt:before {\n  content: \"\\f3bf\";\n}\n\n.fa-life-ring:before {\n  content: \"\\f1cd\";\n}\n\n.fa-lightbulb:before {\n  content: \"\\f0eb\";\n}\n\n.fa-line:before {\n  content: \"\\f3c0\";\n}\n\n.fa-link:before {\n  content: \"\\f0c1\";\n}\n\n.fa-linkedin:before {\n  content: \"\\f08c\";\n}\n\n.fa-linkedin-in:before {\n  content: \"\\f0e1\";\n}\n\n.fa-linode:before {\n  content: \"\\f2b8\";\n}\n\n.fa-linux:before {\n  content: \"\\f17c\";\n}\n\n.fa-lira-sign:before {\n  content: \"\\f195\";\n}\n\n.fa-list:before {\n  content: \"\\f03a\";\n}\n\n.fa-list-alt:before {\n  content: \"\\f022\";\n}\n\n.fa-list-ol:before {\n  content: \"\\f0cb\";\n}\n\n.fa-list-ul:before {\n  content: \"\\f0ca\";\n}\n\n.fa-location-arrow:before {\n  content: \"\\f124\";\n}\n\n.fa-lock:before {\n  content: \"\\f023\";\n}\n\n.fa-lock-open:before {\n  content: \"\\f3c1\";\n}\n\n.fa-long-arrow-alt-down:before {\n  content: \"\\f309\";\n}\n\n.fa-long-arrow-alt-left:before {\n  content: \"\\f30a\";\n}\n\n.fa-long-arrow-alt-right:before {\n  content: \"\\f30b\";\n}\n\n.fa-long-arrow-alt-up:before {\n  content: \"\\f30c\";\n}\n\n.fa-low-vision:before {\n  content: \"\\f2a8\";\n}\n\n.fa-lyft:before {\n  content: \"\\f3c3\";\n}\n\n.fa-magento:before {\n  content: \"\\f3c4\";\n}\n\n.fa-magic:before {\n  content: \"\\f0d0\";\n}\n\n.fa-magnet:before {\n  content: \"\\f076\";\n}\n\n.fa-male:before {\n  content: \"\\f183\";\n}\n\n.fa-map:before {\n  content: \"\\f279\";\n}\n\n.fa-map-marker:before {\n  content: \"\\f041\";\n}\n\n.fa-map-marker-alt:before {\n  content: \"\\f3c5\";\n}\n\n.fa-map-pin:before {\n  content: \"\\f276\";\n}\n\n.fa-map-signs:before {\n  content: \"\\f277\";\n}\n\n.fa-mars:before {\n  content: \"\\f222\";\n}\n\n.fa-mars-double:before {\n  content: \"\\f227\";\n}\n\n.fa-mars-stroke:before {\n  content: \"\\f229\";\n}\n\n.fa-mars-stroke-h:before {\n  content: \"\\f22b\";\n}\n\n.fa-mars-stroke-v:before {\n  content: \"\\f22a\";\n}\n\n.fa-maxcdn:before {\n  content: \"\\f136\";\n}\n\n.fa-medapps:before {\n  content: \"\\f3c6\";\n}\n\n.fa-medium:before {\n  content: \"\\f23a\";\n}\n\n.fa-medium-m:before {\n  content: \"\\f3c7\";\n}\n\n.fa-medkit:before {\n  content: \"\\f0fa\";\n}\n\n.fa-medrt:before {\n  content: \"\\f3c8\";\n}\n\n.fa-meetup:before {\n  content: \"\\f2e0\";\n}\n\n.fa-meh:before {\n  content: \"\\f11a\";\n}\n\n.fa-mercury:before {\n  content: \"\\f223\";\n}\n\n.fa-microchip:before {\n  content: \"\\f2db\";\n}\n\n.fa-microphone:before {\n  content: \"\\f130\";\n}\n\n.fa-microphone-slash:before {\n  content: \"\\f131\";\n}\n\n.fa-microsoft:before {\n  content: \"\\f3ca\";\n}\n\n.fa-minus:before {\n  content: \"\\f068\";\n}\n\n.fa-minus-circle:before {\n  content: \"\\f056\";\n}\n\n.fa-minus-square:before {\n  content: \"\\f146\";\n}\n\n.fa-mix:before {\n  content: \"\\f3cb\";\n}\n\n.fa-mixcloud:before {\n  content: \"\\f289\";\n}\n\n.fa-mizuni:before {\n  content: \"\\f3cc\";\n}\n\n.fa-mobile:before {\n  content: \"\\f10b\";\n}\n\n.fa-mobile-alt:before {\n  content: \"\\f3cd\";\n}\n\n.fa-modx:before {\n  content: \"\\f285\";\n}\n\n.fa-monero:before {\n  content: \"\\f3d0\";\n}\n\n.fa-money-bill-alt:before {\n  content: \"\\f3d1\";\n}\n\n.fa-moon:before {\n  content: \"\\f186\";\n}\n\n.fa-motorcycle:before {\n  content: \"\\f21c\";\n}\n\n.fa-mouse-pointer:before {\n  content: \"\\f245\";\n}\n\n.fa-music:before {\n  content: \"\\f001\";\n}\n\n.fa-napster:before {\n  content: \"\\f3d2\";\n}\n\n.fa-neuter:before {\n  content: \"\\f22c\";\n}\n\n.fa-newspaper:before {\n  content: \"\\f1ea\";\n}\n\n.fa-nintendo-switch:before {\n  content: \"\\f418\";\n}\n\n.fa-node:before {\n  content: \"\\f419\";\n}\n\n.fa-node-js:before {\n  content: \"\\f3d3\";\n}\n\n.fa-npm:before {\n  content: \"\\f3d4\";\n}\n\n.fa-ns8:before {\n  content: \"\\f3d5\";\n}\n\n.fa-nutritionix:before {\n  content: \"\\f3d6\";\n}\n\n.fa-object-group:before {\n  content: \"\\f247\";\n}\n\n.fa-object-ungroup:before {\n  content: \"\\f248\";\n}\n\n.fa-odnoklassniki:before {\n  content: \"\\f263\";\n}\n\n.fa-odnoklassniki-square:before {\n  content: \"\\f264\";\n}\n\n.fa-opencart:before {\n  content: \"\\f23d\";\n}\n\n.fa-openid:before {\n  content: \"\\f19b\";\n}\n\n.fa-opera:before {\n  content: \"\\f26a\";\n}\n\n.fa-optin-monster:before {\n  content: \"\\f23c\";\n}\n\n.fa-osi:before {\n  content: \"\\f41a\";\n}\n\n.fa-outdent:before {\n  content: \"\\f03b\";\n}\n\n.fa-page4:before {\n  content: \"\\f3d7\";\n}\n\n.fa-pagelines:before {\n  content: \"\\f18c\";\n}\n\n.fa-paint-brush:before {\n  content: \"\\f1fc\";\n}\n\n.fa-palfed:before {\n  content: \"\\f3d8\";\n}\n\n.fa-paper-plane:before {\n  content: \"\\f1d8\";\n}\n\n.fa-paperclip:before {\n  content: \"\\f0c6\";\n}\n\n.fa-paragraph:before {\n  content: \"\\f1dd\";\n}\n\n.fa-paste:before {\n  content: \"\\f0ea\";\n}\n\n.fa-patreon:before {\n  content: \"\\f3d9\";\n}\n\n.fa-pause:before {\n  content: \"\\f04c\";\n}\n\n.fa-pause-circle:before {\n  content: \"\\f28b\";\n}\n\n.fa-paw:before {\n  content: \"\\f1b0\";\n}\n\n.fa-paypal:before {\n  content: \"\\f1ed\";\n}\n\n.fa-pen-square:before {\n  content: \"\\f14b\";\n}\n\n.fa-pencil-alt:before {\n  content: \"\\f303\";\n}\n\n.fa-percent:before {\n  content: \"\\f295\";\n}\n\n.fa-periscope:before {\n  content: \"\\f3da\";\n}\n\n.fa-phabricator:before {\n  content: \"\\f3db\";\n}\n\n.fa-phoenix-framework:before {\n  content: \"\\f3dc\";\n}\n\n.fa-phone:before {\n  content: \"\\f095\";\n}\n\n.fa-phone-square:before {\n  content: \"\\f098\";\n}\n\n.fa-phone-volume:before {\n  content: \"\\f2a0\";\n}\n\n.fa-pied-piper:before {\n  content: \"\\f2ae\";\n}\n\n.fa-pied-piper-alt:before {\n  content: \"\\f1a8\";\n}\n\n.fa-pied-piper-pp:before {\n  content: \"\\f1a7\";\n}\n\n.fa-pinterest:before {\n  content: \"\\f0d2\";\n}\n\n.fa-pinterest-p:before {\n  content: \"\\f231\";\n}\n\n.fa-pinterest-square:before {\n  content: \"\\f0d3\";\n}\n\n.fa-plane:before {\n  content: \"\\f072\";\n}\n\n.fa-play:before {\n  content: \"\\f04b\";\n}\n\n.fa-play-circle:before {\n  content: \"\\f144\";\n}\n\n.fa-playstation:before {\n  content: \"\\f3df\";\n}\n\n.fa-plug:before {\n  content: \"\\f1e6\";\n}\n\n.fa-plus:before {\n  content: \"\\f067\";\n}\n\n.fa-plus-circle:before {\n  content: \"\\f055\";\n}\n\n.fa-plus-square:before {\n  content: \"\\f0fe\";\n}\n\n.fa-podcast:before {\n  content: \"\\f2ce\";\n}\n\n.fa-pound-sign:before {\n  content: \"\\f154\";\n}\n\n.fa-power-off:before {\n  content: \"\\f011\";\n}\n\n.fa-print:before {\n  content: \"\\f02f\";\n}\n\n.fa-product-hunt:before {\n  content: \"\\f288\";\n}\n\n.fa-pushed:before {\n  content: \"\\f3e1\";\n}\n\n.fa-puzzle-piece:before {\n  content: \"\\f12e\";\n}\n\n.fa-python:before {\n  content: \"\\f3e2\";\n}\n\n.fa-qq:before {\n  content: \"\\f1d6\";\n}\n\n.fa-qrcode:before {\n  content: \"\\f029\";\n}\n\n.fa-question:before {\n  content: \"\\f128\";\n}\n\n.fa-question-circle:before {\n  content: \"\\f059\";\n}\n\n.fa-quora:before {\n  content: \"\\f2c4\";\n}\n\n.fa-quote-left:before {\n  content: \"\\f10d\";\n}\n\n.fa-quote-right:before {\n  content: \"\\f10e\";\n}\n\n.fa-random:before {\n  content: \"\\f074\";\n}\n\n.fa-ravelry:before {\n  content: \"\\f2d9\";\n}\n\n.fa-react:before {\n  content: \"\\f41b\";\n}\n\n.fa-rebel:before {\n  content: \"\\f1d0\";\n}\n\n.fa-recycle:before {\n  content: \"\\f1b8\";\n}\n\n.fa-red-river:before {\n  content: \"\\f3e3\";\n}\n\n.fa-reddit:before {\n  content: \"\\f1a1\";\n}\n\n.fa-reddit-alien:before {\n  content: \"\\f281\";\n}\n\n.fa-reddit-square:before {\n  content: \"\\f1a2\";\n}\n\n.fa-redo:before {\n  content: \"\\f01e\";\n}\n\n.fa-redo-alt:before {\n  content: \"\\f2f9\";\n}\n\n.fa-registered:before {\n  content: \"\\f25d\";\n}\n\n.fa-rendact:before {\n  content: \"\\f3e4\";\n}\n\n.fa-renren:before {\n  content: \"\\f18b\";\n}\n\n.fa-reply:before {\n  content: \"\\f3e5\";\n}\n\n.fa-reply-all:before {\n  content: \"\\f122\";\n}\n\n.fa-replyd:before {\n  content: \"\\f3e6\";\n}\n\n.fa-resolving:before {\n  content: \"\\f3e7\";\n}\n\n.fa-retweet:before {\n  content: \"\\f079\";\n}\n\n.fa-road:before {\n  content: \"\\f018\";\n}\n\n.fa-rocket:before {\n  content: \"\\f135\";\n}\n\n.fa-rocketchat:before {\n  content: \"\\f3e8\";\n}\n\n.fa-rockrms:before {\n  content: \"\\f3e9\";\n}\n\n.fa-rss:before {\n  content: \"\\f09e\";\n}\n\n.fa-rss-square:before {\n  content: \"\\f143\";\n}\n\n.fa-ruble-sign:before {\n  content: \"\\f158\";\n}\n\n.fa-rupee-sign:before {\n  content: \"\\f156\";\n}\n\n.fa-safari:before {\n  content: \"\\f267\";\n}\n\n.fa-sass:before {\n  content: \"\\f41e\";\n}\n\n.fa-save:before {\n  content: \"\\f0c7\";\n}\n\n.fa-schlix:before {\n  content: \"\\f3ea\";\n}\n\n.fa-scribd:before {\n  content: \"\\f28a\";\n}\n\n.fa-search:before {\n  content: \"\\f002\";\n}\n\n.fa-search-minus:before {\n  content: \"\\f010\";\n}\n\n.fa-search-plus:before {\n  content: \"\\f00e\";\n}\n\n.fa-searchengin:before {\n  content: \"\\f3eb\";\n}\n\n.fa-sellcast:before {\n  content: \"\\f2da\";\n}\n\n.fa-sellsy:before {\n  content: \"\\f213\";\n}\n\n.fa-server:before {\n  content: \"\\f233\";\n}\n\n.fa-servicestack:before {\n  content: \"\\f3ec\";\n}\n\n.fa-share:before {\n  content: \"\\f064\";\n}\n\n.fa-share-alt:before {\n  content: \"\\f1e0\";\n}\n\n.fa-share-alt-square:before {\n  content: \"\\f1e1\";\n}\n\n.fa-share-square:before {\n  content: \"\\f14d\";\n}\n\n.fa-shekel-sign:before {\n  content: \"\\f20b\";\n}\n\n.fa-shield-alt:before {\n  content: \"\\f3ed\";\n}\n\n.fa-ship:before {\n  content: \"\\f21a\";\n}\n\n.fa-shirtsinbulk:before {\n  content: \"\\f214\";\n}\n\n.fa-shopping-bag:before {\n  content: \"\\f290\";\n}\n\n.fa-shopping-basket:before {\n  content: \"\\f291\";\n}\n\n.fa-shopping-cart:before {\n  content: \"\\f07a\";\n}\n\n.fa-shower:before {\n  content: \"\\f2cc\";\n}\n\n.fa-sign-in-alt:before {\n  content: \"\\f2f6\";\n}\n\n.fa-sign-language:before {\n  content: \"\\f2a7\";\n}\n\n.fa-sign-out-alt:before {\n  content: \"\\f2f5\";\n}\n\n.fa-signal:before {\n  content: \"\\f012\";\n}\n\n.fa-simplybuilt:before {\n  content: \"\\f215\";\n}\n\n.fa-sistrix:before {\n  content: \"\\f3ee\";\n}\n\n.fa-sitemap:before {\n  content: \"\\f0e8\";\n}\n\n.fa-skyatlas:before {\n  content: \"\\f216\";\n}\n\n.fa-skype:before {\n  content: \"\\f17e\";\n}\n\n.fa-slack:before {\n  content: \"\\f198\";\n}\n\n.fa-slack-hash:before {\n  content: \"\\f3ef\";\n}\n\n.fa-sliders-h:before {\n  content: \"\\f1de\";\n}\n\n.fa-slideshare:before {\n  content: \"\\f1e7\";\n}\n\n.fa-smile:before {\n  content: \"\\f118\";\n}\n\n.fa-snapchat:before {\n  content: \"\\f2ab\";\n}\n\n.fa-snapchat-ghost:before {\n  content: \"\\f2ac\";\n}\n\n.fa-snapchat-square:before {\n  content: \"\\f2ad\";\n}\n\n.fa-snowflake:before {\n  content: \"\\f2dc\";\n}\n\n.fa-sort:before {\n  content: \"\\f0dc\";\n}\n\n.fa-sort-alpha-down:before {\n  content: \"\\f15d\";\n}\n\n.fa-sort-alpha-up:before {\n  content: \"\\f15e\";\n}\n\n.fa-sort-amount-down:before {\n  content: \"\\f160\";\n}\n\n.fa-sort-amount-up:before {\n  content: \"\\f161\";\n}\n\n.fa-sort-down:before {\n  content: \"\\f0dd\";\n}\n\n.fa-sort-numeric-down:before {\n  content: \"\\f162\";\n}\n\n.fa-sort-numeric-up:before {\n  content: \"\\f163\";\n}\n\n.fa-sort-up:before {\n  content: \"\\f0de\";\n}\n\n.fa-soundcloud:before {\n  content: \"\\f1be\";\n}\n\n.fa-space-shuttle:before {\n  content: \"\\f197\";\n}\n\n.fa-speakap:before {\n  content: \"\\f3f3\";\n}\n\n.fa-spinner:before {\n  content: \"\\f110\";\n}\n\n.fa-spotify:before {\n  content: \"\\f1bc\";\n}\n\n.fa-square:before {\n  content: \"\\f0c8\";\n}\n\n.fa-stack-exchange:before {\n  content: \"\\f18d\";\n}\n\n.fa-stack-overflow:before {\n  content: \"\\f16c\";\n}\n\n.fa-star:before {\n  content: \"\\f005\";\n}\n\n.fa-star-half:before {\n  content: \"\\f089\";\n}\n\n.fa-staylinked:before {\n  content: \"\\f3f5\";\n}\n\n.fa-steam:before {\n  content: \"\\f1b6\";\n}\n\n.fa-steam-square:before {\n  content: \"\\f1b7\";\n}\n\n.fa-steam-symbol:before {\n  content: \"\\f3f6\";\n}\n\n.fa-step-backward:before {\n  content: \"\\f048\";\n}\n\n.fa-step-forward:before {\n  content: \"\\f051\";\n}\n\n.fa-stethoscope:before {\n  content: \"\\f0f1\";\n}\n\n.fa-sticker-mule:before {\n  content: \"\\f3f7\";\n}\n\n.fa-sticky-note:before {\n  content: \"\\f249\";\n}\n\n.fa-stop:before {\n  content: \"\\f04d\";\n}\n\n.fa-stop-circle:before {\n  content: \"\\f28d\";\n}\n\n.fa-stopwatch:before {\n  content: \"\\f2f2\";\n}\n\n.fa-strava:before {\n  content: \"\\f428\";\n}\n\n.fa-street-view:before {\n  content: \"\\f21d\";\n}\n\n.fa-strikethrough:before {\n  content: \"\\f0cc\";\n}\n\n.fa-stripe:before {\n  content: \"\\f429\";\n}\n\n.fa-stripe-s:before {\n  content: \"\\f42a\";\n}\n\n.fa-studiovinari:before {\n  content: \"\\f3f8\";\n}\n\n.fa-stumbleupon:before {\n  content: \"\\f1a4\";\n}\n\n.fa-stumbleupon-circle:before {\n  content: \"\\f1a3\";\n}\n\n.fa-subscript:before {\n  content: \"\\f12c\";\n}\n\n.fa-subway:before {\n  content: \"\\f239\";\n}\n\n.fa-suitcase:before {\n  content: \"\\f0f2\";\n}\n\n.fa-sun:before {\n  content: \"\\f185\";\n}\n\n.fa-superpowers:before {\n  content: \"\\f2dd\";\n}\n\n.fa-superscript:before {\n  content: \"\\f12b\";\n}\n\n.fa-supple:before {\n  content: \"\\f3f9\";\n}\n\n.fa-sync:before {\n  content: \"\\f021\";\n}\n\n.fa-sync-alt:before {\n  content: \"\\f2f1\";\n}\n\n.fa-table:before {\n  content: \"\\f0ce\";\n}\n\n.fa-tablet:before {\n  content: \"\\f10a\";\n}\n\n.fa-tablet-alt:before {\n  content: \"\\f3fa\";\n}\n\n.fa-tachometer-alt:before {\n  content: \"\\f3fd\";\n}\n\n.fa-tag:before {\n  content: \"\\f02b\";\n}\n\n.fa-tags:before {\n  content: \"\\f02c\";\n}\n\n.fa-tasks:before {\n  content: \"\\f0ae\";\n}\n\n.fa-taxi:before {\n  content: \"\\f1ba\";\n}\n\n.fa-telegram:before {\n  content: \"\\f2c6\";\n}\n\n.fa-telegram-plane:before {\n  content: \"\\f3fe\";\n}\n\n.fa-tencent-weibo:before {\n  content: \"\\f1d5\";\n}\n\n.fa-terminal:before {\n  content: \"\\f120\";\n}\n\n.fa-text-height:before {\n  content: \"\\f034\";\n}\n\n.fa-text-width:before {\n  content: \"\\f035\";\n}\n\n.fa-th:before {\n  content: \"\\f00a\";\n}\n\n.fa-th-large:before {\n  content: \"\\f009\";\n}\n\n.fa-th-list:before {\n  content: \"\\f00b\";\n}\n\n.fa-themeisle:before {\n  content: \"\\f2b2\";\n}\n\n.fa-thermometer-empty:before {\n  content: \"\\f2cb\";\n}\n\n.fa-thermometer-full:before {\n  content: \"\\f2c7\";\n}\n\n.fa-thermometer-half:before {\n  content: \"\\f2c9\";\n}\n\n.fa-thermometer-quarter:before {\n  content: \"\\f2ca\";\n}\n\n.fa-thermometer-three-quarters:before {\n  content: \"\\f2c8\";\n}\n\n.fa-thumbs-down:before {\n  content: \"\\f165\";\n}\n\n.fa-thumbs-up:before {\n  content: \"\\f164\";\n}\n\n.fa-thumbtack:before {\n  content: \"\\f08d\";\n}\n\n.fa-ticket-alt:before {\n  content: \"\\f3ff\";\n}\n\n.fa-times:before {\n  content: \"\\f00d\";\n}\n\n.fa-times-circle:before {\n  content: \"\\f057\";\n}\n\n.fa-tint:before {\n  content: \"\\f043\";\n}\n\n.fa-toggle-off:before {\n  content: \"\\f204\";\n}\n\n.fa-toggle-on:before {\n  content: \"\\f205\";\n}\n\n.fa-trademark:before {\n  content: \"\\f25c\";\n}\n\n.fa-train:before {\n  content: \"\\f238\";\n}\n\n.fa-transgender:before {\n  content: \"\\f224\";\n}\n\n.fa-transgender-alt:before {\n  content: \"\\f225\";\n}\n\n.fa-trash:before {\n  content: \"\\f1f8\";\n}\n\n.fa-trash-alt:before {\n  content: \"\\f2ed\";\n}\n\n.fa-tree:before {\n  content: \"\\f1bb\";\n}\n\n.fa-trello:before {\n  content: \"\\f181\";\n}\n\n.fa-tripadvisor:before {\n  content: \"\\f262\";\n}\n\n.fa-trophy:before {\n  content: \"\\f091\";\n}\n\n.fa-truck:before {\n  content: \"\\f0d1\";\n}\n\n.fa-tty:before {\n  content: \"\\f1e4\";\n}\n\n.fa-tumblr:before {\n  content: \"\\f173\";\n}\n\n.fa-tumblr-square:before {\n  content: \"\\f174\";\n}\n\n.fa-tv:before {\n  content: \"\\f26c\";\n}\n\n.fa-twitch:before {\n  content: \"\\f1e8\";\n}\n\n.fa-twitter:before {\n  content: \"\\f099\";\n}\n\n.fa-twitter-square:before {\n  content: \"\\f081\";\n}\n\n.fa-typo3:before {\n  content: \"\\f42b\";\n}\n\n.fa-uber:before {\n  content: \"\\f402\";\n}\n\n.fa-uikit:before {\n  content: \"\\f403\";\n}\n\n.fa-umbrella:before {\n  content: \"\\f0e9\";\n}\n\n.fa-underline:before {\n  content: \"\\f0cd\";\n}\n\n.fa-undo:before {\n  content: \"\\f0e2\";\n}\n\n.fa-undo-alt:before {\n  content: \"\\f2ea\";\n}\n\n.fa-uniregistry:before {\n  content: \"\\f404\";\n}\n\n.fa-universal-access:before {\n  content: \"\\f29a\";\n}\n\n.fa-university:before {\n  content: \"\\f19c\";\n}\n\n.fa-unlink:before {\n  content: \"\\f127\";\n}\n\n.fa-unlock:before {\n  content: \"\\f09c\";\n}\n\n.fa-unlock-alt:before {\n  content: \"\\f13e\";\n}\n\n.fa-untappd:before {\n  content: \"\\f405\";\n}\n\n.fa-upload:before {\n  content: \"\\f093\";\n}\n\n.fa-usb:before {\n  content: \"\\f287\";\n}\n\n.fa-user:before {\n  content: \"\\f007\";\n}\n\n.fa-user-circle:before {\n  content: \"\\f2bd\";\n}\n\n.fa-user-md:before {\n  content: \"\\f0f0\";\n}\n\n.fa-user-plus:before {\n  content: \"\\f234\";\n}\n\n.fa-user-secret:before {\n  content: \"\\f21b\";\n}\n\n.fa-user-times:before {\n  content: \"\\f235\";\n}\n\n.fa-users:before {\n  content: \"\\f0c0\";\n}\n\n.fa-ussunnah:before {\n  content: \"\\f407\";\n}\n\n.fa-utensil-spoon:before {\n  content: \"\\f2e5\";\n}\n\n.fa-utensils:before {\n  content: \"\\f2e7\";\n}\n\n.fa-vaadin:before {\n  content: \"\\f408\";\n}\n\n.fa-venus:before {\n  content: \"\\f221\";\n}\n\n.fa-venus-double:before {\n  content: \"\\f226\";\n}\n\n.fa-venus-mars:before {\n  content: \"\\f228\";\n}\n\n.fa-viacoin:before {\n  content: \"\\f237\";\n}\n\n.fa-viadeo:before {\n  content: \"\\f2a9\";\n}\n\n.fa-viadeo-square:before {\n  content: \"\\f2aa\";\n}\n\n.fa-viber:before {\n  content: \"\\f409\";\n}\n\n.fa-video:before {\n  content: \"\\f03d\";\n}\n\n.fa-vimeo:before {\n  content: \"\\f40a\";\n}\n\n.fa-vimeo-square:before {\n  content: \"\\f194\";\n}\n\n.fa-vimeo-v:before {\n  content: \"\\f27d\";\n}\n\n.fa-vine:before {\n  content: \"\\f1ca\";\n}\n\n.fa-vk:before {\n  content: \"\\f189\";\n}\n\n.fa-vnv:before {\n  content: \"\\f40b\";\n}\n\n.fa-volume-down:before {\n  content: \"\\f027\";\n}\n\n.fa-volume-off:before {\n  content: \"\\f026\";\n}\n\n.fa-volume-up:before {\n  content: \"\\f028\";\n}\n\n.fa-vuejs:before {\n  content: \"\\f41f\";\n}\n\n.fa-weibo:before {\n  content: \"\\f18a\";\n}\n\n.fa-weixin:before {\n  content: \"\\f1d7\";\n}\n\n.fa-whatsapp:before {\n  content: \"\\f232\";\n}\n\n.fa-whatsapp-square:before {\n  content: \"\\f40c\";\n}\n\n.fa-wheelchair:before {\n  content: \"\\f193\";\n}\n\n.fa-whmcs:before {\n  content: \"\\f40d\";\n}\n\n.fa-wifi:before {\n  content: \"\\f1eb\";\n}\n\n.fa-wikipedia-w:before {\n  content: \"\\f266\";\n}\n\n.fa-window-close:before {\n  content: \"\\f410\";\n}\n\n.fa-window-maximize:before {\n  content: \"\\f2d0\";\n}\n\n.fa-window-minimize:before {\n  content: \"\\f2d1\";\n}\n\n.fa-window-restore:before {\n  content: \"\\f2d2\";\n}\n\n.fa-windows:before {\n  content: \"\\f17a\";\n}\n\n.fa-won-sign:before {\n  content: \"\\f159\";\n}\n\n.fa-wordpress:before {\n  content: \"\\f19a\";\n}\n\n.fa-wordpress-simple:before {\n  content: \"\\f411\";\n}\n\n.fa-wpbeginner:before {\n  content: \"\\f297\";\n}\n\n.fa-wpexplorer:before {\n  content: \"\\f2de\";\n}\n\n.fa-wpforms:before {\n  content: \"\\f298\";\n}\n\n.fa-wrench:before {\n  content: \"\\f0ad\";\n}\n\n.fa-xbox:before {\n  content: \"\\f412\";\n}\n\n.fa-xing:before {\n  content: \"\\f168\";\n}\n\n.fa-xing-square:before {\n  content: \"\\f169\";\n}\n\n.fa-y-combinator:before {\n  content: \"\\f23b\";\n}\n\n.fa-yahoo:before {\n  content: \"\\f19e\";\n}\n\n.fa-yandex:before {\n  content: \"\\f413\";\n}\n\n.fa-yandex-international:before {\n  content: \"\\f414\";\n}\n\n.fa-yelp:before {\n  content: \"\\f1e9\";\n}\n\n.fa-yen-sign:before {\n  content: \"\\f157\";\n}\n\n.fa-yoast:before {\n  content: \"\\f2b1\";\n}\n\n.fa-youtube:before {\n  content: \"\\f167\";\n}\n\n.fa-youtube-square:before {\n  content: \"\\f431\";\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.sr-only-focusable:active,\n.sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n}\n\n@font-face {\n  font-family: Font Awesome\\ 5 Brands;\n  font-style: normal;\n  font-weight: 400;\n  src: url(../../assets/fonts/fa-brands-400.eot);\n  src: url(../../assets/fonts/fa-brands-400.eot?#iefix) format(\"embedded-opentype\"), url(../../assets/fonts/fa-brands-400.woff2) format(\"woff2\"), url(../../assets/fonts/fa-brands-400.woff) format(\"woff\"), url(../../assets/fonts/fa-brands-400.ttf) format(\"truetype\"), url(../../assets/fonts/fa-brands-400.svg#fontawesome) format(\"svg\");\n}\n.fab {\n  font-family: Font Awesome\\ 5 Brands;\n}\n.fab:before {\n  font-family: Font Awesome\\ 5 Brands;\n}\n\n@font-face {\n  font-family: Font Awesome\\ 5 Free;\n  font-style: normal;\n  font-weight: 400;\n  src: url(../../assets/fonts/fa-regular-400.eot);\n  src: url(../../assets/fonts/fa-regular-400.eot?#iefix) format(\"embedded-opentype\"), url(../../assets/fonts/fa-regular-400.woff2) format(\"woff2\"), url(../../assets/fonts/fa-regular-400.woff) format(\"woff\"), url(../../assets/fonts/fa-regular-400.ttf) format(\"truetype\"), url(../../assets/fonts/fa-regular-400.svg#fontawesome) format(\"svg\");\n}\n.far {\n  font-weight: 400;\n}\n.far:before {\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: Font Awesome\\ 5 Free;\n  font-style: normal;\n  font-weight: 900;\n  src: url(../../assets/fonts/fa-solid-900.eot);\n  src: url(../../assets/fonts/fa-solid-900.eot?#iefix) format(\"embedded-opentype\"), url(../../assets/fonts/fa-solid-900.woff2) format(\"woff2\"), url(../../assets/fonts/fa-solid-900.woff) format(\"woff\"), url(../../assets/fonts/fa-solid-900.ttf) format(\"truetype\"), url(../../assets/fonts/fa-solid-900.svg#fontawesome) format(\"svg\");\n}\n.fa,\n.far,\n.fal,\n.fas {\n  font-family: Font Awesome\\ 5 Free;\n}\n.fa:before,\n.far:before,\n.fal:before,\n.fas:before {\n  font-family: Font Awesome\\ 5 Free;\n}\n\n.fa,\n.fas {\n  font-weight: 900;\n}\n.fa:before,\n.fas:before {\n  font-weight: 900;\n}\n\n.accordion {\n  box-shadow: none;\n  border-radius: 0;\n}\n.accordion .title {\n  display: block;\n  border: 1px solid #ccc;\n  -webkit-border-radius: 0;\n  -moz-border-radius: 0;\n  -ms-border-radius: 0;\n  -o-box-sizing: 0;\n  border-radius: 0;\n  background-color: rgb(236, 236, 236);\n  -webkit-box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);\n  -moz-box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);\n  -ms-box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);\n  -o-box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);\n  min-height: 43px;\n  border-bottom: 1px solid #ccc;\n  margin-bottom: 10px;\n  position: relative;\n  padding-left: 20px !important;\n  font-size: 20px !important;\n  color: #232f3a !important;\n}\n.accordion .title i.dropdown {\n  position: absolute;\n  right: 0px;\n  top: 10px;\n  text-align: center !important;\n}\n.accordion .title i.dropdown:before {\n  content: \"\\f107\" !important;\n  color: #686c6d;\n}\n.accordion .title.active {\n  border-radius: 0;\n}\n.accordion .title.active i.dropdown {\n  top: 17px;\n  transform: rotate(180deg) !important;\n}\n.accordion .title.active i.dropdown:before {\n  color: #232f3a;\n}\n.accordion .content {\n  border-radius: 0;\n  margin-bottom: 10px;\n  border: 1px solid #ccc;\n  padding: 20px !important;\n  background: rgb(247, 248, 250);\n}\n.accordion .content table {\n  border-radius: 0 0 0 0;\n}\n.accordion .content table th {\n  padding: 10px 5px;\n}\n.accordion .title.active + .content.active {\n  margin-top: -10px;\n  border-top: none;\n}\n\n.ui.button {\n  padding: 0.6em 1.5em 0.6em;\n  font-size: 12px;\n  line-height: 1;\n  border: none;\n  -webkit-border-radius: 0;\n  -moz-border-radius: 0;\n  -ms-border-radius: 0;\n  -o-box-sizing: 0;\n  border-radius: 0;\n  vertical-align: middle;\n  text-transform: uppercase;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  cursor: pointer;\n  min-width: 85px;\n}\n.ui.button a {\n  font-size: 12px;\n  line-height: 15px;\n  color: #232f3a;\n}\n.ui.button i {\n  margin-right: 0 !important;\n  margin-top: -5px !important;\n}\n.ui.button i:before {\n  color: #fff;\n  font-size: 0.8em;\n}\n.ui.primary.button,\n.ui.primary.buttons .button {\n  background: #fdc92f;\n  color: #232f3a;\n}\n.ui.primary.button i:before,\n.ui.primary.buttons .button i:before {\n  color: #232f3a;\n}\n.ui.primary.button:hover, .ui.primary.button:active, .ui.primary.button:focus,\n.ui.primary.buttons .button:hover,\n.ui.primary.buttons .button:active,\n.ui.primary.buttons .button:focus {\n  background: #f8a800;\n  color: #232f3a;\n}\n\n.ui.secondary.button,\n.ui.secondary.buttons .button {\n  background: #285482;\n  color: #fff;\n}\n.ui.secondary.button:hover, .ui.secondary.button:active, .ui.secondary.button:focus,\n.ui.secondary.buttons .button:hover,\n.ui.secondary.buttons .button:active,\n.ui.secondary.buttons .button:focus {\n  background: #009ada;\n  color: #fff;\n}\n\n.ui.cancel.button,\n.ui.cancel.buttons .button {\n  background: #686c6d;\n  color: #fff;\n}\n.ui.cancel.button:hover, .ui.cancel.button:active, .ui.cancel.button:focus,\n.ui.cancel.buttons .button:hover,\n.ui.cancel.buttons .button:active,\n.ui.cancel.buttons .button:focus {\n  background: #87959c;\n  color: #fff;\n}\n\nbutton[disabled=disabled],\nbutton:disabled,\n.btn.disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.editBtn {\n  display: inline-block;\n  background: #285482;\n  width: 26px;\n  height: 26px;\n  color: #fff;\n  text-align: center;\n  cursor: pointer;\n}\n.editBtn i {\n  padding-left: 4px;\n}\n.editBtn i:before {\n  font-size: 0.7em;\n  color: #fff;\n}\n\n.addBtn {\n  display: inline-block;\n  background: #285482;\n  width: 26px;\n  height: 26px;\n  color: #fff;\n  text-align: center;\n  cursor: pointer;\n}\n.addBtn i {\n  padding-left: 4px;\n}\n.addBtn i:before {\n  font-size: 0.7em;\n  color: #fff;\n}\n\n.closeBtn {\n  display: inline-block;\n  background: #686c6d;\n  width: 26px;\n  height: 26px;\n  color: #fff;\n  text-align: center;\n  cursor: pointer;\n}\n.closeBtn i {\n  padding-left: 4px;\n  line-height: 26px;\n}\n.closeBtn i:before {\n  font-size: 0.9em;\n  color: #fff;\n}\n\n.ui.button.attachBtn {\n  background: #285482 !important;\n  color: #fff !important;\n}\n.ui.button.attachBtn i {\n  margin-right: 10px !important;\n}\n.ui.button.attachBtn i:before {\n  font-size: 1.1em !important;\n  color: #fff;\n}\n\n.uploadBtn {\n  display: block;\n  width: 100%;\n}\n.uploadBtn input {\n  display: inline-block !important;\n  padding: 5px !important;\n  font-size: 12px !important;\n  -webkit-appearance: none !important;\n}\n.uploadBtn .errorMessage {\n  margin-top: 0;\n}\n\n.pagerWrap {\n  padding: 12px 0;\n  border-radius: 2px;\n  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.02);\n  background-color: rgb(255, 255, 255);\n  height: 52px;\n}\n.pagerWrap .pager {\n  float: left;\n  padding-left: 3px;\n  padding-top: 4px;\n  min-width: 270px;\n}\n.pagerWrap .pager .ui.pagination {\n  min-height: auto;\n  border: none;\n  box-shadow: none;\n}\n.pagerWrap .pager .ui.pagination .item {\n  min-width: auto;\n  width: 32px;\n  height: 2spx;\n  font-size: 13px;\n  color: #686c6d;\n  padding: 4px;\n  justify-content: center;\n  margin: 0 2px;\n}\n.pagerWrap .pager .ui.pagination .item i::before {\n  font-size: 0.7em;\n  color: #686c6d;\n}\n.pagerWrap .pager .ui.pagination .item i.caret::before {\n  font-size: 0.9em;\n  color: #686c6d;\n}\n.pagerWrap .pager .ui.pagination .item i.step {\n  margin-top: -3px;\n}\n.pagerWrap .pager .ui.pagination .item::before {\n  display: none;\n}\n.pagerWrap .pager .ui.pagination .item.active {\n  background-color: #009ada;\n  color: #fff;\n  border-radius: 2px;\n}\n.pagerWrap .itemPerPage {\n  float: left;\n  margin: 0 20px;\n  font-size: 14px;\n  color: #686c6d;\n}\n.pagerWrap .itemPerPage .field {\n  display: inline-block;\n  vertical-align: middle;\n  height: 30px;\n}\n.pagerWrap .itemPerPage .field .dropdown {\n  display: inline-block;\n  width: 66px;\n  min-width: auto !important;\n  margin-right: 10px;\n}\n.pagerWrap .itemPerPage .field .dropdown i.dropdown {\n  top: 8px !important;\n}\n.pagerWrap .itemPerPage .field .dropdown .menu > .item {\n  font-size: 14px;\n  color: #686c6d;\n  padding: 0.278571429rem 0.54285714rem !important;\n}\n.pagerWrap .itemPerPage .itemsPerPage {\n  display: inline-block;\n  font-size: 14px;\n  color: #686c6d;\n  margin-left: 10px;\n  vertical-align: middle;\n}\n.pagerWrap .totalPage {\n  float: right;\n  font-size: 14px;\n  color: #686c6d;\n  padding-right: 10px;\n  padding-top: 5px;\n}\n\n.label,\n.ui.form .field > label {\n  display: block;\n  line-height: 17px;\n  font-size: 14px;\n  color: #232f3a;\n  text-align: left;\n  font-weight: 500;\n  margin-bottom: 2px;\n}\n.label .icon.asterisk,\n.label .icon.info,\n.ui.form .field > label .icon.asterisk,\n.ui.form .field > label .icon.info {\n  margin-right: 0;\n}\n.label .icon.asterisk::before,\n.label .icon.info::before,\n.ui.form .field > label .icon.asterisk::before,\n.ui.form .field > label .icon.info::before {\n  font-size: 0.7em;\n  color: #009ada;\n}\n.label .commonToolTip,\n.ui.form .field > label .commonToolTip {\n  display: inline-block;\n}\n\n.label2 {\n  display: block;\n  line-height: 17px;\n  font-size: 14px;\n  color: #686c6d;\n  text-align: left;\n  font-weight: 500;\n  margin-bottom: 0;\n}\n.label2 .icon.asterisk,\n.label2 .icon.info {\n  margin-right: 0;\n}\n.label2 .icon.asterisk::before,\n.label2 .icon.info::before {\n  font-size: 0.7em;\n  color: #009ada;\n}\n.label2 .commonToolTip {\n  display: inline-block;\n}\n\n.labelData {\n  font-size: 16px;\n  color: #232f3a;\n  font-weight: 500;\n}\n\n.ui.input input,\n.ui.mini.input input {\n  font-size: 14px;\n  padding: 0.52em 0.5em;\n  border-radius: 4px;\n  box-shadow: inset 0 2px 3px 0 rgba(0, 0, 0, 0.1);\n  background-color: rgb(255, 255, 255);\n  color: #99928a;\n}\n\n.ui.selection.dropdown {\n  padding: 0 1.8em 0 8px;\n  height: 30px;\n  min-height: 30px;\n  line-height: 30px;\n  border-radius: 4px;\n}\n.ui.selection.dropdown .dropdown.icon {\n  top: 7px;\n  right: 6px;\n  margin: 0;\n  padding: 0;\n  opacity: 0.4;\n}\n.ui.selection.dropdown .dropdown.icon:before {\n  content: \"\\f078\" !important;\n  font-size: 1em;\n}\n.ui.selection.dropdown > .text {\n  font-size: 14px;\n  color: #232f3a !important;\n  vertical-align: text-bottom;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n}\n.ui.selection.dropdown .menu > .item {\n  padding: 5px 0.54285714rem !important;\n  color: #232f3a !important;\n}\n.ui.selection.dropdown .menu span {\n  font-size: 14px !important;\n}\n.ui.selection.dropdown .menu .message {\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.ui.selection.dropdown.search .text {\n  top: -2px;\n}\n\n.ui.dropdown .visible.menu .message {\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.87);\n}\n\n.ui.form .field {\n  margin: 0 0 10px 0;\n}\n.ui.form .field .field.error {\n  margin: 0 0 0 0;\n}\n\n.ui.form .disabled.field,\n.ui.form .disabled.fields .field,\n.ui.form .field :disabled,\n.ui.disabled.input,\n.ui.input:not(.disabled) input[disabled] {\n  opacity: 0.85;\n}\n\n.ui.basic.red.label {\n  margin: -10px 0 0 0;\n  padding: 0;\n  border: none;\n  font-weight: 300;\n}\n\n.radioWrap .field {\n  margin: 5px 20px 0 0 !important;\n  display: inline-block !important;\n}\n\n.radioWrapCheckBoxOfficerTitle > div {\n  margin-right: 10px;\n}\n\n.ui.radio.checkbox input:checked ~ .box:after,\n.ui.radio.checkbox input:checked ~ label:after,\n.ui.radio.checkbox input:focus:checked ~ .box:after,\n.ui.radio.checkbox input:focus:checked ~ label:after {\n  background-color: #fff;\n}\n\n.ui.radio.checkbox input:checked ~ .box:before,\n.ui.radio.checkbox input:checked ~ label:before,\n.ui.radio.checkbox input:focus:checked ~ .box:before,\n.ui.radio.checkbox input:focus:checked ~ label:before {\n  background-color: #009ada;\n}\n\n.ui.checkbox input:checked ~ .box:before,\n.ui.checkbox input:checked ~ label:before {\n  border-color: #009ada;\n}\n\n.ui.radio.checkbox .box,\n.ui.radio.checkbox label {\n  padding-left: 1.4em;\n}\n\n.ui.checkbox .box:before,\n.ui.checkbox label:before {\n  border-radius: 0;\n  width: 16px;\n  height: 16px;\n}\n\n.ui.checkbox input:checked ~ .box:before,\n.ui.checkbox input:checked ~ label:before,\n.ui.checkbox input:checked:focus ~ .box:before,\n.ui.checkbox input:checked:focus ~ label:before {\n  background: #009ada;\n  color: #fff;\n}\n\n.ui.checkbox input:checked ~ .box:after,\n.ui.checkbox input:checked ~ label:after,\n.ui.checkbox input:checked:focus ~ .box:after,\n.ui.checkbox input:checked:focus ~ label:after {\n  font-size: 12px;\n  color: #fff;\n}\n\n.ui.checkbox.partial .box:before,\n.ui.checkbox.partial label:before {\n  background: #686c6d;\n}\n\n.ui.form textarea {\n  font-size: 14px;\n  color: #232f3a;\n  padding: 0.52em 0.5em;\n  box-shadow: inset 0 2px 3px 0 rgba(0, 0, 0, 0.1);\n}\n\n.twoColInput {\n  width: 300px !important;\n  flex-grow: 0 !important;\n  margin-right: 20px;\n}\n\n.dollarPrefix .input {\n  position: relative !important;\n}\n\n.dollarPrefix .input:before {\n  display: inline-block !important;\n  content: \"$\" !important;\n  background-position: 0 50%;\n  width: 13px;\n  height: 13px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  font-size: 16px;\n}\n\n.radioWrapper {\n  display: block;\n  margin-top: 10px;\n}\n\n.ui.tiny.modal {\n  width: 640px;\n}\n@media (max-width: 600px) {\n  .ui.tiny.modal {\n    width: 100%;\n  }\n}\n\n.ui.modal {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.5);\n  background-color: rgb(241, 241, 241);\n}\n.ui.modal .header:not(.ui) {\n  position: relative;\n  background: #686c6d;\n  font-size: 16px;\n  line-height: 20px;\n  color: #fff;\n  padding: 9px 10px;\n  border-bottom: none;\n  text-transform: uppercase;\n  font-weight: 400;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.ui.modal .header:not(.ui) > .close {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  color: #fff;\n  font-style: normal;\n  cursor: pointer;\n  z-index: 2;\n  z-index: 2;\n}\n.ui.modal .header:not(.ui) > .close:before {\n  color: #fff;\n}\n.ui.modal .content {\n  background-color: rgb(241, 241, 241);\n  padding: 0 10px;\n  max-height: 70vh;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n.ui.modal .content .description {\n  min-height: 80px;\n  padding-bottom: 45px;\n}\n.ui.modal .content .description .ui.dropdown .menu > .item > .description,\n.ui.modal .content .description .ui.dropdown > .text > .description {\n  min-height: auto;\n}\n.ui.modal .content .description .actions {\n  position: fixed;\n  bottom: 0;\n  z-index: 1;\n  width: 98% !important;\n}\n.ui.modal .actions {\n  background-color: rgb(241, 241, 241);\n  box-shadow: none;\n  border-top: none;\n  text-align: left;\n  padding: 10px 10px 15px 10px;\n}\n.ui.modal .actions .button:first-child {\n  margin-left: 0;\n}\n@media (max-width: 767px) {\n  .ui.modal .actions .button {\n    padding: 15px 20px;\n  }\n}\n.ui.modal.infoBox {\n  padding: 20px 10px;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.ui.modal.infoBox .header:not(.ui) {\n  background-color: rgb(241, 241, 241);\n  padding: 0 10px;\n}\n.ui.modal.infoBox .header:not(.ui) > .close {\n  color: #686c6d;\n  right: 0;\n  top: -10px;\n  cursor: pointer;\n}\n.ui.modal.infoBox h4 {\n  margin: 15px 0 20px 0;\n}\n.ui.modal.infoBox .actions {\n  padding: 10px 10px 0 10px;\n  bottom: 20px !important;\n}\n\n.confirmBox {\n  border-radius: 4px !important;\n}\n.confirmBox > .header:not(.ui) {\n  font-size: 16px;\n}\n.confirmBox .content {\n  font-size: 16px !important;\n  color: #232f3a;\n  text-align: center;\n  padding: 40px 15px 30px 15px !important;\n}\n.confirmBox .actions {\n  text-align: center !important;\n  padding-bottom: 40px !important;\n}\n.confirmBox .actions .ui.button {\n  background: #285482;\n  color: #fff;\n}\n.confirmBox.noCancelBtn .actions .ui.button {\n  display: none;\n}\n.confirmBox.noCancelBtn .actions .ui.button.primary {\n  display: inline-block;\n}\n\n.dblColData .colIcon {\n  display: inline-block;\n  width: 10%;\n  text-align: center;\n  vertical-align: top;\n}\n.dblColData .colText {\n  display: inline-block;\n  width: 90%;\n  font-size: 16px;\n}\n\n.editorStyleFix .questionLabel {\n  font-size: 16px;\n  color: #009ada;\n}\n.editorStyleFix .questionLabel * {\n  color: #009ada !important;\n}\n.editorStyleFix .answerLabel {\n  font-size: 16px;\n  color: #232f3a;\n}\n.editorStyleFix .answerLabel * a,\n.editorStyleFix .answerLabel * a * {\n  color: #009ada !important;\n}\n.editorStyleFix .questionLabel *,\n.editorStyleFix .answerLabel * {\n  background-color: transparent !important;\n  vertical-align: initial !important;\n}\n.editorStyleFix .questionLabel i,\n.editorStyleFix .questionLabel em,\n.editorStyleFix .answerLabel i,\n.editorStyleFix .answerLabel em {\n  font-style: italic;\n}\n.editorStyleFix .questionLabel ol,\n.editorStyleFix .answerLabel ol {\n  list-style-position: inside;\n  display: initial !important;\n}\n.editorStyleFix .questionLabel ul,\n.editorStyleFix .answerLabel ul {\n  list-style-position: inside;\n  list-style-type: initial;\n  margin-left: 17px;\n}\n.editorStyleFix .questionLabel ul li,\n.editorStyleFix .answerLabel ul li {\n  list-style-type: disc;\n}\n\n.viewModeForm .input input[disabled] {\n  box-shadow: none;\n  background: rgb(241, 241, 241);\n}\n\n.ui.modal.errormodalbox .header i:before {\n  color: #fff;\n  font-size: 14px;\n  vertical-align: top;\n}\n.ui.modal.errormodalbox .content {\n  padding: 20px 10px;\n}\n.ui.modal.errormodalbox .content ul li {\n  list-style: disc;\n  margin-left: 20px;\n  line-height: 18px;\n  margin-bottom: 10px;\n}\n.ui.modal.add-depends-tasks .content {\n  height: 200px;\n}\n.ui.modal.add-depends-tasks .content .errorMessage {\n  margin-top: 0px;\n}\n\n.passwordReset {\n  max-width: 400px;\n}\n.passwordReset .description {\n  text-align: center;\n}\n.passwordReset .description .passwordBox {\n  display: block;\n  margin: 5px auto 2px auto;\n  background: #fff;\n  width: 150px;\n  padding: 10px;\n  font-size: 16px;\n  text-align: center;\n  -webkit-border-radius: 3px;\n  -moz-border-radius: 3px;\n  -ms-border-radius: 3px;\n  -o-box-sizing: 3px;\n  border-radius: 3px;\n  box-shadow: 0 2px 8px 0 rgba(255, 255, 255, 0.5);\n}\n.passwordReset .description a {\n  font-size: 14px;\n  color: #009ada;\n  cursor: pointer;\n}\n\n.breadcrumb {\n  display: block;\n  width: 100%;\n  padding: 10px 0;\n  position: fixed;\n  top: 90px;\n  left: 24px;\n}\n.breadcrumb * {\n  font-size: 13px;\n}\n.breadcrumb .breadcrumbList li {\n  display: block;\n  float: left;\n}\n.breadcrumb .breadcrumbList li a,\n.breadcrumb .breadcrumbList li span {\n  display: inline-block;\n  font-size: 12px;\n  color: #87959c;\n}\n.breadcrumb .breadcrumbList li .current {\n  color: #232f3a;\n  cursor: default;\n}\n.breadcrumb .breadcrumbList li .sepert {\n  display: inline-block;\n  color: #87959c;\n  margin: 0 15px;\n  font-size: 22px;\n}\n.breadcrumb .breadcrumbList li .active.section {\n  font-weight: 500 !important;\n}\n.breadcrumb a {\n  color: #87959c !important;\n  white-space: nowrap;\n}\n.breadcrumb a * {\n  color: #87959c !important;\n  white-space: nowrap;\n}\n\n.tableWrapper {\n  display: block;\n  width: 100%;\n  margin: 10px 0 0 0;\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n\n.customTable {\n  width: 100%;\n  table-layout: fixed;\n  word-break: break-word;\n  word-wrap: break-word;\n  border-collapse: separate;\n  border-spacing: 0 0.625em;\n}\n.customTable thead tr th {\n  position: relative;\n  height: 52px;\n  padding: 6px 15px 6px 10px;\n  color: #686c6d;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: left;\n  font-family: \"ProximaNovaBold\";\n  border-right: 1px solid rgba(220, 220, 220, 0.5);\n  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.02);\n  background-color: rgb(255, 255, 255);\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.customTable thead tr th:first-child {\n  border-top-left-radius: 2px;\n  border-bottom-left-radius: 2px;\n}\n.customTable thead tr th:last-child {\n  border-right: none;\n  border-top-right-radius: 2px;\n  border-bottom-right-radius: 2px;\n}\n.customTable thead tr th i {\n  position: absolute;\n  right: -4px;\n  top: 15px;\n  z-index: 1;\n}\n.customTable thead tr th i::before {\n  color: rgba(220, 220, 220, 0.5);\n}\n.customTable thead tr th i.activeSort::before {\n  color: #009ada;\n}\n@media (max-width: 1023px) {\n  .customTable thead tr th {\n    display: block;\n    width: 100% !important;\n    text-align: left !important;\n    padding-left: 15px;\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n}\n.customTable tbody tr td {\n  padding: 11px 10px;\n  color: #232f3a;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: left;\n  vertical-align: middle;\n  border: none;\n  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.02);\n  background-color: rgb(255, 255, 255);\n}\n.customTable tbody tr td:first-child {\n  border-top-left-radius: 2px;\n  border-bottom-left-radius: 2px;\n}\n.customTable tbody tr td:last-child {\n  border-top-right-radius: 2px;\n  border-bottom-right-radius: 2px;\n}\n.customTable tbody tr td a {\n  font-size: 14px;\n  color: #009ada;\n  cursor: pointer;\n}\n.customTable tbody tr td a:hover {\n  text-decoration: underline;\n}\n.customTable tbody tr td span {\n  font-size: 14px;\n}\n.customTable tbody tr td i.icon {\n  cursor: pointer;\n}\n.customTable tbody tr td img {\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 10px;\n}\n.customTable tbody tr td .dblColData {\n  position: relative;\n}\n.customTable tbody tr td .dblColData .colIcon {\n  display: inline-block;\n  width: 24px;\n  position: absolute;\n  left: 0;\n  top: -2px;\n}\n.customTable tbody tr td .dblColData .colText {\n  display: inline-block;\n  padding-left: 30px;\n  font-size: 16px;\n}\n.customTable tbody tr td.action button {\n  display: inline-block;\n  vertical-align: top;\n  border: none;\n  background: none;\n  margin-right: 4px;\n}\n.customTable tbody tr td.action button i.icon {\n  width: 1.8em;\n  height: 1.8em;\n  line-height: 1.8em;\n}\n.customTable tbody tr td.action button i.icon::before {\n  font-size: 1em;\n  color: #fff;\n  line-height: 1.7em;\n}\n@media (max-width: 1023px) {\n  .customTable tbody tr td {\n    display: block;\n    width: 100% !important;\n    text-align: left !important;\n    padding-left: 15px;\n  }\n}\n.customTable .customizeTableCol {\n  width: 30px !important;\n  background: #009ada;\n  text-align: center;\n}\n.customTable .customizeTableCol i::before {\n  color: #fff;\n}\n\n.appTable th.appName {\n  width: 20%;\n}\n.appTable th.appId {\n  width: 13%;\n}\n.appTable th.secureKey {\n  width: 17%;\n}\n.appTable th.contactName {\n  width: 15%;\n}\n.appTable th.emailId {\n  width: 24%;\n}\n.appTable th.status {\n  width: 11%;\n}\n.appTable td.appId {\n  text-transform: uppercase;\n}\n.appTable td.secureKey {\n  text-transform: uppercase;\n}\n.appTable td.contactName {\n  text-transform: capitalize;\n}\n\n.faqTable tr {\n  background: transparent !important;\n}\n.faqTable th.questions {\n  width: 40%;\n}\n.faqTable th.answers {\n  width: 40%;\n}\n.faqTable th.status {\n  width: 10%;\n}\n.faqTable th.action {\n  width: 10%;\n}\n.faqTable td i {\n  display: none;\n  text-decoration: none;\n  display: inline-block;\n  vertical-align: text-top;\n  width: 26px;\n}\n.faqTable td i:before {\n  color: #686c6d;\n  font-size: 0.9em;\n}\n.faqTable td i:hover {\n  text-decoration: none !important;\n}\n.faqTable td.question {\n  font-size: 14px !important;\n  color: #009ada !important;\n}\n.faqTable td.question * {\n  font-size: 14px !important;\n  color: #009ada !important;\n  font-weight: normal !important;\n}\n.faqTable td.question *:hover {\n  text-decoration: underline;\n}\n.faqTable td.question p {\n  display: inline-block;\n}\n.faqTable td.question sup {\n  vertical-align: -webkit-baseline-middle;\n}\n.faqTable td.question sub {\n  vertical-align: 2px;\n}\n.faqTable td.question ol {\n  list-style-position: inside;\n}\n.faqTable td.question ul {\n  list-style-position: inside;\n  list-style-type: initial;\n  margin-left: 20px;\n}\n.faqTable td.question .truncatedText {\n  display: inline-block;\n  width: calc(100% - 30px);\n  vertical-align: middle;\n}\n.faqTable td.answer {\n  font-size: 14px !important;\n  color: #232f3a !important;\n}\n.faqTable td.answer * {\n  font-size: 14px !important;\n  color: #232f3a !important;\n  line-height: 20px !important;\n}\n.faqTable td.answer ol {\n  list-style-position: inside;\n}\n.faqTable td.answer ol li {\n  font-size: 14px !important;\n  color: #232f3a !important;\n  line-height: 20px !important;\n}\n.faqTable td.answer ul {\n  list-style-position: inside;\n  list-style-type: initial;\n  margin-left: 20px;\n}\n.faqTable td.answer ul li {\n  font-size: 14px !important;\n  color: #232f3a !important;\n  line-height: 20px !important;\n  list-style-type: disc;\n}\n.faqTable td.answer a {\n  color: #009ada !important;\n}\n\n.memberShipTable th.membershipName {\n  width: 20%;\n}\n.memberShipTable th.membershipFee {\n  width: 20%;\n}\n.memberShipTable th.isEnabled {\n  width: 20%;\n}\n.memberShipTable th.membershiptypecode {\n  width: 20%;\n}\n.memberShipTable th.stockcode {\n  width: 20%;\n}\n\n.membershipClassifTable th.seqNo {\n  width: 12%;\n}\n.membershipClassifTable th.classifType {\n  width: 25%;\n}\n.membershipClassifTable th.description {\n  width: 40%;\n}\n.membershipClassifTable th.isEnabled {\n  width: 23%;\n}\n.membershipClassifTable td.seqNo i {\n  height: 20px;\n  vertical-align: middle;\n}\n.membershipClassifTable td.seqNo span {\n  vertical-align: middle;\n  font-size: 14px;\n}\n\n.membershipDocTable th.Name {\n  width: 50%;\n}\n.membershipDocTable th.Type {\n  width: 30%;\n}\n.membershipDocTable th.Status {\n  width: 20%;\n}\n\n.officerTable th.officerTitle {\n  width: 25%;\n}\n.officerTable th.description {\n  width: 65%;\n}\n.officerTable th.status {\n  width: 10%;\n}\n\n.responsibilitiesTable th.appName {\n  width: 25%;\n}\n.responsibilitiesTable th.url {\n  width: 65%;\n}\n.responsibilitiesTable th.status {\n  width: 10%;\n}\n\n.meetingTypeTable th.meetingType {\n  width: 40%;\n}\n.meetingTypeTable th.description {\n  width: 45%;\n}\n.meetingTypeTable th.status {\n  width: 15%;\n}\n\n.documentTable th.documentName {\n  width: 65%;\n}\n.documentTable th.type {\n  width: 20%;\n}\n.documentTable th.action {\n  width: 15%;\n  text-align: center;\n  padding-left: 15px;\n}\n\n.userTable th.userName {\n  width: 25%;\n}\n.userTable th.name {\n  width: 25%;\n}\n.userTable th.email {\n  width: 30%;\n}\n.userTable th.userType {\n  width: 20%;\n}\n.userTable th.action {\n  width: 7%;\n}\n.userTable td .viewOnly {\n  display: none;\n}\n.userTable td .field .ui.selection.dropdown {\n  min-width: auto;\n  width: 100%;\n}\n.userTable td .field .ui.selection.dropdown .dropdown.icon {\n  top: 5px;\n  right: 5px;\n}\n\n.dg-menu.Container {\n  background: #fff;\n  position: absolute;\n  left: auto !important;\n  right: 20px;\n  z-index: 2;\n  width: 250px;\n  padding: 20px;\n  border-radius: 4px;\n  border: solid 1px #99928a;\n  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.05);\n}\n\n.message {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  position: fixed !important;\n  right: 0;\n  top: -16px;\n  z-index: 9999999;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  padding: 14px 30px 14px 10px !important;\n  text-align: left;\n}\n.message .content p {\n  font-size: 14px;\n  color: #fff;\n  font-weight: 500;\n  opacity: 1;\n}\n.message i {\n  opacity: 1 !important;\n}\n.message i::before {\n  font-weight: normal;\n  font-size: 0.9em;\n  color: #fff;\n}\n.message.success {\n  background: #34ab36 !important;\n  color: #fff !important;\n  border: 1px solid #34ab36 !important;\n}\n.message.error {\n  background-color: #b13036 !important;\n  color: #fff !important;\n  border: 1px solid #b13036 !important;\n}\n.message.attention {\n  color: #000 !important;\n  border: 1px solid #fdc92f !important;\n  background: #fdc92f !important;\n}\n@media (max-width: 767px) {\n  .message {\n    min-height: 60px;\n    padding: 17px 20px;\n  }\n}\n\n.sideMenuLeft {\n  display: block;\n  width: 290px;\n  position: fixed;\n  top: 140px;\n  z-index: 1;\n}\n.sideMenuLeft .menuWrapper {\n  margin-bottom: 2px;\n}\n.sideMenuLeft .menuWrapper .menuHeaderLabel {\n  position: relative;\n  font-size: 14px;\n  color: #285482;\n  background: #f1f1f1;\n  padding: 4px 4px 4px 36px;\n  margin-bottom: 0;\n  cursor: pointer;\n}\n.sideMenuLeft .menuWrapper .menuHeaderLabel .icon {\n  position: absolute;\n  left: 5px;\n  top: 4px;\n}\n.sideMenuLeft .menuWrapper .menuHeaderLabel .icon:before {\n  font-size: 16px;\n  color: #285482;\n}\n.sideMenuLeft .menuWrapper .menuHeaderLabel .icon.chevron.down,\n.sideMenuLeft .menuWrapper .menuHeaderLabel .icon.chevron.up {\n  position: absolute;\n  left: auto;\n  right: 0;\n  top: 5px;\n}\n.sideMenuLeft .menuWrapper .menuHeaderLabel .icon.chevron.down:before,\n.sideMenuLeft .menuWrapper .menuHeaderLabel .icon.chevron.up:before {\n  color: #c8c8c8;\n  font-size: 14px;\n}\n.sideMenuLeft .menuWrapper .menuHeaderLabel.active {\n  background: #285482;\n  color: #fff;\n}\n.sideMenuLeft .menuWrapper .menuHeaderLabel.active .icon:before {\n  color: #fff;\n}\n.sideMenuLeft .menuWrapper .menuHeaderLabel.active .icon.chevron.down:before,\n.sideMenuLeft .menuWrapper .menuHeaderLabel.active .icon.chevron.up:before {\n  font-size: 14px;\n  color: #fff;\n}\n.sideMenuLeft .menuWrapper .subMenu {\n  background-color: rgb(236, 236, 236);\n  padding: 14px 22px;\n  position: relative;\n}\n.sideMenuLeft .menuWrapper .subMenu::before {\n  display: block;\n  content: \" \";\n  background-color: #c8c8c8;\n  position: absolute;\n  left: 26px;\n  width: 2px;\n  height: calc(100% - 42px);\n  top: 22px;\n}\n.sideMenuLeft .menuWrapper .subMenu li {\n  position: relative;\n  font-size: 14px;\n  color: #717575;\n  padding-bottom: 5px;\n  padding-left: 22px;\n  cursor: pointer;\n}\n.sideMenuLeft .menuWrapper .subMenu li:last-child {\n  padding-bottom: 0;\n}\n.sideMenuLeft .menuWrapper .subMenu li:before {\n  display: inline-block;\n  content: \"•\";\n  position: absolute;\n  left: 0;\n  top: -1px;\n  font-size: 28px;\n  color: #717575;\n}\n.sideMenuLeft .menuWrapper .subMenu li.active, .sideMenuLeft .menuWrapper .subMenu li:active, .sideMenuLeft .menuWrapper .subMenu li:hover {\n  color: #009ada;\n  font-size: 15px;\n}\n.sideMenuLeft .menuWrapper .subMenu li.active:before, .sideMenuLeft .menuWrapper .subMenu li:active:before, .sideMenuLeft .menuWrapper .subMenu li:hover:before {\n  color: #009ada;\n}\n\n.ui.inverted.popup {\n  background: rgba(0, 0, 0, 0.8);\n  padding: 6px 12px !important;\n  z-index: 99999;\n}\n.ui.inverted.popup::before {\n  background: rgba(41, 41, 41, 0.8) !important;\n}\n.ui.inverted.popup .content {\n  font-size: 13px;\n  color: #fff;\n  text-align: center;\n}\n.ui.inverted.popup.leftAlignTolltip .content {\n  text-align: left;\n}\n\n.ui.tabular.menu {\n  border: none;\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);\n}\n.ui.tabular.menu .item {\n  font-size: 14px;\n  color: #285482;\n  background: #ececec;\n  font-weight: 500;\n  text-transform: uppercase;\n  border: none;\n}\n.ui.tabular.menu .item.active {\n  border-radius: 0;\n  color: #009ada;\n  margin-top: -10px;\n}\n\n.ui.segment[class*=\"bottom attached\"] {\n  border-radius: 0;\n  border: none;\n}\n\n.tabWithBtn {\n  position: relative;\n}\n.tabWithBtn .actionBtnWrap {\n  position: absolute;\n  right: 0;\n  top: 10px;\n  z-index: 2;\n}\n\n.ui.selection.dropdown.multiple {\n  min-height: 30px !important;\n  padding: 0 18px 0 5px !important;\n  height: auto;\n  max-width: 550px;\n}\n.ui.selection.dropdown.multiple > .text {\n  font-size: 14px;\n  color: #232f3a !important;\n  padding-top: 6px !important;\n  padding-left: 0 !important;\n  top: 0;\n  margin: 0;\n}\n.ui.selection.dropdown.multiple > .text.default {\n  color: rgba(191, 191, 191, 0.87) !important;\n}\n.ui.selection.dropdown.multiple .menu {\n  max-height: 130px;\n}\n.ui.selection.dropdown.multiple.search > .text {\n  padding-left: 6px !important;\n}\n.ui.selection.dropdown.multiple.search input.search {\n  height: 30px;\n  padding-left: 0px !important;\n  margin: 0 !important;\n}\n.ui.selection.dropdown.multiple > .label {\n  margin: 1px 5px 2px 0;\n  padding: 0 7px;\n  font-size: 14px !important;\n  display: inline-block !important;\n  color: #232f3a !important;\n  font-weight: normal;\n  vertical-align: initial;\n}\n.ui.selection.dropdown.multiple > .label > .close.icon::before,\n.ui.selection.dropdown.multiple > .label > .delete.icon::before {\n  content: \"✖\";\n  font-size: 12px;\n  color: #686c6d !important;\n}\n.ui.selection.dropdown.multiple.active {\n  border-bottom-left-radius: 4px !important;\n  border-bottom-right-radius: 4px !important;\n}\n\n.ui.modal .ui.selection.dropdown.multiple {\n  max-width: 100%;\n}\n\n.statusActive {\n  display: inline-block;\n  background: #009ada;\n  -webkit-border-radius: 12.5px;\n  -moz-border-radius: 12.5px;\n  -ms-border-radius: 12.5px;\n  -o-box-sizing: 12.5px;\n  border-radius: 12.5px;\n  font-size: 14px;\n  line-height: 25px;\n  text-align: center;\n  color: #fff;\n  padding: 0 14px;\n}\n\n.statusInactive {\n  display: inline-block;\n  background: #fdc92f;\n  -webkit-border-radius: 12.5px;\n  -moz-border-radius: 12.5px;\n  -ms-border-radius: 12.5px;\n  -o-box-sizing: 12.5px;\n  border-radius: 12.5px;\n  font-size: 14px;\n  line-height: 25px;\n  text-align: center;\n  color: #fff;\n  padding: 0 14px;\n}\n\n.rdw-editor-wrapper {\n  border: 1px solid #c8c8c8;\n  margin-bottom: 10px;\n}\n.rdw-editor-wrapper .rdw-editor-toolbar {\n  margin-bottom: 0;\n  border-bottom: 1px solid #c8c8c8;\n}\n.rdw-editor-wrapper .rdw-editor-main {\n  background-color: #fff;\n  min-height: 150px;\n  max-height: 150px;\n  border: 1px solid rgba(220, 220, 220, 0.5);\n  border-bottom: 28px solid #f1f1f1;\n}\n.rdw-editor-wrapper .rdw-editor-main .public-DraftStyleDefault-block {\n  margin: 0.5em 0.75em;\n}\n.rdw-editor-wrapper .rdw-emoji-wrapper {\n  display: none !important;\n}\n.rdw-editor-wrapper .rdw-image-modal,\n.rdw-editor-wrapper .rdw-link-modal,\n.rdw-editor-wrapper .rdw-colorpicker-modal,\n.rdw-editor-wrapper .rdw-embedded-modal {\n  left: auto !important;\n  right: 5px !important;\n}\n\n.fa-1:before {\n  font-size: 1.4em;\n}\n\n@media (min-width: 800px) and (max-width: 1000px) {\n  .floatRight .selection {\n    min-width: 10em !important;\n  }\n}\n\n.PagingOption {\n  min-width: 10em !important;\n}\n\n.inputIconWrapper {\n  position: relative;\n}\n.inputIconWrapper .input input {\n  padding-right: 30px !important;\n}\n.inputIconWrapper .refeshIcon {\n  position: absolute;\n  right: 20px;\n  top: 22px;\n  z-index: 2;\n  cursor: pointer;\n}\n.inputIconWrapper .refeshIcon i::before {\n  font-size: 0.9em;\n  color: #c8c8c8;\n}\n.inputIconWrapper .refeshIcon:hover i::before {\n  color: #686c6d;\n}\n\nheader {\n  display: block;\n  width: 100%;\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100%;\n  z-index: 9999;\n  background: #fff;\n  padding: 10px 0;\n  min-height: 88px;\n  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);\n}\nheader .logoWrap {\n  float: left;\n}\nheader .loggedUserWrap {\n  float: right;\n  margin-top: 20px;\n  background: #fdc92f;\n  padding: 6px 10px;\n}\nheader .loggedUserWrap .ui.dropdown .menu {\n  left: auto;\n  right: -11px;\n  top: 31px;\n  width: 192px;\n  box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.2);\n  background-color: #fff;\n  border-radius: 0;\n}\nheader .loggedUserWrap .ui.dropdown .menu .item {\n  padding: 5px 1.14285714rem !important;\n}\nheader .loggedUserWrap .ui.dropdown .menu > .item:hover, header .loggedUserWrap .ui.dropdown .menu .selected.item, header .loggedUserWrap .ui.dropdown .menu .selected {\n  background: #285482;\n  color: #fff;\n}\nheader .loggedUserWrap .ui.dropdown .menu > .item:hover .text, header .loggedUserWrap .ui.dropdown .menu .selected.item .text, header .loggedUserWrap .ui.dropdown .menu .selected .text {\n  color: #fff;\n}\nheader .loggedUserWrap .maxName {\n  display: inline-block;\n  vertical-align: bottom;\n  width: 75px;\n}\n\n#root,\n.appWrapper,\n.App {\n  height: 100%;\n}\n\n#root {\n  height: 100%;\n  overflow: auto;\n}\n\n.mainWrapperRight {\n  display: block;\n  width: calc(100% - 290px);\n  float: right;\n  padding-left: 32px;\n}\n.mainWrapperRight .headingTitle {\n  position: relative;\n  margin-bottom: 10px;\n}\n.mainWrapperRight .headingTitle h2 {\n  float: left;\n}\n.mainWrapperRight .headingTitle h2 .recordCount {\n  display: block;\n  font-size: 14px;\n  color: #009ada;\n}\n.mainWrapperRight .headingTitle .editBtn {\n  float: right;\n  margin-top: 7px;\n}\n.mainWrapperRight .headingTitle .editBtn i {\n  line-height: inherit;\n}\n.mainWrapperRight .headingTitle .button {\n  float: right;\n  margin-top: 7px;\n}\n.mainWrapperRight .headingTitle .button i {\n  line-height: inherit;\n}\n.mainWrapperRight .headingTitle .searchBx {\n  width: 400px;\n  position: absolute;\n  right: 0;\n  top: 40px;\n  z-index: 99;\n}\n.mainWrapperRight .headingTitle .searchBx div {\n  width: 100%;\n  background-color: #fff;\n}\n.mainWrapperRight .headingTitle .searchBx div input {\n  border-radius: 2px;\n  padding: 0.42em 0.5em;\n}\n.mainWrapperRight .headingTitle .searchBx .ui.icon.input > i.circular.icon {\n  top: 0.15em;\n  right: 0.5em;\n}\n.mainWrapperRight .headingTitle .searchBx .results.visible {\n  max-height: 300px;\n  overflow: auto;\n}\n.mainWrapperRight .headingTitle .searchBx .results .message {\n  border: 1px solid #99928a !important;\n  position: static !important;\n  padding: 10px !important;\n}\n.mainWrapperRight .headingTitle .searchBx .results .message .header {\n  font-size: 14px;\n  color: #232f3a;\n}\n.mainWrapperRight .headingTitle .searchBx .hiddenSearchIcon {\n  display: inline-block;\n  width: 30px;\n  height: 30px;\n  position: absolute;\n  right: 5px;\n  top: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n.mainWrapperRight .headingTitle .selectDrop {\n  display: inline-block;\n  position: absolute;\n  right: 410px;\n  top: 40px;\n  z-index: 99;\n}\n.mainWrapperRight .headingTitle .selectDrop .ui.selection.dropdown {\n  min-width: 9em;\n}\n.mainWrapperRight .headingTitle .exportAction {\n  display: block;\n  float: right;\n  min-width: 270px;\n}\n.mainWrapperRight .headingTitle .exportAction .label2 {\n  padding-top: 12px;\n}\n.mainWrapperRight .headingTitle .lastLogin {\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.mainWrapperRight.type2 {\n  width: 100%;\n  padding-left: 0;\n}\n.mainWrapperRight.bg {\n  width: 100%;\n  background: #fff;\n  padding: 20px;\n}\n\n.commonLoader {\n  display: none;\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.75);\n  z-index: 9999;\n}\n.commonLoader .loaderWrap {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  border-radius: 14px;\n  width: 104px;\n  height: 116px;\n  display: block;\n  margin: -52px 0 0 -58px;\n  text-align: center;\n}\n.commonLoader .loaderWrap img {\n  display: block;\n  margin: 8px auto;\n  max-width: 100%;\n  height: 60px;\n  width: auto;\n}\n.commonLoader .loaderWrap span {\n  display: block;\n  font-size: 14px;\n  color: #fff;\n}\n\n.loginPage {\n  height: 100%;\n}\n.loginPage .loginWrap {\n  display: block;\n  width: 100%;\n  max-width: 380px;\n  margin: 0 auto;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  -ms-border-radius: 4px;\n  -o-box-sizing: 4px;\n  border-radius: 4px;\n  position: relative;\n  top: 50%;\n  -moz-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  -khtml-transform: translateY(-50%);\n  -o-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n.loginPage .loginWrap .loginCard {\n  padding: 30px 40px 40px 40px;\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);\n  background-color: rgb(255, 255, 255);\n}\n.loginPage .loginWrap .loginCard .field {\n  margin: 0 0 10px 0;\n}\n.loginPage .loginWrap .loginCard .field .field.error {\n  margin: 0 0 0 0;\n}\n.loginPage .loginWrap .titleHead {\n  font-size: 33px;\n  line-height: 40px;\n  text-align: center;\n  margin-bottom: 30px;\n}\n.loginPage .loginWrap .logo {\n  display: block;\n  height: 85px;\n  width: auto;\n  margin: 0 auto 60px auto;\n}\n.loginPage .loginWrap .actionBtnWrap {\n  text-align: center;\n  padding-top: 20px;\n}\n\n.privligeWrap figure {\n  display: block;\n  background: #fff;\n  padding: 10px 20px;\n  margin: 0;\n}\n.privligeWrap figure img.ui.image {\n  display: inline-block;\n  height: 65px;\n}\n\n.validateAD {\n  position: relative;\n}\n.validateAD .searchBx {\n  height: 32px;\n  width: 100%;\n}\n.validateAD .editBtn {\n  position: absolute;\n  right: 5px;\n  top: 1px;\n  z-index: 1;\n}\n\n.userRelatedInfo {\n  margin: 20px 0;\n  border-top: dashed 1px #ccc;\n  border-bottom: dashed 1px #ccc;\n}\n\n.titleLabel {\n  display: block;\n  font-size: 14px;\n  color: #99928a;\n}\n\n.titleInfo {\n  display: inline-block;\n  font-size: 16px;\n  color: #232f3a;\n  word-break: break-word;\n}\n\n.viewModeFix ol {\n  list-style-position: inside;\n  margin-left: 20px;\n}\n.viewModeFix ol li {\n  font-size: 16px;\n  color: #232f3a;\n}\n.viewModeFix ul {\n  list-style-position: inside;\n  margin-left: 40px;\n}\n.viewModeFix ul li {\n  list-style-type: disc;\n  font-size: 16px;\n  color: #232f3a;\n}\n.viewModeFix .titleInfo {\n  margin-top: 5px;\n}\n.viewModeFix .titleInfo p {\n  margin-bottom: 0;\n}\n.viewModeFix .titleInfo sup {\n  margin-top: 15px;\n  display: inline-block;\n}\n.viewModeFix .titleInfo sub {\n  margin-bottom: 15px;\n  display: inline-block;\n}\n.viewModeFix .titleInfo em {\n  font-style: italic;\n}\n\n.colorBoxActive {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  background: #653294;\n  vertical-align: middle;\n}\n\n.selectedColor {\n  position: relative;\n  width: 100%;\n  min-height: 33px;\n  border-radius: 0.28571429rem;\n  background-color: rgb(255, 255, 255);\n  box-shadow: inset 1px apx apx #ccc;\n  border: 1px solid rgba(34, 36, 38, 0.15);\n  color: rgba(0, 0, 0, 0.87);\n  cursor: pointer;\n  padding: 0 10px;\n}\n.selectedColor .dropdown.icon {\n  top: 6px;\n  right: 6px;\n  position: absolute;\n  width: auto;\n  height: auto;\n  line-height: 1.21428571em;\n  opacity: 0.4;\n}\n.selectedColor .dropdown.icon:before {\n  content: \"\\f078\" !important;\n  font-size: 1em;\n}\n.selectedColor .colorNameActive {\n  display: inline-block;\n  vertical-align: -3px;\n  font-size: 14px;\n  color: #232f3a;\n  padding-left: 10px;\n  height: 16px;\n}\n\n.customColorChooser {\n  position: relative;\n  z-index: 2;\n}\n.customColorChooser .allColors {\n  width: 100%;\n  min-height: 120px;\n}\n.customColorChooser .allColors .defaultColor {\n  display: inline-grid;\n  grid-template-columns: auto auto auto auto auto auto auto;\n  grid-column-gap: 0;\n  grid-row-gap: 0;\n  width: 100%;\n  margin-bottom: 10px;\n  margin-left: 2px;\n  max-height: 136px;\n  overflow: auto;\n}\n.customColorChooser .allColors .defaultColor:last-child {\n  margin-bottom: 0;\n}\n.customColorChooser .allColors .defaultColor .commonToolTip {\n  margin: 2px 14px;\n}\n.customColorChooser .allColors .defaultColor .commonToolTip:nth-child(7n+7) {\n  margin-right: 0;\n  padding-right: 0;\n}\n.customColorChooser .allColors .defaultColor .commonToolTip:nth-child(7n+1) {\n  margin-left: 0;\n  padding-left: 0;\n}\n.customColorChooser .allColors .defaultColor .colorDV {\n  display: inline-block;\n  width: 26px;\n  height: 26px;\n  cursor: pointer;\n}\n.customColorChooser .allColors .defaultColor .colorDV.addColor {\n  background: #fff;\n  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);\n  font-size: 20px;\n  line-height: 26px;\n  text-align: center;\n  color: #686c6d;\n  font-weight: 700;\n}\n.customColorChooser .allColors .defaultColor .colorDV.used::before {\n  display: inline-block;\n  width: 26px;\n  height: 26px;\n  content: \"✕\";\n  font-size: 26px;\n  line-height: 28px;\n  text-align: center;\n  color: #fff;\n  opacity: 0.4;\n}\n.customColorChooser .allColors .defaultColor .colorDV.active::before {\n  display: inline-block;\n  width: 26px;\n  height: 26px;\n  content: \"\\f00c\";\n  font-family: Icons;\n  font-size: 12px;\n  line-height: 26px;\n  text-align: center;\n  color: #fff;\n}\n\n.addNewColor > div {\n  width: 80%;\n  display: inline-block;\n}\n\n.checkBoxWrapper .ui.grid > .row > .column {\n  margin-top: 0.7rem;\n  margin-bottom: 0.5rem;\n}\n\n.slider-picker {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n\n.statusIndicator {\n  display: inline-block;\n  background: #99928a;\n  font-size: 16px;\n  line-height: 25px;\n  text-align: center;\n  color: #fff;\n  padding: 0 10px;\n  border-radius: 15px;\n}\n.statusIndicator.active {\n  background: #009ada;\n}\n.statusIndicator.inactive {\n  background: #fdc92f;\n}\n\n.permissionIndicator.full::before {\n  color: #34ab36;\n}\n.permissionIndicator.partial::before {\n  color: #fdc92f;\n}\n.permissionIndicator.none::before {\n  color: #b13036;\n}\n\n.contentWrapper.type2 {\n  margin-top: 80px;\n}\n\n.chBoxLegend {\n  position: absolute;\n  right: 0;\n  top: 85px;\n}\n.chBoxLegend ul {\n  margin: 0;\n  padding: 0;\n}\n.chBoxLegend ul li {\n  display: inline-block;\n}\n.chBoxLegend ul li .ui.checkbox {\n  vertical-align: middle;\n  margin: 0 12px 0 20px;\n}\n.chBoxLegend ul li span {\n  vertical-align: middle;\n}\n\n.helper, .manageRoleWrap .ui.cards {\n  width: 100%;\n  border-radius: 2px;\n  box-shadow: none;\n  background-color: transparent;\n  margin: 0 !important;\n}\n.helper .roleCard, .manageRoleWrap .ui.cards .roleCard {\n  position: relative;\n  padding: 20px 20px 0 20px;\n  height: 100%;\n  border-top: 4px solid #009ada !important;\n}\n.helper .roleCard.inactive, .manageRoleWrap .ui.cards .roleCard.inactive {\n  border-top: 4px solid #fdc92f !important;\n}\n.helper .roleCard .roleStatus, .manageRoleWrap .ui.cards .roleCard .roleStatus {\n  margin: 0 0 20px 0;\n}\n.helper .roleCard .roleStatus .positionMumber, .manageRoleWrap .ui.cards .roleCard .roleStatus .positionMumber {\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  background: #c8c8c8;\n  border-radius: 50%;\n  font-family: \"ProximaNovaBold\";\n  font-size: 14px;\n  color: #fff;\n  line-height: 26px;\n  text-align: center;\n  vertical-align: top;\n}\n.helper .roleCard .roleStatus i, .manageRoleWrap .ui.cards .roleCard .roleStatus i {\n  margin-left: 10px;\n  cursor: pointer;\n}\n.helper .roleCard .roleStatus i::before, .manageRoleWrap .ui.cards .roleCard .roleStatus i::before {\n  font-size: 1em;\n  color: #c8c8c8;\n}\n.helper .roleCard .roleStatus i:hover::before, .manageRoleWrap .ui.cards .roleCard .roleStatus i:hover::before {\n  color: #285482;\n}\n.helper .roleCard .roleStatus .descHead, .manageRoleWrap .ui.cards .roleCard .roleStatus .descHead {\n  font-size: 16px;\n  color: #232f3a;\n  font-family: \"ProximaNovaBold\";\n}\n.helper .roleCard .officerSubInfo, .manageRoleWrap .ui.cards .roleCard .officerSubInfo {\n  margin-bottom: 20px;\n}\n.helper .roleCard .officerSubInfo span, .manageRoleWrap .ui.cards .roleCard .officerSubInfo span {\n  font-size: 14px;\n  color: #686c6d;\n}\n.helper .roleCard .privileges .privelegeHead, .manageRoleWrap .ui.cards .roleCard .privileges .privelegeHead {\n  display: block;\n  font-size: 12px;\n  color: #c8c8c8;\n  font-family: \"ProximaNovaBold\";\n  text-transform: uppercase;\n  margin-bottom: 10px;\n}\n.helper .roleCard .privileges ul, .manageRoleWrap .ui.cards .roleCard .privileges ul {\n  margin: 0 -20px;\n  min-height: 130px;\n  max-height: 180px;\n  overflow: auto;\n}\n.helper .roleCard .privileges ul li, .manageRoleWrap .ui.cards .roleCard .privileges ul li {\n  padding: 9px 10px 7px 15px;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n.helper .roleCard .privileges ul li .ui.checkbox.partial .box:before, .manageRoleWrap .ui.cards .roleCard .privileges ul li .ui.checkbox.partial .box:before,\n.helper .roleCard .privileges ul li .ui.checkbox.partial label:before,\n.manageRoleWrap .ui.cards .roleCard .privileges ul li .ui.checkbox.partial label:before {\n  background: #686c6d;\n}\n.helper .roleCard .privileges ul li .ui.checkbox, .manageRoleWrap .ui.cards .roleCard .privileges ul li .ui.checkbox {\n  vertical-align: middle;\n}\n.helper .roleCard .privileges ul li .privelegeName, .manageRoleWrap .ui.cards .roleCard .privileges ul li .privelegeName {\n  display: inline-block;\n  font-size: 16px;\n  color: #232f3a;\n  vertical-align: text-top;\n  margin-left: 10px;\n  width: calc(100% - 30px);\n}\n.helper .roleCard .privileges ul li:hover, .manageRoleWrap .ui.cards .roleCard .privileges ul li:hover, .helper .roleCard .privileges ul li:active, .manageRoleWrap .ui.cards .roleCard .privileges ul li:active {\n  background: #f7f8fa;\n}\n.helper .roleCard .privileges ul li:last-child, .manageRoleWrap .ui.cards .roleCard .privileges ul li:last-child {\n  border-bottom: none;\n}\n\n.manageRoleWrap {\n  margin: 0 -10px;\n  position: relative;\n  max-height: calc(100vh - 290px);\n  overflow: auto;\n}\n.manageRoleWrap .ui.cards.waterMark {\n  position: absolute;\n  top: 0;\n}\n.manageRoleWrap .ui.cards.waterMark .ui.card {\n  position: relative;\n  background: #f7f8fa;\n}\n.manageRoleWrap .ui.cards.waterMark .ui.card .bookmarkNum {\n  position: absolute;\n  display: block;\n  width: 100%;\n  height: 100%;\n  font-size: 8em;\n  line-height: 290px;\n  color: #ccc;\n  text-align: center;\n}\n.manageRoleWrap .ui.cards.waterMark .ui.card .roleCard {\n  border-top: 4px solid transparent !important;\n  visibility: hidden;\n}\n\n.helper {\n  z-index: 999;\n}\n\n.privListTooltip {\n  padding: 20px;\n  width: 600px;\n  background: #fff;\n  box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.2);\n}\n.privListTooltip .ui.grid > .column:not(.row) {\n  padding-top: 0.5em !important;\n  padding-bottom: 0.5em !important;\n}\n.privListTooltip .privActionList {\n  border-bottom: dashed 1px #686c6d;\n}\n.privListTooltip .privActionList .ui.fitted.checkbox {\n  display: inline-block;\n  width: 26px;\n  vertical-align: sub;\n}\n.privListTooltip .privActionList .ui.checkbox.partial .box:before,\n.privListTooltip .privActionList .ui.checkbox.partial label:before {\n  background: #686c6d;\n}\n.privListTooltip .privActionList .permsnName {\n  display: inline-block;\n  width: calc(100% - 26px);\n  vertical-align: top;\n  font-size: 14px;\n  color: #232f3a;\n}\n.privListTooltip .privActionList.noBottBorder {\n  border-bottom: none;\n}\n.privListTooltip .privGrroupname {\n  font-size: 16px;\n  color: #686c6d;\n  font-family: \"ProximaNovaBold\";\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n.privListTooltip .privGrroupname:first-child {\n  margin-top: 0;\n}\n\n.ui.modal.addOfficerModal .accordHead {\n  display: block;\n  font-size: 16px;\n  text-transform: uppercase;\n  padding-top: 10px;\n  padding-left: 12px;\n  margin-bottom: 10px;\n}\n.ui.modal.addOfficerModal .accordion {\n  padding: 0 10px;\n}\n.ui.modal.addOfficerModal .accordion .content {\n  background: #f7f8fa;\n}\n.ui.modal.addOfficerModal .accordion .content .commonTitle {\n  font-family: \"ProximaNovaBold\";\n  font-size: 16px;\n  color: #686c6d;\n  margin-bottom: 0;\n}\n.ui.modal.addOfficerModal .accordion .content .commonTitle + .checkBoxWrapper {\n  border-bottom: dashed 1px #8d939a;\n  margin-bottom: 20px;\n}\n.ui.modal.addOfficerModal .accordion .content .commonTitle + .checkBoxWrapper:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n}\n.ui.modal.addOfficerModal .accordion .content .commonTitle + .checkBoxWrapper .ui.grid {\n  margin-top: 0;\n}\n.ui.modal.addOfficerModal .accordion .content .privActionList .ui.fitted.checkbox {\n  display: inline-block;\n  width: 26px;\n  vertical-align: sub;\n}\n.ui.modal.addOfficerModal .accordion .content .privActionList .permsnName {\n  display: inline-block;\n  width: calc(100% - 26px);\n  font-size: 14px;\n  color: #232f3a;\n  vertical-align: inherit;\n}\n\n.comApplyRemove {\n  position: relative;\n  border: 1px solid rgba(220, 220, 220, 0.5);\n  padding: 10px;\n  background: #f7f8fa;\n}\n.comApplyRemove .tableWrapper {\n  width: calc(100% - 40px);\n  margin-top: 0;\n  overflow-x: initial;\n  overflow-y: initial;\n}\n.comApplyRemove .tableWrapper td {\n  vertical-align: top;\n}\n.comApplyRemove .tableWrapper td button {\n  display: inline-block;\n  margin-top: 22px;\n}\n.comApplyRemove .tableWrapper td button i.icon {\n  width: 1.8em;\n  height: 1.8em;\n  line-height: 1.8em;\n}\n.comApplyRemove .tableWrapper td button i.icon::before {\n  font-size: 1em;\n}\n.comApplyRemove .deletAction {\n  position: absolute;\n  right: 10px;\n  bottom: 34px;\n  z-index: 1;\n  cursor: pointer;\n}\n\n.react-grid-item {\n  border: 2px solid #000;\n}\n\n.react-grid-layout {\n  position: relative;\n  transition: height 200ms ease;\n}\n\n.react-grid-item {\n  transition: all 200ms ease;\n  transition-property: left, top;\n}\n\n.react-grid-item.cssTransforms {\n  transition-property: transform;\n}\n\n.react-grid-item.resizing {\n  z-index: 1;\n  will-change: width, height;\n}\n\n.react-grid-item.react-draggable-dragging {\n  transition: none;\n  z-index: 3;\n  will-change: transform;\n}\n\n.react-grid-item.react-grid-placeholder {\n  background: red;\n  opacity: 0.2;\n  transition-duration: 100ms;\n  z-index: 2;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  -o-user-select: none;\n  user-select: none;\n}\n\n.react-grid-item > .react-resizable-handle {\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  bottom: 0;\n  right: 0;\n  cursor: se-resize;\n}\n\n.react-grid-item > .react-resizable-handle::after {\n  content: \"\";\n  position: absolute;\n  right: 3px;\n  bottom: 3px;\n  width: 5px;\n  height: 5px;\n  border-right: 2px solid rgba(0, 0, 0, 0.4);\n  border-bottom: 2px solid rgba(0, 0, 0, 0.4);\n}\n\n.addCommitteeWrap {\n  padding: 5px 10px;\n  background: #fff;\n}\n.addCommitteeWrap h5 {\n  border-top: dashed 1px #ccc;\n  padding-top: 10px;\n  margin-top: 10px;\n}\n.addCommitteeWrap .labelList li {\n  background: #fff;\n  border-radius: 2px;\n  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.02);\n  padding: 9px;\n  margin-bottom: 10px;\n}\n.addCommitteeWrap .labelList li .comitteName {\n  font-size: 14px;\n  color: #232f3a;\n}\n.addCommitteeWrap .labelList li .eligibleFields {\n  display: inline-block;\n  float: right;\n  font-size: 14px;\n  color: #009ada;\n  margin-right: 20px;\n  margin-top: 3px;\n  cursor: pointer;\n}\n.addCommitteeWrap .labelList li .closeIcon {\n  float: right;\n  cursor: pointer;\n}\n.addCommitteeWrap .labelList li .closeIcon .icon::before {\n  font-weight: 400;\n  color: #99928a;\n}\n.addCommitteeWrap .addNewLabel .specify {\n  display: inline-block;\n  width: calc(100% - 40px);\n}\n.addCommitteeWrap .addNewLabel .addAction {\n  float: right;\n  display: inline-block;\n  width: 40px;\n  text-align: right;\n  margin-top: 5px;\n}\n.addCommitteeWrap .memClassType {\n  display: block;\n  float: left;\n  width: 33%;\n}\n.addCommitteeWrap .memClassType .memClassTypeTitle {\n  display: block;\n  font-size: 14px;\n  color: #232f3a;\n  margin-bottom: 5px;\n}\n.addCommitteeWrap .memClassType .memClassTypeList {\n  display: block;\n  background: #fff;\n  padding: 20px;\n  border-radius: 2px;\n  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.02);\n  max-height: 320px;\n  overflow-y: auto;\n}\n.addCommitteeWrap .memClassType .memClassTypeList li {\n  font-size: 14px;\n  color: #232f3a;\n  margin: 5px 0;\n}\n.addCommitteeWrap .memClassType .memClassTypeList li .checkbox {\n  margin-right: 10px;\n  vertical-align: bottom;\n}\n.addCommitteeWrap .operator {\n  display: block;\n  width: 30%;\n  float: left;\n  margin: 0 2%;\n}\n.addCommitteeWrap .sc-ifAKCX {\n  position: relative;\n  margin-top: 10px;\n}\n.addCommitteeWrap .sc-ifAKCX .KYUqY {\n  max-height: 320px;\n  overflow-y: auto;\n}\n.addCommitteeWrap .sc-ifAKCX .bpKHpE {\n  background-color: #f7f8fa;\n  padding: 15px;\n  min-height: auto !important;\n}\n.addCommitteeWrap .sc-ifAKCX .bpKHpE .gmcSqE {\n  border: none;\n  font-size: 16px;\n  color: #232f3a;\n  padding: 8px 20px;\n}\n.addCommitteeWrap .sc-ifAKCX .bpKHpE .iQCjkp {\n  font-size: 16px;\n  color: #232f3a;\n  padding: 8px 20px;\n}\n.addCommitteeWrap .sc-ifAKCX h3 {\n  font-size: 14px;\n  color: #232f3a;\n  position: absolute;\n  top: -20px;\n  margin-left: -8px;\n}\n.addCommitteeWrap .comitteeAccord .chbx {\n  display: inline-block;\n  margin-right: 10px;\n}\n.addCommitteeWrap .comitteeAccord .chbx > label {\n  display: inline-block;\n}\n.addCommitteeWrap .comitteeAccord .checkBoxWrapper .checkbox {\n  vertical-align: middle;\n  margin-right: 10px;\n}\n.addCommitteeWrap .comitteeAccord .checkBoxWrapper label {\n  font-size: 14px;\n}\n.addCommitteeWrap .column .committee-droparea {\n  height: 100%;\n}\n.addCommitteeWrap .column .committee-droparea > div {\n  height: 100%;\n}\n\n.greyBox {\n  display: block;\n  padding: 20px;\n  border: solid 1px #ccc;\n  background-color: #f7f8fa;\n  max-height: 320px;\n  overflow-y: auto;\n}\n.greyBox.type2 {\n  max-height: none;\n  overflow-y: inherit;\n}\n\n.borderDashed {\n  display: block;\n  width: 100%;\n  border-top: dashed 1px #ccc;\n  padding-top: 10px;\n  margin-top: 10px;\n}\n\n.levelPills {\n  display: inline-block;\n  background: rgb(236, 236, 236);\n  padding: 3px 8px 2px 8px;\n  font-size: 14px;\n  color: #232f3a;\n  text-align: center;\n  margin-right: 10px;\n  margin-bottom: 10px;\n}\n.levelPills .icon {\n  display: inline-block;\n  margin-left: 10px;\n  cursor: pointer;\n}\n.levelPills .icon::before {\n  font-size: 0.9em;\n  color: #009ada;\n}\n\n.manageFields {\n  width: 436px;\n  padding: 20px !important;\n  border: none !important;\n  box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.2) !important;\n  border-radius: 0 !important;\n}\n.manageFields .privGrroupname {\n  font-size: 16px;\n  color: #686c6d;\n  font-family: \"ProximaNovaBold\";\n  margin-bottom: 15px;\n}\n.manageFields .ui.checkbox .box,\n.manageFields .ui.checkbox label {\n  font-size: 14px;\n  padding-left: 1.5em;\n}\n\n.dashed-Border {\n  display: block;\n  width: 100%;\n  border-top: dashed 1px #ccc;\n  padding-top: 20px;\n  margin-top: 20px;\n}\n\n.unAuthorizeDv {\n  padding: 150px 0 50px 0;\n  text-align: center;\n}\n.unAuthorizeDv .dontSign {\n  display: block;\n  margin-bottom: 30px;\n}\n.unAuthorizeDv .dontSign i {\n  text-align: center;\n  display: initial;\n}\n.unAuthorizeDv .dontSign i::before {\n  font-size: 3.7em;\n  color: #c8c8c8;\n}\n.unAuthorizeDv .permissionHead {\n  display: block;\n  font-size: 20px;\n  color: #686c6d;\n}\n.unAuthorizeDv .permissionSub {\n  font-size: 16px;\n  color: #686c6d;\n}","/*COMMON STYLES*/\n\n/*! Generated by Font Squirrel (https://www.fontsquirrel.com) on January 7, 2019 */\n\n@font-face {\n    font-family: \"ProximaNovaRegular\";\n    src: url(\"../../assets/fonts/proxima-nova-regular-webfont.woff\") format(\"woff2\"),\n        url(\"../../assets/fonts/proxima-nova-regular-webfont.woff2\") format(\"woff2\");\n    font-weight: normal;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: \"ProximaNovaBold\";\n    src: url(\"../../assets/fonts/PN-Bold.woff2\") format(\"woff2\");\n    font-weight: normal;\n    font-style: normal;\n}\n\n\n*,\n*:before,\n*:after {\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n    outline: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0.5);\n    margin: 0;\n    padding: 0;\n    -webkit-text-size-adjust: 100%;\n    -moz-text-size-adjust: 100%;\n    -ms-text-size-adjust: 100%;\n    -webkit-touch-callout: default;\n    -webkit-overflow-scrolling: touch;\n    font-size: 16px;\n    color: $dkblue;\n    font-family: \"ProximaNovaRegular\", sans-serif;\n    white-space: normal;\n    word-wrap: break-word;\n}\n\nbody,\nform,\ninput,\nselect,\ntextarea,\nbutton,\nlabel,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n    font-family: \"ProximaNovaRegular\", sans-serif;\n}\n\nhtml,\nbody {\n    -webkit-text-size-adjust: 100%;\n    -ms-text-size-adjust: 100%;\n    font-size: 16px;\n    line-height: 24px;\n    color: $black;\n    font-weight: normal;\n    height: 100%;\n    width: 100%;\n    margin: 0;\n    padding: 0;\n    background: $pageBG;\n    font-family: \"ProximaNovaRegular\", sans-serif;\n}\n\nimg {\n    display: block;\n    margin: 0 auto;\n    max-width: 100%;\n}\n\nul {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n\n    li {\n        list-style: none;\n    }\n}\n\n.ui.container {\n    padding: 0 20px;\n    width: 100%;\n\n    @media only screen and (min-width: 1200px) {\n        width: 100%;\n        max-width: 100%;\n    }\n}\n\n.ui.grid {\n    margin-top: 10px;\n    margin-bottom: 0;\n    margin-left: -0.5rem;\n    margin-right: -0.5rem;\n\n    >.row {\n        padding-top: 0;\n        padding-bottom: 0;\n        margin-bottom: 10px;\n    }\n}\n\n.ui.grid>.row:before {\n    box-shadow: none !important;\n}\n\n.ui.grid>.row>.column {\n    margin-top: 0.1rem;\n    margin-bottom: 0.1rem;\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n}\n\n.nopadding {\n    padding: 0 !important;\n}\n\n.clear {\n    clear: both;\n    line-height: 0;\n    font-size: 0;\n    overflow: hidden;\n}\n\n.clearfix {\n    *zoom: 1;\n}\n\n.clearfix:after,\n.container:after {\n    clear: both;\n    content: \".\";\n    display: block;\n    font-size: 0;\n    height: 0;\n    line-height: 0;\n    visibility: hidden;\n}\n\n// ::-webkit-scrollbar {\n//   width: 6px;\n// }\n// ::-webkit-scrollbar-track {\n//   -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.4);\n//   border-radius: 5px;\n// }\n// ::-webkit-scrollbar-thumb {\n//   border-radius: 5px;\n//   -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.6);\n// }\n\nsup {\n    vertical-align: top;\n    padding: 0;\n    margin: 0;\n}\n\n:focus,\na {\n    outline: none;\n}\n\n::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n}\n\n::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);\n    border-radius: 5px;\n}\n\n::-webkit-scrollbar-thumb {\n    border-radius: 5px;\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.7);\n}\n\ni.icon:before {\n    font-family: Icons;\n}\n\ni.icon.outline {\n    font-family: outline-icons;\n\n    &::before {\n        font-family: outline-icons;\n    }\n}\n\ni.icon.close:before {\n    content: \"\\2716\";\n    font-weight: $fontWeight600;\n}\n\ni.icon.equal:before {\n    font-size: 2em;\n    content: \"=\";\n    font-weight: $fontWeight600;\n    color: #dcdcdc;\n}\n\ni.squareIcon {\n    background-color: $dkblue2;\n\n    &::before {\n        color: $white !important;\n        font-size: 0.9em;\n    }\n}","//MAIN COLORS HERE\n$black:#000;\n$white: #fff;\n$border-color: #99928a;\n$border-color2: #ccc;\n$yellow: #fdc92f;\n$dkyellow: #f8a800;\n$dkblue: #232f3a;\n$dkblue2:#285482;\n$ltgrey: #99928a;\n$ltgrey2: #c8c8c8;\n$pageBG: #f7f8fa;\n$skyblue: #009ada;\n$darkgrey: #686c6d;\n$darkgreyhover: #87959c;\n$accordianbg: #f1f1f1;\n$thead-border:rgba(220,220,220,0.5);\n$modalBg: rgb(241, 241, 241);\n$subMenuBg:rgb(236, 236, 236);\n$subMenuTxt:#717575;\n$dullRed: #a94442;\n$red: #b13036;\n$labelData: #2b3641;\n$toastbg: rgba(0,0,0,.8);\n$tabBg: #ececec;\n$green: #34ab36;\n\n//FONT WEIGHT HERE\n$fontWeight100: 100;\n$fontWeight200: 200;\n$fontWeight300: 300;\n$fontWeight400: 400;\n$fontWeight500: 500;\n$fontWeight600: 600;\n$fontWeight700: 700;\n$fontWeight800: 800;\n$fontWeight900: 900;","h1 {\n    font-family: 'ProximaNovaRegular';\n    font-size: 2.49em;\n    line-height: 1.2em;\n    color: $dkblue;\n    font-weight: normal;\n}\n\nh2 {\n    font-family: 'ProximaNovaRegular';\n    font-size: 2.07em;\n    line-height: 1.2em;\n    color: $dkblue;\n    font-weight: normal;\n}\n\nh3 {\n    font-family: 'ProximaNovaRegular';\n    font-size: 1.73em;\n    line-height: 1.2em;\n    color: $dkblue;\n    font-weight: normal;\n}\n\nh4 {\n    font-family: 'ProximaNovaRegular';\n    font-size: 1.44em;\n    line-height: 1.2em;\n    color: $dkblue;\n    font-weight: normal;\n}\n\nh5 {\n    font-family: 'ProximaNovaRegular';\n    font-size: 1.44em;\n    line-height: 1.2em;\n    color: $dkblue;\n    font-weight: normal;\n}\n\nh6 {\n    font-family: 'ProximaNovaRegular';\n    font-size: 11.9px;\n    line-height: 1.2em;\n    color: $dkblue;\n    font-weight: normal;\n}\n\np,\nli,\nspan {\n    font-family: 'ProximaNovaRegular';\n    font-size: 16px;\n    line-height: 1.5em;\n    font-weight: 400;\n    font-style: normal;\n    color:$dkblue;\n    text-transform: none;\n  \n}\n\na {\n    font-size: 16px;\n    line-height: 1.5em;\n    font-weight: 400;\n    font-style: normal;\n    color: $dkblue;\n    text-decoration: none;\n}","/*COMMON CLASSES*/\n\n.noPrivilege {\n    padding: 0px 0 50px 0;\n    text-align: center;\n\n    .dontSign {\n        display: block;\n        margin-bottom: 30px;\n\n        i {\n            text-align: center;\n            display: initial;\n\n            &::before {\n                font-size: 3.7em;\n                color: $ltgrey2;\n            }\n        }\n    }\n}\n\n.floatLeft {\n    float: left !important;\n}\n\n.floatRight {\n    float: right !important;\n}\n\n.floatNone {\n    float: none !important;\n}\n\n.txtCenter {\n    text-align: center !important;\n}\n\n.txtLeft {\n    text-align: left;\n}\n\n.txtRight {\n    text-align: right;\n}\n\n.textJustify {\n    text-align: justify;\n}\n\n.textNowrap {\n    white-space: nowrap;\n}\n\n.lowercase {\n    text-transform: lowercase !important;\n}\n\n.uppercase {\n    text-transform: uppercase !important;\n}\n\n.capitalize {\n    text-transform: capitalize !important;\n}\n\n.transformNone {\n    text-transform: none !important;\n}\n\n.relative {\n    position: relative;\n}\n\n.heightAuto {\n    height: auto !important;\n    min-height: 100%;\n}\n\n.ellip {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.breakAll {\n    word-break: break-all;\n}\n\n.noBreak {\n    word-break: normal !important;\n}\n\n.noScroll {\n    overflow: hidden !important;\n}\n\n.no_bg {\n    background: none !important;\n}\n\n.noBorder {\n    border: none !important;\n}\n\n.borderLeft {\n    border-left: 1px solid $border-color;\n}\n\n.borderTop {\n    border-top: 1px solid $border-color;\n}\n\n.borderRight {\n    border-right: 1px solid $border-color;\n}\n\n.borderBottom {\n    border-bottom: 1px solid $border-color;\n}\n\n//COMMON Bootstrap\n.center-block {\n    display: block;\n    margin-right: auto;\n    margin-left: auto;\n}\n\n.hide {\n    display: none !important;\n}\n\n.show {\n    display: block !important;\n}\n\n.invisible {\n    visibility: hidden;\n}\n\n.text-hide {\n    font: 0/0 a;\n    color: transparent;\n    text-shadow: none;\n    background-color: transparent;\n    border: 0;\n}\n\n//MARGIN CLASSES\n.paddingLR0 {\n    padding-left: 0px !important;\n    padding-right: 0px !important;\n}\n\n.pt0 {\n    padding-top: 0 !important;\n}\n\n.pt5 {\n    padding-top: 5px !important;\n}\n\n.pt10 {\n    padding-top: 10px !important;\n}\n\n.padTopBot50 {\n    position: relative;\n    padding-top: 140px !important;\n    padding-bottom: 30px !important;\n}\n\n.pb10 {\n    padding-bottom: 10px !important;\n}\n\n.pt20 {\n    padding-top: 20px !important;\n}\n\n.pb20 {\n    padding-bottom: 20px !important;\n}\n\n.pl10 {\n    padding-left: 10px !important;\n}\n\n.margin0 {\n    margin: 0 !important;\n}\n\n.mt0 {\n    margin-top: 0 !important;\n}\n\n.mt5 {\n    margin-top: 5px !important;\n}\n\n.mt10 {\n    margin-top: 10px !important;\n}\n\n.mt20 {\n    margin-top: 20px !important;\n}\n\n.mt30 {\n    margin-top: 30px !important;\n}\n\n.mt-20 {\n    margin-top: -20px !important;\n}\n\n.mb0 {\n    margin-bottom: 0 !important;\n}\n\n.mb5 {\n    margin-bottom: 5px !important;\n}\n\n.mb10 {\n    margin-bottom: 10px !important;\n}\n\n.mb20 {\n    margin-bottom: 20px !important;\n}\n\n.mb30 {\n    margin-bottom: 30px !important;\n}\n\n.mr5 {\n    margin-right: 5px !important;\n}\n\n.mr10 {\n    margin-right: 10px !important;\n}\n\n.mr20 {\n    margin-right: 20px !important;\n}\n\n.mr30 {\n    margin-right: 30px !important;\n}\n\n.ml5 {\n    margin-left: 5px !important;\n}\n\n.ml10 {\n    margin-left: 10px !important;\n}\n\n.ml20 {\n    margin-left: 20px !important;\n}\n\n.ml30 {\n    margin-left: 30px !important;\n}\n\n.middleIcon {\n    display: inline-block;\n    width: 24px;\n    height: 22px;\n    margin: 0 10px;\n    vertical-align: middle;\n}\n\n.leftIcon {\n    display: inline-block;\n    width: 24px;\n    height: 22px;\n    margin: 0 10px 0 0;\n    vertical-align: middle;\n}\n\n.commonList {\n    list-style: disc;\n    margin-left: 30px;\n}\n\n.font13 {\n    font-size: 13px !important;\n}\n\n.font18 {\n    font-size: 18px !important;\n}\n\n.message {\n    display: block;\n    background: $dullRed;\n    font-size: 15px;\n    color: $white;\n    text-align: center;\n    padding: 10px;\n    border: 1px solid $dullRed;\n}\n\n.inlineB {\n    display: inline-block !important;\n}\n\n.inline {\n    display: inline !important;\n}\n\n.dot {\n    display: inline-block;\n    width: 10px;\n    height: 10px;\n    background: $black;\n    border: 1px solid $white;\n    @include border-radius(50%);\n}\n\n.vMiddle {\n    vertical-align: middle;\n}\n\n.headTitle {\n    font-size: 20px;\n    color: $dkblue;\n    line-height: 25px;\n}\n\n.lineH30 {\n    line-height: 30px !important;\n}\n\n.pointer {\n    cursor: pointer !important;\n}\n\n.noPointer {\n    cursor: not-allowed !important;\n}\n\n.ui.dimmer {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    height: 100%;\n    width: 100%;\n    background: rgba(35, 47, 58, 0.95);\n    z-index: 10000 !important;\n\n    &.modals {\n        z-index: 9999 !important;\n    }\n\n}\n\n.noRecordMessage {\n    display: block;\n    width: 100%;\n    font-size: 16px;\n    color: $darkgrey;\n    margin: 80px 0 30px 0;\n    text-align: center;\n}\n\n\n.threeLiner {\n    width: 100%;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    overflow: hidden;\n}\n\n.twoLiner {\n    width: 100%;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    overflow: hidden;\n}\n\n.oneLiner {\n    width: 100%;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    overflow: hidden;\n}\n\n.validationError {\n    .ui.selection {\n        border: 1px solid #e0b4b4 !important;\n        background: #fff6f6 !important;\n        color: #9f3a38;\n    }\n}\n\n.txtRed {\n    color: $red !important;\n}\n\n.errorMessage {\n    display: block;\n    margin-top: -10px;\n    font-size: 14px;\n    color: $dullRed;\n}","@mixin border-radius($radius) {\n    -webkit-border-radius: $radius;\n    -moz-border-radius: $radius;\n    -ms-border-radius: $radius;\n    -o-border-radius: $radius;\n    border-radius: $radius;\n}\n\n@mixin border-top-radius($radius) {\n    border-top-right-radius: $radius;\n    border-top-left-radius: $radius;\n}\n\n@mixin border-right-radius($radius) {\n    border-bottom-right-radius: $radius;\n    border-top-right-radius: $radius;\n}\n\n@mixin border-bottom-radius($radius) {\n    border-bottom-right-radius: $radius;\n    border-bottom-left-radius: $radius;\n}\n\n@mixin border-left-radius($radius) {\n    border-bottom-left-radius: $radius;\n    border-top-left-radius: $radius;\n}\n\n@mixin box-shadow($shadow) {\n    -webkit-box-shadow: $shadow;\n    -moz-box-shadow: $shadow;\n    -ms-box-shadow: $shadow;\n    -o-box-shadow: $shadow;\n    box-shadow: $shadow;\n}\n\n@mixin transition($transition) {\n    -webkit-transition: $transition;\n    -moz-transition: $transition;\n    -ms-transition: $transition;\n    -o-transition: $transition;\n    transition: $transition;\n}\n\n// generic transform\n@mixin transform($transforms) {\n    -moz-transform: $transforms;\n    -ms-transform: $transforms;\n    -webkit-transform: $transforms;\n    -khtml-transform: $transforms;\n    -o-transform: $transforms;\n    transform: $transforms;\n}\n\n// generic translateX\n@mixin translateX($translate) {\n    -moz-transform: translateX($translate);\n    -ms-transform: translateX($translate);\n    -webkit-transform: translateX($translate);\n    -khtml-transform: translateX($translate);\n    -o-transform: translateX($translate);\n    transform: translateX($translate);\n}\n\n// generic translateY\n@mixin translateY($translate) {\n    -moz-transform: translateY($translate);\n    -ms-transform: translateY($translate);\n    -webkit-transform: translateY($translate);\n    -khtml-transform: translateY($translate);\n    -o-transform: translateY($translate);\n    transform: translateY($translate);\n}\n\n// BACKGROUND gradient//\n@mixin gradient($start, $gradient1, $gradient2) {\n    background: $gradient1;\n    background: -webkit-linear-gradient($start, $gradient1, $gradient2);\n    background: -o-linear-gradient($start, $gradient1, $gradient2);\n    background: -moz-linear-gradient($start, $gradient1, $gradient2);\n    background: linear-gradient(to $start, $gradient1, $gradient2);\n}\n\n// rotate\n@mixin rotate($deg) {\n    @include transform(rotate(#{$deg}deg));\n}\n\n//display flex\n@mixin flex() {\n    display: flex;\n    display: -ms-flexbox;\n    display: -webkit-box;\n    display: -webkit-flex;\n}\n\n\n//user select none\n@mixin userselect($select) {\n  -webkit-user-select: $select;\n     -moz-user-select: $select;\n      -ms-user-select: $select; // IE10+\n          user-select: $select;\n}\n\n@mixin appearance($value) {\n  -webkit-appearance: $value;\n     -moz-appearance: $value;\n      -ms-appearance: $value; // IE10+\n          appearance: $value;\n}\n\n\n\n@mixin boxsizing($bxsizing) {\n    -webkit-box-sizing: $bxsizing;\n    -moz-box-sizing: $bxsizing;\n    -ms-box-sizing: $bxsizing;\n    -o-box-sizing: $bxsizing;\n    box-sizing: $bxsizing;\n}\n\n@mixin opacity($opacity) {\n    -webkit-opacity: $opacity;\n    -moz-opacity: $opacity;\n    -khtml-opacity: $opacity;\n    opacity: $opacity;\n}\n\n\n\n@mixin clearboth{\n  clear: both;\n  overflow:hidden;\n}\n\n@mixin border-radius($radius) {\n  -webkit-border-radius: $radius;\n     -moz-border-radius: $radius;\n      -ms-border-radius: $radius;\n          border-radius: $radius;\n}\n\n@mixin transition-duration($time){\n     -webkit-transition-duration:$time;\n      -moz-transition-duration: $time;\n      -o-transition-duration: $time;\n       transition-duration: $time;\n}\n\n@mixin fade{\n    -moz-transition: all 0.3s ease-out;\n  -webkit-transition: all 0.3s ease-out;\n  transition: all 0.3s ease-out;\n}\n\n\n//@mixin box-shadow($top, $left, $blur, $color, $inset: false) {\n//  @if $inset {\n//    -webkit-box-shadow:inset $top $left $blur $color;\n//    -moz-box-shadow:inset $top $left $blur $color;\n//    box-shadow:inset $top $left $blur $color;\n//  } @else {\n//    -webkit-box-shadow: $top $left $blur $color;\n//    -moz-box-shadow: $top $left $blur $color;\n//    box-shadow: $top $left $blur $color;\n//  }\n//}\n\n@mixin transfromMAC{ \n-ms-transform: translate(0%, -50%); /* IE 9 */\n-webkit-transform: translate(0%, -50%); /* Chrome, Safari, Opera */\ntransform: translate(0%, -50%);\n-moz-transform: translate(0%, -50%);\n-o-transform: translate(0%, -50%);\n}\n\n\n@mixin border-radius($radius){\n   -webkit-border-radius: $radius;\n     -moz-border-radius: $radius;\n      -ms-border-radius: $radius;\n     -o-box-sizing: $radius;\n          border-radius: $radius;\n}\n\n@mixin filter($ftgray){\n   -webkit-filter:grayscale($ftgray);\n     -webkit-filter:grayscale($ftgray);\n       -webkit-filter:grayscale($ftgray);\n      -webkit-filter:grayscale($ftgray);\n          filter:grayscale($ftgray);\n}\n\n@mixin box-sizing( $type: border-box ){\n    -webkit-box-sizing: $type;\n       -moz-box-sizing: $type;\n         -o-box-sizing: $type;\n        -ms-box-sizing: $type;\n            box-sizing: $type; \n}\n\n\n\n\n@mixin transition($transition-property, $transition-in-time, $method,  $transition-out-time) {\n    -webkit-transition: $transition-property $transition-in-time $method  $transition-out-time;\n    -moz-transition: $transition-property $transition-in-time $method  $transition-out-time;\n    -ms-transition: $transition-property $transition-in-time $method  $transition-out-time;\n    -o-transition: $transition-property $transition-in-time $method  $transition-out-time;\n    transition: $transition-property $transition-in-time $method  $transition-out-time;\n}\n\n@mixin menuArrow(){\n    &:after,\n    &:before {\n        bottom: 100%;\n        left: 92%;\n        border: solid transparent;\n        content: \" \";\n        height: 0;\n        width: 0;\n        position: absolute;\n        pointer-events: none;\n    }\n    &:after {\n        border-color: rgba(255, 255, 255, 0);\n        border-bottom-color: $white;\n        border-width: 8px;\n        margin-left: -8px;\n    }\n    &:before {\n        border-color: rgba(0, 0, 0, 0);\n        border-bottom-color: $ltslate;\n        border-width: 9px;\n        margin-left: -9px;\n    }\n}\n\n","/*!\n * Font Awesome Free 5.0.4 by @fontawesome - http://fontawesome.com\n * License - http://fontawesome.com/license (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)\n */\n\n.fa,\n.fab,\n.fal,\n.far,\n.fas {\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased;\n    display: inline-block;\n    font-style: normal;\n    font-variant: normal;\n    text-rendering: auto;\n    line-height: 1\n}\n\n.fa-lg {\n    font-size: 1.33333em;\n    line-height: .75em;\n    vertical-align: -.0667em\n}\n\n.fa-xs {\n    font-size: .75em;\n    &:before{\n        font-size: .75em\n    }\n}\n\n.fa-sm {\n    font-size: .875em;\n    &:before{\n        font-size: .875em;\n    }\n}\n\n.fa-1x {\n    font-size: 1em;\n    &:before{\n        font-size: 1em;\n    }\n}\n.fa-1_2x {\n    font-size: 1.25em;\n    &:before{\n        font-size: 1.25em;\n    }\n}\n\n.fa-2x {\n    font-size: 2em;\n    &:before{\n        font-size: 2em;\n    }\n}\n\n.fa-3x {\n    font-size: 3em;\n    &:before{\n        font-size: 3em;\n    }\n}\n\n.fa-4x {\n    font-size: 4em;\n    &:before{\n        font-size: 4em;\n    }\n}\n\n.fa-5x {\n    font-size: 5em;\n    &:before{\n        font-size: 5em;\n    }\n}\n\n.fa-6x {\n    font-size: 6em\n}\n\n.fa-7x {\n    font-size: 7em\n}\n\n.fa-8x {\n    font-size: 8em\n}\n\n.fa-9x {\n    font-size: 9em\n}\n\n.fa-10x {\n    font-size: 10em\n}\n\n.fa-fw {\n    text-align: center;\n    width: 1.25em\n}\n\n.fa-ul {\n    list-style-type: none;\n    margin-left: 2.5em;\n    padding-left: 0\n}\n\n.fa-ul>li {\n    position: relative\n}\n\n.fa-li {\n    left: -2em;\n    position: absolute;\n    text-align: center;\n    width: 2em;\n    line-height: inherit\n}\n\n.fa-border {\n    border: .08em solid #eee;\n    border-radius: .1em;\n    padding: .2em .25em .15em\n}\n\n.fa-pull-left {\n    float: left\n}\n\n.fa-pull-right {\n    float: right\n}\n\n.fa.fa-pull-left,\n.fab.fa-pull-left,\n.fal.fa-pull-left,\n.far.fa-pull-left,\n.fas.fa-pull-left {\n    margin-right: .3em\n}\n\n.fa.fa-pull-right,\n.fab.fa-pull-right,\n.fal.fa-pull-right,\n.far.fa-pull-right,\n.fas.fa-pull-right {\n    margin-left: .3em\n}\n\n.fa-spin {\n    -webkit-animation: a 2s infinite linear;\n    animation: a 2s infinite linear\n}\n\n.fa-pulse {\n    -webkit-animation: a 1s infinite steps(8);\n    animation: a 1s infinite steps(8)\n}\n\n@-webkit-keyframes a {\n    0% {\n        -webkit-transform: rotate(0deg);\n        transform: rotate(0deg)\n    }\n    to {\n        -webkit-transform: rotate(1turn);\n        transform: rotate(1turn)\n    }\n}\n\n@keyframes a {\n    0% {\n        -webkit-transform: rotate(0deg);\n        transform: rotate(0deg)\n    }\n    to {\n        -webkit-transform: rotate(1turn);\n        transform: rotate(1turn)\n    }\n}\n\n.fa-rotate-90 {\n    -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n    -webkit-transform: rotate(90deg);\n    transform: rotate(90deg)\n}\n\n.fa-rotate-180 {\n    -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n    -webkit-transform: rotate(180deg);\n    transform: rotate(180deg)\n}\n\n.fa-rotate-270 {\n    -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n    -webkit-transform: rotate(270deg);\n    transform: rotate(270deg)\n}\n\n.fa-flip-horizontal {\n    -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n    -webkit-transform: scaleX(-1);\n    transform: scaleX(-1)\n}\n\n.fa-flip-vertical {\n    -webkit-transform: scaleY(-1);\n    transform: scaleY(-1)\n}\n\n.fa-flip-horizontal.fa-flip-vertical,\n.fa-flip-vertical {\n    -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\"\n}\n\n.fa-flip-horizontal.fa-flip-vertical {\n    -webkit-transform: scale(-1);\n    transform: scale(-1)\n}\n\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270 {\n    -webkit-filter: none;\n    filter: none\n}\n\n.fa-stack {\n    display: inline-block;\n    height: 2em;\n    line-height: 2em;\n    position: relative;\n    vertical-align: middle;\n    width: 2em\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n    left: 0;\n    position: absolute;\n    text-align: center;\n    width: 100%\n}\n\n.fa-stack-1x {\n    line-height: inherit\n}\n\n.fa-stack-2x {\n    font-size: 2em\n}\n\n.fa-inverse {\n    color: #fff\n}\n\n.fa-500px:before {\n    content: \"\\f26e\"\n}\n\n.fa-accessible-icon:before {\n    content: \"\\f368\"\n}\n\n.fa-accusoft:before {\n    content: \"\\f369\"\n}\n\n.fa-address-book:before {\n    content: \"\\f2b9\"\n}\n\n.fa-address-card:before {\n    content: \"\\f2bb\"\n}\n\n.fa-adjust:before {\n    content: \"\\f042\"\n}\n\n.fa-adn:before {\n    content: \"\\f170\"\n}\n\n.fa-adversal:before {\n    content: \"\\f36a\"\n}\n\n.fa-affiliatetheme:before {\n    content: \"\\f36b\"\n}\n\n.fa-algolia:before {\n    content: \"\\f36c\"\n}\n\n.fa-align-center:before {\n    content: \"\\f037\"\n}\n\n.fa-align-justify:before {\n    content: \"\\f039\"\n}\n\n.fa-align-left:before {\n    content: \"\\f036\"\n}\n\n.fa-align-right:before {\n    content: \"\\f038\"\n}\n\n.fa-amazon:before {\n    content: \"\\f270\"\n}\n\n.fa-amazon-pay:before {\n    content: \"\\f42c\"\n}\n\n.fa-ambulance:before {\n    content: \"\\f0f9\"\n}\n\n.fa-american-sign-language-interpreting:before {\n    content: \"\\f2a3\"\n}\n\n.fa-amilia:before {\n    content: \"\\f36d\"\n}\n\n.fa-anchor:before {\n    content: \"\\f13d\"\n}\n\n.fa-android:before {\n    content: \"\\f17b\"\n}\n\n.fa-angellist:before {\n    content: \"\\f209\"\n}\n\n.fa-angle-double-down:before {\n    content: \"\\f103\"\n}\n\n.fa-angle-double-left:before {\n    content: \"\\f100\"\n}\n\n.fa-angle-double-right:before {\n    content: \"\\f101\"\n}\n\n.fa-angle-double-up:before {\n    content: \"\\f102\"\n}\n\n.fa-angle-down:before {\n    content: \"\\f107\"\n}\n\n.fa-angle-left:before {\n    content: \"\\f104\"\n}\n\n.fa-angle-right:before {\n    content: \"\\f105\"\n}\n\n.fa-angle-up:before {\n    content: \"\\f106\"\n}\n\n.fa-angrycreative:before {\n    content: \"\\f36e\"\n}\n\n.fa-angular:before {\n    content: \"\\f420\"\n}\n\n.fa-app-store:before {\n    content: \"\\f36f\"\n}\n\n.fa-app-store-ios:before {\n    content: \"\\f370\"\n}\n\n.fa-apper:before {\n    content: \"\\f371\"\n}\n\n.fa-apple:before {\n    content: \"\\f179\"\n}\n\n.fa-apple-pay:before {\n    content: \"\\f415\"\n}\n\n.fa-archive:before {\n    content: \"\\f187\"\n}\n\n.fa-arrow-alt-circle-down:before {\n    content: \"\\f358\"\n}\n\n.fa-arrow-alt-circle-left:before {\n    content: \"\\f359\"\n}\n\n.fa-arrow-alt-circle-right:before {\n    content: \"\\f35a\"\n}\n\n.fa-arrow-alt-circle-up:before {\n    content: \"\\f35b\"\n}\n\n.fa-arrow-circle-down:before {\n    content: \"\\f0ab\"\n}\n\n.fa-arrow-circle-left:before {\n    content: \"\\f0a8\"\n}\n\n.fa-arrow-circle-right:before {\n    content: \"\\f0a9\"\n}\n\n.fa-arrow-circle-up:before {\n    content: \"\\f0aa\"\n}\n\n.fa-arrow-down:before {\n    content: \"\\f063\"\n}\n\n.fa-arrow-left:before {\n    content: \"\\f060\"\n}\n\n.fa-arrow-right:before {\n    content: \"\\f061\"\n}\n\n.fa-arrow-up:before {\n    content: \"\\f062\"\n}\n\n.fa-arrows-alt:before {\n    content: \"\\f0b2\"\n}\n\n.fa-arrows-alt-h:before {\n    content: \"\\f337\"\n}\n\n.fa-arrows-alt-v:before {\n    content: \"\\f338\"\n}\n\n.fa-assistive-listening-systems:before {\n    content: \"\\f2a2\"\n}\n\n.fa-asterisk:before {\n    content: \"\\f069\"\n}\n\n.fa-asymmetrik:before {\n    content: \"\\f372\"\n}\n\n.fa-at:before {\n    content: \"\\f1fa\"\n}\n\n.fa-audible:before {\n    content: \"\\f373\"\n}\n\n.fa-audio-description:before {\n    content: \"\\f29e\"\n}\n\n.fa-autoprefixer:before {\n    content: \"\\f41c\"\n}\n\n.fa-avianex:before {\n    content: \"\\f374\"\n}\n\n.fa-aviato:before {\n    content: \"\\f421\"\n}\n\n.fa-aws:before {\n    content: \"\\f375\"\n}\n\n.fa-backward:before {\n    content: \"\\f04a\"\n}\n\n.fa-balance-scale:before {\n    content: \"\\f24e\"\n}\n\n.fa-ban:before {\n    content: \"\\f05e\"\n}\n\n.fa-bandcamp:before {\n    content: \"\\f2d5\"\n}\n\n.fa-barcode:before {\n    content: \"\\f02a\"\n}\n\n.fa-bars:before {\n    content: \"\\f0c9\"\n}\n\n.fa-bath:before {\n    content: \"\\f2cd\"\n}\n\n.fa-battery-empty:before {\n    content: \"\\f244\"\n}\n\n.fa-battery-full:before {\n    content: \"\\f240\"\n}\n\n.fa-battery-half:before {\n    content: \"\\f242\"\n}\n\n.fa-battery-quarter:before {\n    content: \"\\f243\"\n}\n\n.fa-battery-three-quarters:before {\n    content: \"\\f241\"\n}\n\n.fa-bed:before {\n    content: \"\\f236\"\n}\n\n.fa-beer:before {\n    content: \"\\f0fc\"\n}\n\n.fa-behance:before {\n    content: \"\\f1b4\"\n}\n\n.fa-behance-square:before {\n    content: \"\\f1b5\"\n}\n\n.fa-bell:before {\n    content: \"\\f0f3\"\n}\n\n.fa-bell-slash:before {\n    content: \"\\f1f6\"\n}\n\n.fa-bicycle:before {\n    content: \"\\f206\"\n}\n\n.fa-bimobject:before {\n    content: \"\\f378\"\n}\n\n.fa-binoculars:before {\n    content: \"\\f1e5\"\n}\n\n.fa-birthday-cake:before {\n    content: \"\\f1fd\"\n}\n\n.fa-bitbucket:before {\n    content: \"\\f171\"\n}\n\n.fa-bitcoin:before {\n    content: \"\\f379\"\n}\n\n.fa-bity:before {\n    content: \"\\f37a\"\n}\n\n.fa-black-tie:before {\n    content: \"\\f27e\"\n}\n\n.fa-blackberry:before {\n    content: \"\\f37b\"\n}\n\n.fa-blind:before {\n    content: \"\\f29d\"\n}\n\n.fa-blogger:before {\n    content: \"\\f37c\"\n}\n\n.fa-blogger-b:before {\n    content: \"\\f37d\"\n}\n\n.fa-bluetooth:before {\n    content: \"\\f293\"\n}\n\n.fa-bluetooth-b:before {\n    content: \"\\f294\"\n}\n\n.fa-bold:before {\n    content: \"\\f032\"\n}\n\n.fa-bolt:before {\n    content: \"\\f0e7\"\n}\n\n.fa-bomb:before {\n    content: \"\\f1e2\"\n}\n\n.fa-book:before {\n    content: \"\\f02d\"\n}\n\n.fa-bookmark:before {\n    content: \"\\f02e\"\n}\n\n.fa-braille:before {\n    content: \"\\f2a1\"\n}\n\n.fa-briefcase:before {\n    content: \"\\f0b1\"\n}\n\n.fa-btc:before {\n    content: \"\\f15a\"\n}\n\n.fa-bug:before {\n    content: \"\\f188\"\n}\n\n.fa-building:before {\n    content: \"\\f1ad\"\n}\n\n.fa-bullhorn:before {\n    content: \"\\f0a1\"\n}\n\n.fa-bullseye:before {\n    content: \"\\f140\"\n}\n\n.fa-buromobelexperte:before {\n    content: \"\\f37f\"\n}\n\n.fa-bus:before {\n    content: \"\\f207\"\n}\n\n.fa-buysellads:before {\n    content: \"\\f20d\"\n}\n\n.fa-calculator:before {\n    content: \"\\f1ec\"\n}\n\n.fa-calendar:before {\n    content: \"\\f133\"\n}\n\n.fa-calendar-alt:before {\n    content: \"\\f073\"\n}\n\n.fa-calendar-check:before {\n    content: \"\\f274\"\n}\n\n.fa-calendar-minus:before {\n    content: \"\\f272\"\n}\n\n.fa-calendar-plus:before {\n    content: \"\\f271\"\n}\n\n.fa-calendar-times:before {\n    content: \"\\f273\"\n}\n\n.fa-camera:before {\n    content: \"\\f030\"\n}\n\n.fa-camera-retro:before {\n    content: \"\\f083\"\n}\n\n.fa-car:before {\n    content: \"\\f1b9\"\n}\n\n.fa-caret-down:before {\n    content: \"\\f0d7\"\n}\n\n.fa-caret-left:before {\n    content: \"\\f0d9\"\n}\n\n.fa-caret-right:before {\n    content: \"\\f0da\"\n}\n\n.fa-caret-square-down:before {\n    content: \"\\f150\"\n}\n\n.fa-caret-square-left:before {\n    content: \"\\f191\"\n}\n\n.fa-caret-square-right:before {\n    content: \"\\f152\"\n}\n\n.fa-caret-square-up:before {\n    content: \"\\f151\"\n}\n\n.fa-caret-up:before {\n    content: \"\\f0d8\"\n}\n\n.fa-cart-arrow-down:before {\n    content: \"\\f218\"\n}\n\n.fa-cart-plus:before {\n    content: \"\\f217\"\n}\n\n.fa-cc-amazon-pay:before {\n    content: \"\\f42d\"\n}\n\n.fa-cc-amex:before {\n    content: \"\\f1f3\"\n}\n\n.fa-cc-apple-pay:before {\n    content: \"\\f416\"\n}\n\n.fa-cc-diners-club:before {\n    content: \"\\f24c\"\n}\n\n.fa-cc-discover:before {\n    content: \"\\f1f2\"\n}\n\n.fa-cc-jcb:before {\n    content: \"\\f24b\"\n}\n\n.fa-cc-mastercard:before {\n    content: \"\\f1f1\"\n}\n\n.fa-cc-paypal:before {\n    content: \"\\f1f4\"\n}\n\n.fa-cc-stripe:before {\n    content: \"\\f1f5\"\n}\n\n.fa-cc-visa:before {\n    content: \"\\f1f0\"\n}\n\n.fa-centercode:before {\n    content: \"\\f380\"\n}\n\n.fa-certificate:before {\n    content: \"\\f0a3\"\n}\n\n.fa-chart-area:before {\n    content: \"\\f1fe\"\n}\n\n.fa-chart-bar:before {\n    content: \"\\f080\"\n}\n\n.fa-chart-line:before {\n    content: \"\\f201\"\n}\n\n.fa-chart-pie:before {\n    content: \"\\f200\"\n}\n\n.fa-check:before {\n    content: \"\\f00c\"\n}\n\n.fa-check-circle:before {\n    content: \"\\f058\"\n}\n\n.fa-check-square:before {\n    content: \"\\f14a\"\n}\n\n.fa-chevron-circle-down:before {\n    content: \"\\f13a\"\n}\n\n.fa-chevron-circle-left:before {\n    content: \"\\f137\"\n}\n\n.fa-chevron-circle-right:before {\n    content: \"\\f138\"\n}\n\n.fa-chevron-circle-up:before {\n    content: \"\\f139\"\n}\n\n.fa-chevron-down:before {\n    content: \"\\f078\"\n}\n\n.fa-chevron-left:before {\n    content: \"\\f053\"\n}\n\n.fa-chevron-right:before {\n    content: \"\\f054\"\n}\n\n.fa-chevron-up:before {\n    content: \"\\f077\"\n}\n\n.fa-child:before {\n    content: \"\\f1ae\"\n}\n\n.fa-chrome:before {\n    content: \"\\f268\"\n}\n\n.fa-circle:before {\n    content: \"\\f111\"\n}\n\n.fa-circle-notch:before {\n    content: \"\\f1ce\"\n}\n\n.fa-clipboard:before {\n    content: \"\\f328\"\n}\n\n.fa-clock:before {\n    content: \"\\f017\"\n}\n\n.fa-clone:before {\n    content: \"\\f24d\"\n}\n\n.fa-closed-captioning:before {\n    content: \"\\f20a\"\n}\n\n.fa-cloud:before {\n    content: \"\\f0c2\"\n}\n\n.fa-cloud-download-alt:before {\n    content: \"\\f381\"\n}\n\n.fa-cloud-upload-alt:before {\n    content: \"\\f382\"\n}\n\n.fa-cloudscale:before {\n    content: \"\\f383\"\n}\n\n.fa-cloudsmith:before {\n    content: \"\\f384\"\n}\n\n.fa-cloudversify:before {\n    content: \"\\f385\"\n}\n\n.fa-code:before {\n    content: \"\\f121\"\n}\n\n.fa-code-branch:before {\n    content: \"\\f126\"\n}\n\n.fa-codepen:before {\n    content: \"\\f1cb\"\n}\n\n.fa-codiepie:before {\n    content: \"\\f284\"\n}\n\n.fa-coffee:before {\n    content: \"\\f0f4\"\n}\n\n.fa-cog:before {\n    content: \"\\f013\"\n}\n\n.fa-cogs:before {\n    content: \"\\f085\"\n}\n\n.fa-columns:before {\n    content: \"\\f0db\"\n}\n\n.fa-comment:before {\n    content: \"\\f075\"\n}\n\n.fa-comment-alt:before {\n    content: \"\\f27a\"\n}\n\n.fa-comments:before {\n    content: \"\\f086\"\n}\n\n.fa-compass:before {\n    content: \"\\f14e\"\n}\n\n.fa-compress:before {\n    content: \"\\f066\"\n}\n\n.fa-connectdevelop:before {\n    content: \"\\f20e\"\n}\n\n.fa-contao:before {\n    content: \"\\f26d\"\n}\n\n.fa-copy:before {\n    content: \"\\f0c5\"\n}\n\n.fa-copyright:before {\n    content: \"\\f1f9\"\n}\n\n.fa-cpanel:before {\n    content: \"\\f388\"\n}\n\n.fa-creative-commons:before {\n    content: \"\\f25e\"\n}\n\n.fa-credit-card:before {\n    content: \"\\f09d\"\n}\n\n.fa-crop:before {\n    content: \"\\f125\"\n}\n\n.fa-crosshairs:before {\n    content: \"\\f05b\"\n}\n\n.fa-css3:before {\n    content: \"\\f13c\"\n}\n\n.fa-css3-alt:before {\n    content: \"\\f38b\"\n}\n\n.fa-cube:before {\n    content: \"\\f1b2\"\n}\n\n.fa-cubes:before {\n    content: \"\\f1b3\"\n}\n\n.fa-cut:before {\n    content: \"\\f0c4\"\n}\n\n.fa-cuttlefish:before {\n    content: \"\\f38c\"\n}\n\n.fa-d-and-d:before {\n    content: \"\\f38d\"\n}\n\n.fa-dashcube:before {\n    content: \"\\f210\"\n}\n\n.fa-database:before {\n    content: \"\\f1c0\"\n}\n\n.fa-deaf:before {\n    content: \"\\f2a4\"\n}\n\n.fa-delicious:before {\n    content: \"\\f1a5\"\n}\n\n.fa-deploydog:before {\n    content: \"\\f38e\"\n}\n\n.fa-deskpro:before {\n    content: \"\\f38f\"\n}\n\n.fa-desktop:before {\n    content: \"\\f108\"\n}\n\n.fa-deviantart:before {\n    content: \"\\f1bd\"\n}\n\n.fa-digg:before {\n    content: \"\\f1a6\"\n}\n\n.fa-digital-ocean:before {\n    content: \"\\f391\"\n}\n\n.fa-discord:before {\n    content: \"\\f392\"\n}\n\n.fa-discourse:before {\n    content: \"\\f393\"\n}\n\n.fa-dochub:before {\n    content: \"\\f394\"\n}\n\n.fa-docker:before {\n    content: \"\\f395\"\n}\n\n.fa-dollar-sign:before {\n    content: \"\\f155\"\n}\n\n.fa-dot-circle:before {\n    content: \"\\f192\"\n}\n\n.fa-download:before {\n    content: \"\\f019\"\n}\n\n.fa-draft2digital:before {\n    content: \"\\f396\"\n}\n\n.fa-dribbble:before {\n    content: \"\\f17d\"\n}\n\n.fa-dribbble-square:before {\n    content: \"\\f397\"\n}\n\n.fa-dropbox:before {\n    content: \"\\f16b\"\n}\n\n.fa-drupal:before {\n    content: \"\\f1a9\"\n}\n\n.fa-dyalog:before {\n    content: \"\\f399\"\n}\n\n.fa-earlybirds:before {\n    content: \"\\f39a\"\n}\n\n.fa-edge:before {\n    content: \"\\f282\"\n}\n\n.fa-edit:before {\n    content: \"\\f044\"\n}\n\n.fa-eject:before {\n    content: \"\\f052\"\n}\n\n.fa-elementor:before {\n    content: \"\\f430\"\n}\n\n.fa-ellipsis-h:before {\n    content: \"\\f141\"\n}\n\n.fa-ellipsis-v:before {\n    content: \"\\f142\"\n}\n\n.fa-ember:before {\n    content: \"\\f423\"\n}\n\n.fa-empire:before {\n    content: \"\\f1d1\"\n}\n\n.fa-envelope:before {\n    content: \"\\f0e0\"\n}\n\n.fa-envelope-open:before {\n    content: \"\\f2b6\"\n}\n\n.fa-envelope-square:before {\n    content: \"\\f199\"\n}\n\n.fa-envira:before {\n    content: \"\\f299\"\n}\n\n.fa-eraser:before {\n    content: \"\\f12d\"\n}\n\n.fa-erlang:before {\n    content: \"\\f39d\"\n}\n\n.fa-ethereum:before {\n    content: \"\\f42e\"\n}\n\n.fa-etsy:before {\n    content: \"\\f2d7\"\n}\n\n.fa-euro-sign:before {\n    content: \"\\f153\"\n}\n\n.fa-exchange-alt:before {\n    content: \"\\f362\"\n}\n\n.fa-exclamation:before {\n    content: \"\\f12a\"\n}\n\n.fa-exclamation-circle:before {\n    content: \"\\f06a\"\n}\n\n.fa-exclamation-triangle:before {\n    content: \"\\f071\"\n}\n\n.fa-expand:before {\n    content: \"\\f065\"\n}\n\n.fa-expand-arrows-alt:before {\n    content: \"\\f31e\"\n}\n\n.fa-expeditedssl:before {\n    content: \"\\f23e\"\n}\n\n.fa-external-link-alt:before {\n    content: \"\\f35d\"\n}\n\n.fa-external-link-square-alt:before {\n    content: \"\\f360\"\n}\n\n.fa-eye:before {\n    content: \"\\f06e\"\n}\n\n.fa-eye-dropper:before {\n    content: \"\\f1fb\"\n}\n\n.fa-eye-slash:before {\n    content: \"\\f070\"\n}\n\n.fa-facebook:before {\n    content: \"\\f09a\"\n}\n\n.fa-facebook-f:before {\n    content: \"\\f39e\"\n}\n\n.fa-facebook-messenger:before {\n    content: \"\\f39f\"\n}\n\n.fa-facebook-square:before {\n    content: \"\\f082\"\n}\n\n.fa-fast-backward:before {\n    content: \"\\f049\"\n}\n\n.fa-fast-forward:before {\n    content: \"\\f050\"\n}\n\n.fa-fax:before {\n    content: \"\\f1ac\"\n}\n\n.fa-female:before {\n    content: \"\\f182\"\n}\n\n.fa-fighter-jet:before {\n    content: \"\\f0fb\"\n}\n\n.fa-file:before {\n    content: \"\\f15b\"\n}\n\n.fa-file-alt:before {\n    content: \"\\f15c\"\n}\n\n.fa-file-archive:before {\n    content: \"\\f1c6\"\n}\n\n.fa-file-audio:before {\n    content: \"\\f1c7\"\n}\n\n.fa-file-code:before {\n    content: \"\\f1c9\"\n}\n\n.fa-file-excel:before {\n    content: \"\\f1c3\"\n}\n\n.fa-file-image:before {\n    content: \"\\f1c5\"\n}\n\n.fa-file-pdf:before {\n    content: \"\\f1c1\"\n}\n\n.fa-file-powerpoint:before {\n    content: \"\\f1c4\"\n}\n\n.fa-file-video:before {\n    content: \"\\f1c8\"\n}\n\n.fa-file-word:before {\n    content: \"\\f1c2\"\n}\n\n.fa-film:before {\n    content: \"\\f008\"\n}\n\n.fa-filter:before {\n    content: \"\\f0b0\"\n}\n\n.fa-fire:before {\n    content: \"\\f06d\"\n}\n\n.fa-fire-extinguisher:before {\n    content: \"\\f134\"\n}\n\n.fa-firefox:before {\n    content: \"\\f269\"\n}\n\n.fa-first-order:before {\n    content: \"\\f2b0\"\n}\n\n.fa-firstdraft:before {\n    content: \"\\f3a1\"\n}\n\n.fa-flag:before {\n    content: \"\\f024\"\n}\n\n.fa-flag-checkered:before {\n    content: \"\\f11e\"\n}\n\n.fa-flask:before {\n    content: \"\\f0c3\"\n}\n\n.fa-flickr:before {\n    content: \"\\f16e\"\n}\n\n.fa-fly:before {\n    content: \"\\f417\"\n}\n\n.fa-folder:before {\n    content: \"\\f07b\"\n}\n\n.fa-folder-open:before {\n    content: \"\\f07c\"\n}\n\n.fa-font:before {\n    content: \"\\f031\"\n}\n\n.fa-font-awesome:before {\n    content: \"\\f2b4\"\n}\n\n.fa-font-awesome-alt:before {\n    content: \"\\f35c\"\n}\n\n.fa-font-awesome-flag:before {\n    content: \"\\f425\"\n}\n\n.fa-fonticons:before {\n    content: \"\\f280\"\n}\n\n.fa-fonticons-fi:before {\n    content: \"\\f3a2\"\n}\n\n.fa-fort-awesome:before {\n    content: \"\\f286\"\n}\n\n.fa-fort-awesome-alt:before {\n    content: \"\\f3a3\"\n}\n\n.fa-forumbee:before {\n    content: \"\\f211\"\n}\n\n.fa-forward:before {\n    content: \"\\f04e\"\n}\n\n.fa-foursquare:before {\n    content: \"\\f180\"\n}\n\n.fa-free-code-camp:before {\n    content: \"\\f2c5\"\n}\n\n.fa-freebsd:before {\n    content: \"\\f3a4\"\n}\n\n.fa-frown:before {\n    content: \"\\f119\"\n}\n\n.fa-futbol:before {\n    content: \"\\f1e3\"\n}\n\n.fa-gamepad:before {\n    content: \"\\f11b\"\n}\n\n.fa-gavel:before {\n    content: \"\\f0e3\"\n}\n\n.fa-gem:before {\n    content: \"\\f3a5\"\n}\n\n.fa-genderless:before {\n    content: \"\\f22d\"\n}\n\n.fa-get-pocket:before {\n    content: \"\\f265\"\n}\n\n.fa-gg:before {\n    content: \"\\f260\"\n}\n\n.fa-gg-circle:before {\n    content: \"\\f261\"\n}\n\n.fa-gift:before {\n    content: \"\\f06b\"\n}\n\n.fa-git:before {\n    content: \"\\f1d3\"\n}\n\n.fa-git-square:before {\n    content: \"\\f1d2\"\n}\n\n.fa-github:before {\n    content: \"\\f09b\"\n}\n\n.fa-github-alt:before {\n    content: \"\\f113\"\n}\n\n.fa-github-square:before {\n    content: \"\\f092\"\n}\n\n.fa-gitkraken:before {\n    content: \"\\f3a6\"\n}\n\n.fa-gitlab:before {\n    content: \"\\f296\"\n}\n\n.fa-gitter:before {\n    content: \"\\f426\"\n}\n\n.fa-glass-martini:before {\n    content: \"\\f000\"\n}\n\n.fa-glide:before {\n    content: \"\\f2a5\"\n}\n\n.fa-glide-g:before {\n    content: \"\\f2a6\"\n}\n\n.fa-globe:before {\n    content: \"\\f0ac\"\n}\n\n.fa-gofore:before {\n    content: \"\\f3a7\"\n}\n\n.fa-goodreads:before {\n    content: \"\\f3a8\"\n}\n\n.fa-goodreads-g:before {\n    content: \"\\f3a9\"\n}\n\n.fa-google:before {\n    content: \"\\f1a0\"\n}\n\n.fa-google-drive:before {\n    content: \"\\f3aa\"\n}\n\n.fa-google-play:before {\n    content: \"\\f3ab\"\n}\n\n.fa-google-plus:before {\n    content: \"\\f2b3\"\n}\n\n.fa-google-plus-g:before {\n    content: \"\\f0d5\"\n}\n\n.fa-google-plus-square:before {\n    content: \"\\f0d4\"\n}\n\n.fa-google-wallet:before {\n    content: \"\\f1ee\"\n}\n\n.fa-graduation-cap:before {\n    content: \"\\f19d\"\n}\n\n.fa-gratipay:before {\n    content: \"\\f184\"\n}\n\n.fa-grav:before {\n    content: \"\\f2d6\"\n}\n\n.fa-gripfire:before {\n    content: \"\\f3ac\"\n}\n\n.fa-grunt:before {\n    content: \"\\f3ad\"\n}\n\n.fa-gulp:before {\n    content: \"\\f3ae\"\n}\n\n.fa-h-square:before {\n    content: \"\\f0fd\"\n}\n\n.fa-hacker-news:before {\n    content: \"\\f1d4\"\n}\n\n.fa-hacker-news-square:before {\n    content: \"\\f3af\"\n}\n\n.fa-hand-lizard:before {\n    content: \"\\f258\"\n}\n\n.fa-hand-paper:before {\n    content: \"\\f256\"\n}\n\n.fa-hand-peace:before {\n    content: \"\\f25b\"\n}\n\n.fa-hand-point-down:before {\n    content: \"\\f0a7\"\n}\n\n.fa-hand-point-left:before {\n    content: \"\\f0a5\"\n}\n\n.fa-hand-point-right:before {\n    content: \"\\f0a4\"\n}\n\n.fa-hand-point-up:before {\n    content: \"\\f0a6\"\n}\n\n.fa-hand-pointer:before {\n    content: \"\\f25a\"\n}\n\n.fa-hand-rock:before {\n    content: \"\\f255\"\n}\n\n.fa-hand-scissors:before {\n    content: \"\\f257\"\n}\n\n.fa-hand-spock:before {\n    content: \"\\f259\"\n}\n\n.fa-handshake:before {\n    content: \"\\f2b5\"\n}\n\n.fa-hashtag:before {\n    content: \"\\f292\"\n}\n\n.fa-hdd:before {\n    content: \"\\f0a0\"\n}\n\n.fa-heading:before {\n    content: \"\\f1dc\"\n}\n\n.fa-headphones:before {\n    content: \"\\f025\"\n}\n\n.fa-heart:before {\n    content: \"\\f004\"\n}\n\n.fa-heartbeat:before {\n    content: \"\\f21e\"\n}\n\n.fa-hire-a-helper:before {\n    content: \"\\f3b0\"\n}\n\n.fa-history:before {\n    content: \"\\f1da\"\n}\n\n.fa-home:before {\n    content: \"\\f015\"\n}\n\n.fa-hooli:before {\n    content: \"\\f427\"\n}\n\n.fa-hospital:before {\n    content: \"\\f0f8\"\n}\n\n.fa-hotjar:before {\n    content: \"\\f3b1\"\n}\n\n.fa-hourglass:before {\n    content: \"\\f254\"\n}\n\n.fa-hourglass-end:before {\n    content: \"\\f253\"\n}\n\n.fa-hourglass-half:before {\n    content: \"\\f252\"\n}\n\n.fa-hourglass-start:before {\n    content: \"\\f251\"\n}\n\n.fa-houzz:before {\n    content: \"\\f27c\"\n}\n\n.fa-html5:before {\n    content: \"\\f13b\"\n}\n\n.fa-hubspot:before {\n    content: \"\\f3b2\"\n}\n\n.fa-i-cursor:before {\n    content: \"\\f246\"\n}\n\n.fa-id-badge:before {\n    content: \"\\f2c1\"\n}\n\n.fa-id-card:before {\n    content: \"\\f2c2\"\n}\n\n.fa-image:before {\n    content: \"\\f03e\"\n}\n\n.fa-images:before {\n    content: \"\\f302\"\n}\n\n.fa-imdb:before {\n    content: \"\\f2d8\"\n}\n\n.fa-inbox:before {\n    content: \"\\f01c\"\n}\n\n.fa-indent:before {\n    content: \"\\f03c\"\n}\n\n.fa-industry:before {\n    content: \"\\f275\"\n}\n\n.fa-info:before {\n    content: \"\\f129\"\n}\n\n.fa-info-circle:before {\n    content: \"\\f05a\"\n}\n\n.fa-instagram:before {\n    content: \"\\f16d\"\n}\n\n.fa-internet-explorer:before {\n    content: \"\\f26b\"\n}\n\n.fa-ioxhost:before {\n    content: \"\\f208\"\n}\n\n.fa-italic:before {\n    content: \"\\f033\"\n}\n\n.fa-itunes:before {\n    content: \"\\f3b4\"\n}\n\n.fa-itunes-note:before {\n    content: \"\\f3b5\"\n}\n\n.fa-jenkins:before {\n    content: \"\\f3b6\"\n}\n\n.fa-joget:before {\n    content: \"\\f3b7\"\n}\n\n.fa-joomla:before {\n    content: \"\\f1aa\"\n}\n\n.fa-js:before {\n    content: \"\\f3b8\"\n}\n\n.fa-js-square:before {\n    content: \"\\f3b9\"\n}\n\n.fa-jsfiddle:before {\n    content: \"\\f1cc\"\n}\n\n.fa-key:before {\n    content: \"\\f084\"\n}\n\n.fa-keyboard:before {\n    content: \"\\f11c\"\n}\n\n.fa-keycdn:before {\n    content: \"\\f3ba\"\n}\n\n.fa-kickstarter:before {\n    content: \"\\f3bb\"\n}\n\n.fa-kickstarter-k:before {\n    content: \"\\f3bc\"\n}\n\n.fa-korvue:before {\n    content: \"\\f42f\"\n}\n\n.fa-language:before {\n    content: \"\\f1ab\"\n}\n\n.fa-laptop:before {\n    content: \"\\f109\"\n}\n\n.fa-laravel:before {\n    content: \"\\f3bd\"\n}\n\n.fa-lastfm:before {\n    content: \"\\f202\"\n}\n\n.fa-lastfm-square:before {\n    content: \"\\f203\"\n}\n\n.fa-leaf:before {\n    content: \"\\f06c\"\n}\n\n.fa-leanpub:before {\n    content: \"\\f212\"\n}\n\n.fa-lemon:before {\n    content: \"\\f094\"\n}\n\n.fa-less:before {\n    content: \"\\f41d\"\n}\n\n.fa-level-down-alt:before {\n    content: \"\\f3be\"\n}\n\n.fa-level-up-alt:before {\n    content: \"\\f3bf\"\n}\n\n.fa-life-ring:before {\n    content: \"\\f1cd\"\n}\n\n.fa-lightbulb:before {\n    content: \"\\f0eb\"\n}\n\n.fa-line:before {\n    content: \"\\f3c0\"\n}\n\n.fa-link:before {\n    content: \"\\f0c1\"\n}\n\n.fa-linkedin:before {\n    content: \"\\f08c\"\n}\n\n.fa-linkedin-in:before {\n    content: \"\\f0e1\"\n}\n\n.fa-linode:before {\n    content: \"\\f2b8\"\n}\n\n.fa-linux:before {\n    content: \"\\f17c\"\n}\n\n.fa-lira-sign:before {\n    content: \"\\f195\"\n}\n\n.fa-list:before {\n    content: \"\\f03a\"\n}\n\n.fa-list-alt:before {\n    content: \"\\f022\"\n}\n\n.fa-list-ol:before {\n    content: \"\\f0cb\"\n}\n\n.fa-list-ul:before {\n    content: \"\\f0ca\"\n}\n\n.fa-location-arrow:before {\n    content: \"\\f124\"\n}\n\n.fa-lock:before {\n    content: \"\\f023\"\n}\n\n.fa-lock-open:before {\n    content: \"\\f3c1\"\n}\n\n.fa-long-arrow-alt-down:before {\n    content: \"\\f309\"\n}\n\n.fa-long-arrow-alt-left:before {\n    content: \"\\f30a\"\n}\n\n.fa-long-arrow-alt-right:before {\n    content: \"\\f30b\"\n}\n\n.fa-long-arrow-alt-up:before {\n    content: \"\\f30c\"\n}\n\n.fa-low-vision:before {\n    content: \"\\f2a8\"\n}\n\n.fa-lyft:before {\n    content: \"\\f3c3\"\n}\n\n.fa-magento:before {\n    content: \"\\f3c4\"\n}\n\n.fa-magic:before {\n    content: \"\\f0d0\"\n}\n\n.fa-magnet:before {\n    content: \"\\f076\"\n}\n\n.fa-male:before {\n    content: \"\\f183\"\n}\n\n.fa-map:before {\n    content: \"\\f279\"\n}\n\n.fa-map-marker:before {\n    content: \"\\f041\"\n}\n\n.fa-map-marker-alt:before {\n    content: \"\\f3c5\"\n}\n\n.fa-map-pin:before {\n    content: \"\\f276\"\n}\n\n.fa-map-signs:before {\n    content: \"\\f277\"\n}\n\n.fa-mars:before {\n    content: \"\\f222\"\n}\n\n.fa-mars-double:before {\n    content: \"\\f227\"\n}\n\n.fa-mars-stroke:before {\n    content: \"\\f229\"\n}\n\n.fa-mars-stroke-h:before {\n    content: \"\\f22b\"\n}\n\n.fa-mars-stroke-v:before {\n    content: \"\\f22a\"\n}\n\n.fa-maxcdn:before {\n    content: \"\\f136\"\n}\n\n.fa-medapps:before {\n    content: \"\\f3c6\"\n}\n\n.fa-medium:before {\n    content: \"\\f23a\"\n}\n\n.fa-medium-m:before {\n    content: \"\\f3c7\"\n}\n\n.fa-medkit:before {\n    content: \"\\f0fa\"\n}\n\n.fa-medrt:before {\n    content: \"\\f3c8\"\n}\n\n.fa-meetup:before {\n    content: \"\\f2e0\"\n}\n\n.fa-meh:before {\n    content: \"\\f11a\"\n}\n\n.fa-mercury:before {\n    content: \"\\f223\"\n}\n\n.fa-microchip:before {\n    content: \"\\f2db\"\n}\n\n.fa-microphone:before {\n    content: \"\\f130\"\n}\n\n.fa-microphone-slash:before {\n    content: \"\\f131\"\n}\n\n.fa-microsoft:before {\n    content: \"\\f3ca\"\n}\n\n.fa-minus:before {\n    content: \"\\f068\"\n}\n\n.fa-minus-circle:before {\n    content: \"\\f056\"\n}\n\n.fa-minus-square:before {\n    content: \"\\f146\"\n}\n\n.fa-mix:before {\n    content: \"\\f3cb\"\n}\n\n.fa-mixcloud:before {\n    content: \"\\f289\"\n}\n\n.fa-mizuni:before {\n    content: \"\\f3cc\"\n}\n\n.fa-mobile:before {\n    content: \"\\f10b\"\n}\n\n.fa-mobile-alt:before {\n    content: \"\\f3cd\"\n}\n\n.fa-modx:before {\n    content: \"\\f285\"\n}\n\n.fa-monero:before {\n    content: \"\\f3d0\"\n}\n\n.fa-money-bill-alt:before {\n    content: \"\\f3d1\"\n}\n\n.fa-moon:before {\n    content: \"\\f186\"\n}\n\n.fa-motorcycle:before {\n    content: \"\\f21c\"\n}\n\n.fa-mouse-pointer:before {\n    content: \"\\f245\"\n}\n\n.fa-music:before {\n    content: \"\\f001\"\n}\n\n.fa-napster:before {\n    content: \"\\f3d2\"\n}\n\n.fa-neuter:before {\n    content: \"\\f22c\"\n}\n\n.fa-newspaper:before {\n    content: \"\\f1ea\"\n}\n\n.fa-nintendo-switch:before {\n    content: \"\\f418\"\n}\n\n.fa-node:before {\n    content: \"\\f419\"\n}\n\n.fa-node-js:before {\n    content: \"\\f3d3\"\n}\n\n.fa-npm:before {\n    content: \"\\f3d4\"\n}\n\n.fa-ns8:before {\n    content: \"\\f3d5\"\n}\n\n.fa-nutritionix:before {\n    content: \"\\f3d6\"\n}\n\n.fa-object-group:before {\n    content: \"\\f247\"\n}\n\n.fa-object-ungroup:before {\n    content: \"\\f248\"\n}\n\n.fa-odnoklassniki:before {\n    content: \"\\f263\"\n}\n\n.fa-odnoklassniki-square:before {\n    content: \"\\f264\"\n}\n\n.fa-opencart:before {\n    content: \"\\f23d\"\n}\n\n.fa-openid:before {\n    content: \"\\f19b\"\n}\n\n.fa-opera:before {\n    content: \"\\f26a\"\n}\n\n.fa-optin-monster:before {\n    content: \"\\f23c\"\n}\n\n.fa-osi:before {\n    content: \"\\f41a\"\n}\n\n.fa-outdent:before {\n    content: \"\\f03b\"\n}\n\n.fa-page4:before {\n    content: \"\\f3d7\"\n}\n\n.fa-pagelines:before {\n    content: \"\\f18c\"\n}\n\n.fa-paint-brush:before {\n    content: \"\\f1fc\"\n}\n\n.fa-palfed:before {\n    content: \"\\f3d8\"\n}\n\n.fa-paper-plane:before {\n    content: \"\\f1d8\"\n}\n\n.fa-paperclip:before {\n    content: \"\\f0c6\"\n}\n\n.fa-paragraph:before {\n    content: \"\\f1dd\"\n}\n\n.fa-paste:before {\n    content: \"\\f0ea\"\n}\n\n.fa-patreon:before {\n    content: \"\\f3d9\"\n}\n\n.fa-pause:before {\n    content: \"\\f04c\"\n}\n\n.fa-pause-circle:before {\n    content: \"\\f28b\"\n}\n\n.fa-paw:before {\n    content: \"\\f1b0\"\n}\n\n.fa-paypal:before {\n    content: \"\\f1ed\"\n}\n\n.fa-pen-square:before {\n    content: \"\\f14b\"\n}\n\n.fa-pencil-alt:before {\n    content: \"\\f303\"\n}\n\n.fa-percent:before {\n    content: \"\\f295\"\n}\n\n.fa-periscope:before {\n    content: \"\\f3da\"\n}\n\n.fa-phabricator:before {\n    content: \"\\f3db\"\n}\n\n.fa-phoenix-framework:before {\n    content: \"\\f3dc\"\n}\n\n.fa-phone:before {\n    content: \"\\f095\"\n}\n\n.fa-phone-square:before {\n    content: \"\\f098\"\n}\n\n.fa-phone-volume:before {\n    content: \"\\f2a0\"\n}\n\n.fa-pied-piper:before {\n    content: \"\\f2ae\"\n}\n\n.fa-pied-piper-alt:before {\n    content: \"\\f1a8\"\n}\n\n.fa-pied-piper-pp:before {\n    content: \"\\f1a7\"\n}\n\n.fa-pinterest:before {\n    content: \"\\f0d2\"\n}\n\n.fa-pinterest-p:before {\n    content: \"\\f231\"\n}\n\n.fa-pinterest-square:before {\n    content: \"\\f0d3\"\n}\n\n.fa-plane:before {\n    content: \"\\f072\"\n}\n\n.fa-play:before {\n    content: \"\\f04b\"\n}\n\n.fa-play-circle:before {\n    content: \"\\f144\"\n}\n\n.fa-playstation:before {\n    content: \"\\f3df\"\n}\n\n.fa-plug:before {\n    content: \"\\f1e6\"\n}\n\n.fa-plus:before {\n    content: \"\\f067\"\n}\n\n.fa-plus-circle:before {\n    content: \"\\f055\"\n}\n\n.fa-plus-square:before {\n    content: \"\\f0fe\"\n}\n\n.fa-podcast:before {\n    content: \"\\f2ce\"\n}\n\n.fa-pound-sign:before {\n    content: \"\\f154\"\n}\n\n.fa-power-off:before {\n    content: \"\\f011\"\n}\n\n.fa-print:before {\n    content: \"\\f02f\"\n}\n\n.fa-product-hunt:before {\n    content: \"\\f288\"\n}\n\n.fa-pushed:before {\n    content: \"\\f3e1\"\n}\n\n.fa-puzzle-piece:before {\n    content: \"\\f12e\"\n}\n\n.fa-python:before {\n    content: \"\\f3e2\"\n}\n\n.fa-qq:before {\n    content: \"\\f1d6\"\n}\n\n.fa-qrcode:before {\n    content: \"\\f029\"\n}\n\n.fa-question:before {\n    content: \"\\f128\"\n}\n\n.fa-question-circle:before {\n    content: \"\\f059\"\n}\n\n.fa-quora:before {\n    content: \"\\f2c4\"\n}\n\n.fa-quote-left:before {\n    content: \"\\f10d\"\n}\n\n.fa-quote-right:before {\n    content: \"\\f10e\"\n}\n\n.fa-random:before {\n    content: \"\\f074\"\n}\n\n.fa-ravelry:before {\n    content: \"\\f2d9\"\n}\n\n.fa-react:before {\n    content: \"\\f41b\"\n}\n\n.fa-rebel:before {\n    content: \"\\f1d0\"\n}\n\n.fa-recycle:before {\n    content: \"\\f1b8\"\n}\n\n.fa-red-river:before {\n    content: \"\\f3e3\"\n}\n\n.fa-reddit:before {\n    content: \"\\f1a1\"\n}\n\n.fa-reddit-alien:before {\n    content: \"\\f281\"\n}\n\n.fa-reddit-square:before {\n    content: \"\\f1a2\"\n}\n\n.fa-redo:before {\n    content: \"\\f01e\"\n}\n\n.fa-redo-alt:before {\n    content: \"\\f2f9\"\n}\n\n.fa-registered:before {\n    content: \"\\f25d\"\n}\n\n.fa-rendact:before {\n    content: \"\\f3e4\"\n}\n\n.fa-renren:before {\n    content: \"\\f18b\"\n}\n\n.fa-reply:before {\n    content: \"\\f3e5\"\n}\n\n.fa-reply-all:before {\n    content: \"\\f122\"\n}\n\n.fa-replyd:before {\n    content: \"\\f3e6\"\n}\n\n.fa-resolving:before {\n    content: \"\\f3e7\"\n}\n\n.fa-retweet:before {\n    content: \"\\f079\"\n}\n\n.fa-road:before {\n    content: \"\\f018\"\n}\n\n.fa-rocket:before {\n    content: \"\\f135\"\n}\n\n.fa-rocketchat:before {\n    content: \"\\f3e8\"\n}\n\n.fa-rockrms:before {\n    content: \"\\f3e9\"\n}\n\n.fa-rss:before {\n    content: \"\\f09e\"\n}\n\n.fa-rss-square:before {\n    content: \"\\f143\"\n}\n\n.fa-ruble-sign:before {\n    content: \"\\f158\"\n}\n\n.fa-rupee-sign:before {\n    content: \"\\f156\"\n}\n\n.fa-safari:before {\n    content: \"\\f267\"\n}\n\n.fa-sass:before {\n    content: \"\\f41e\"\n}\n\n.fa-save:before {\n    content: \"\\f0c7\"\n}\n\n.fa-schlix:before {\n    content: \"\\f3ea\"\n}\n\n.fa-scribd:before {\n    content: \"\\f28a\"\n}\n\n.fa-search:before {\n    content: \"\\f002\"\n}\n\n.fa-search-minus:before {\n    content: \"\\f010\"\n}\n\n.fa-search-plus:before {\n    content: \"\\f00e\"\n}\n\n.fa-searchengin:before {\n    content: \"\\f3eb\"\n}\n\n.fa-sellcast:before {\n    content: \"\\f2da\"\n}\n\n.fa-sellsy:before {\n    content: \"\\f213\"\n}\n\n.fa-server:before {\n    content: \"\\f233\"\n}\n\n.fa-servicestack:before {\n    content: \"\\f3ec\"\n}\n\n.fa-share:before {\n    content: \"\\f064\"\n}\n\n.fa-share-alt:before {\n    content: \"\\f1e0\"\n}\n\n.fa-share-alt-square:before {\n    content: \"\\f1e1\"\n}\n\n.fa-share-square:before {\n    content: \"\\f14d\"\n}\n\n.fa-shekel-sign:before {\n    content: \"\\f20b\"\n}\n\n.fa-shield-alt:before {\n    content: \"\\f3ed\"\n}\n\n.fa-ship:before {\n    content: \"\\f21a\"\n}\n\n.fa-shirtsinbulk:before {\n    content: \"\\f214\"\n}\n\n.fa-shopping-bag:before {\n    content: \"\\f290\"\n}\n\n.fa-shopping-basket:before {\n    content: \"\\f291\"\n}\n\n.fa-shopping-cart:before {\n    content: \"\\f07a\"\n}\n\n.fa-shower:before {\n    content: \"\\f2cc\"\n}\n\n.fa-sign-in-alt:before {\n    content: \"\\f2f6\"\n}\n\n.fa-sign-language:before {\n    content: \"\\f2a7\"\n}\n\n.fa-sign-out-alt:before {\n    content: \"\\f2f5\"\n}\n\n.fa-signal:before {\n    content: \"\\f012\"\n}\n\n.fa-simplybuilt:before {\n    content: \"\\f215\"\n}\n\n.fa-sistrix:before {\n    content: \"\\f3ee\"\n}\n\n.fa-sitemap:before {\n    content: \"\\f0e8\"\n}\n\n.fa-skyatlas:before {\n    content: \"\\f216\"\n}\n\n.fa-skype:before {\n    content: \"\\f17e\"\n}\n\n.fa-slack:before {\n    content: \"\\f198\"\n}\n\n.fa-slack-hash:before {\n    content: \"\\f3ef\"\n}\n\n.fa-sliders-h:before {\n    content: \"\\f1de\"\n}\n\n.fa-slideshare:before {\n    content: \"\\f1e7\"\n}\n\n.fa-smile:before {\n    content: \"\\f118\"\n}\n\n.fa-snapchat:before {\n    content: \"\\f2ab\"\n}\n\n.fa-snapchat-ghost:before {\n    content: \"\\f2ac\"\n}\n\n.fa-snapchat-square:before {\n    content: \"\\f2ad\"\n}\n\n.fa-snowflake:before {\n    content: \"\\f2dc\"\n}\n\n.fa-sort:before {\n    content: \"\\f0dc\"\n}\n\n.fa-sort-alpha-down:before {\n    content: \"\\f15d\"\n}\n\n.fa-sort-alpha-up:before {\n    content: \"\\f15e\"\n}\n\n.fa-sort-amount-down:before {\n    content: \"\\f160\"\n}\n\n.fa-sort-amount-up:before {\n    content: \"\\f161\"\n}\n\n.fa-sort-down:before {\n    content: \"\\f0dd\"\n}\n\n.fa-sort-numeric-down:before {\n    content: \"\\f162\"\n}\n\n.fa-sort-numeric-up:before {\n    content: \"\\f163\"\n}\n\n.fa-sort-up:before {\n    content: \"\\f0de\"\n}\n\n.fa-soundcloud:before {\n    content: \"\\f1be\"\n}\n\n.fa-space-shuttle:before {\n    content: \"\\f197\"\n}\n\n.fa-speakap:before {\n    content: \"\\f3f3\"\n}\n\n.fa-spinner:before {\n    content: \"\\f110\"\n}\n\n.fa-spotify:before {\n    content: \"\\f1bc\"\n}\n\n.fa-square:before {\n    content: \"\\f0c8\"\n}\n\n.fa-stack-exchange:before {\n    content: \"\\f18d\"\n}\n\n.fa-stack-overflow:before {\n    content: \"\\f16c\"\n}\n\n.fa-star:before {\n    content: \"\\f005\"\n}\n\n.fa-star-half:before {\n    content: \"\\f089\"\n}\n\n.fa-staylinked:before {\n    content: \"\\f3f5\"\n}\n\n.fa-steam:before {\n    content: \"\\f1b6\"\n}\n\n.fa-steam-square:before {\n    content: \"\\f1b7\"\n}\n\n.fa-steam-symbol:before {\n    content: \"\\f3f6\"\n}\n\n.fa-step-backward:before {\n    content: \"\\f048\"\n}\n\n.fa-step-forward:before {\n    content: \"\\f051\"\n}\n\n.fa-stethoscope:before {\n    content: \"\\f0f1\"\n}\n\n.fa-sticker-mule:before {\n    content: \"\\f3f7\"\n}\n\n.fa-sticky-note:before {\n    content: \"\\f249\"\n}\n\n.fa-stop:before {\n    content: \"\\f04d\"\n}\n\n.fa-stop-circle:before {\n    content: \"\\f28d\"\n}\n\n.fa-stopwatch:before {\n    content: \"\\f2f2\"\n}\n\n.fa-strava:before {\n    content: \"\\f428\"\n}\n\n.fa-street-view:before {\n    content: \"\\f21d\"\n}\n\n.fa-strikethrough:before {\n    content: \"\\f0cc\"\n}\n\n.fa-stripe:before {\n    content: \"\\f429\"\n}\n\n.fa-stripe-s:before {\n    content: \"\\f42a\"\n}\n\n.fa-studiovinari:before {\n    content: \"\\f3f8\"\n}\n\n.fa-stumbleupon:before {\n    content: \"\\f1a4\"\n}\n\n.fa-stumbleupon-circle:before {\n    content: \"\\f1a3\"\n}\n\n.fa-subscript:before {\n    content: \"\\f12c\"\n}\n\n.fa-subway:before {\n    content: \"\\f239\"\n}\n\n.fa-suitcase:before {\n    content: \"\\f0f2\"\n}\n\n.fa-sun:before {\n    content: \"\\f185\"\n}\n\n.fa-superpowers:before {\n    content: \"\\f2dd\"\n}\n\n.fa-superscript:before {\n    content: \"\\f12b\"\n}\n\n.fa-supple:before {\n    content: \"\\f3f9\"\n}\n\n.fa-sync:before {\n    content: \"\\f021\"\n}\n\n.fa-sync-alt:before {\n    content: \"\\f2f1\"\n}\n\n.fa-table:before {\n    content: \"\\f0ce\"\n}\n\n.fa-tablet:before {\n    content: \"\\f10a\"\n}\n\n.fa-tablet-alt:before {\n    content: \"\\f3fa\"\n}\n\n.fa-tachometer-alt:before {\n    content: \"\\f3fd\"\n}\n\n.fa-tag:before {\n    content: \"\\f02b\"\n}\n\n.fa-tags:before {\n    content: \"\\f02c\"\n}\n\n.fa-tasks:before {\n    content: \"\\f0ae\"\n}\n\n.fa-taxi:before {\n    content: \"\\f1ba\"\n}\n\n.fa-telegram:before {\n    content: \"\\f2c6\"\n}\n\n.fa-telegram-plane:before {\n    content: \"\\f3fe\"\n}\n\n.fa-tencent-weibo:before {\n    content: \"\\f1d5\"\n}\n\n.fa-terminal:before {\n    content: \"\\f120\"\n}\n\n.fa-text-height:before {\n    content: \"\\f034\"\n}\n\n.fa-text-width:before {\n    content: \"\\f035\"\n}\n\n.fa-th:before {\n    content: \"\\f00a\"\n}\n\n.fa-th-large:before {\n    content: \"\\f009\"\n}\n\n.fa-th-list:before {\n    content: \"\\f00b\"\n}\n\n.fa-themeisle:before {\n    content: \"\\f2b2\"\n}\n\n.fa-thermometer-empty:before {\n    content: \"\\f2cb\"\n}\n\n.fa-thermometer-full:before {\n    content: \"\\f2c7\"\n}\n\n.fa-thermometer-half:before {\n    content: \"\\f2c9\"\n}\n\n.fa-thermometer-quarter:before {\n    content: \"\\f2ca\"\n}\n\n.fa-thermometer-three-quarters:before {\n    content: \"\\f2c8\"\n}\n\n.fa-thumbs-down:before {\n    content: \"\\f165\"\n}\n\n.fa-thumbs-up:before {\n    content: \"\\f164\"\n}\n\n.fa-thumbtack:before {\n    content: \"\\f08d\"\n}\n\n.fa-ticket-alt:before {\n    content: \"\\f3ff\"\n}\n\n.fa-times:before {\n    content: \"\\f00d\"\n}\n\n.fa-times-circle:before {\n    content: \"\\f057\"\n}\n\n.fa-tint:before {\n    content: \"\\f043\"\n}\n\n.fa-toggle-off:before {\n    content: \"\\f204\"\n}\n\n.fa-toggle-on:before {\n    content: \"\\f205\"\n}\n\n.fa-trademark:before {\n    content: \"\\f25c\"\n}\n\n.fa-train:before {\n    content: \"\\f238\"\n}\n\n.fa-transgender:before {\n    content: \"\\f224\"\n}\n\n.fa-transgender-alt:before {\n    content: \"\\f225\"\n}\n\n.fa-trash:before {\n    content: \"\\f1f8\"\n}\n\n.fa-trash-alt:before {\n    content: \"\\f2ed\"\n}\n\n.fa-tree:before {\n    content: \"\\f1bb\"\n}\n\n.fa-trello:before {\n    content: \"\\f181\"\n}\n\n.fa-tripadvisor:before {\n    content: \"\\f262\"\n}\n\n.fa-trophy:before {\n    content: \"\\f091\"\n}\n\n.fa-truck:before {\n    content: \"\\f0d1\"\n}\n\n.fa-tty:before {\n    content: \"\\f1e4\"\n}\n\n.fa-tumblr:before {\n    content: \"\\f173\"\n}\n\n.fa-tumblr-square:before {\n    content: \"\\f174\"\n}\n\n.fa-tv:before {\n    content: \"\\f26c\"\n}\n\n.fa-twitch:before {\n    content: \"\\f1e8\"\n}\n\n.fa-twitter:before {\n    content: \"\\f099\"\n}\n\n.fa-twitter-square:before {\n    content: \"\\f081\"\n}\n\n.fa-typo3:before {\n    content: \"\\f42b\"\n}\n\n.fa-uber:before {\n    content: \"\\f402\"\n}\n\n.fa-uikit:before {\n    content: \"\\f403\"\n}\n\n.fa-umbrella:before {\n    content: \"\\f0e9\"\n}\n\n.fa-underline:before {\n    content: \"\\f0cd\"\n}\n\n.fa-undo:before {\n    content: \"\\f0e2\"\n}\n\n.fa-undo-alt:before {\n    content: \"\\f2ea\"\n}\n\n.fa-uniregistry:before {\n    content: \"\\f404\"\n}\n\n.fa-universal-access:before {\n    content: \"\\f29a\"\n}\n\n.fa-university:before {\n    content: \"\\f19c\"\n}\n\n.fa-unlink:before {\n    content: \"\\f127\"\n}\n\n.fa-unlock:before {\n    content: \"\\f09c\"\n}\n\n.fa-unlock-alt:before {\n    content: \"\\f13e\"\n}\n\n.fa-untappd:before {\n    content: \"\\f405\"\n}\n\n.fa-upload:before {\n    content: \"\\f093\"\n}\n\n.fa-usb:before {\n    content: \"\\f287\"\n}\n\n.fa-user:before {\n    content: \"\\f007\"\n}\n\n.fa-user-circle:before {\n    content: \"\\f2bd\"\n}\n\n.fa-user-md:before {\n    content: \"\\f0f0\"\n}\n\n.fa-user-plus:before {\n    content: \"\\f234\"\n}\n\n.fa-user-secret:before {\n    content: \"\\f21b\"\n}\n\n.fa-user-times:before {\n    content: \"\\f235\"\n}\n\n.fa-users:before {\n    content: \"\\f0c0\"\n}\n\n.fa-ussunnah:before {\n    content: \"\\f407\"\n}\n\n.fa-utensil-spoon:before {\n    content: \"\\f2e5\"\n}\n\n.fa-utensils:before {\n    content: \"\\f2e7\"\n}\n\n.fa-vaadin:before {\n    content: \"\\f408\"\n}\n\n.fa-venus:before {\n    content: \"\\f221\"\n}\n\n.fa-venus-double:before {\n    content: \"\\f226\"\n}\n\n.fa-venus-mars:before {\n    content: \"\\f228\"\n}\n\n.fa-viacoin:before {\n    content: \"\\f237\"\n}\n\n.fa-viadeo:before {\n    content: \"\\f2a9\"\n}\n\n.fa-viadeo-square:before {\n    content: \"\\f2aa\"\n}\n\n.fa-viber:before {\n    content: \"\\f409\"\n}\n\n.fa-video:before {\n    content: \"\\f03d\"\n}\n\n.fa-vimeo:before {\n    content: \"\\f40a\"\n}\n\n.fa-vimeo-square:before {\n    content: \"\\f194\"\n}\n\n.fa-vimeo-v:before {\n    content: \"\\f27d\"\n}\n\n.fa-vine:before {\n    content: \"\\f1ca\"\n}\n\n.fa-vk:before {\n    content: \"\\f189\"\n}\n\n.fa-vnv:before {\n    content: \"\\f40b\"\n}\n\n.fa-volume-down:before {\n    content: \"\\f027\"\n}\n\n.fa-volume-off:before {\n    content: \"\\f026\"\n}\n\n.fa-volume-up:before {\n    content: \"\\f028\"\n}\n\n.fa-vuejs:before {\n    content: \"\\f41f\"\n}\n\n.fa-weibo:before {\n    content: \"\\f18a\"\n}\n\n.fa-weixin:before {\n    content: \"\\f1d7\"\n}\n\n.fa-whatsapp:before {\n    content: \"\\f232\"\n}\n\n.fa-whatsapp-square:before {\n    content: \"\\f40c\"\n}\n\n.fa-wheelchair:before {\n    content: \"\\f193\"\n}\n\n.fa-whmcs:before {\n    content: \"\\f40d\"\n}\n\n.fa-wifi:before {\n    content: \"\\f1eb\"\n}\n\n.fa-wikipedia-w:before {\n    content: \"\\f266\"\n}\n\n.fa-window-close:before {\n    content: \"\\f410\"\n}\n\n.fa-window-maximize:before {\n    content: \"\\f2d0\"\n}\n\n.fa-window-minimize:before {\n    content: \"\\f2d1\"\n}\n\n.fa-window-restore:before {\n    content: \"\\f2d2\"\n}\n\n.fa-windows:before {\n    content: \"\\f17a\"\n}\n\n.fa-won-sign:before {\n    content: \"\\f159\"\n}\n\n.fa-wordpress:before {\n    content: \"\\f19a\"\n}\n\n.fa-wordpress-simple:before {\n    content: \"\\f411\"\n}\n\n.fa-wpbeginner:before {\n    content: \"\\f297\"\n}\n\n.fa-wpexplorer:before {\n    content: \"\\f2de\"\n}\n\n.fa-wpforms:before {\n    content: \"\\f298\"\n}\n\n.fa-wrench:before {\n    content: \"\\f0ad\"\n}\n\n.fa-xbox:before {\n    content: \"\\f412\"\n}\n\n.fa-xing:before {\n    content: \"\\f168\"\n}\n\n.fa-xing-square:before {\n    content: \"\\f169\"\n}\n\n.fa-y-combinator:before {\n    content: \"\\f23b\"\n}\n\n.fa-yahoo:before {\n    content: \"\\f19e\"\n}\n\n.fa-yandex:before {\n    content: \"\\f413\"\n}\n\n.fa-yandex-international:before {\n    content: \"\\f414\"\n}\n\n.fa-yelp:before {\n    content: \"\\f1e9\"\n}\n\n.fa-yen-sign:before {\n    content: \"\\f157\"\n}\n\n.fa-yoast:before {\n    content: \"\\f2b1\"\n}\n\n.fa-youtube:before {\n    content: \"\\f167\"\n}\n\n.fa-youtube-square:before {\n    content: \"\\f431\"\n}\n\n.sr-only {\n    border: 0;\n    clip: rect(0, 0, 0, 0);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: 1px\n}\n\n.sr-only-focusable:active,\n.sr-only-focusable:focus {\n    clip: auto;\n    height: auto;\n    margin: 0;\n    overflow: visible;\n    position: static;\n    width: auto\n}\n\n@font-face {\n    font-family: Font Awesome\\ 5 Brands;\n    font-style: normal;\n    font-weight: 400;\n    src: url(../../assets/fonts/fa-brands-400.eot);\n    src: url(../../assets/fonts/fa-brands-400.eot?#iefix) format(\"embedded-opentype\"), url(../../assets/fonts/fa-brands-400.woff2) format(\"woff2\"), url(../../assets/fonts/fa-brands-400.woff) format(\"woff\"), url(../../assets/fonts/fa-brands-400.ttf) format(\"truetype\"), url(../../assets/fonts/fa-brands-400.svg#fontawesome) format(\"svg\")\n}\n\n.fab {\n    font-family: Font Awesome\\ 5 Brands;\n    &:before{\n        font-family: Font Awesome\\ 5 Brands;\n    }\n}\n\n@font-face {\n    font-family: Font Awesome\\ 5 Free;\n    font-style: normal;\n    font-weight: 400;\n    src: url(../../assets/fonts/fa-regular-400.eot);\n    src: url(../../assets/fonts/fa-regular-400.eot?#iefix) format(\"embedded-opentype\"), url(../../assets/fonts/fa-regular-400.woff2) format(\"woff2\"), url(../../assets/fonts/fa-regular-400.woff) format(\"woff\"), url(../../assets/fonts/fa-regular-400.ttf) format(\"truetype\"), url(../../assets/fonts/fa-regular-400.svg#fontawesome) format(\"svg\")\n}\n\n.far {\n    font-weight: 400;\n    &:before{\n        font-weight: 400;\n    }\n}\n\n@font-face {\n    font-family: Font Awesome\\ 5 Free;\n    font-style: normal;\n    font-weight: 900;\n    src: url(../../assets/fonts/fa-solid-900.eot);\n    src: url(../../assets/fonts/fa-solid-900.eot?#iefix) format(\"embedded-opentype\"), url(../../assets/fonts/fa-solid-900.woff2) format(\"woff2\"), url(../../assets/fonts/fa-solid-900.woff) format(\"woff\"), url(../../assets/fonts/fa-solid-900.ttf) format(\"truetype\"), url(../../assets/fonts/fa-solid-900.svg#fontawesome) format(\"svg\")\n}\n\n.fa,\n.far,\n.fal,\n.fas {\n    font-family: Font Awesome\\ 5 Free;\n    &:before{\n        font-family: Font Awesome\\ 5 Free;\n    }\n}\n\n.fa,\n.fas {\n    font-weight: 900;\n    &:before{\n        font-weight: 900;\n    }\n}",".accordion {\n    box-shadow: none;\n    border-radius: 0;\n    .title {\n        display: block;\n        border: 1px solid $border-color2;\n        @include border-radius(0);\n        background-color: $subMenuBg;\n        @include box-shadow( 0 2px 8px 0 rgba(0, 0, 0, 0.05));\n        min-height: 43px;\n        border-bottom: 1px solid $border-color2;\n        margin-bottom: 10px;\n        position: relative;\n        padding-left: 20px !important;\n        font-size: 20px !important;\n        color: $dkblue !important;\n        i.dropdown {\n            position: absolute;\n            right: 0px;\n            top: 10px;\n            text-align: center !important;\n            &:before {\n                content: \"\\f107\" !important;\n                color: $darkgrey;\n            }\n        }\n        \n        &.active {\n            border-radius: 0;\n            i.dropdown {\n                top: 17px;\n                transform: rotate(180deg) !important;\n            }\n            i.dropdown:before {\n                color: $dkblue;\n            }\n        }\n    }\n    .content {\n        border-radius: 0;\n        margin-bottom: 10px;\n        border: 1px solid $border-color2;\n        padding: 20px !important;\n        background: rgb(247, 248, 250);\n        table {\n            border-radius: 0 0 0 0;\n            th {\n                padding: 10px 5px;\n            }\n        }\n       \n    }\n    .title.active {\n        & +.content.active {\n          margin-top: -10px;\n          border-top: none;\n        }\n    }\n    // .ui.grid>.row {\n    //     padding-top: .5em;\n    //     padding-bottom: .5em;\n    // }\n}","//STYLE CSS FOR BUTTON\n.ui.button {\n    padding: .6em 1.5em .6em;\n    font-size: 12px;\n    line-height: 1;\n    // background: $yellow;\n    // color: $dkblue;\n    border: none;\n    @include border-radius(0);\n    vertical-align: middle;\n    text-transform: uppercase;\n    -ms-touch-action: manipulation;\n    touch-action: manipulation;\n    cursor: pointer;\n    min-width: 85px;\n\n    a {\n        font-size: 12px;\n        line-height: 15px;\n        color: $dkblue;\n    }\n\n    i {\n        margin-right: 0 !important;\n        margin-top: -5px !important;\n\n        &:before {\n            color: $white;\n            font-size: .8em;\n        }\n    }\n\n    @media(max-width: 1023px) {\n        // padding: 15px 30px;\n    }\n\n}\n\n.ui.primary.button,\n.ui.primary.buttons .button {\n    background: $yellow;\n    color: $dkblue;\n\n    i {\n        &:before {\n            color: $dkblue;\n\n        }\n    }\n\n    &:hover,\n    &:active,\n    &:focus {\n        background: $dkyellow;\n        color: $dkblue;\n    }\n}\n\n.ui.secondary.button,\n.ui.secondary.buttons .button {\n    background: $dkblue2;\n    color: $white;\n\n    &:hover,\n    &:active,\n    &:focus {\n        background: $skyblue;\n        color: $white;\n    }\n}\n\n.ui.cancel.button,\n.ui.cancel.buttons .button {\n    background: $darkgrey;\n    color: $white;\n\n    &:hover,\n    &:active,\n    &:focus {\n        background: $darkgreyhover;\n        color: $white;\n    }\n}\n\nbutton[disabled=disabled],\nbutton:disabled,\n.btn.disabled {\n    opacity: .6;\n    cursor: not-allowed;\n    // pointer-events: none;\n}\n\n.editBtn {\n    display: inline-block;\n    background: $dkblue2;\n    width: 26px;\n    height: 26px;\n    color: $white;\n    text-align: center;\n    cursor: pointer;\n\n    i {\n        padding-left: 4px;\n\n        &:before {\n            font-size: .7em;\n            color: $white;\n        }\n    }\n}\n\n.addBtn {\n    display: inline-block;\n    background: $dkblue2;\n    width: 26px;\n    height: 26px;\n    color: $white;\n    text-align: center;\n    cursor: pointer;\n\n    i {\n        padding-left: 4px;\n\n        &:before {\n            font-size: .7em;\n            color: $white;\n        }\n    }\n}\n\n.closeBtn {\n    display: inline-block;\n    background: $darkgrey;\n    width: 26px;\n    height: 26px;\n    color: $white;\n    text-align: center;\n    cursor: pointer;\n\n    i {\n        padding-left: 4px;\n        line-height: 26px;\n\n        &:before {\n            font-size: .9em;\n            color: $white;\n        }\n    }\n}\n\n\n.ui.button.attachBtn {\n    background: $dkblue2 !important;\n    color: $white !important;\n\n    i {\n        margin-right: 10px !important;\n\n        &:before {\n            font-size: 1.1em !important;\n            color: $white;\n        }\n    }\n}\n\n.uploadBtn {\n    display: block;\n    width: 100%;\n\n    // border: 1px solid $border-color2;\n    // height: 30px;\n    input {\n        display: inline-block !important;\n        padding: 5px !important;\n        font-size: 12px !important;\n        -webkit-appearance: none !important;\n    }\n\n    .errorMessage {\n        margin-top: 0;\n    }\n}",".pagerWrap {\n    padding: 12px 0;\n    border-radius: 2px;\n    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.02);\n    background-color: rgb(255, 255, 255);\n    height: 52px;\n\n    .pager {\n        float: left;\n        padding-left: 3px;\n        padding-top: 4px;\n        min-width: 270px;\n\n        .ui.pagination {\n            min-height: auto;\n            border: none;\n            box-shadow: none;\n\n            .item {\n                min-width: auto;\n                width: 32px;\n                height: 2spx;\n                font-size: 13px;\n                color: $darkgrey;\n                padding: 4px;\n                justify-content: center;\n                margin: 0 2px;\n\n                i {\n                    &::before {\n                        font-size: .7em;\n                        color: $darkgrey;\n                    }\n\n                    &.caret {\n                        &::before {\n                            font-size: .9em;\n                            color: $darkgrey;\n                        }\n                    }\n\n                    &.step {\n                        margin-top: -3px;\n                    }\n                }\n\n                &::before {\n                    display: none;\n                }\n\n                &.active {\n                    background-color: $skyblue;\n                    color: $white;\n                    border-radius: 2px;\n                }\n            }\n        }\n\n    }\n\n    .itemPerPage {\n        float: left;\n        margin: 0 20px;\n        font-size: 14px;\n        color: $darkgrey;\n\n        .field {\n            display: inline-block;\n            vertical-align: middle;\n            height: 30px;\n\n            .dropdown {\n                display: inline-block;\n                width: 66px;\n                min-width: auto !important;\n                margin-right: 10px;\n\n                i.dropdown {\n                    top: 8px !important;\n                }\n\n                .menu>.item {\n                    font-size: 14px;\n                    color: $darkgrey;\n                    padding: .278571429rem .54285714rem !important;\n                }\n            }\n        }\n\n        .itemsPerPage {\n            display: inline-block;\n            font-size: 14px;\n            color: $darkgrey;\n            margin-left: 10px;\n            vertical-align: middle;\n        }\n    }\n\n    .totalPage {\n        float: right;\n        font-size: 14px;\n        color: $darkgrey;\n        padding-right: 10px;\n        padding-top: 5px;\n    }\n\n}",".label,\n.ui.form .field>label {\n    display: block;\n    line-height: 17px;\n    font-size: 14px;\n    color: $dkblue;\n    text-align: left;\n    font-weight: $fontWeight500;\n    margin-bottom: 2px;\n\n    .icon.asterisk,\n    .icon.info {\n        margin-right: 0;\n\n        &::before {\n            font-size: .7em;\n            color: $skyblue;\n        }\n    }\n\n    .commonToolTip {\n        display: inline-block;\n    }\n}\n\n.label2 {\n    display: block;\n    line-height: 17px;\n    font-size: 14px;\n    color: $darkgrey;\n    text-align: left;\n    font-weight: $fontWeight500;\n    margin-bottom: 0;\n\n    .icon.asterisk,\n    .icon.info {\n        margin-right: 0;\n\n        &::before {\n            font-size: .7em;\n            color: $skyblue;\n        }\n    }\n\n    .commonToolTip {\n        display: inline-block;\n    }\n}\n\n.labelData {\n    font-size: 16px;\n    color: $dkblue;\n    font-weight: $fontWeight500;\n}\n\n.ui.input,\n.ui.mini.input {\n    input {\n        font-size: 14px;\n        padding: .52em .5em;\n        border-radius: 4px;\n        box-shadow: inset 0 2px 3px 0 rgba(0, 0, 0, 0.1);\n        background-color: rgb(255, 255, 255);\n        color: $ltgrey;\n    }\n}\n\n.ui.selection.dropdown {\n    padding: 0 1.8em 0 8px;\n    height: 30px;\n    min-height: 30px;\n    line-height: 30px;\n    border-radius: 4px;\n\n    .dropdown.icon {\n        top: 7px;\n        right: 6px;\n        margin: 0;\n        padding: 0;\n        opacity: .4;\n\n        &:before {\n            content: \"\\f078\" !important;\n            font-size: 1em;\n        }\n    }\n\n    >.text {\n        font-size: 14px;\n        color: $dkblue !important;\n        vertical-align: text-bottom;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        width: 100%;\n    }\n\n    .menu {\n        >.item {\n            padding: 5px .54285714rem !important;\n            color: $dkblue !important;\n        }\n\n        span {\n            font-size: 14px !important;\n        }\n\n        .message {\n            text-overflow: ellipsis;\n            overflow: hidden;\n        }\n    }\n\n    &.search {\n        .text {\n            top: -2px;\n        }\n    }\n}\n\n.ui.dropdown {\n    .visible.menu {\n        .message {\n            font-size: 14px;\n            color: rgba(0, 0, 0, 0.87);\n        }\n    }\n}\n\n// VALIDATION MESSAGE\n.ui.form {\n    .field {\n        margin: 0 0 10px 0;\n\n        .field.error {\n            margin: 0 0 0 0;\n        }\n    }\n}\n\n\n.ui.form .disabled.field,\n.ui.form .disabled.fields .field,\n.ui.form .field :disabled,\n.ui.disabled.input,\n.ui.input:not(.disabled) input[disabled] {\n    opacity: .85;\n}\n\n.ui.basic.red.label {\n    margin: -10px 0 0 0;\n    padding: 0;\n    border: none;\n    font-weight: $fontWeight300;\n}\n\n// RADIO BOX CUSTOMIZE\n.radioWrap {\n    .field {\n        margin: 5px 20px 0 0 !important;\n        display: inline-block !important;\n    }\n}\n\n.radioWrapCheckBoxOfficerTitle > div {\n    margin-right: 10px;\n}\n\n.ui.radio.checkbox input:checked~.box:after,\n.ui.radio.checkbox input:checked~label:after,\n.ui.radio.checkbox input:focus:checked~.box:after,\n.ui.radio.checkbox input:focus:checked~label:after {\n    background-color: $white;\n}\n\n.ui.radio.checkbox input:checked~.box:before,\n.ui.radio.checkbox input:checked~label:before,\n.ui.radio.checkbox input:focus:checked~.box:before,\n.ui.radio.checkbox input:focus:checked~label:before {\n    background-color: $skyblue;\n}\n\n.ui.checkbox input:checked~.box:before,\n.ui.checkbox input:checked~label:before {\n    border-color: $skyblue;\n}\n\n.ui.radio.checkbox .box,\n.ui.radio.checkbox label {\n    padding-left: 1.4em;\n}\n\n// CHECKBOX CUSTOMIZE\n.ui.checkbox .box:before,\n.ui.checkbox label:before {\n    border-radius: 0;\n    width: 16px;\n    height: 16px;\n}\n\n.ui.checkbox input:checked~.box:before,\n.ui.checkbox input:checked~label:before,\n.ui.checkbox input:checked:focus~.box:before,\n.ui.checkbox input:checked:focus~label:before {\n    background: $skyblue;\n    color: $white;\n}\n\n.ui.checkbox input:checked~.box:after,\n.ui.checkbox input:checked~label:after,\n.ui.checkbox input:checked:focus~.box:after,\n.ui.checkbox input:checked:focus~label:after {\n    font-size: 12px;\n    color: $white;\n}\n\n.ui.checkbox.partial .box:before,\n.ui.checkbox.partial label:before {\n    background: $darkgrey;\n}\n\n// TEXTAREA CUSTOMIZE\n.ui.form textarea {\n    font-size: 14px;\n    color: $dkblue;\n    padding: .52em .5em;\n    box-shadow: inset 0 2px 3px 0 rgba(0, 0, 0, 0.1);\n}\n\n.twoColInput {\n    width: 300px !important;\n    flex-grow: 0 !important;\n    margin-right: 20px;\n}\n\n.dollarPrefix .input {\n    position: relative !important;\n}\n\n.dollarPrefix .input:before {\n    display: inline-block !important;\n    content: \"$\" !important;\n    background-position: 0 50%;\n    width: 13px;\n    height: 13px;\n    position: absolute;\n    left: 0;\n    top: 0;\n    font-size: 16px;\n}\n\n.radioWrapper {\n    display: block;\n    margin-top: 10px;\n}",".ui.tiny.modal {\n    width: 640px;\n\n    @media (max-width: 600px) {\n        width: 100%;\n    }\n}\n\n.ui.modal {\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.5);\n    background-color: $modalBg;\n\n    .header:not(.ui) {\n        position: relative;\n        background: $darkgrey;\n        font-size: 16px;\n        line-height: 20px;\n        color: $white;\n        padding: 9px 10px;\n        border-bottom: none;\n        text-transform: uppercase;\n        font-weight: $fontWeight400;\n        border-top-left-radius: 0;\n        border-top-right-radius: 0;\n\n        >.close {\n            position: absolute;\n            top: 10px;\n            right: 10px;\n            color: #fff;\n            font-style: normal;\n            cursor: pointer;\n            z-index: 2;\n            z-index: 2;\n\n            &:before {\n                color: $white;\n            }\n        }\n    }\n\n    .content {\n        background-color: $modalBg;\n        padding: 0 10px;\n        max-height: calc(70vh);\n        overflow-x: hidden;\n        overflow-y: auto;\n\n        .description {\n            min-height: 80px;\n            padding-bottom: 45px;\n\n            .ui.dropdown .menu>.item>.description,\n            .ui.dropdown>.text>.description {\n                min-height: auto;\n            }\n\n            .actions {\n                position: fixed;\n                bottom: 0;\n                z-index: 1;\n                width: 98% !important;\n            }\n        }\n    }\n\n    .actions {\n        background-color: $modalBg;\n        box-shadow: none;\n        border-top: none;\n        text-align: left;\n        padding: 10px 10px 15px 10px;\n\n        .button:first-child {\n            margin-left: 0;\n        }\n\n        @media (max-width: 767px) {\n            .button {\n                padding: 15px 20px;\n            }\n        }\n    }\n\n    &.infoBox {\n        padding: 20px 10px;\n        border-top-left-radius: 0;\n        border-top-right-radius: 0;\n\n        .header:not(.ui) {\n            background-color: $modalBg;\n            padding: 0 10px;\n\n            >.close {\n                color: $darkgrey;\n                right: 0;\n                top: -10px;\n                cursor: pointer;\n            }\n        }\n\n        h4 {\n            margin: 15px 0 20px 0;\n        }\n\n        .actions {\n            padding: 10px 10px 0 10px;\n            bottom: 20px !important;\n        }\n    }\n}\n\n.confirmBox {\n    border-radius: 4px !important;\n\n    >.header:not(.ui) {\n        font-size: 16px;\n    }\n\n    .content {\n        font-size: 16px !important;\n        color: $dkblue;\n        text-align: center;\n        padding: 40px 15px 30px 15px !important;\n    }\n\n    .actions {\n        text-align: center !important;\n        padding-bottom: 40px !important;\n\n        .ui.button {\n            background: $dkblue2;\n            color: $white;\n        }\n    }\n\n    &.noCancelBtn {\n        .actions {\n            .ui.button {\n                display: none;\n            }\n\n            .ui.button.primary {\n                display: inline-block;\n            }\n        }\n    }\n}\n\n.dblColData {\n    .colIcon {\n        display: inline-block;\n        width: 10%;\n        text-align: center;\n        vertical-align: top;\n    }\n\n    .colText {\n        display: inline-block;\n        width: 90%;\n        font-size: 16px;\n    }\n}\n\n.editorStyleFix {\n    .questionLabel {\n        font-size: 16px;\n        color: $skyblue;\n\n        * {\n            color: $skyblue !important;\n        }\n    }\n\n    .answerLabel {\n        font-size: 16px;\n        color: $dkblue;\n\n        * {\n\n            a,\n            a * {\n                color: $skyblue !important;\n            }\n        }\n    }\n\n    .questionLabel,\n    .answerLabel {\n        * {\n            background-color: transparent !important;\n            vertical-align: initial !important;\n        }\n\n        i,\n        em {\n            font-style: italic;\n        }\n\n        ol {\n            list-style-position: inside;\n            display: initial !important;\n        }\n\n        ul {\n            list-style-position: inside;\n            list-style-type: initial;\n            margin-left: 17px;\n\n            li {\n                list-style-type: disc;\n            }\n        }\n    }\n}\n\n.viewModeForm {\n    .input input[disabled] {\n        box-shadow: none;\n        background: $modalBg;\n    }\n}\n\n\n// ERROR MODAL BOX CSS STAR\n.ui.modal {\n    &.errormodalbox {\n        .header {\n            i {\n                &:before {\n                    color: $white;\n                    font-size: 14px;\n                    vertical-align: top;\n                }\n            }\n        }\n\n        .content {\n            padding: 20px 10px;\n\n            ul {\n                li {\n                    list-style: disc;\n                    margin-left: 20px;\n                    line-height: 18px;\n                    margin-bottom: 10px;\n                }\n            }\n        }\n\n    }\n\n    &.add-depends-tasks {\n        .content {\n            height: 200px;\n\n            .errorMessage {\n                margin-top: 0px;\n            }\n        }\n    }\n}\n\n.passwordReset {\n    max-width: 400px;\n\n    .description {\n        text-align: center;\n\n        .passwordBox {\n            display: block;\n            margin: 5px auto 2px auto;\n            background: $white;\n            width: 150px;\n            padding: 10px;\n            font-size: 16px;\n            text-align: center;\n            @include border-radius(3px);\n            box-shadow: 0 2px 8px 0 rgba(255, 255, 255, 0.5);\n        }\n\n        a {\n            font-size: 14px;\n            color: $skyblue;\n            cursor: pointer;\n        }\n    }\n\n}",".breadcrumb {\n    display: block;\n    width: 100%;\n    padding: 10px 0;\n    position: fixed;\n    top: 90px;\n    left: 24px;\n\n    * {\n        font-size: 13px;\n    }\n\n    .breadcrumbList {\n        li {\n            display: block;\n            float: left;\n\n            a,\n            span {\n                display: inline-block;\n                font-size: 12px;\n                color: #87959c;\n            }\n\n            .current {\n                color: #232f3a;\n                ;\n                cursor: default;\n            }\n\n            .sepert {\n                display: inline-block;\n                color: #87959c;\n                margin: 0 15px;\n                font-size: 22px;\n            }\n\n            .active.section {\n                font-weight: 500 !important\n            }\n        }\n    }\n\n    a {\n        color: #87959c !important;\n        white-space: nowrap;\n\n        * {\n            color: #87959c !important;\n            white-space: nowrap;\n        }\n    }\n}",".tableWrapper {\n    display: block;\n    width: 100%;\n    margin: 10px 0 0 0;\n    overflow-x: auto;\n    overflow-y: hidden;\n}\n\n.customTable {\n    width: 100%;\n    table-layout: fixed;\n    word-break: break-word;\n    word-wrap: break-word;\n    border-collapse: separate;\n    border-spacing: 0 0.625em;\n\n    thead tr {\n        th {\n            position: relative;\n            height: 52px;\n            padding: 6px 15px 6px 10px;\n            color: $darkgrey;\n            font-size: 14px;\n            line-height: 20px;\n            text-align: left;\n            font-family: \"ProximaNovaBold\";\n            border-right: 1px solid $thead-border;\n            box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.02);\n            background-color: rgb(255, 255, 255);\n            white-space: nowrap;\n            text-overflow: ellipsis;\n            overflow: hidden;\n\n            &:first-child {\n                border-top-left-radius: 2px;\n                border-bottom-left-radius: 2px;\n            }\n\n            &:last-child {\n                border-right: none;\n                border-top-right-radius: 2px;\n                border-bottom-right-radius: 2px;\n            }\n\n            i {\n                position: absolute;\n                right: -4px;\n                top: 15px;\n                z-index: 1;\n\n                &::before {\n                    color: $thead-border;\n                }\n\n                &.activeSort {\n                    &::before {\n                        color: $skyblue;\n                    }\n                }\n            }\n\n            @media(max-width: 1023px) {\n                display: block;\n                width: 100% !important;\n                text-align: left !important;\n                padding-left: 15px;\n                padding-top: 10px;\n                padding-bottom: 10px;\n            }\n        }\n    }\n\n    tbody tr {\n        td {\n            padding: 11px 10px;\n            color: $dkblue;\n            font-size: 14px;\n            line-height: 20px;\n            text-align: left;\n            vertical-align: middle;\n            border: none;\n            box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.02);\n            background-color: rgb(255, 255, 255);\n\n            &:first-child {\n                border-top-left-radius: 2px;\n                border-bottom-left-radius: 2px;\n            }\n\n            &:last-child {\n                border-top-right-radius: 2px;\n                border-bottom-right-radius: 2px;\n            }\n\n            a {\n                font-size: 14px;\n                color: $skyblue;\n                cursor: pointer;\n\n                &:hover {\n                    text-decoration: underline;\n                }\n            }\n            \n            span {\n                font-size: 14px;\n            }\n\n            i.icon {\n                cursor: pointer;\n            }\n\n            img {\n                display: inline-block;\n                vertical-align: middle;\n                margin-right: 10px;\n            }\n\n            .dblColData {\n                position: relative;\n\n                .colIcon {\n                    display: inline-block;\n                    width: 24px;\n                    position: absolute;\n                    left: 0;\n                    top: -2px;\n                }\n\n                .colText {\n                    display: inline-block;\n                    padding-left: 30px;\n                    font-size: 16px;\n                }\n            }\n\n            &.action {\n                button {\n                    display: inline-block;\n                    vertical-align: top;\n                    border: none;\n                    background: none;\n                    margin-right: 4px;\n\n                    i.icon {\n                        width: 1.8em;\n                        height: 1.8em;\n                        line-height: 1.8em;\n\n                        &::before {\n                            font-size: 1em;\n                            color: $white;\n                            line-height: 1.7em;\n                        }\n                    }\n                }\n\n            }\n\n            @media(max-width: 1023px) {\n                display: block;\n                width: 100% !important;\n                text-align: left !important;\n                padding-left: 15px;\n            }\n        }\n    }\n\n    .customizeTableCol {\n        width: 30px !important;\n        background: $skyblue;\n        text-align: center;\n\n        i {\n            &::before {\n                color: $white;\n            }\n        }\n    }\n}\n\n\n// APPLICATION TABLE DESIGN\n.appTable {\n    th.appName {\n        width: 20%;\n    }\n\n    th.appId {\n        width: 13%;\n    }\n\n    th.secureKey {\n        width: 17%;\n    }\n\n    th.contactName {\n        width: 15%;\n    }\n\n    th.emailId {\n        width: 24%;\n    }\n\n    th.status {\n        width: 11%;\n    }\n\n    td.appId {\n        text-transform: uppercase;\n    }\n\n    td.secureKey {\n        text-transform: uppercase;\n    }\n\n    td.contactName {\n        text-transform: capitalize;\n    }\n}\n\n// FAQ TABLE DESIGN\n.faqTable {\n    tr {\n        background: transparent !important;\n    }\n\n    th.questions {\n        width: 40%;\n    }\n\n    th.answers {\n        width: 40%;\n    }\n\n    th.status {\n        width: 10%;\n    }\n\n    th.action {\n        width: 10%;\n    }\n\n    td {\n        i {\n            display: none;\n            text-decoration: none;\n            display: inline-block;\n            vertical-align: text-top;\n            width: 26px;\n\n            &:before {\n                color: $darkgrey;\n                font-size: .9em;\n            }\n\n            &:hover {\n                text-decoration: none !important;\n            }\n        }\n    }\n\n    td.question {\n        font-size: 14px !important;\n        color: $skyblue !important;\n\n        * {\n            font-size: 14px !important;\n            color: $skyblue !important;\n            font-weight: normal !important;\n\n            &:hover {\n                text-decoration: underline;\n            }\n        }\n\n        p {\n            display: inline-block;\n        }\n\n        sup {\n            vertical-align: -webkit-baseline-middle;\n        }\n\n        sub {\n            vertical-align: 2px;\n        }\n\n        ol {\n            list-style-position: inside;\n\n        }\n\n        ul {\n            list-style-position: inside;\n            list-style-type: initial;\n            margin-left: 20px;\n\n        }\n\n        .truncatedText {\n            display: inline-block;\n            width: calc(100% - 30px);\n            vertical-align: middle;\n        }\n    }\n\n    td.answer {\n        font-size: 14px !important;\n        color: $dkblue !important;\n\n        * {\n            font-size: 14px !important;\n            color: $dkblue !important;\n            line-height: 20px !important;\n        }\n\n        ol {\n            list-style-position: inside;\n\n            li {\n                font-size: 14px !important;\n                color: $dkblue !important;\n                line-height: 20px !important;\n            }\n        }\n\n        ul {\n            list-style-position: inside;\n            list-style-type: initial;\n            margin-left: 20px;\n\n            li {\n                font-size: 14px !important;\n                color: $dkblue !important;\n                line-height: 20px !important;\n                list-style-type: disc;\n            }\n        }\n\n        a {\n            color: $skyblue !important;\n        }\n    }\n\n}\n\n// MEMBERSHIP TABLE DESIGN\n.memberShipTable {\n    th.membershipName {\n        width: 20%;\n    }\n\n    th.membershipFee {\n        width: 20%;\n    }\n\n    th.isEnabled {\n        width: 20%;\n    }\n\n    th.membershiptypecode {\n        width: 20%;\n    }\n\n    th.stockcode {\n        width: 20%;\n    }\n}\n\n// MEMBERSHIP CLASSIFICATION TABLE DESIGN\n.membershipClassifTable {\n    th.seqNo {\n        width: 12%;\n    }\n\n    th.classifType {\n        width: 25%;\n    }\n\n    th.description {\n        width: 40%;\n    }\n\n    th.isEnabled {\n        width: 23%;\n    }\n\n    td.seqNo {\n        i {\n            height: 20px;\n            vertical-align: middle;\n        }\n\n        span {\n            vertical-align: middle;\n            font-size: 14px;\n        }\n    }\n}\n\n.membershipDocTable {\n    th.Name {\n        width: 50%;\n    }\n\n    th.Type {\n        width: 30%;\n    }\n\n    th.Status {\n        width: 20%;\n    }\n\n\n}\n\n// OFFICER TITLES TABLE DESIGN\n.officerTable {\n    th.officerTitle {\n        width: 25%;\n    }\n\n    th.description {\n        width: 65%;\n    }\n\n    th.status {\n        width: 10%;\n    }\n}\n\n//RESPONSIBILITIES TABLE DESIGN\n\n.responsibilitiesTable {\n    th.appName {\n        width: 25%;\n    }\n\n    th.url {\n        width: 65%;\n    }\n\n    th.status {\n        width: 10%;\n    }\n}\n\n//MEETING TYPE TABLE DESIGN\n.meetingTypeTable {\n    th.meetingType {\n        width: 40%;\n    }\n\n    th.description {\n        width: 45%;\n    }\n\n    th.status {\n        width: 15%;\n    }\n}\n\n// DOCUMENT TABLE DESIGN\n.documentTable {\n    // th.documentID {\n    //     width: 20%;\n    // }\n\n    th.documentName {\n        width: 65%;\n    }\n\n    th.type {\n        width: 20%;\n    }\n\n    th.action {\n        width: 15%;\n        text-align: center;\n        padding-left: 15px;\n    }\n\n}\n\n// USER TABLE DESIGN\n.userTable {\n    th.userName {\n        width: 25%;\n    }\n\n    th.name {\n        width: 25%;\n    }\n\n    th.email {\n        width: 30%;\n    }\n\n    th.userType {\n        width: 20%;\n    }\n\n    th.action {\n        width: 7%;\n    }\n\n    td {\n\n        .viewOnly {\n            display: none;\n        }\n\n        .field {\n            .ui.selection.dropdown {\n                min-width: auto;\n                width: 100%;\n\n                .dropdown.icon {\n                    top: 5px;\n                    right: 5px;\n                }\n            }\n        }\n    }\n}\n\n.dg-menu.Container {\n    background: $white;\n    position: absolute;\n    left: auto !important;\n    right: 20px;\n    z-index: 2;\n    width: 250px;\n    padding: 20px;\n    border-radius: 4px;\n    border: solid 1px $border-color;\n    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.05);\n}",".message {\n    display: block;\n    width: 100%;\n    max-width: 100%;\n    position: fixed !important;\n    right: 0;\n    top: -16px;\n    z-index: 9999999;\n    border-radius: 0 !important;\n    box-shadow: none !important;\n    padding: 14px 30px 14px 10px !important;\n    text-align: left;\n    .content{\n        p{\n            font-size: 14px;\n            color: $white;\n            font-weight: $fontWeight500;\n            opacity: 1;\n        }\n    }\n    i{\n        opacity: 1 !important;\n        &::before{\n            font-weight: normal;\n            font-size: .9em;\n            color: $white;\n        }\n    }\n    &.success {\n       \n            background: $green !important;\n            color: $white !important;\n            border: 1px solid $green !important;\n           \n    }\n    &.error {\n            background-color: $red !important;\n            color: $white !important;\n            border: 1px solid $red !important;\n       \n    }\n    &.attention {\n        \n            color: $black !important;\n            border: 1px solid $yellow !important;\n            background: $yellow !important;\n       \n    }\n    @media(max-width:767px) {\n        min-height: 60px;\n        padding: 17px 20px;\n    }\n}",".sideMenuLeft {\n    display: block;\n    width: 290px;\n    position: fixed;\n    top: 140px;\n    z-index: 1;\n\n    .menuWrapper {\n        margin-bottom: 2px;\n\n        .menuHeaderLabel {\n            position: relative;\n            font-size: 14px;\n            color: $dkblue2;\n            background: $accordianbg;\n            padding: 4px 4px 4px 36px;\n            margin-bottom: 0;\n            cursor: pointer;\n\n            .icon {\n                position: absolute;\n                left: 5px;\n                top: 4px;\n\n                &:before {\n                    font-size: 16px;\n                    color: $dkblue2;\n                }\n            }\n\n            .icon.chevron.down,\n            .icon.chevron.up {\n                position: absolute;\n                left: auto;\n                right: 0;\n                top: 5px;\n\n                &:before {\n                    color: $ltgrey2;\n                    font-size: 14px;\n                }\n            }\n\n            &.active {\n                background: $dkblue2;\n                color: $white;\n\n                .icon {\n                    &:before {\n                        color: $white;\n                    }\n                }\n\n                .icon.chevron.down,\n                .icon.chevron.up {\n                    &:before {\n                        font-size: 14px;\n                        color: $white;\n                    }\n                }\n            }\n        }\n\n        .subMenu {\n            background-color: $subMenuBg;\n            padding: 14px 22px;\n            position: relative;\n\n            &::before {\n                display: block;\n                content: ' ';\n                background-color: $ltgrey2;\n                position: absolute;\n                left: 26px;\n                width: 2px;\n                height: calc(100% - 42px);\n                top: 22px;\n            }\n\n            li {\n                position: relative;\n                font-size: 14px;\n                color: $subMenuTxt;\n                padding-bottom: 5px;\n                padding-left: 22px;\n                cursor: pointer;\n\n                &:last-child {\n                    padding-bottom: 0;\n                }\n\n                &:before {\n                    display: inline-block;\n                    content: '\\2022';\n                    position: absolute;\n                    left: 0;\n                    top: -1px;\n                    font-size: 28px;\n                    color: $subMenuTxt;\n                }\n\n                &.active,\n                &:active,\n                &:hover {\n                    color: $skyblue;\n                    font-size: 15px;\n\n                    &:before {\n                        color: $skyblue;\n                    }\n                }\n            }\n        }\n    }\n}",".ui.inverted.popup {\n    background: $toastbg;\n    padding: 6px 12px !important;\n    z-index: 99999;\n\n    &::before {\n        background: rgba(41, 41, 41, .8) !important;\n    }\n\n    .content {\n        font-size: 13px;\n        color: $white;\n        text-align: center;\n    }\n\n    &.leftAlignTolltip {\n        .content {\n            text-align: left;\n        }\n    }\n}",".ui.tabular.menu {\n    border: none;\n    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);\n    .item{\n        font-size: 14px;\n        color: $dkblue2;\n        background: $tabBg;\n        font-weight: $fontWeight500;\n        text-transform: uppercase;\n        border: none;\n        &.active{\n            border-radius: 0;\n            color: $skyblue;\n            margin-top: -10px;\n            \n        }\n    }\n}\n.ui.segment[class*=\"bottom attached\"]{\n    border-radius: 0;\n    border: none;\n}\n\n.tabWithBtn{\n    position: relative;\n    .actionBtnWrap{\n        position: absolute;\n        right: 0;\n        top: 10px;\n        z-index: 2;\n    }\n}",".ui.selection.dropdown.multiple {\n  min-height: 30px !important;\n  padding: 0 18px 0 5px !important;\n  height: auto;\n  max-width: 550px;\n\n  >.text {\n    font-size: 14px;\n    color: $dkblue !important;\n    padding-top: 6px !important;\n    padding-left: 0 !important;\n    top: 0;\n    margin: 0;\n\n    &.default {\n      color: rgba(191, 191, 191, .87) !important;\n    }\n  }\n\n  .menu {\n    max-height: 130px;\n  }\n\n  &.search {\n\n    >.text {\n      padding-left: 6px !important;\n    }\n\n    input.search {\n      height: 30px;\n      padding-left: 0px !important;\n      margin: 0 !important;\n    }\n  }\n\n\n  >.label {\n    margin: 1px 5px 2px 0;\n    padding: 0 7px;\n    font-size: 14px !important;\n    display: inline-block !important;\n    color: $dkblue !important;\n    font-weight: normal;\n    vertical-align: initial;\n\n    >.close.icon,\n    >.delete.icon {\n      &::before {\n        content: '\\2716';\n        font-size: 12px;\n        color: $darkgrey !important;\n      }\n    }\n  }\n\n  &.active {\n    border-bottom-left-radius: 4px !important;\n    border-bottom-right-radius: 4px !important;\n  }\n}\n\n.ui.modal {\n  .ui.selection.dropdown.multiple {\n    max-width: 100%;\n  }\n}",".statusActive {\n  display: inline-block;\n  background: $skyblue;\n  @include border-radius(12.5px);\n  font-size: 14px;\n  line-height: 25px;\n  text-align: center;\n  color: $white;\n  padding: 0 14px;\n}\n\n.statusInactive {\n  display: inline-block;\n  background: $yellow;\n  @include border-radius(12.5px);\n  font-size: 14px;\n  line-height: 25px;\n  text-align: center;\n  color: $white;\n  padding: 0 14px;\n}\n\n\n\n.rdw-editor-wrapper {\n  border: 1px solid $ltgrey2;\n  margin-bottom: 10px;\n\n  .rdw-editor-toolbar {\n    margin-bottom: 0;\n    border-bottom: 1px solid $ltgrey2;\n  }\n\n  .rdw-editor-main {\n    background-color: $white;\n    min-height: 150px;\n    max-height: 150px;\n    border: 1px solid $thead-border;\n    border-bottom: 28px solid $accordianbg;\n\n    .public-DraftStyleDefault-block {\n      margin: 0.5em 0.75em;\n    }\n  }\n\n  .rdw-emoji-wrapper {\n    display: none !important;\n  }\n\n  .rdw-image-modal,\n  .rdw-link-modal,\n  .rdw-colorpicker-modal,\n  .rdw-embedded-modal {\n    left: auto !important;\n    right: 5px !important;\n  }\n}\n\n.fa-1 {\n  &:before {\n    font-size: 1.4em;\n  }\n}\n\n.fa-info-circle {\n  &:before {}\n}\n\n\n.floatRight {\n  .selection {\n    @media(min-width: 800px) and (max-width: 1000px) {\n      min-width: 10em !important;\n    }\n  }\n}\n\n.PagingOption {\n  min-width: 10em !important;\n}\n\n.inputIconWrapper {\n  position: relative;\n\n  .input input {\n    padding-right: 30px !important;\n  }\n\n  .refeshIcon {\n    position: absolute;\n    right: 20px;\n    top: 22px;\n    z-index: 2;\n    cursor: pointer;\n\n    i::before {\n      font-size: 0.9em;\n      color: $ltgrey2;\n    }\n\n    &:hover {\n      i::before {\n        color: $darkgrey;\n      }\n    }\n  }\n}","header {\n    display: block;\n    width: 100%;\n    position: fixed;\n    left: 0;\n    top: 0;\n    width: 100%;\n    z-index: 9999;\n    background: $white;\n    padding: 10px 0;\n    min-height: 88px;\n    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);\n\n    .logoWrap {\n        float: left;\n    }\n\n    .loggedUserWrap {\n        float: right;\n        margin-top: 20px;\n        background: $yellow;\n        padding: 6px 10px;\n\n        .ui.dropdown .menu {\n            left: auto;\n            right: -11px;\n            top: 31px;\n            width: 192px;\n            box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.2);\n            background-color: $white;\n            border-radius: 0;\n\n            .item {\n                padding: 5px 1.14285714rem !important;\n            }\n\n            &>.item:hover,\n            & .selected.item,\n            & .selected {\n                background: $dkblue2;\n                color: $white;\n\n                .text {\n                    color: $white;\n                }\n            }\n        }\n\n        .maxName {\n            display: inline-block;\n            vertical-align: bottom;\n            width: 75px;\n\n        }\n    }\n}","#root,\n.appWrapper,\n.App {\n    height: 100%;\n}\n\n#root {\n    height: 100%;\n    overflow: auto;\n}\n\n.mainWrapperRight {\n    display: block;\n    width: calc(100% - 290px);\n    float: right;\n    padding-left: 32px;\n\n    .headingTitle {\n        position: relative;\n        margin-bottom: 10px;\n\n        h2 {\n            float: left;\n\n            .recordCount {\n                display: block;\n                font-size: 14px;\n                color: $skyblue;\n            }\n        }\n\n        .editBtn {\n            float: right;\n            margin-top: 7px;\n\n            i {\n                line-height: inherit;\n            }\n        }\n\n        .button {\n            float: right;\n            margin-top: 7px;\n\n            i {\n                line-height: inherit;\n            }\n        }\n\n        .searchBx {\n            width: 400px;\n            position: absolute;\n            right: 0;\n            top: 40px;\n            z-index: 99;\n\n\n            div {\n                width: 100%;\n                background-color: $white;\n\n                input {\n                    border-radius: 2px;\n                    padding: .42em .5em;\n                }\n            }\n\n            .ui.icon.input>i.circular.icon {\n                top: .15em;\n                right: .5em;\n            }\n\n            .results {\n                &.visible {\n                    max-height: 300px;\n                    overflow: auto;\n                }\n\n                .message {\n                    border: 1px solid $border-color !important;\n                    position: static !important;\n                    padding: 10px !important;\n\n                    .header {\n                        font-size: 14px;\n                        color: $dkblue;\n                    }\n                }\n            }\n\n            .hiddenSearchIcon {\n                display: inline-block;\n                width: 30px;\n                height: 30px;\n                position: absolute;\n                right: 5px;\n                top: 0;\n                opacity: 0;\n                cursor: pointer;\n            }\n        }\n\n        .selectDrop {\n            display: inline-block;\n            position: absolute;\n            right: 410px;\n            top: 40px;\n            z-index: 99;\n\n            .ui.selection.dropdown {\n                min-width: 9em;\n            }\n        }\n\n        .exportAction {\n            display: block;\n            float: right;\n            min-width: 270px;\n\n            .label2 {\n                padding-top: 12px;\n            }\n        }\n\n\n        .lastLogin {\n            position: absolute;\n            right: 0;\n            top: 0;\n        }\n    }\n\n    &.type2 {\n        width: 100%;\n        padding-left: 0;\n    }\n\n    &.bg {\n        width: 100%;\n        background: $white;\n        padding: 20px;\n    }\n}\n\n\n//COMMON LOADER\n.commonLoader {\n    display: none;\n    position: fixed;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, .75);\n    z-index: 9999;\n\n    .loaderWrap {\n        position: absolute;\n        left: 50%;\n        top: 50%;\n        border-radius: 14px;\n        width: 104px;\n        height: 116px;\n        display: block;\n        margin: -52px 0 0 -58px;\n        text-align: center;\n\n        img {\n            display: block;\n            margin: 8px auto;\n            max-width: 100%;\n            height: 60px;\n            width: auto;\n        }\n\n        span {\n            display: block;\n            font-size: 14px;\n            color: #fff;\n        }\n    }\n}",".loginPage{\n    height: 100%;\n    .loginWrap{\n        display: block;\n        width: 100%;\n        max-width: 380px;\t\n        margin: 0 auto;\n        @include border-radius(4px);\n        position: relative;\n        top: 50%;\n        @include translateY(-50%);\n        .loginCard{\n            padding: 30px 40px 40px 40px;\n            box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);\n            background-color: rgb(255, 255, 255);\n            .field{\n                margin: 0 0 10px 0;\n                .field.error{\n                    margin: 0 0 0 0;\n                }\n            }\n        }\n        .titleHead{\n            font-size: 33px;\n            line-height: 40px;\n            text-align: center;\n            margin-bottom: 30px;\n        }\n        .logo{\n            display: block;\n            height: 85px;\n            width: auto;\n            margin: 0 auto 60px auto;\n        }\n        .actionBtnWrap{\n            text-align: center;\n            padding-top: 20px;\n        }\n    }\n}\n.privligeWrap {\n    figure {\n        display: block;\n        background: $white;\n        padding: 10px 20px;\n        margin: 0;\n\n        img.ui.image {\n            display: inline-block;\n            height: 65px;\n        }\n    }\n}",".validateAD {\n    position: relative;\n\n    .searchBx {\n        height: 32px;\n        width: 100%;\n    }\n\n    .editBtn {\n        position: absolute;\n        right: 5px;\n        top: 1px;\n        z-index: 1;\n    }\n}\n\n.userRelatedInfo {\n    margin: 20px 0;\n    border-top: dashed 1px $border-color2;\n    border-bottom: dashed 1px $border-color2;\n}\n\n.titleLabel {\n    display: block;\n    font-size: 14px;\n    color: $ltgrey;\n}\n\n.titleInfo {\n    display: inline-block;\n    font-size: 16px;\n    color: $dkblue;\n    word-break: break-word;\n}\n\n.viewModeFix {\n    ol {\n        list-style-position: inside;\n        margin-left: 20px;\n\n        li {\n            font-size: 16px;\n            color: $dkblue;\n        }\n    }\n\n    ul {\n        list-style-position: inside;\n        margin-left: 40px;\n\n        li {\n            list-style-type: disc;\n            font-size: 16px;\n            color: $dkblue;\n        }\n    }\n\n    .titleInfo {\n        margin-top: 5px;\n\n        p {\n            margin-bottom: 0;\n        }\n\n        sup {\n            margin-top: 15px;\n            display: inline-block;\n        }\n\n        sub {\n            margin-bottom: 15px;\n            display: inline-block;\n        }\n\n        em {\n            font-style: italic;\n        }\n    }\n}\n\n.colorBoxActive {\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    background: #653294;\n    vertical-align: middle;\n}\n\n.selectedColor {\n    position: relative;\n    width: 100%;\n    min-height: 33px;\n    border-radius: .28571429rem;\n    background-color: rgb(255, 255, 255);\n    box-shadow: inset 1px apx apx #ccc;\n    border: 1px solid rgba(34, 36, 38, .15);\n    color: rgba(0, 0, 0, .87);\n    cursor: pointer;\n    padding: 0 10px;\n\n    .dropdown.icon {\n        top: 6px;\n        right: 6px;\n        position: absolute;\n        width: auto;\n        height: auto;\n        line-height: 1.21428571em;\n        opacity: .4;\n\n        &:before {\n            content: \"\\F078\" !important;\n            font-size: 1em;\n        }\n    }\n\n    .colorNameActive {\n        display: inline-block;\n        vertical-align: -3px;\n        font-size: 14px;\n        color: $dkblue;\n        padding-left: 10px;\n        height: 16px;\n\n    }\n\n}\n\n.customColorChooser {\n    position: relative;\n    z-index: 2;\n\n    .allColors {\n        width: 100%;\n        min-height: 120px;\n\n        .defaultColor {\n            display: inline-grid;\n            grid-template-columns: auto auto auto auto auto auto auto;\n            grid-column-gap: 0;\n            grid-row-gap: 0;\n            width: 100%;\n            margin-bottom: 10px;\n            margin-left: 2px;\n            max-height: 136px;\n            overflow: auto;\n\n            &:last-child {\n                margin-bottom: 0;\n\n            }\n\n            .commonToolTip {\n                margin: 2px 14px;\n\n                &:nth-child(7n + 7) {\n                    margin-right: 0;\n                    padding-right: 0;\n                }\n\n                &:nth-child(7n + 1) {\n                    margin-left: 0;\n                    padding-left: 0;\n                }\n            }\n\n            .colorDV {\n                display: inline-block;\n                width: 26px;\n                height: 26px;\n                cursor: pointer;\n\n            }\n\n            .colorDV {\n                &.addColor {\n                    background: $white;\n                    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);\n                    font-size: 20px;\n                    line-height: 26px;\n                    text-align: center;\n                    color: $darkgrey;\n                    font-weight: $fontWeight700;\n                }\n\n                &.used {\n                    &::before {\n                        display: inline-block;\n                        width: 26px;\n                        height: 26px;\n                        content: '\\2715';\n                        font-size: 26px;\n                        line-height: 28px;\n                        text-align: center;\n                        color: $white;\n                        opacity: .4;\n                    }\n                }\n\n                &.active {\n                    &::before {\n                        display: inline-block;\n                        width: 26px;\n                        height: 26px;\n                        content: '\\F00C';\n                        font-family: Icons;\n                        font-size: 12px;\n                        line-height: 26px;\n                        text-align: center;\n                        color: $white;\n                    }\n                }\n\n\n            }\n\n        }\n\n\n    }\n}\n\n.addNewColor {\n    >div {\n        width: 80%;\n        display: inline-block;\n\n    }\n\n}\n\n.checkBoxWrapper {\n    .ui.grid>.row>.column {\n        margin-top: .7rem;\n        margin-bottom: .5rem;\n\n    }\n}\n\n// SLIDER CSS FOR COLOR PICKER\n.slider-picker {\n    display: block;\n    position: relative;\n    width: 100%;\n}",".statusIndicator {\n    display: inline-block;\n    background: $ltgrey;\n    font-size: 16px;\n    line-height: 25px;\n    text-align: center;\n    color: $white;\n    padding: 0 10px;\n    border-radius: 15px;\n\n    &.active {\n        background: $skyblue;\n    }\n\n    &.inactive {\n        background: $yellow;\n    }\n}\n\n.permissionIndicator {\n\n\n    &.full {\n        &::before {\n            color: $green;\n        }\n\n    }\n\n    &.partial {\n        &::before {\n            color: $yellow;\n        }\n\n    }\n\n    &.none {\n        &::before {\n            color: $red;\n        }\n\n    }\n\n\n}\n\n.contentWrapper.type2 {\n    margin-top: 80px;\n}\n\n.chBoxLegend {\n    position: absolute;\n    right: 0;\n    top: 85px;\n\n    ul {\n        margin: 0;\n        padding: 0;\n\n        li {\n            display: inline-block;\n\n            .ui.checkbox {\n                vertical-align: middle;\n                margin: 0 12px 0 20px;\n            }\n\n            span {\n                vertical-align: middle;\n            }\n        }\n    }\n}\n\n%officerCard {\n    width: 100%;\n    border-radius: 2px;\n    box-shadow: none;\n    background-color: transparent;\n    margin: 0 !important;\n\n    .roleCard {\n        position: relative;\n        padding: 20px 20px 0 20px;\n        height: 100%;\n        border-top: 4px solid $skyblue !important;\n\n        &.inactive {\n            border-top: 4px solid $yellow !important;\n        }\n\n        .roleStatus {\n            margin: 0 0 20px 0;\n\n            .positionMumber {\n                display: inline-block;\n                width: 24px;\n                height: 24px;\n                background: $ltgrey2;\n                border-radius: 50%;\n                font-family: \"ProximaNovaBold\";\n                font-size: 14px;\n                color: $white;\n                line-height: 26px;\n                text-align: center;\n                vertical-align: top;\n            }\n\n            i {\n                margin-left: 10px;\n                cursor: pointer;\n\n                &::before {\n                    font-size: 1em;\n                    color: $ltgrey2;\n                }\n\n                &:hover {\n                    &::before {\n                        color: $dkblue2;\n                    }\n                }\n            }\n\n            .descHead {\n                font-size: 16px;\n                color: $dkblue;\n                font-family: \"ProximaNovaBold\";\n            }\n\n\n        }\n\n        .officerSubInfo {\n            margin-bottom: 20px;\n\n            span {\n                font-size: 14px;\n                color: $darkgrey;\n\n            }\n        }\n\n\n\n        .privileges {\n            .privelegeHead {\n                display: block;\n                font-size: 12px;\n                color: $ltgrey2;\n                font-family: \"ProximaNovaBold\";\n                text-transform: uppercase;\n                margin-bottom: 10px;\n            }\n\n            ul {\n                margin: 0 -20px;\n                min-height: 130px;\n                max-height: 180px;\n                overflow: auto;\n\n                li {\n                    padding: 9px 10px 7px 15px;\n                    border-top: 1px solid rgba(0, 0, 0, 0.1);\n\n                    .ui.checkbox.partial .box:before,\n                    .ui.checkbox.partial label:before {\n                        background: $darkgrey;\n                    }\n\n                    .ui.checkbox {\n                        vertical-align: middle;\n                    }\n\n                    .privelegeName {\n                        display: inline-block;\n                        font-size: 16px;\n                        color: $dkblue;\n                        vertical-align: text-top;\n                        margin-left: 10px;\n                        width: calc(100% - 30px);\n                    }\n\n                    &:hover,\n                    &:active {\n                        background: $pageBG;\n                    }\n\n                    &:last-child {\n                        border-bottom: none;\n                    }\n                }\n            }\n        }\n\n\n    }\n\n}\n\n.manageRoleWrap {\n    margin: 0 -10px;\n    position: relative;\n    max-height: calc(100vh - 290px);\n    overflow: auto;\n\n\n    .ui.cards {\n\n        @extend %officerCard;\n\n        &.waterMark {\n            position: absolute;\n            top: 0;\n\n            .ui.card {\n                position: relative;\n                background: $pageBG;\n                // outline: 1px dashed $border-color;\n\n                .bookmarkNum {\n                    position: absolute;\n                    display: block;\n                    width: 100%;\n                    height: 100%;\n                    font-size: 8em;\n                    line-height: 290px;\n                    color: $border-color2;\n                    text-align: center;\n                }\n\n                .roleCard {\n                    border-top: 4px solid transparent !important;\n                    visibility: hidden;\n                }\n\n            }\n\n        }\n    }\n\n}\n\n.helper {\n    z-index: 999;\n    @extend %officerCard;\n\n}\n\n// PRIVILEGE LIST CARD TOOLTIP\n.privListTooltip {\n    padding: 20px;\n    width: 600px;\n    background: $white;\n    box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.2);\n\n    .ui.grid>.column:not(.row) {\n        padding-top: .5em !important;\n        padding-bottom: .5em !important;\n\n    }\n\n    .privActionList {\n        border-bottom: dashed 1px $darkgrey;\n\n        .ui.fitted.checkbox {\n            display: inline-block;\n            width: 26px;\n            vertical-align: sub;\n        }\n\n        .ui.checkbox.partial .box:before,\n        .ui.checkbox.partial label:before {\n            background: $darkgrey;\n        }\n\n        .permsnName {\n            display: inline-block;\n            width: calc(100% - 26px);\n            vertical-align: top;\n            font-size: 14px;\n            color: $dkblue;\n        }\n\n        &.noBottBorder {\n\n            border-bottom: none;\n        }\n    }\n\n    .privGrroupname {\n        font-size: 16px;\n        color: $darkgrey;\n        font-family: \"ProximaNovaBold\";\n        margin-top: 20px;\n        margin-bottom: 20px;\n\n        &:first-child {\n            margin-top: 0;\n        }\n    }\n}\n\n\n// ADD ROLE MODAL CSS START\n.ui.modal.addOfficerModal {\n\n    .accordHead {\n        display: block;\n        font-size: 16px;\n        text-transform: uppercase;\n        padding-top: 10px;\n        padding-left: 12px;\n        margin-bottom: 10px;\n    }\n\n    .accordion {\n        padding: 0 10px;\n\n        .content {\n            background: $pageBG;\n\n            .commonTitle {\n                font-family: \"ProximaNovaBold\";\n                font-size: 16px;\n                color: $darkgrey;\n                margin-bottom: 0;\n\n                &+.checkBoxWrapper {\n                    border-bottom: dashed 1px #8d939a;\n                    margin-bottom: 20px;\n\n                    &:last-child {\n                        border-bottom: none;\n                        margin-bottom: 0;\n                    }\n\n                    .ui.grid {\n                        margin-top: 0;\n                    }\n                }\n            }\n\n            .privActionList {\n                .ui.fitted.checkbox {\n                    display: inline-block;\n                    width: 26px;\n                    vertical-align: sub;\n                }\n\n                .permsnName {\n                    display: inline-block;\n                    width: calc(100% - 26px);\n                    font-size: 14px;\n                    color: $dkblue;\n                    vertical-align: inherit;\n                }\n            }\n\n        }\n    }\n\n}\n\n\n.comApplyRemove {\n    position: relative;\n    border: 1px solid $thead-border;\n    padding: 10px;\n    background: $pageBG;\n\n    .tableWrapper {\n        width: calc(100% - 40px);\n        margin-top: 0;\n        overflow-x: initial;\n        overflow-y: initial;\n\n        td {\n            vertical-align: top;\n\n            button {\n                display: inline-block;\n                margin-top: 22px;\n\n                i.icon {\n                    width: 1.8em;\n                    height: 1.8em;\n                    line-height: 1.8em;\n\n                    &::before {\n                        font-size: 1em;\n\n                    }\n                }\n            }\n        }\n\n    }\n\n    .deletAction {\n        position: absolute;\n        right: 10px;\n        bottom: 34px;\n        z-index: 1;\n        cursor: pointer;\n    }\n}\n\n\n.react-grid-item {\n\n    border: 2px solid #000;\n}\n\n.react-grid-layout {\n    position: relative;\n    transition: height 200ms ease;\n}\n\n.react-grid-item {\n    transition: all 200ms ease;\n    transition-property: left, top;\n}\n\n.react-grid-item.cssTransforms {\n    transition-property: transform;\n}\n\n.react-grid-item.resizing {\n    z-index: 1;\n    will-change: width, height;\n}\n\n.react-grid-item.react-draggable-dragging {\n    transition: none;\n    z-index: 3;\n    will-change: transform;\n}\n\n.react-grid-item.react-grid-placeholder {\n    background: red;\n    opacity: 0.2;\n    transition-duration: 100ms;\n    z-index: 2;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    -o-user-select: none;\n    user-select: none;\n}\n\n.react-grid-item>.react-resizable-handle {\n    position: absolute;\n    width: 20px;\n    height: 20px;\n    bottom: 0;\n    right: 0;\n    cursor: se-resize;\n}\n\n.react-grid-item>.react-resizable-handle::after {\n    content: \"\";\n    position: absolute;\n    right: 3px;\n    bottom: 3px;\n    width: 5px;\n    height: 5px;\n    border-right: 2px solid rgba(0, 0, 0, 0.4);\n    border-bottom: 2px solid rgba(0, 0, 0, 0.4);\n}",".addCommitteeWrap {\n    padding: 5px 10px;\n    background: $white;\n\n    h5 {\n        border-top: dashed 1px $border-color2;\n        padding-top: 10px;\n        margin-top: 10px;\n    }\n\n    .labelList {\n        li {\n            background: $white;\n            border-radius: 2px;\n            box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.02);\n            padding: 9px;\n            margin-bottom: 10px;\n\n            .comitteName {\n                font-size: 14px;\n                color: $dkblue;\n            }\n\n            .eligibleFields {\n                display: inline-block;\n                float: right;\n                font-size: 14px;\n                color: $skyblue;\n                margin-right: 20px;\n                margin-top: 3px;\n                cursor: pointer;\n            }\n\n            .closeIcon {\n                float: right;\n                cursor: pointer;\n\n                .icon {\n                    &::before {\n                        font-weight: $fontWeight400;\n                        color: $ltgrey;\n                    }\n                }\n            }\n        }\n    }\n\n    .addNewLabel {\n        .specify {\n            display: inline-block;\n            width: calc(100% - 40px);\n        }\n\n        .addAction {\n            float: right;\n            display: inline-block;\n            width: 40px;\n            text-align: right;\n            margin-top: 5px;\n        }\n    }\n\n    .memClassType {\n        display: block;\n        float: left;\n        width: 33%;\n\n        .memClassTypeTitle {\n            display: block;\n            font-size: 14px;\n            color: $dkblue;\n            margin-bottom: 5px;\n        }\n\n        .memClassTypeList {\n            display: block;\n            background: $white;\n            padding: 20px;\n            border-radius: 2px;\n            box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.02);\n            max-height: 320px;\n            overflow-y: auto;\n\n            li {\n                font-size: 14px;\n                color: $dkblue;\n                margin: 5px 0;\n\n                .checkbox {\n                    margin-right: 10px;\n                    vertical-align: bottom;\n                }\n            }\n        }\n\n\n    }\n\n    .operator {\n        display: block;\n        width: 30%;\n        float: left;\n        margin: 0 2%;\n    }\n\n    .sc-ifAKCX {\n        position: relative;\n        margin-top: 10px;\n\n        .KYUqY {\n            max-height: 320px;\n            overflow-y: auto;\n        }\n\n        .bpKHpE {\n            background-color: $pageBG;\n            padding: 15px;\n            min-height: auto !important;\n\n            .gmcSqE {\n                border: none;\n                font-size: 16px;\n                color: $dkblue;\n                padding: 8px 20px;\n            }\n\n            .iQCjkp {\n                font-size: 16px;\n                color: $dkblue;\n                padding: 8px 20px;\n            }\n        }\n\n        h3 {\n            font-size: 14px;\n            color: $dkblue;\n            position: absolute;\n            top: -20px;\n            margin-left: -8px;\n        }\n    }\n\n    .comitteeAccord {\n        .chbx {\n            display: inline-block;\n            margin-right: 10px;\n\n            >label {\n                display: inline-block;\n            }\n        }\n\n        .checkBoxWrapper {\n            .checkbox {\n                vertical-align: middle;\n                margin-right: 10px;\n            }\n\n            label {\n                font-size: 14px;\n            }\n        }\n    }\n    .column {\n        .committee-droparea {\n            height: 100%;\n            & > div {\n                height: 100%;\n            }\n        }\n    }\n}\n\n.greyBox {\n    display: block;\n    padding: 20px;\n    border: solid 1px $border-color2;\n    background-color: $pageBG;\n    max-height: 320px;\n    overflow-y: auto;\n\n    &.type2 {\n        max-height: none;\n        overflow-y: inherit;\n    }\n}\n\n.borderDashed {\n    display: block;\n    width: 100%;\n    border-top: dashed 1px $border-color2;\n    padding-top: 10px;\n    margin-top: 10px;\n\n}\n\n.levelPills {\n    display: inline-block;\n    background: $subMenuBg;\n    padding: 3px 8px 2px 8px;\n    font-size: 14px;\n    color: $dkblue;\n    text-align: center;\n    margin-right: 10px;\n    margin-bottom: 10px;\n\n    .icon {\n        display: inline-block;\n        margin-left: 10px;\n        cursor: pointer;\n\n        &::before {\n            font-size: .9em;\n            color: $skyblue;\n        }\n    }\n}\n\n.manageFields {\n    width: 436px;\n    padding: 20px !important;\n    border: none !important;\n    box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.2) !important;\n    border-radius: 0 !important;\n\n    .privGrroupname {\n        font-size: 16px;\n        color: $darkgrey;\n        font-family: \"ProximaNovaBold\";\n        margin-bottom: 15px;\n\n    }\n\n    .ui.checkbox .box,\n    .ui.checkbox label {\n        font-size: 14px;\n        padding-left: 1.5em;\n    }\n}\n\n//dashed bottom border to seperate fields\n.dashed-Border{\n    display: block;\n    width: 100%;\n    border-top: dashed 1px $border-color2;\n    padding-top: 20px;\n    margin-top: 20px;\n}",".unAuthorizeDv {\n    padding: 150px 0 50px 0;\n    text-align: center;\n\n    .dontSign {\n        display: block;\n        margin-bottom: 30px;\n\n        i {\n            text-align: center;\n            display: initial;\n\n            &::before {\n                font-size: 3.7em;\n                color: $ltgrey2;\n            }\n        }\n    }\n\n    .permissionHead {\n        display: block;\n        font-size: 20px;\n        color: $darkgrey;\n    }\n\n    .permissionSub {\n        font-size: 16px;\n        color: $darkgrey;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
